import { Component, OnInit, ViewContainerRef, ViewChild, Input, OnDestroy, HostListener, ChangeDetectionStrategy, AfterViewInit, DoCheck, OnChanges, SimpleChanges, signal } from '@angular/core';
import { WebsocketService } from '../../services/websocket.service'; import { Share } from '@capacitor/share';
import { VideoThumbnailCaptureService } from 'src/app/services/video-thumbnail-capture.service';
import { Capacitor } from '@capacitor/core'; import { ProductService } from 'src/app/services/product.service'; import { PickListSourceFilterEvent } from 'primeng/picklist';
import { Browser } from '@capacitor/browser';
import { BehaviorSubject } from 'rxjs'; import { SidebarService } from 'src/app/services/sidebar.service'; import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { ChangeDetectorRef } from '@angular/core'; import { ShowProductsComponent } from '../show-products/show-products.component';
import { NgZone } from '@angular/core';
import { ChatAppComponent } from 'src/app/components/chat/chat.app.component';
import { combineLatest, map, of, firstValueFrom } from 'rxjs';
import { debounceTime, filter, startWith, take } from 'rxjs/operators';
import { Subject } from 'rxjs'; import { environment } from 'src/environments/environment'; import { PlatformService } from 'src/app/services/platform.service';
import { UnregisterSwService } from 'src/app/services/unregister-sw/unregister-sw.service';
import { ChatWebSocketService } from 'src/app/services/chat-web-socket.service';
import { Router, ParamMap, Params } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { PedidosService } from 'src/app/services/pedidos.service';
import { PickListObserverService } from 'src/app/services/pick-list-observer.service';
import { Produto, ProdutoCategory, ProdutoShopify } from 'src/app/models/product-picklist.model';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { ElementRef, Renderer2 } from '@angular/core';
import { formatDate } from '@angular/common';
import { LazyLoadEvent } from 'primeng/api';
//import { TableLazyLoadEvent } from 'primeng/api'; 
import { ConfirmationService } from 'primeng/api';
import { Menu } from 'primeng/menu';
import { MegaMenuItem } from 'primeng/api';
const RecordRTC = require('recordrtc');
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { ActivatedRoute } from '@angular/router';
import { Metric } from 'src/app/api/metric';
// import { FileAppService } from '../../demo/service/file.app.service';
declare var videojs: any;
import { LiveShopService } from 'src/app/services/liveshop.service';
import { FeedService } from 'src/app/services/feed.service';
import { MessageService } from 'primeng/api';
import { MenuItem } from 'primeng/api';
import { UserCardComponent } from './user-card/user-card.component';
//import videojs from 'video.js';
import { Hotspot, ProductCard } from 'src/app/models/hotspot.model';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { withLatestFrom } from 'rxjs/operators';
import { ChatSidebarComponent } from './../chat/chat-sidebar/chat-sidebar.component';
import { User } from 'src/app/api/user';
import { ChatService } from '../chat/service/chat.service';
//import { PhotoService } from 'src/app/demo/service/photo.service';
import { MediaStreamService } from 'src/app/services/media-stream.service';
import { WalletService } from 'src/app/services/wallet.service';
import { IWallet } from 'src/app/@types/Wallet';
import { HomeService } from 'src/app/services/home.service';
import { LiveStatusService } from 'src/app/services/live-status.service';
import { interval } from 'rxjs';
import { LiveShop, Item, Coupon, AnimatedText } from 'src/app/models/liveshop';
import { Observable, fromEvent } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { CdkDropList } from '@angular/cdk/drag-drop';
import domtoimage from 'dom-to-image';
import { v4 as uuidv4 } from 'uuid';
import { MediaUploadService } from 'src/app/services/media-upload.service';
import { from, defer } from 'rxjs';
import { StateManagementService } from 'src/app/services/state-management.service';
import { Asset, HotspotShopTheLookDto, HotspotSettingsDto, HotspotDto } from 'src/app/models/liveshop';
import { SwiperOptions } from 'swiper';
import { Swiper } from 'swiper'; import { UserGridSidebarComponent } from '../user-grid-sidebar/user-grid-sidebar.component';
import { ManangeLayoutService } from 'src/app/services/manange-layout.service';
import { LayoutService } from 'src/app/layout/service/app.layout.service';
import { throwError } from 'rxjs';
import { FormatDurationPipe } from 'src/app/shared/format-duration.pipe';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormArray,
  FormControl,
  ValidatorFn
} from '@angular/forms';
import { Pipe, PipeTransform } from '@angular/core';
import { GalleriaThumbnails } from 'primeng/galleria';
import { LitPlayerEmbedBridgeService, LitPlayerEmbedHandle } from '../../services/lit-player-embed-bridge.service';

@Pipe({
  name: 'highlightLimit'
})
export class ClockData {
  id?: string;
  stream_key?: string;
}
interface SlickType {
  label: string;
  value: string;
}
interface AssetsResponse {
  assets: Asset[];   // Define a propriedade 'assets' como um array de 'Asset'
  totalAssets: number; // Define 'totalAssets' como um número
}
// Produto/ProdutoCategory/ProdutoShopify agora vivem em
// src/app/models/product-picklist.model.ts (compartilhado com
// app-product-picklist).
interface Promotion {
  id: number;
  name: string;
  value: number;
  status: number;
  show_item?: boolean;
  isSelected?: boolean;
  highlight?: boolean;
  define_interval?: boolean;
  show_slider?: boolean;
  interval_time?: { start: string; end: string };
}
interface Custom {
  id: number;
  interval_time?: { start: string; end: string };
}
interface AccordionTab {
  header: string;
  button_text?: string;
  redirect_url?: string;
  font_color_custom?: string;
  bg_color_custom?: string;
  define_interval?: boolean;
  show_item?: boolean;
  interval_time?: { start: string; end: string };
  slider_time_range: [number, number];
}
interface AlertsTab {
  header: string;
  text?: string;
  showAlerts?: boolean;
  font_color?: string;
  background?: string;
  define_interval?: boolean;
  show_item?: boolean;
  interval_time?: { start: string; end: string };
  slider_time_range: [number, number];
}
interface Links {
  id: number;
  name?: string;
  show_link?: boolean;
  bg_color?: string;
  position?: number;
  redirect_url?: string;
  click_url?: string;
  define_interval?: boolean;
  show_item?: boolean;
  time_from?: string;
  time_to?: string;
  interval_time?: { start: string; end: string };
  slider_time_range: [number, number];
  button_text_color?: string; // Cor da fonte do botão
  button_bg_color?: string;   // Cor de fundo do botão
  button_text?: string;       // Texto do botão
  card_text_color?: string;
  description?: string;       // Descrição exibida no card (estilo CTA da Meta)
}
interface WhatsAppTab {
  header: string;
  ddi?: string;
  ddd?: string;
  fone?: string;
  redirect_url?: string;
  define_interval?: boolean;
  show_item?: boolean;
  interval_time?: { start: string; end: string };
  slider_time_range: [number, number];
  whatsappMsg?: string;
}
interface SlickMaps {
  id: number;
  uniq_id: string;
  asset_uniq_id: string;
  url: string;
  status: number;
  created_at: string;
  updated_at: string;
  type: number;
}
interface SocketErrorEvent {
  event: string;
  error: any; // Você pode especificar um tipo mais específico para o erro, se disponível
}
interface Interval {
  start: number;
  end: number;
  source: string;
}
interface IconResponse {
  data: Gif[];
  meta: Meta;
}

interface Meta {
  pagination: Pagination;
}
interface Pagination {
  total: number;
  last_page: number;
  per_page: number;
  current_page: number;
}
interface Icon {
  id: number;
  name: string;
  created: string;
  slug: string;
  style: { id: number, name: string };
  family: { id: number, name: string, total: number };
  free_svg: boolean;
  author: { id: number, name: string, slug: string, avatar: string, assets: number };
  thumbnails: { width: number, height: number, url: string }[];
}
interface Gif {
  type: string;
  id: string;
  url: string;
  images: {
    downsized: {
      url: string;
    };
    // Inclua outras versões conforme necessário
  };
  title: string;
}

interface GifResponse {
  data: Gif[];
  meta: {

  };
  pagination: {
    total_count: number;
    last_page: number;
    per_page: number;
    current_page: number;
  };
}
interface Tab {
  define_interval_custom?: boolean;
  interval_time: { start: string; end: string };
  define_interval?: boolean;
}
export interface AlertChange {
  index: number;
  text?: string;
  fontColor?: string;
  backgroundColor?: string;
}
@Component({
  selector: 'app-slick-detail',
  templateUrl: './slick-detail.component.html',
  styleUrls: ['./slick-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('fadeInOut', [
      state('in', style({ opacity: 1 })),
      transition(':enter', [
        style({ opacity: 0 }),
        animate(600)
      ]),
      transition(':leave', [
        animate(10, style({ opacity: 0 }))
      ])
    ]),
    trigger('slideInUp', [
      transition(':enter', [
        style({ height: '0', overflow: 'hidden' }), // Começa com altura 0
        animate('300ms ease-in', style({ height: '*' })) // Cresce até a altura definida no CSS
      ]),
      transition(':leave', [
        animate('300ms ease-out', style({ height: '0' })) // Diminui até altura 0 ao sair
      ])
    ]),
    trigger('slideInUpChat', [
      transition('void => *', [
        style({ height: '0', overflow: 'hidden' }),
        animate('600ms ease-in', style({ height: '*' }))
      ]),
      transition('* => void', [
        animate('600ms ease-out', style({ height: '0', overflow: 'hidden' })) // Aumenta a duração para 600ms
      ])
    ])
  ]
})
export class SlickDetailComponent implements OnInit, OnDestroy, DoCheck, OnChanges {
  allItems: Item[] = []; currentIndex: number = -1;
  @ViewChild('dynamicComponentContainer', { read: ViewContainerRef, static: true })
  dynamicComponentContainer!: ViewContainerRef;

  @ViewChild('videoUploadContainer') videoUploadContainer?: ElementRef;
  @ViewChild('videoUploadContainerInside') videoUploadContainerInside?: ElementRef;
  @ViewChild('videoInner') videoInnerRef?: ElementRef;
  @ViewChild('videoElement') videoElementRef?: ElementRef;
  loadingContent?: ElementRef;
  @ViewChild('controlsContainer') controlsContainer?: ElementRef;
  @ViewChild('fallbackVideoElement') fallbackVideoElement?: ElementRef<HTMLVideoElement>;
  @ViewChild('canvasElement') canvasElement?: ElementRef<HTMLCanvasElement>;
  @ViewChild('imagemElement') imagemElement?: ElementRef<HTMLImageElement>;

  // Player Lit embutido via iframe (Studio) — mesmo padrão de
  // `video-modal.component.ts`/`p-video-player-lit.component.ts`: UM único
  // iframe criado em `ngOnInit()` e mantido vivo até `ngOnDestroy()`. Toda
  // edição ao vivo (CTA/cor/capítulo/rotação) chama `pushLiveUpdate()`, que
  // debounca e reenvia o item inteiro via `bridge.updateItem()` — nunca um
  // diff.
  @ViewChild('iframeHost', { static: true }) iframeHost!: ElementRef<HTMLElement>;
  private bridge?: LitPlayerEmbedHandle;
  currentOrientation: 'portrait' | 'landscape' = 'portrait';
  private updateItemSubject = new Subject<void>();

  uuid?: string | null;
  get storeId(): string { return localStorage.getItem('ss_SelectedStoreId') ?? ''; }
  metrics: Metric[] = [];
  menuitems: MenuItem[] = [];
  items!: MenuItem[];
  hasErrorCalendar: boolean = false;
  minDate: Date = new Date();
  boundOnDragging: any;
  boundOnDragEnd: any;
  lastVolume: number = 0.5;
  private colorSubscription: Subscription;

  private subscriptionsGeneric: Subscription = new Subscription();
  noPadding: boolean = false;
  toggleLayoutClass() {
    this.manangeLayoutService.toggleClass();
    this.noPadding = !this.noPadding;
  }
  constructor(
    private productService: ProductService,
    private platformService: PlatformService,
    private errorHandler: ErrorHandlerService,
    private route: ActivatedRoute,
    private sidebarService: SidebarService,
    private confirmationService: ConfirmationService,
    private breakpointObserver: BreakpointObserver,
    private breakpointObserverScreen: BreakpointObserver,
    private manangeLayoutService: ManangeLayoutService,
    private layoutService: LayoutService,
    private unregisterSwService: UnregisterSwService,
    private cdr: ChangeDetectorRef,
    private chatService: ChatService,
    private liveShopService: LiveShopService,
    private feedService: FeedService,
    private el: ElementRef,
    private router: Router,
    private messageService: MessageService,
    private mediaStreamService: MediaStreamService,
    private websocketService: WebsocketService,
    private walletService: WalletService,
    private auth: AuthService,
    private productsService: PedidosService,
    private liveStatusService: LiveStatusService,
    private homeService: HomeService,
    public fb: FormBuilder,
    private ngZone: NgZone,
    public stateManagementService: StateManagementService,
    public pickListObserverService: PickListObserverService,
    private chatWebSocketService: ChatWebSocketService,
    private renderer: Renderer2,
    private videoThumbnailCaptureService: VideoThumbnailCaptureService,
    private embedBridgeService: LitPlayerEmbedBridgeService,
    private mediaUploadService: MediaUploadService
  ) {
    console.log('[Capacitor] referenced in ClockData');
    this.boundBeforeUnloadHandler = this.handleBeforeUnload.bind(this);
    if (this.stream) {
      this.stopMediaTracks(this.stream);
    }
    this.liveStatusSubscription = this.liveStatusService.subscribe((newState: 'idle' | 'offline' | 'online') => {

      if (newState === 'offline') {
        this.firstSuccessfulSend = false;
        this.recording = false;
        this.recording = false;
        if (this.updateSubscription) {
          this.updateSubscription.unsubscribe();
        }
        clearTimeout(this.tertInterval);
        clearTimeout(this.analyticsInterval);
        this.tertInterval = null;
        this.analyticsInterval = null;
        //this.stopMediaTracks(this.stream);
        this.pauseSlick = false;



      } else if (newState === 'online') {
        // if (!this.tertInterval) {
        //   this.tertInterval = setInterval(() => {
        //     this.getLiveTert();
        //   }, 30000);
        // }
        // if (!this.analyticsInterval) {
        //   this.analyticsInterval = setInterval(() => {
        //     this.getLiveAndUpdagte();
        //   }, 60000);
        // }
        this.pauseSlick = false;

      } else if (newState === 'idle') {
        this.pauseSlick = true;
      }
      this.liveStatus = newState;
    });

    this.issueForm = this.fb.group({
      // defina os controles do formulário aqui
      // exemplo: 'name': ['']
    });

    this.colorSubscription = this.stateManagementService.getAccordionColors().pipe(takeUntil(this.destroy$)).subscribe(colors => {
      this.playPauseColor = colors.fontColor;
      this.barColor = colors.bgColor;
    });
    this.boundOnDragging = this.onDragging.bind(this);
    this.boundOnDragEnd = this.onDragEnd.bind(this);
    this.lastVolume = parseFloat(localStorage.getItem('lastVolume') || '0.5');


    this.dragEventsSubscription = this.dragEvents.pipe(
      debounceTime(100)  // ajuste conforme necessário
    ).pipe(takeUntil(this.destroy$)).subscribe(event => {
      this.moveMarker(event);
    });



    this.updateItemsDock();

    // Debounce das edições ao vivo (CTA/cor/capítulo/rotação/thumbnail) antes
    // de reenviar o item inteiro pro player Lit embutido — cada handler só
    // chama `pushLiveUpdate()`, nunca `bridge.updateItem()` direto.
    this.updateItemSubject.pipe(debounceTime(150), takeUntil(this.destroy$)).subscribe(() => {
      const item = this.buildLivePlayerItem();
      void this.bridge?.updateItem({ item, orientation: this.currentOrientation, editableHotspots: true, hideCloseButton: true, storeColors: this.storeColors });
    });

  }

  // Sem `private` — chamado direto do template (switches "Exibir" de
  // custom/whatsapp, ver .html) além de internamente pelos handlers TS.
  pushLiveUpdate(): void {
    this.updateItemSubject.next();
  }

  // Monta o item bruto (mesmo shape de `LiveShopAssetResource`/`Item`) a
  // partir do estado vivo do componente — MESMO mapeamento campo→path que
  // `saveAsset()` usa pro FormGroup, só que como objeto plano (sem reactive
  // forms) e mesclado sobre `this.currentItem` (preserva content.uid,
  // media_creator, e qualquer coisa que não faça parte do formulário
  // editável). Usado tanto no `bridge.init()` inicial quanto em todo
  // `pushLiveUpdate()` — não duplicar esse shape em outro lugar.
  // Bug real corrigido: `accordionTabs`/`whatsappTabs`/`targetProducts` são o
  // formato INTERNO de edição do Angular (nomes de campo escolhidos livremente
  // pra esse componente — ex. `button_text`/`bg_color_custom`/`fone`/
  // `thumbnail`) — DIFERENTE do formato bruto que o backend devolve em GET
  // (`LiveShopAssetResource`) e que `extractPlayerItems()`/`normalize.ts`
  // (slicksell-lit-widget) esperam (`title`/`background`/`phone`/`image`).
  // Antes essa tradução só acontecia no backend (Angular manda o formato
  // interno pro `saveAsset()`, o backend persiste e RE-EMITE no formato cru
  // na próxima leitura) — como agora mandamos o item direto pro player sem
  // passar pelo round-trip do backend, precisamos fazer essa tradução aqui
  // também, ou o player nunca reconhece os campos (CTA custom não aparecia
  // NEM depois de recarregar a página, porque `buildLivePlayerItem()` sempre
  // sobrescrevia `content.cta.components.custom` com o formato interno).
  private toRawCustomButtons(tabs: AccordionTab[] | null | undefined): any[] {
    return (tabs ?? []).map((t) => ({
      id: (t as any).id,
      title: t.button_text,
      background: t.bg_color_custom,
      font: t.font_color_custom,
      redirect_url: t.redirect_url,
      show_item: t.show_item,
    }));
  }

  private toRawWhatsapp(tabs: WhatsAppTab[] | null | undefined): any[] {
    return (tabs ?? []).map((t) => ({
      id: (t as any).id,
      ddd: t.ddd,
      phone: t.fone,
      whatsappMsg: t.whatsappMsg,
      show_item: t.show_item,
    }));
  }

  private toRawProducts(products: any[] | null | undefined): any[] {
    return (products ?? []).map((p) => ({
      ...p,
      image: p.image ?? p.thumbnail,
    }));
  }

  private buildLivePlayerItem(): any {
    const base = this.currentItem ?? {};

    const hotspotEnabled = this.showHotspots === true;
    const hotspotItems = (this.hotspotsData ?? []).map((h, idx) => ({
      productId: h.productId,
      xPct: h.xPct,
      yPct: h.yPct,
      wPct: h.wPct,
      hPct: h.hPct,
      position: h.position ?? idx,
    }));
    const chaptersPayload = this.chaptersEnabled ? (this.chapters ?? []) : [];

    return {
      ...base,
      schedule: {
        ...(base.schedule ?? {}),
        date_from: this.scheduleDateFrom,
        date_to: this.scheduleDateTo,
      },
      media: {
        ...(base.media ?? {}),
        type: this.mediaType,
        src: this.replaceDomain(this.mediaSrc),
        time_to_pitch: this.time_to_pitch,
        duration: this.mediaDuration,
        thumbnail: this.imageSelected ? this.replaceDomain(this.mediaThumbnail) : this.currentThumbnail,
        thumbnail_source: this.thumbnailMode,
        aspect_ratio: this.mediaAspectRatio,
        status: this.mediaStatus,
        chapters_enabled: this.chaptersEnabled,
        chapters: chaptersPayload,
      },
      media_creator: {
        ...(base.media_creator ?? {}),
        handle: this.handleUser,
        avatar: this.avatar,
      },
      content: {
        ...(base.content ?? {}),
        description: this.slickDesc,
        cta: {
          ...(base.content?.cta ?? {}),
          type: 0,
          components: {
            ...(base.content?.cta?.components ?? {}),
            custom: this.toRawCustomButtons(this.accordionTabs),
            whatsapp: this.toRawWhatsapp(this.whatsappTabs),
            products: { items: this.toRawProducts(this.targetProducts) },
            promotions: { items: this.targetPromotions ?? [] },
            alerts: this.alertsTabs ?? [],
            links: this.linksSelecteds ?? [],
            hotspot: {
              enabled: hotspotEnabled,
              items: hotspotItems,
              settings: {
                markerType: this.hotspotMarkerType,
                shopTheLook: {
                  enabled: this.hotspotShopEnabled,
                  label: this.hotspotShopLabel,
                  btnBgColor: this.hotspotShopBtnBg,
                  btnTextColor: this.hotspotShopBtnText,
                  icon: this.hotspotShopIcon,
                },
              },
            },
          },
        },
      },
      extra: {
        ...(base.extra ?? {}),
        player: {
          ...(base.extra?.player ?? {}),
          time_to_pitch: this.timeToPitch ? 1 : 0,
          time_to_pitch_value: this.timePitch,
          player_color: this.playPauseColor,
          progress_bar_color: this.progressBarColor,
          auto_play: true,
          show_progress_bar: this.showProgressBar ? 1 : 0,
        },
        tags: this.tagsString,
        profileBtn: this.profileBtn,
      },
    };
  }

  // Mesmas chaves de localStorage/sessionStorage que `video-modal.component.ts`/
  // `slicksell-widget.ts` já usam (`ensureSessionId()`/`ensurePlayerSessionId()`).
  // `generateUID()` já existe neste componente (usa uuidv4(), ver mais abaixo)
  // — reaproveitado aqui em vez de duplicar.
  private ensureSessionId(): string {
    const stored = sessionStorage.getItem('ss_session_id');
    if (stored) return stored;
    const generated = this.generateUID();
    sessionStorage.setItem('ss_session_id', generated);
    return generated;
  }

  private ensurePlayerSessionId(): string {
    const stored = localStorage.getItem('ss_player_session_id');
    if (stored) return stored;
    const generated = this.generateUID();
    localStorage.setItem('ss_player_session_id', generated);
    return generated;
  }
  updateItemsDock() {
    this.itemsDock = [
      {
        label: 'Finder',
        icon: this.showCTAs ? 'assets/aberto.png' : 'assets/fechado.png',
        command: (event: any) => {
          this.toggleShowCTAs();
        }
      },
      {
        label: 'Sidebar Right',
        icon: 'assets/magic.png',
        command: (event: any) => {
          this.openSidebar();
        }
      },
      {
        label: 'Sidebar Bottom',
        icon: 'assets/more.png',
        command: (event: any) => {
          this.openSidebarBottom();
        }
      }
    ];
  }

  handleBeforeUnload(event: BeforeUnloadEvent) {
    // Custom logic here
    event.returnValue = "You'll never see this as the browser overrides it!";
    if (this.messageContainer && this.messageContainer.nativeElement) {
      const messageElement = document.createElement("div");
      messageElement.innerHTML = "<p style='color: red'>Don't close me bro!</p>";
      this.messageContainer.nativeElement.appendChild(messageElement);
    }
    console.log('Usuário está tentando sair da página');
  }
  displayReconnectDialog: boolean = false;
  reconnectAttempts: number = 0;
  reconnectMessage: string = 'Tentando reconectar...';
  monitorSocketErrors(): void {
    this.websocketService.errorObservable.pipe(takeUntil(this.destroy$)).subscribe({
      next: (error: any) => {
        console.log('chegou no monitor de erros: ' + error.event);
        clearInterval(this.timer);
        if (error.event !== 'disconnect') {
          if (this.reconnectAttempts === 0) {
            this.promptReconnect();
          } else if (this.reconnectAttempts === 3) {
            this.disconnectSocket();
          }
        } else {
          if (this.stream) {
            this.stopMediaTracks(this.stream);
          }
        }
      },
      error: (err: any) => console.error('Erro ao monitorar o socket:', err)
    });
  }


  /// área de reconexão
  promptReconnect(): void {
    this.displayReconnectDialog = true;
    this.reconnectMessage = 'Tentando reconectar...';
    this.tryReconnect();
  }
  timeOutReconnect: any;
  tryReconnect(): void {
    if (this.reconnectAttempts < 3) {
      this.reconnectAttempts++;
      this.reconnectMessage = `Tentativa ${this.reconnectAttempts} de 3...`;

      this.websocketService.reconnect().then(() => {
        // Reconexão bem-sucedida, feche o diálogo
        this.displayReconnectDialog = false;
        this.startRecording(0);
      }).catch((error) => {
        // Falha na reconexão, aguarde um momento antes da próxima tentativa
        if (this.reconnectAttempts < 3) {
          this.timeOutReconnect = setTimeout(() => {
            //this.reconnectAttempts = 1;
            this.tryReconnect();
          }, 2000);


        } else {
          // Falhou após 3 tentativas, feche o diálogo e desconecte
          this.onDisconnectClick();
        }
      });
    } else {
      // Falhou após 3 tentativas, feche o diálogo e desconecte
      this.onDisconnectClick();
    }
  }



  onDisconnectClick(): void {
    this.reconnectAttempts = 3;
    this.disconnectSocketRecon();
    this.displayReconnectDialog = false; // Feche o diálogo
    this.websocketService.sendMessage({ action: 'stop' });
    this.websocketService.disconnectSocket();
    this.stopMediaTracks(this.stream);
    this.websocketService.disconnect();
  }

  disconnectSocket(): void {
    this.websocketService.disconnectSocket();
    this.websocketService.disconnect();
    this.websocketService.sendMessage({ action: 'stop' });
  }
  disconnectSocketRecon(): void {
    this.websocketService.disconnect();
  }
  /// área de reconexão
  reconnect(): void {
    // Chama o método de reconexão do seu WebsocketService
    this.websocketService.reconnect();
  }
  tertInterval: any = 0;
  analyticsInterval: any = 0;
  private dragEventsSubscription?: Subscription;
  forceFocus(event: MouseEvent): void {
    (event.target as HTMLInputElement).focus();
  }
  private updateSubscription?: Subscription;
  liveStatus: 'idle' | 'offline' | 'online' = 'offline';
  videoUrl: string = '';
  fullScreen: boolean = false;
  handleFullscreenChange = () => {
    if (!document.fullscreenElement) {
      // Atualiza o estado quando sair do modo de tela cheia
      this.fullScreen = false;
      if (this.videoUploadContainerInside) {
        this.videoUploadContainerInside.nativeElement.style.marginLeft = '';
      }
      //this.adjustVideoMarginSubMenu();

    }
    this.showMenuInf = false;
    // const videoJsControlBar = document.getElementsByClassName('vjs-control-bar');
    // (videoJsControlBar[0] as HTMLElement).style.display = 'none';
    //if (!this.fullScreen) {
    this.marginTopVideo();
    //}
    if (this.valSelect1Video.value == 1) {
      this.aplicarEstiloFullscreen();
      //this.adjustVideoMargin();
    }

    if (!this.typeLive) {
      if (this.fullScreen) {
        this.myButtonDom.innerHTML = "<i class='pi pi-window-minimize' style='cursor:pointer;'></i>";
      } else {
        this.myButtonDom.innerHTML = "<i class='pi pi-window-maximize' style='cursor:pointer;'></i>";
      }
      this.myButtonDom.onclick = () => {
        if (this.fullScreen) {
          this.goMinscreen();
        } else {
          this.goFullscreen();
        }
      };
    }
    this.playerBorderRadius();
    //this.adjustVideoMargin();

  }
  showMenuInf = false;
  timeoutRef: any = null;
  private destroy$ = new Subject<void>();
  private detailCancel$ = new Subject<void>();
  private liveStatusSubscription: Subscription;



  private cameraChangeProcessedSubscription?: Subscription;
  getActionMenu = () => { // Usando arrow function para manter o contexto de `this`
    return [
      { label: 'Ver Slick', icon: 'pi pi-file-edit', command: () => this.redirectToSlick(), disable: this.verSlickStatus },
      { label: 'Compartilhar', icon: 'pi pi-trash', command: () => this.compartilhar() }
    ];
  }
  redirectToSlick() {
    const domainStore = localStorage.getItem('domain_store');

    // Verificar e obter o subdomínio
    let subdomain = '';
    let domain = '';
    if (domainStore) {
      const parts = domainStore.split('.');
      if (parts.length >= 2) {
        subdomain = parts[0]; // Atribui a primeira parte como subdomínio
        domain = parts.slice(1).join('.'); // Junta o restante das partes para formar o domínio
      } else {
        domain = parts.join('.'); // Caso só exista um domínio sem subdomínio
      }
    }
    domain = environment.frontendUrl.replace(/^https?:\/\//, '');

    const cleanedDomain = environment.frontendUrl.replace(/^https?:\/\//, '');
    // Obter o UID da URL atual
    const currentUrl = window.location.href;
    const uidMatch = currentUrl.match(/\/slick\/([^/]+)/);
    const uid = uidMatch ? uidMatch[1] : '';

    if (!uid) {
      console.error('UID não encontrado na URL atual.');
      return;
    }

    // Construir a URL de redirecionamento
    const redirectUrl = `${window.location.protocol}//${cleanedDomain}/${subdomain}?slick_id=${uid}`;


    console.log(redirectUrl);
    // Redirecionar para a nova URL em uma nova aba
    window.open(redirectUrl, '_blank');
  }

  confirmDeletion() {

  }

  showMenu(): void {
    this.showMenuInf = true;
    // const videoJsControlBar = document.getElementsByClassName('vjs-control-bar');
    // (videoJsControlBar[0] as HTMLElement).style.display = 'flex';
    //this.adjustVideoMarginSubMenu();
    this.resetHideTimer();
  }

  hideMenu(): void {
    // Intencionalmente vazio para evitar esconder imediatamente quando o mouse sai
  }

  onMouseMove(): void {
    //if (!this.isLive) {
    this.showMenuInf = true;
    const videoJsControlBar = document.getElementsByClassName('vjs-control-bar');
    if (videoJsControlBar.length > 0) {
      (videoJsControlBar[0] as HTMLElement).style.display = 'flex';
    }

    this.adjustVideoMarginSubMenu();
    // Garante que o menu só será escondido após 3 segundos sem movimento
    if (!this.showMenuInf) {
      console.log("mostrandoMenu");
      this.showMenu();
    } else {
      this.resetHideTimer();
    }
    // }
  }
  //
  resetHideTimer(): void {
    if (!this.isLive) {
      this.clearHideTimer();
      this.timeoutRef = setTimeout(() => {
        if (this.showMenuInf) {
          const videoJsControlBar = document.getElementsByClassName('vjs-control-bar');
          //(videoJsControlBar[0] as HTMLElement).style.display = 'none';
          this.showMenuInf = false;
        }
      }, 3000); // Esconde após 3 segundos sem movimento
    }
  }

  clearHideTimer(): void {
    if (this.timeoutRef) {
      clearTimeout(this.timeoutRef);
      this.timeoutRef = null;
    }
  }

  onTouch(event?: Event): void {
    //if (!this.isLive) {
    const videoJsControlBar = document.getElementsByClassName('vjs-control-bar');
    if (videoJsControlBar.length > 0) {
      (videoJsControlBar[0] as HTMLElement).style.display = 'flex';
    }
    if (!this.showMenuInf) {
      this.showMenuInf = true;
      this.adjustVideoMarginSubMenu();
      //
      this.resetHideTimer();
      if (event) {

        event.stopPropagation();
      }
    }
    //}
  }



  openDialog() {
    this.displayRTMPInofos = true;
  }
  displaySidebar: boolean = false;
  displaySidebarSaldo: boolean = false;
  displaySidebarBottom: boolean = false;
  sidebarGerenciar: boolean = false;
  sidebarChatApp: boolean = false;
  timeOutCloseSideBar: any;
  onSidebarClose() {
    this.timeOutCloseSideBar = setTimeout(() => {
      document.body.classList.remove('body-fixed');
    }, 300);
  }
  openSidebarBottom() {
    //document.body.classList.add('body-fixed');
    this.displaySidebarBottom = true;
    this.onSidebarShow();
  }
  openSidebarSaldo() {
    this.displaySidebarSaldo = this.displaySidebarSaldo == true ? false : true;;
    this.displaySidebar = false;
    if (this.observer) {
      this.observer.disconnect();
    }
  }
  backStudio() {
    this.mananger = 0;
    this.pageStudio = 'Studio';
    this.pageStudioNow = '';
    this.sidebarChatApp = false;
    this.sidebarGerenciar = true;
  }
  openSidebar() {
    this.displaySidebarSaldo = false;
    if (this.sidebarChatApp) {
      this.displaySidebar = true;
    } else {
      this.displaySidebar = this.displaySidebar == true ? false : true;
    }
    if (this.observer && this.displaySidebar == false) {
      this.observer.disconnect();
    }
    this.sidebarGerenciar = true;
    this.mananger = 0;
    this.pageStudio = 'Studio';
    this.pageStudioNow = '';
    this.sidebarChatApp = false;
  }

  @HostListener('window:resize')
  onResize() {
    this.updateDynamicStyle(); // Atualiza o estilo quando a janela é redimensionada
    this.updateProgressBarPosition();
    this.isCompactView = window.innerWidth < 992;
    this.updateManagerPanelFixedState();
  }
  micShow: boolean = true;





  async adjustVideoAspectRatio(videoData: Blob, targetAspectRatio: number): Promise<Blob> {
    return new Promise((resolve, reject) => {
      const video = document.createElement('video');
      video.onloadedmetadata = () => {
        // Calcular as novas dimensões
        let newWidth = video.videoHeight * targetAspectRatio;
        let newHeight = video.videoHeight;

        // Caso queira cortar em vez de ajustar somente a altura,
        // poderíamos ajustar a largura mantendo a altura e cortar os lados, por exemplo:
        // let newWidth = video.videoWidth;
        // let newHeight = video.videoWidth / targetAspectRatio;

        // Criar um canvas para o redimensionamento
        var canvas = document.createElement('canvas');
        canvas.width = newWidth;
        canvas.height = newHeight;

        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject(new Error('Não foi possível obter o contexto 2D do canvas.'));
          return;
        }

        // Desenhar o vídeo no canvas com as novas dimensões
        ctx.drawImage(video, 0, 0, newWidth, newHeight);

        // Converter o canvas para Blob
        canvas.toBlob(blob => {
          if (blob) {
            resolve(blob);
          } else {
            reject(new Error('Falha ao converter canvas para Blob.'));
          }
        }, 'video/webm');
      };

      // Ã‰ necessário carregar a fonte de vídeo para que os metadados sejam carregados
      video.onerror = (event) => {
        reject(new Error('Falha ao carregar o vídeo.'));
      };

      video.src = URL.createObjectURL(videoData);
      video.load();
    });
  }


  openCloseMic() {
    this.micShow = !this.micShow; // Alternar o estado
    if (this.player) {
      this.player.muted(!this.player.muted()); // Alterna o estado de mute
    }
    if (this.stream) {
      // Acessa todas as faixas de áudio da stream
      this.stream.getAudioTracks().forEach(track => {
        // Alterna o estado de 'enabled' da faixa
        track.enabled = !track.enabled;
      });
    }
  }



  screenWidth?: number;
  screenHeight?: number;
  adjustVideoMarginSubMenu() {
    const menuInf = document.getElementsByClassName('ss-g-menu-inf')[0];
    if (!menuInf) return;

    // Garanta que menuInf é tratado como HTMLElement
    if (!(menuInf instanceof HTMLElement)) return;

    // Detectar o zoom do navegador
    const zoomLevel = window.innerWidth / window.screen.width;
    this.screenWidth = window.screen.width * zoomLevel;
    this.screenHeight = window.screen.height * zoomLevel;

    if (this.fullScreen && this.screenHeight && this.screenWidth) {
      const larguraDoVideo = this.screenHeight * (9 / 16);
      let marginLeftRight = (this.screenWidth - larguraDoVideo) / 2;
      if (marginLeftRight > 0) {
        menuInf.style.setProperty('width', `${larguraDoVideo}px`, 'important');
        menuInf.style.marginLeft = `${marginLeftRight}px`;
        menuInf.style.marginRight = `${marginLeftRight}px`;
      }

    } else {
      menuInf.style.width = `100%`;
      menuInf.style.marginLeft = `0px`;
      menuInf.style.marginRight = `0px`;
    }
  }


  getVideoHeightInRem() {
    if (this.videoElementRef) {
      const videoElement: HTMLVideoElement = this.videoElementRef.nativeElement;
      const rect = videoElement.getBoundingClientRect();

      // Obter o tamanho da fonte do root (document.documentElement)
      const fontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);

      // Converter a altura do vídeo de pixels para rem
      const heightInRem = rect.height / fontSize;

      return heightInRem;
    }
    return '';
  }
  adjustVideoMargin() {
    const videoJsDivs = document.getElementsByClassName('video-js');
    if (this.fullScreen) {
      const zoomLevel = window.innerWidth / window.screen.width;
      //   this.screenWidth = window.screen.width * zoomLevel; // Ajustar largura da tela ao nível de zoom
      // this.screenHeight = window.screen.height * zoomLevel; 
      console.log('entrou ajuste');
      const screenWidth = window.screen.width * zoomLevel;
      const screenHeight = window.screen.height * zoomLevel;
      let marginLeft = 0;
      let marginRight = 0;
      this.marginRightAdj = marginRight;
      let barLeft = 0;

      const videoJsControlBar = document.getElementsByClassName('vjs-control-bar');
      const videoJsSpinner = document.getElementsByClassName('vjs-loading-spinner');
      if (videoJsDivs.length > 0) {
        const videoWidth = (videoJsDivs[0] as HTMLElement).offsetWidth;
        if (this.fullScreen && this.valSelect1Video.value === 1) {
          const larguraDoVideo = screenHeight * (9 / 16);
          marginLeft = (screenWidth / 2) - (larguraDoVideo / 2);
          if (marginLeft < 0) {
            barLeft = -marginLeft;
          } else {
            barLeft = -marginLeft;
          }
          marginRight = marginLeft;
          this.marginRightAdj = marginRight;
        } else if (!this.fullScreen) {
          marginLeft = 0;
          barLeft = 0;

        }


        if (this.fullScreen) {
          (videoJsDivs[0] as HTMLElement).style.marginLeft = `${marginLeft}px`;
          //(videoJsSpinner[0] as HTMLElement).style.marginLeft = `${marginLeft}px`;

          if (this.fullScreen && videoJsControlBar[0]) {
            (videoJsControlBar[0] as HTMLElement).style.width = 'auto';
          }


          //if (!this.isMobileDevice()) {
          (videoJsDivs[0] as HTMLElement).style.marginRight = `${marginLeft - 1}px`;
          this.marginRightAdj = marginLeft;
          //}
        } else {
          if (this.valSelect1Video.value === 2) {
            (videoJsDivs[0] as HTMLElement).style.width = `${100}%`;
          }
        }

      }
    } else {

      const screenWidth = window.innerWidth;

      console.log('mmmm');
      console.log(screenWidth);
      if (screenWidth < 1733) {
        (videoJsDivs[0] as HTMLElement).style.marginRight = '0px';
        this.marginRightAdj = 1;
      } else if (screenWidth < 1800) {
        if (this.valSelect1Video.value === 1) {
          (videoJsDivs[0] as HTMLElement).style.marginRight = '0px';
          this.marginRightAdj = 2;
        } else {
          (videoJsDivs[0] as HTMLElement).style.marginRight = '0px';
          this.marginRightAdj = 3;
        }

      } else {
        if (this.valSelect1Video.value === 1) {
          (videoJsDivs[0] as HTMLElement).style.marginRight = '0px';
          this.marginRightAdj = 2;
        } else {
          (videoJsDivs[0] as HTMLElement).style.marginRight = '0px';
          this.marginRightAdj = 3;
        }
      }
      (videoJsDivs[0] as HTMLElement).style.marginLeft = '0px';

    }

    if (!this.typeLive) {
      console.log('marginLeft: ' + this.marginLeftAdj)
      console.log('marginLeft: ' + this.marginRightAdj)

      //ss-l-alert-btn
      const alerts = document.getElementsByClassName('ss-l-alert-btn');
      const btnFullScrenn = document.getElementsByClassName('ss-g-postionFullScreen');
      const swiperProducts = document.getElementsByClassName('ss-l-swiper-products');
      const controlBarVideoJS = document.getElementsByClassName('vjs-control-bar');
      const btnCustom = document.getElementsByClassName('ss-l-custom-btn-screen');
      const btnWhats = document.getElementsByClassName('ss-l-custom-btn-whats');
      const gemPromos = document.getElementsByClassName('ss-l-gem-promos');
      if (this.fullScreen) {
        this.cdr.detectChanges();

        if (this.alertsTabs.length > 0 && this.showCTAs) {
          if (alerts && this.alertsTabs.length > 0) {
            (alerts[0] as HTMLElement).style.marginRight = `${this.marginRightAdj - 1}px`;
            (alerts[0] as HTMLElement).style.marginLeft = `${this.marginRightAdj - 1}px`;
          }
        }

        // if (controlBarVideoJS) {
        //   (controlBarVideoJS[0] as HTMLElement).style.marginRight = `${this.marginRightAdj - 1}px`;
        //   (controlBarVideoJS[0] as HTMLElement).style.marginLeft = `${this.marginRightAdj - 1}px`;
        // }

        if (this.targetProducts.length > 0 && this.showCTAs) {

          if (swiperProducts.length > 0) {
            (swiperProducts[0] as HTMLElement).style.marginRight = `${this.marginRightAdj - 15}px`;
            (swiperProducts[0] as HTMLElement).style.marginLeft = `${this.marginRightAdj - 15}px`;
            (swiperProducts[0] as HTMLElement).style.top = 'calc(20% - 50px);';
          }
        }


        if (gemPromos && this.targetPromotions.length > 0) {
          const element = gemPromos[0] as HTMLElement;
          element.style.cssText += `margin-left: ${this.marginRightAdj - 1}px !important;`;
        }
      } else {
        this.cdr.detectChanges();
        if (this.alertsTabs.length > 0 && this.showCTAs) {
          if (alerts && this.alertsTabs.length > 0) {
            (alerts[0] as HTMLElement).style.marginRight = '';
            (alerts[0] as HTMLElement).style.marginLeft = '';
          }
        }
        console.log('teste de medidas')
        if (this.videoElementRef) {
          const heightInRem = this.getVideoHeightInRem();
          console.log('ff ' + heightInRem);
        }


        // if (controlBarVideoJS) {
        //   (controlBarVideoJS[0] as HTMLElement).style.marginRight = '';
        //   (controlBarVideoJS[0] as HTMLElement).style.marginLeft = '';
        // }
        if (this.targetProducts.length > 0 && this.showCTAs) {
          if (swiperProducts) {
            (swiperProducts[0] as HTMLElement).style.marginRight = '';
            (swiperProducts[0] as HTMLElement).style.marginLeft = '';
            //(swiperProducts[0] as HTMLElement).style.top = 'calc(85% - 50px);';
          }
        }


        // if (gemPromos && this.targetPromotions.length > 0) {
        //   (gemPromos[0] as HTMLElement).style.marginLeft = '';
        // }
      }
    }
    //ss-g-sidebar-promotions
    const zoomLevel = window.innerWidth / window.screen.width;
    const screenWidth = window.screen.width * zoomLevel;
    const screenHeight = window.screen.height * zoomLevel;
    const tagsPillPlayer = document.getElementsByClassName('ss-l-tagsPlayer');
    const divChat = document.getElementsByClassName('ss-l-div-chat');
    const swiperProducts = document.getElementsByClassName('ss-l-swiper-products');
    const divProductsDestaque = document.getElementsByClassName('ss-g-postionProductsDestaque');
    const swiperAlerts = document.getElementsByClassName('ss-l-alert-btn');
    const sidebarPromotion = document.getElementsByClassName('ss-g-sidebar-promotions');
    const menuRecording = document.getElementsByClassName('ss-g-menu-inf2');
    const gemPromosBtn = document.getElementsByClassName('ss-l-custom-btn');
    const menuInf = document.getElementsByClassName('ss-g-menu-inf');
    const darkArea = document.querySelector('.videoUploadContainer'); // Use a classe ou id da área escura
    if (darkArea) {
      const height = darkArea.getBoundingClientRect().height;
      console.log('tamanho área escura: ' + height);

    }
    // vertical fullscreen 
    if (this.fullScreen && this.valSelect1Video.value === 1 && !this.isMobile) {
      let marginLeft = 0;
      let marginRight = 0;
      let barLeft = 0;
      const larguraDoVideo = screenHeight * (9 / 16);
      marginLeft = (screenWidth / 2) - (larguraDoVideo / 2);
      if (marginLeft < 0) {
        barLeft = -marginLeft;
      } else {
        barLeft = -marginLeft;
      }
      marginRight = marginLeft;
      this.marginRightAdj = marginRight;
      (videoJsDivs[0] as HTMLElement).style.marginLeft = `${marginLeft}px`;

      // Obtem o tamanho da fonte do elemento raiz (normalmente <html>) em pixels
      const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
      const oneRemInPx = rootFontSize * 1; // '1' representa o valor de 1rem

      (tagsPillPlayer[0] as HTMLElement).style.setProperty('margin-left', `${marginLeft}px`, 'important');
      (tagsPillPlayer[0] as HTMLElement).style.width = `${screenWidth - 2 * marginLeft - 2 * oneRemInPx}px`;
      this.cdr.detectChanges();
      if (divChat.length > 0) {
        (divChat[0] as HTMLElement).style.setProperty('width', `${screenWidth - 2 * marginLeft - 8 * oneRemInPx}px`, 'important');
        //(divChat[0] as HTMLElement).style.setProperty('top', `${37}rem`, 'important');
      }
      if (this.targetProducts.length > 0 && this.showCTAs) {
        this.cdr.detectChanges();
        if (swiperProducts.length > 0) {
          (swiperProducts[0] as HTMLElement).style.setProperty('margin-left', `${marginLeft - oneRemInPx}px`, 'important');
          (swiperProducts[0] as HTMLElement).style.setProperty('width', `${screenWidth - 2 * marginLeft - 2 * oneRemInPx}px`, 'important');
          //(swiperProducts[0] as HTMLElement).style.setProperty('bottom', 'calc(78% - 50px)', 'important');
        }
      }
      if (this.targetProducts.length > 0 && this.showCTAs) {
        this.cdr.detectChanges();
        // if (divProductsDestaque.length > 0) {
        //   (divProductsDestaque[0] as HTMLElement).style.setProperty('margin-left', `${marginLeft}px`, 'important');
        // }
      }


      if (this.alertsTabs.length > 0 && this.showCTAs) {
        this.cdr.detectChanges();
        if (swiperAlerts.length > 0) {
          (swiperAlerts[0] as HTMLElement).style.setProperty('margin-left', `${marginLeft}px`, 'important');
          (swiperAlerts[0] as HTMLElement).style.setProperty('width', `${screenWidth - 2 * marginLeft - 2 * oneRemInPx}px`, 'important');
        } else {
          console.log('não tem swiper de alertas');
        }
      }

      console.log("p1")
      if (this.targetPromotions.length > 0 && this.showCTAs) {
        this.cdr.detectChanges();
        if (sidebarPromotion.length > 0) {
          console.log("p3");
          (sidebarPromotion[0] as HTMLElement).style.setProperty('margin-left', `${marginLeft}px`, 'important');
          //(sidebarPromotion[0] as HTMLElement).style.setProperty('top', , 'important');
          (sidebarPromotion[0] as HTMLElement).style.setProperty('top', 'calc(50% - 85px)', 'important');

          (sidebarPromotion[0] as HTMLElement).style.setProperty('width', `${screenWidth - 2 * marginLeft}px`, 'important');
        } else {
          console.log('não tem promos1');
        }
        if (gemPromosBtn.length > 0) {
          (gemPromosBtn[0] as HTMLElement).style.setProperty('margin-right', `${marginLeft}px`, 'important');
        }
        // gemPromosBtn
      }
      console.log("p4");
      if (!this.typeLive) {
        const customProgressBar = document.getElementsByClassName('ss-l-progress-container');
        (customProgressBar[0] as HTMLElement).style.marginLeft = `${marginLeft}px`;
        (customProgressBar[0] as HTMLElement).style.width = `${screenWidth - 2 * marginLeft}px`;

        (menuRecording[0] as HTMLElement).style.setProperty('margin-left', `${marginLeft + oneRemInPx}px`, 'important');
        (menuRecording[0] as HTMLElement).style.setProperty('width', `${screenWidth - 2 * marginLeft - 4 * oneRemInPx}px`, 'important');
      }

      if (menuInf.length > 0) {
        (menuInf[0] as HTMLElement).style.setProperty('top', 'calc(22% - 35px)', 'important');
      }
    } else if (!this.fullScreen && this.valSelect1Video.value === 1 && !this.isMobile) {
      if (this.targetProducts.length > 0 && this.showCTAs) {
        this.cdr.detectChanges();
        if (swiperProducts.length > 0) {
          (swiperProducts[0] as HTMLElement).style.setProperty('bottom', '2%', 'important');
        }
      }
      if (menuInf.length > 0) {
        (menuInf[0] as HTMLElement).style.setProperty('top', '84%', 'important');
      }

    } else if (this.fullScreen && this.valSelect1Video.value === 2 && !this.isMobile) {
      if (this.targetProducts.length > 0 && this.showCTAs) {
        this.cdr.detectChanges();
        // if (swiperProducts.length > 0) {
        //   (swiperProducts[0] as HTMLElement).style.setProperty('top', 'calc(85% - 50px)', 'important');
        // }
      }
      if (menuInf.length > 0) {
        console.log('barra inf1');
        (menuInf[0] as HTMLElement).style.setProperty('top', 'calc(95% - 52px)', 'important');
      }
      console.log('barra inf');
    } else if (!this.fullScreen && this.valSelect1Video.value === 2 && !this.isMobile) {
      this.cdr.detectChanges();
      if (this.targetProducts.length > 0 && this.showCTAs) {

        // if (swiperProducts.length > 0) {
        //   (swiperProducts[0] as HTMLElement).style.setProperty('top', 'calc(85% - 50px)', 'important');
        // }
      }
      if (menuInf.length > 0) {
        (menuInf[0] as HTMLElement).style.setProperty('top', '84%', 'important');
      }

    }
    // vertical preview
    if (!this.fullScreen && this.valSelect1Video.value === 1 && !this.isMobile) {
      let marginLeft = 0;
      let barLeft = 0;
      const screenWidth = window.innerWidth;
      (videoJsDivs[0] as HTMLElement).style.marginRight = '0px';
      this.marginRightAdj = 2;
      (videoJsDivs[0] as HTMLElement).style.marginLeft = '0px';


      if (!this.typeLive) {
        const customProgressBar = document.getElementsByClassName('ss-l-progress-container');
        (customProgressBar[0] as HTMLElement).style.marginLeft = `${marginLeft}px`;
        (customProgressBar[0] as HTMLElement).style.width = `${100}%`;
      }



      (tagsPillPlayer[0] as HTMLElement).style.setProperty('margin-left', `${0}px`, 'important');
      (tagsPillPlayer[0] as HTMLElement).style.width = 'auto';


      if (!this.typeLive) {
        (menuRecording[0] as HTMLElement).style.setProperty('margin-left', `${0}px`, 'important');
        (menuRecording[0] as HTMLElement).style.width = 'auto';
      }

      this.cdr.detectChanges();
      if (divChat.length > 0) {
        (divChat[0] as HTMLElement).style.setProperty('width', `${100}%`, 'important');
        //(divChat[0] as HTMLElement).style.setProperty('top', `${25}rem`, 'important');
      }

      if (this.targetProducts.length > 0 && this.showCTAs) {
        this.cdr.detectChanges();
        if (swiperProducts.length > 0) {
          (swiperProducts[0] as HTMLElement).style.setProperty('margin-left', '', 'important');
          (swiperProducts[0] as HTMLElement).style.width = '';
        }
      }
      if (this.targetProducts.length > 0 && this.showCTAs) {
        this.cdr.detectChanges();
        if (divProductsDestaque.length > 0) {
          (divProductsDestaque[0] as HTMLElement).style.setProperty('margin-left', '', 'important');
        }
      }

      if (this.alertsTabs.length > 0 && this.showCTAs) {
        this.cdr.detectChanges();
        if (swiperAlerts.length > 0) {
          (swiperAlerts[0] as HTMLElement).style.setProperty('margin-left', '', 'important');
          (swiperAlerts[0] as HTMLElement).style.width = '';
        } else {
          console.log('não tem swiper de alertas');
        }
      }


      if (this.targetPromotions.length > 0 && this.showCTAs) {
        this.cdr.detectChanges();
        if (sidebarPromotion.length > 0) {
          (sidebarPromotion[0] as HTMLElement).style.setProperty('margin-left', '0rem', 'important');
          (sidebarPromotion[0] as HTMLElement).style.width = '100%';
          (sidebarPromotion[0] as HTMLElement).style.setProperty('top', 'calc(53% - 6px)', 'important');
        } else {
          console.log('não tem promos2');
        }
        if (gemPromosBtn.length > 0) {
          (gemPromosBtn[0] as HTMLElement).style.setProperty('margin-right', '0rem', 'important');
        }
      }
    }
    if (!this.fullScreen && this.valSelect1Video.value === 2 && !this.isMobile) {
      (videoJsDivs[0] as HTMLElement).style.marginRight = '0.1px';
    }
    if (this.isMobile && this.fullScreen && this.valSelect1Video.value === 1) {
      if (this.targetProducts.length > 0 && this.showCTAs) {
        this.cdr.detectChanges();
        if (swiperProducts.length > 0) {
          (swiperProducts[0] as HTMLElement).style.setProperty('margin-left', '', 'important');
          (swiperProducts[0] as HTMLElement).style.width = '';
          (swiperProducts[0] as HTMLElement).style.setProperty('margin-right', '', 'important');
        }
      }
      console.log('entrou no ajuste de alertas isMobile')


      if (this.alertsTabs.length > 0 && this.showCTAs) {
        console.log('entrou no ajuste de alertas isMobile2')
        let marginLeft = 0;
        let marginRight = 0;
        let barLeft = 0;
        const larguraDoVideo = screenHeight * (9 / 16);
        marginLeft = (screenWidth / 2) - (larguraDoVideo / 2);
        if (marginLeft < 0) {
          barLeft = -marginLeft;
        } else {
          barLeft = -marginLeft;
        }
        console.log('entrou no ajuste de alertas isMobile3');
        marginRight = marginLeft;
        const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
        const oneRemInPx = rootFontSize * 1; // '1' representa o valor de 1rem
        this.cdr.detectChanges();
        if (swiperAlerts.length > 0) {
          console.log('entrou no ajuste de alertas isMobile4');
          (swiperAlerts[0] as HTMLElement).style.setProperty('margin-left', `${0}px`, 'important');
          (swiperAlerts[0] as HTMLElement).style.setProperty('margin-right', `${0}px`, 'important');
        } else {
          console.log('entrou no ajuste de alertas isMobile5');
          console.log('não tem swiper de alertas');
        }
        console.log('entrou no ajuste de alertas isMobile6');
      }
    }

  }
  // setMaxHeight() {
  //   // Define a altura do container para ser no máximo igual à do vídeo
  //   videoInner.style.maxHeight = videoElement.clientHeight + 'px';
  // }
  theaterMode: any = {};
  hasTheaterMode: boolean = false;
  originalStyle?: any;
  dynamicStyle: any = {};


  isInTheaterMode: boolean = false;
  goTheaterMode() {
    if (!this.isFullScreen) {
      this.goFullscreen();
    }

    if ((this.valSelectviewMode.value == 1 && this.valSelect1Video.value == 2) || (this.valSelectviewMode.value == 2 && this.valSelect1Video.value == 1)) {
      this.hasTheaterMode = false;
      this.theaterMode = {};
    } else {
      if (this.isFullScreen) {
        this.hasTheaterMode = true;
        if (this.valSelectviewMode.value == 1) {
          this.theaterMode = { 'width': '100vw' };
        } else if (this.valSelectviewMode.value == 2) {
          this.theaterMode = { 'height': '100vh', 'width': '100vw' };
        } else {
          this.theaterMode = {};
        }
      } else {
        this.hasTheaterMode = false;
        this.theaterMode = {};
      }
    }
    this.isInTheaterMode = true;
  }

  exitTheaterMode() {
    this.theaterMode = {};
    this.isInTheaterMode = false;
  }

  isFullScreen?: boolean = false;
  splitterColumnSize: any;
  @ViewChild('splitterWrapper', { static: false }) splitterWrapperRef!: ElementRef;
  applyColumnSizeToSplitter() {
    if (!this.splitterWrapperRef) return;

    setTimeout(() => {
      const wrapper = this.splitterWrapperRef.nativeElement;

      const allResponsiveClasses = [
        'col-12',
        'sm:col-6',
        'md:col-6', 'md:col-8', 'md:col-12',
        'lg:col-4', 'lg:col-6', 'lg:col-8', 'lg:col-10', 'lg:col-12',
        'xl:col-4', 'xl:col-6', 'xl:col-8', 'xl:col-10', 'xl:col-12',
        '2xl:col-4', '2xl:col-6', '2xl:col-8', '2xl:col-10', '2xl:col-12',
      ];

      allResponsiveClasses.forEach(cls => wrapper.classList.remove(cls));
      this.columnSize?.split(' ').forEach(cls => {
        if (cls.trim()) wrapper.classList.add(cls.trim());
      });
    }, 0);
  }





  modoTeatro() {
    this.aspectRatioClass = '';
    if (this.isFullScreen) {
      if (this.valSelectviewMode.value == 2 && this.valSelect1Video.value == 2) {
        this.theaterMode = { 'height': 'auto', 'width': '100%' };
      }
      if (this.valSelectviewMode.value == 1 && this.valSelect1Video.value == 1) {
        this.theaterMode = { 'height': '100%', 'width': 'auto' };
      }
      this.isInTheaterMode = true;
    } else {
      this.isFullScreen = true;

      this.columnSize = 'col-12';
      this.applyColumnSizeToSplitter();
      this.toggleLayoutClass();

      if (this.valSelectviewMode.value == 2 && this.valSelect1Video.value == 2) {
        this.theaterMode = { 'height': '100%', 'width': 'auto' };
      }
      if (this.valSelectviewMode.value == 1 && this.valSelect1Video.value == 1) {
        this.theaterMode = { 'height': '100%', 'width': 'auto' };
      }

      this.isInTheaterMode = true;
      this.updateDynamicStyle();
    }

  }

  sairModoTeatro() {

    this.isInTheaterMode = false;

    if (this.isFullScreen) {
      if ((this.valSelectviewMode.value == 1 && this.valSelect1Video.value == 2) || (this.valSelectviewMode.value == 2 && this.valSelect1Video.value == 1)) {
        this.hasTheaterMode = false;
      } else {
        this.hasTheaterMode = true;
      }
      this.cdr.detectChanges();

      console.log('saindo modo teatro')
      console.log(this.valSelectviewMode.value)
      console.log('saindo modo teatro')


      if (this.valSelectviewMode.value == 2 && this.valSelect1Video.value == 2) {
        this.theaterMode = { 'height': '100%', 'width': '100%' };
      }
      if (this.valSelectviewMode.value == 1 && this.valSelect1Video.value == 1) {
        this.theaterMode = { 'height': '100%', 'width': '100%' };
      }
      //this.theaterMode = {};
    }



  }
  @ViewChild('fullscreenWrapper', { static: false }) fullscreenWrapperRef!: ElementRef;
  originalWrapperWidth: string | null = null;
  originalWrapperHeight: string | null = null;

  // Painel "Gerenciar Slick" docado em desktop — mesmo mecanismo do painel de
  // Configurações do EditWidgetComponent (ver memória feature_edit_widget_docked_config_panel).
  // isCompactView é baseado em largura de tela (não confundir com `isMobile`,
  // que é baseado em user-agent e usado para outras decisões neste componente).
  isCompactView: boolean = window.innerWidth < 992;
  @ViewChild('managerPanelSlot') managerPanelSlotRef?: ElementRef<HTMLDivElement>;
  @ViewChild('managerPanel') managerPanelRef?: ElementRef<HTMLDivElement>;
  isManagerPanelFixed = false;
  managerPanelLeftPx: number | null = null;
  managerPanelWidthPx: number | null = null;
  managerPanelMaxHeightPx: number | null = null;
  managerPanelSlotMinHeightPx: number | null = null;
  private readonly managerPanelTopOffset = 16; // 1rem
  private managerPanelResizeObserver?: ResizeObserver;

  @HostListener('window:scroll')
  onWindowScrollForManagerPanel(): void {
    this.updateManagerPanelFixedState();
  }

  private updateManagerPanelFixedState(): void {
    const slot = this.managerPanelSlotRef?.nativeElement;
    if (!slot || this.isCompactView) {
      this.isManagerPanelFixed = false;
      this.cdr.markForCheck();
      return;
    }

    const rect = slot.getBoundingClientRect();
    this.managerPanelLeftPx = rect.left;
    this.managerPanelWidthPx = rect.width;
    this.isManagerPanelFixed = rect.top <= this.managerPanelTopOffset;

    const panelHeight = this.managerPanelRef?.nativeElement.getBoundingClientRect().height;
    if (typeof panelHeight === 'number' && panelHeight > 0) {
      this.managerPanelSlotMinHeightPx = panelHeight;
    }

    const panelTop = this.isManagerPanelFixed ? this.managerPanelTopOffset : Math.max(rect.top, this.managerPanelTopOffset);

    const footerTop = document.querySelector('footer')?.getBoundingClientRect().top;
    const viewportBoundY = typeof footerTop === 'number'
      ? Math.min(window.innerHeight - this.managerPanelTopOffset, footerTop - this.managerPanelTopOffset)
      : window.innerHeight - this.managerPanelTopOffset;

    const previewRect = this.fullscreenWrapperRef?.nativeElement?.getBoundingClientRect();
    const contentBoundY = previewRect ? previewRect.top + previewRect.height : viewportBoundY;

    const bottomY = Math.min(viewportBoundY, contentBoundY);
    this.managerPanelMaxHeightPx = Math.max(200, bottomY - panelTop);
    this.cdr.markForCheck();
  }

  goFullscreen() {
    this.isFullScreen = true;

    const wrapper = this.fullscreenWrapperRef?.nativeElement as HTMLElement;
    if (wrapper) {
      this.originalWrapperWidth = wrapper.style.width;
      this.originalWrapperHeight = wrapper.style.height;

      wrapper.style.width = '100vw';
      wrapper.style.height = '100vh';
    }

    this.updateDynamicStyle();
    this.aspectRatioClass = '';
    this.columnSize = 'col-12';
    this.splitterColumnSize = 'col-12';
    this.applyColumnSizeToSplitter();
    this.toggleLayoutClass();
    if (this.valSelectviewMode.value == 2 && this.valSelect1Video.value == 2) {
      //this.theaterMode = { 'height': '100%', 'width': '100%' };
    }
    if (this.valSelectviewMode.value == 1 && this.valSelect1Video.value == 1) {
      //this.theaterMode = { 'height': '100%', 'width': '100%' };
    }

    console.log(this.theaterMode) // COR ABAIXO
    let stmBar = setTimeout(() => {
      this.updateProgressBarPosition();
      clearTimeout(stmBar);
    }, 100);
  } //
  @HostListener('document:keydown.escape', ['$event'])
  onEscPressed(event: KeyboardEvent): void {
    if (this.isFullScreen) {
      this.goMinscreen();
    }
  }
  goMinscreen = () => {
    this.isFullScreen = false;

    const wrapper = this.fullscreenWrapperRef?.nativeElement as HTMLElement;
    if (wrapper) {
      wrapper.style.width = this.originalWrapperWidth ?? '';
      wrapper.style.height = this.originalWrapperHeight ?? '';
    }


    this.changeViewMode();


    this.isInTheaterMode = false;
    if (this.valSelectviewMode.value == 1) {
      this.columnSize = 'col-12 md:col-12 lg:col-12 xl:col-8 2xl:col-4';
      this.splitterColumnSize = 'col-12 md:col-12 lg:col-12 xl:col-12 2xl:col-4';
      this.applyColumnSizeToSplitter();
    }
    this.toggleLayoutClass();
    this.updateDynamicStyle();
    if ((this.valSelectviewMode.value == 1 && this.valSelect1Video.value == 2) || (this.valSelectviewMode.value == 2 && this.valSelect1Video.value == 1)) {
      this.hasTheaterMode = false;
    } else {
      this.hasTheaterMode = true;
    }
    this.cdr.detectChanges();
    this.theaterMode = {};
    let stmBar = setTimeout(() => {
      this.updateProgressBarPosition();
      clearTimeout(stmBar);
    }, 100);
  }

  aplicarEstiloFullscreen(): void {
    const videoTechElement = this.el.nativeElement.querySelector('.video-tag');
    const videoPreview = this.el.nativeElement.querySelector('.video-preview');
    if (this.fullScreen) {
      this.renderer.setStyle(videoTechElement, 'min-height', '100vh');
      this.renderer.setStyle(videoTechElement, 'width', 'auto');
      this.renderer.setStyle(videoTechElement, 'aspect-ratio', '9/16');
      this.renderer.setStyle(videoPreview, 'min-height', '100vh');
      this.renderer.setStyle(videoPreview, 'max-height', '100vh');
    } else {
      this.renderer.removeStyle(videoTechElement, 'min-height');
      this.renderer.removeStyle(videoTechElement, 'width');
      this.renderer.removeStyle(videoPreview, 'min-height');
      this.renderer.removeStyle(videoPreview, 'max-height');
      this.renderer.removeStyle(videoTechElement, 'aspect-ratio');
    }
  }




  private subscription?: Subscription;
  private subscription2?: Subscription;
  private subscription3?: Subscription;
  private subscriptionWhatsapp?: Subscription;
  private subscriptionCustomp?: Subscription;
  private subscriptionAlerts?: Subscription;
  highlightedProductsLimited$?: Observable<Produto[]>;



  closeSidebar(event: Event) {
    event.stopPropagation(); // Previne a propagação do evento
    this.showAllShortucutLinks = false; // Altera a visibilidade
  }

  showSwiper: boolean = false;
  numberOfAlerts: number = 0;
  toggleSwiperVisibility(): void {
    this.showSwiper = !this.showSwiper;
    this.subscription = this.filteredAlerts$!.subscribe(alerts => {
      this.numberOfAlerts = alerts.length;
    });
  }

  filteredAlerts$?: Observable<AlertsTab[]>;
  showAlertsSwiper(): void {
    this.showSwiper = true;
  }
  ngOnDestroy() {
    this.bridge?.destroy();
    clearTimeout(this.showLoadingHideTimer);
    this.clearHoldSpeedTimeout();
    if (this.layoutService.currentSlickChatContext?.uuid === this.uuid) {
      this.layoutService.currentSlickChatContext = null;
    }
    if (this.oauthChannel) {
      this.oauthChannel.close();
      this.oauthChannel = null;
    }
    const videoEl = this.videoElementRef?.nativeElement as HTMLVideoElement;
    if (videoEl) {
      videoEl.onloadedmetadata = null;
      videoEl.onplay = null;
      videoEl.onpause = null;
      videoEl.ontimeupdate = null;
      videoEl.onwaiting = null;
      videoEl.onstalled = null;
      videoEl.onerror = null;

      videoEl.pause();
      videoEl.removeAttribute('src');
      videoEl.load();
    }

    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    this.managerPanelResizeObserver?.disconnect();
    this.detachSourceScrollListener();

    // Se o componente for destruído no meio de um arrasto da barra de
    // progresso (ex: navegar pra fora), boundOnDragEnd nunca dispara pra
    // remover esses listeners — sem isso eles ficam presos no document
    // indefinidamente, mesmo após o componente sair de cena.
    if (this.progressContainer) {
      this.progressContainer.nativeElement.removeEventListener('mousemove', this.boundOnDragging);
      this.progressContainer.nativeElement.removeEventListener('mouseup', this.boundOnDragEnd);
      this.progressContainer.nativeElement.removeEventListener('touchmove', this.boundOnDragging);
      this.progressContainer.nativeElement.removeEventListener('touchend', this.boundOnDragEnd);
    }
    document.removeEventListener('mousemove', this.boundOnDragging);
    document.removeEventListener('mouseup', this.boundOnDragEnd);
    document.removeEventListener('touchmove', this.boundOnDragging);
    document.removeEventListener('touchend', this.boundOnDragEnd);

    this.resizeObserverBreakPoints?.disconnect();
    this.subscriptionsChat.unsubscribe();
    this.liveStatusSubscription?.unsubscribe();
    this.websocketService.disconnect();
    if (this.stream) {
      this.stopMediaTracks(this.stream);
    }
    this.subscriptionsGeneric.unsubscribe();
    this.colorSubscription?.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
    // Desabilitado: listener 'beforeunload' não está mais ativo
    // window.removeEventListener('beforeunload', this.boundBeforeUnloadHandler);
    document.removeEventListener('fullscreenchange', this.handleFullscreenChange);
    this.clearHideTimer();
    this.errorSubscription?.unsubscribe();
    if (!this.pauseSlick) {
      this.pause(); // Chama o método pause ao destruir o componente
    }
    this.subscription?.unsubscribe();
    this.pickListObserverService.shouldEmit = false;
    this.subscription2?.unsubscribe();
    this.subscriptionAlerts?.unsubscribe();
    this.pararTimeout();
    if (this.player) {
      this.player.dispose();
    }
    this.observer?.disconnect();
    this.dragEventsSubscription?.unsubscribe();
    this.showProgressBarSubscription?.unsubscribe();
    clearInterval(this.tertInterval);
    clearInterval(this.recordingTimerInterval);
    clearInterval(this.analyticsInterval);
    clearInterval(this.timer);
    clearInterval(this.countdownInterval);
    clearTimeout(this.playPauseTimeout);
    if (this.stream) {
      this.stopMediaTracks(this.stream);
    }
    clearTimeout(this.playerTimeout);
    clearTimeout(this.debounceTimer);
    clearTimeout(this.volumeControlTimeout);
    clearTimeout(this.debounceTimerCTALinks);
    clearTimeout(this.timeOutReconnect);
    clearTimeout(this.timeoutRef);
    clearTimeout(this.timeOutCloseSideBar);
    clearTimeout(this.timeoutId);
    this.cameraChangeProcessedSubscription?.unsubscribe();
    this.pauseSlick = false;
    this.pause();
    this.destroy$.next();
    this.destroy$.complete();

    const progressBar = this.progressContainerWrapper?.nativeElement;

    if (progressBar) {
      progressBar.removeEventListener('touchmove', this.touchMoveListener);
      progressBar.removeEventListener('touchend', this.touchEndListener);
      progressBar.removeEventListener('touchcancel', this.touchEndListener);
      progressBar.removeEventListener('mousemove', this.mouseMoveListener);
      progressBar.removeEventListener('mouseleave', this.mouseLeaveListener);
    }
  }
  logoStore: string = '';

  @ViewChild('messageContainer') messageContainer?: ElementRef;
  private boundBeforeUnloadHandler = this.handleBeforeUnload.bind(this);
  changeCta() {
    console.log(this.ctaSelected)
  }
  changeCtaLink() {
    console.log('Aba alterada para: ', this.activeItemLinks);
  }

  onDialogCloseMain() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }


  private showProgressBarSubscription?: Subscription;
  timeoutId: any;
  iniciarTimeout(): void {
    this.timeoutId = setTimeout(() => {
      if (!this.player && this.videoElementRef) {
        if (typeof videojs !== 'undefined') {
          this.player = videojs(this.videoElementRef.nativeElement, {
            controls: false
          });

          this.player.ready(() => {
            if (this.hasData) {
              // this.disableRecorder = false;
            }

          })
        }
      }
    }, 1);
  }

  pararTimeout(): void {
    clearTimeout(this.timeoutId);
  }
  iconColor: string = '#FFFFFF';


  activeItem?: MenuItem;
  activeItemLinks?: MenuItem;
  activeOption: number | null = 2;
  activeLinkOption: any;

  selecionarOpcao(opcao: number): void {
    setTimeout(() => this.attachSourceScrollListener(), 0);
    this.activeOption = opcao;
    this.cdr.detectChanges();
  }


  images!: any[];
  filter() {
    let filtered: User[] = [];
    for (let i = 0; i < this.users.length; i++) {
      let user = this.users[i];
      if (user.name.toLowerCase().indexOf(this.searchValue.toLowerCase()) == 0) {
        filtered.push(user)
      }
    }

    this.filteredUsers = [...filtered];
  }
  users: User[] = [];
  filteredUsers: User[] = [];
  searchValue: string = '';
  marginRightAdj: any;
  marginLeftAdj: any;







  speedDialTooltipText: string = '';
  speedDialTooltipTarget: any = null;

  onSpeedDialItemHover(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (target.closest('.p-speeddial-action')) {
      // Usando o operador de coalescência nula para garantir que um valor string seja atribuído
      this.speedDialTooltipText = target.getAttribute('data-label') ?? '';
      this.speedDialTooltipTarget = target;
    }
  }


  onSpeedDialItemOut() {
    this.speedDialTooltipText = '';
    this.speedDialTooltipTarget = null;
  }

  showItemName(name: string) {
    // Lógica para mostrar o nome do item, se necessário
  }

  addItem() {
    // Lógica para adicionar item
  }

  updateItem() {
    // Lógica para atualizar item
  }
  landscapeOptions?: MenuItem[] = [];
  landscapeOptions2: any[] = [];
  landscapeOptions3: any[] = [];
  ctaOptions: any[] = [];
  linksOptions: any[] = [];
  valSelect1Video?: any;
  valSelectviewMode?: any;
  ctaSelected?: any;
  valSelectOrientation?: any;
  changeLandscape() {
    // Orientação enviada pro player Lit embutido — `valSelect1Video` (2 =
    // horizontal/landscape, senão portrait) é a MESMA fonte que
    // `saveAsset()`/`buildLivePlayerItem()` já usam pra `mediaAspectRatio`.
    this.currentOrientation = this.valSelect1Video?.value === 2 ? 'landscape' : 'portrait';
    this.pushLiveUpdate();

    if (this.valSelect1Video) {
      console.log("Seleção alterada para valor:", this.valSelect1Video.value);
      this.cdr.detectChanges();
      this.marginTopVideo();
      //this.adjustVideoMargin();
      this.playerBorderRadius();
      this.debounceFunction();
      this.cdr.detectChanges();
    }
    if ((this.valSelectviewMode.value == 1 && this.valSelect1Video.value == 2) || (this.valSelectviewMode.value == 2 && this.valSelect1Video.value == 1)) {
      this.hasTheaterMode = false; this.cdr.detectChanges();
    } else {
      this.hasTheaterMode = true; this.cdr.detectChanges();
    }
    this.setupResizeObserver();
    this.cdr.detectChanges();
  }
  aspectRatioClass: string = 'aspect-9-16';
  changeViewMode() {

    if (this.valSelectviewMode) {
      const isMobile = this.valSelectviewMode.value === 1;
      const isDesktop = this.valSelectviewMode.value === 2;
      const isFull = this.isFullScreen;

      console.log("Seleção alterada para valor:", this.valSelectviewMode.value);

      if (isMobile && !isFull) {
        console.log('ppp1')

        this.columnSize = 'col-12 md:col-12 lg:col-12 xl:col-8 2xl:col-4';
        this.splitterColumnSize = 'col-12 md:col-12 lg:col-12 xl:col-12 2xl:col-4';
      } else {
        console.log('ppp2')
        this.columnSize = 'col-12 md:col-12 lg:col-12 xl:col-8 2xl:col-4';
        this.splitterColumnSize = 'col-12 md:col-12 lg:col-12 xl:col-12 2xl:col-12';
      }

      this.aspectRatioClass = isMobile ? 'aspect-9-16' : 'aspect-16-9';

      // Swiper de produtos (mySwiperSecond): em 9:16 cada slide ocupa ~83% da
      // largura (slidesPerView 1.2), mas em 16:9 o vídeo é bem mais largo e
      // esse mesmo percentual fica enorme — em desktop cada slide passa a
      // ocupar 50% (slidesPerView 2). Reatribuímos o objeto (não só a
      // propriedade) pra o binding [config] do swiper detectar a mudança.
      this.configSwiperSecond = {
        ...this.configSwiperSecond,
        slidesPerView: isDesktop ? 2 : 1.2
      };

      // ðŸ”¥ Use um delay um pouco maior para garantir que as refs estejam prontas
      setTimeout(() => {
        this.applyColumnSizeToSplitter();
        //this.marginTopVideo();
      }, 50);
    }

    this.hasTheaterMode = !(
      this.valSelectviewMode.value === 1 && this.valSelect1Video.value === 2 ||
      this.valSelectviewMode.value === 2 && this.valSelect1Video.value === 1
    );

    this.handleTruncatedDesc();
    this.setupResizeObserver();

    setTimeout(() => {
      this.updateProgressBarPosition();
    }, 100);
  }


  aspect_ratio: string | null = "1";
  exibePlayer: boolean = false;
  isLive: boolean = false;
  hasData: boolean = false;
  loadingDetail: boolean = false;
  disableRecorder: boolean = true;

  private player: any;
  isMobile: boolean = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  isMobileDevice() {
    const isMobileUA = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const isTouchCapable = navigator.maxTouchPoints > 0;
    return isMobileUA || isTouchCapable;
  }
  myButtonDom: any;
  typeSlick?: number;
  sliderMaxValue: number = 0;

  @ViewChild('thumbnailPreview') thumbnailPreview!: ElementRef;
  preventAutoPlay = false;
  // Segurar no vídeo acelera pra 2x; soltar volta pra velocidade que estava antes
  // (a selecionada via engrenagem no app-progress-bar, ou 1x por padrão).
  private holdSpeedTimeout?: any;
  private holdSpeedActive: boolean = false;
  private holdSpeedBaseRate: number = 1;
  private holdSpeedStartX: number = 0;
  private holdSpeedStartY: number = 0;
  private suppressNextTogglePlayPause: boolean = false;
  private readonly HOLD_SPEED_DELAY_MS = 180;
  private readonly HOLD_SPEED_RATE = 2;
  private readonly HOLD_SPEED_MOVE_CANCEL_PX = 10;

  private getEventPoint(event: MouseEvent | TouchEvent): { x: number; y: number } {
    if (event instanceof MouseEvent) return { x: event.clientX, y: event.clientY };
    const touch = event.touches[0] || event.changedTouches[0];
    return { x: touch?.clientX ?? 0, y: touch?.clientY ?? 0 };
  }

  private clearHoldSpeedTimeout(): void {
    if (this.holdSpeedTimeout) {
      clearTimeout(this.holdSpeedTimeout);
      this.holdSpeedTimeout = undefined;
    }
  }

  private activateHoldSpeed(): void {
    const video = this.videoElementRef?.nativeElement;
    if (!video) return;
    this.holdSpeedBaseRate = video.playbackRate || 1;
    video.playbackRate = this.HOLD_SPEED_RATE;
    this.holdSpeedActive = true;
  }

  onVideoHoldStart(event: MouseEvent | TouchEvent): void {
    if (this.isImage) return;
    this.clearHoldSpeedTimeout();
    const point = this.getEventPoint(event);
    this.holdSpeedStartX = point.x;
    this.holdSpeedStartY = point.y;
    this.holdSpeedTimeout = setTimeout(() => this.activateHoldSpeed(), this.HOLD_SPEED_DELAY_MS);
  }

  onVideoHoldMove(event: MouseEvent | TouchEvent): void {
    if (!this.holdSpeedTimeout && !this.holdSpeedActive) return;
    const point = this.getEventPoint(event);
    const dx = Math.abs(point.x - this.holdSpeedStartX);
    const dy = Math.abs(point.y - this.holdSpeedStartY);
    if (dx > this.HOLD_SPEED_MOVE_CANCEL_PX || dy > this.HOLD_SPEED_MOVE_CANCEL_PX) {
      this.onVideoHoldEnd(event);
    }
  }

  onVideoHoldEnd(event: MouseEvent | TouchEvent): void {
    this.clearHoldSpeedTimeout();
    if (this.holdSpeedActive) {
      const video = this.videoElementRef?.nativeElement;
      if (video) {
        video.playbackRate = this.holdSpeedBaseRate;
      }
      this.holdSpeedActive = false;
      this.suppressNextTogglePlayPause = true;
    }
  }

  togglePlayPause(): void {
    console.log('togglePlayPause');

    if (this.suppressNextTogglePlayPause) {
      this.suppressNextTogglePlayPause = false;
      return;
    }

    if (this.videoElementRef && this.videoElementRef.nativeElement) {
      const videoEl = this.videoElementRef.nativeElement as HTMLVideoElement;

      this.showPlayPauseButton = true; // Mostra o botão temporariamente

      if (videoEl.paused) {
        this.preventAutoPlay = false; // Libera o autoplay manualmente
        videoEl.play().then(() => {
          this.isPaused = false;
          this.showPlayPauseButton = false;
        }).catch((err) => {
          console.error('Erro ao tentar tocar o vídeo:', err);
        });
      } else {
        this.preventAutoPlay = true; // Impede que o init reinicie automaticamente
        videoEl.pause();
        this.isPaused = true;
        this.showPlayPauseButton = true;
      }
    }
  }


  showPlayPauseButton: boolean = false;
  playPauseTimeout: any;
  // Quando o mouse entra na área do vídeo
  onVideoMouseEnter(): void {
    this.showPlayPauseButton = true;
    // Limpar o timeout anterior se o vídeo estiver tocando

    if (this.playPauseTimeout && !this.isPaused) {
      clearTimeout(this.playPauseTimeout);
    }
  }
  // Quando o mouse sai da área do vídeo
  onVideoMouseLeave(): void {
    if (!this.isPaused) {
      // Iniciar um novo timeout para esconder o botão
      this.playPauseTimeout = setTimeout(() => this.showPlayPauseButton = false, 3000);
    }
  }
  onVideoMouseMove(): void {
    // Mostra o botão quando o mouse se move dentro do vídeo
    this.showPlayPauseButton = true;

    // Reinicia o temporizador para esconder o botão após 3 segundos
    clearTimeout(this.playPauseTimeout);
    if (!this.isPaused) {
      this.playPauseTimeout = setTimeout(() => {
        this.showPlayPauseButton = false;
      }, 3000);
    }

  }
  posterURL?: string;
  combinedTime$!: Observable<{ current: string | null, total: string | null }>;
  removeNgswBypassParam(url: string): string {
    return url
      .replace(/[?&]ngsw-bypass=[^&]*/g, '')
      .replace(/\?&/, '?');
  }
  // removeUrlValidator(url: string): string {
  //   return url.includes('?') ? url.split('?')[0] : url;
  // }

  removeUrlValidator(url: string): string {
    if (url.includes('cloudfront')) {
      return url.includes('?') ? url.split('?')[0] : url;
    }

    // Se for cdninstagram ou qualquer outra, retorna a URL sem alterações
    return url;
  }
  showLoading: boolean = true;
  private showLoadingHideTimer: any = null;
  initVideoPlayer(): void {

    const isImage = this.mediaType?.toLowerCase() === 'photo'; // 

    if (this.videoElementRef && this.videoElementRef.nativeElement) {
      const videoEl = this.videoElementRef.nativeElement as HTMLVideoElement;

      // Zera o vídeo antes de reusar
      videoEl.pause();
      videoEl.removeAttribute('src');
      videoEl.removeAttribute('poster');
      videoEl.load();

      if (isImage) {
        // this.renderer.setAttribute(videoEl, 'poster', this.mediaThumbnail ?? '');
        // this.renderer.setStyle(videoEl, 'display', 'block');
        this.showLoading = false;
        this.canSave = true;
        return;
      }

      // ðŸŽžï¸ Para vídeo normal
      this.renderer.setAttribute(videoEl, 'poster', this.mediaThumbnail ?? '');
      this.renderer.setAttribute(videoEl, 'src', this.removeNgswBypassParam(this.removeUrlValidator(this.videoUrl)));
      this.renderer.setAttribute(videoEl, 'playsinline', '');
      //this.renderer.setAttribute(videoEl, 'autoplay', '');
      this.renderer.setAttribute(videoEl, 'loop', '');
      this.renderer.setAttribute(videoEl, 'muted', '');
      this.renderer.setAttribute(videoEl, 'preload', 'auto');
      this.renderer.setStyle(videoEl, 'display', 'block');
      this.showLoading = false;
      videoEl.onloadedmetadata = () => {
        this.sliderMaxValue = videoEl.duration;
        this.videoDurationSeconds = isNaN(videoEl.duration) ? 0 : videoEl.duration;

        if (!this.timePitch) {
          this.updateTimeValue();
        }

        this.setCustom(this.customComponentsTmp);

        //this.setWhatsAppTabs(this.whatsAppComponentsTmp);
        this.setupVisibleButtonWhatsApp();
        this.setAlerts(this.alertsAppComponentsTmp);
        this.showLoading = false;
        this.generateAndInjectVtt();
      };

      videoEl.onplay = () => {
        this.ngZone.run(() => {
          this.isPaused = false;
          clearTimeout(this.playPauseTimeout);
          this.playPauseTimeout = setTimeout(() => {
            this.showPlayPauseButton = false;
          }, 3000);
        });
      };

      videoEl.onpause = () => {
        this.ngZone.run(() => {
          this.isPaused = true;
          this.showPlayPauseButton = true;
          clearTimeout(this.playPauseTimeout);
        });
      };

      videoEl.ontimeupdate = () => {
        const currentTime = videoEl.currentTime;
        const duration = videoEl.duration;
        this.currentVideoTime.set(currentTime);
        this.durationTotal = this.formatTime(duration);
        this.videoDurationSeconds = isNaN(duration) ? 0 : duration;
      };

      videoEl.onwaiting = () => {
        //console.log('Evento: waiting - Buffering or seeking');
      };

      videoEl.onstalled = () => {
        //console.log('Evento: stalled - Buffering');
      };

      videoEl.onerror = (e) => {
        //this.showLoading = false;
        //console.error('Erro ao carregar vídeo:', e);
      };

      // â¯ï¸ Tenta reproduzir automaticamente
      if (!this.preventAutoPlay) {
        videoEl.play().then(() => {
          this.isPaused = false;
          console.log("Vídeo começou a tocar.");
        }).catch((error) => {
          console.error("Erro ao tentar reproduzir o vídeo: ", error);
        });
      }

      // Aqui você pode continuar com seus métodos de UI
      this.playerBorderRadius();
      this.moveControlBar();
      this.updateDynamicStyle();

      this.canSave = true;
    } else {
      console.log('não achou elemento de vídeo');
    }
  }
  canSave: boolean = false;

  setThumbNail(player: any) {
    const progressBar = this.progressContainerWrapper?.nativeElement;
    const thumbnailPreview = this.thumbnailPreview.nativeElement;

    if (progressBar) {
      this.touchMoveListener = (event: TouchEvent) => {
        const touch = event.touches[0];
        const rect = progressBar.getBoundingClientRect();
        const seekPercentage = (touch.clientX - rect.left) / rect.width;
        const duration = player.duration();
        const seekTime = seekPercentage * duration;
        const thumbnailIndex = Math.floor(seekTime);
        const backgroundPosX = thumbnailIndex * -160;

        thumbnailPreview.style.display = 'block';
        thumbnailPreview.style.left = `${touch.clientX - 80}px`;
        thumbnailPreview.style.top = `${-100}px`;
        thumbnailPreview.style.backgroundImage = `url('https://raw.githubusercontent.com/GiriAakula/samuel-miller-task/master/openvideo.png')`;
        thumbnailPreview.style.backgroundPosition = `${backgroundPosX}px 0px`;
        thumbnailPreview.style.backgroundSize = '1600px 450px';
      };

      this.touchEndListener = () => {
        thumbnailPreview.style.display = 'none';
      };

      this.mouseMoveListener = (event: MouseEvent) => {
        const rect = progressBar.getBoundingClientRect();
        const seekPercentage = (event.clientX - rect.left) / rect.width;
        const duration = player.duration();
        const seekTime = seekPercentage * duration;
        const thumbnailIndex = Math.floor(seekTime);
        const backgroundPosX = thumbnailIndex * -160;

        thumbnailPreview.style.display = 'block';
        let thumbnailLeft = event.clientX - rect.left - 80;
        if (thumbnailLeft < 0) {
          thumbnailLeft = 0;
        } else if (thumbnailLeft + 160 > rect.width) {
          thumbnailLeft = rect.width - 160;
        }

        thumbnailPreview.style.left = `${thumbnailLeft}px`;
        thumbnailPreview.style.top = `${-100}px`;
        thumbnailPreview.style.backgroundImage = `url('https://raw.githubusercontent.com/GiriAakula/samuel-miller-task/master/openvideo.png')`;
        thumbnailPreview.style.backgroundPosition = `${backgroundPosX}px 0px`;
        thumbnailPreview.style.backgroundSize = '1600px 450px';
      };

      this.mouseLeaveListener = () => {
        thumbnailPreview.style.display = 'none';
      };

      progressBar.addEventListener('touchmove', this.touchMoveListener);
      progressBar.addEventListener('touchend', this.touchEndListener);
      progressBar.addEventListener('touchcancel', this.touchEndListener);
      progressBar.addEventListener('mousemove', this.mouseMoveListener);
      progressBar.addEventListener('mouseleave', this.mouseLeaveListener);
    }
  }

  private touchMoveListener: any;
  private touchEndListener: any;
  private mouseMoveListener: any;
  private mouseLeaveListener: any;
  private transitionEndListener: any;
  createCustomMarkers(): void {
    const markers = [
      { time: 10, text: 'Time to pitch' } // Você pode ter uma array de objetos de marcadores
    ];

    const duration = this.player.duration();
    if (this.progressContainer) {
      const containerWidth = this.progressContainer.nativeElement.getBoundingClientRect().width;

      // Remova todos os marcadores existentes antes de adicionar novos
      const progressContainerElement = this.progressContainer.nativeElement;
      const markersContainer = document.querySelector('#my-markers-container');
      if (markersContainer) {
        markersContainer.innerHTML = '';

        // Crie e adicione os marcadores
        markers.forEach(marker => {
          const markerElement = document.createElement('div');
          markerElement.classList.add('custom-marker');
          markerElement.title = marker.text;

          // Calcule a posição do marcador
          const position = (marker.time / duration) * progressContainerElement.offsetWidth;
          markerElement.style.left = `${position}px`;

          markersContainer.appendChild(markerElement);
        });
      }

    }

  }
  timeToSeconds(time: string): number {
    const [hours, minutes, seconds] = time.split(":").map(Number);
    return hours * 3600 + minutes * 60 + seconds;
  }

  moveControlBar() {
    const controlBar = this.player?.controlBar?.el();
    if (controlBar && this.controlsContainer?.nativeElement) {
      this.controlsContainer.nativeElement.appendChild(controlBar);
    }
  }
  playerBorderRadius() {
    const videoTechElement = this.el.nativeElement.querySelector('.video-tag');
    if (this.valSelect1Video.value === 1 && videoTechElement) {
      if (this.fullScreen) {
        this.renderer.setStyle(videoTechElement, 'border-radius', '0px');
      } else {
        if (this.isMobileDevice()) {
          this.renderer.setStyle(videoTechElement, 'border-radius', '10px 10px 10px 10px');
        }

      }

    } else {
      if (videoTechElement) {
        this.renderer.setStyle(videoTechElement, 'border-radius', '0px');
      }
      if (this.isMobileDevice()) {
        this.renderer.setStyle(videoTechElement, 'border-radius', '10px 10px 10px 10px');
      }
    }
  }
  detectDevice(): string {
    const ua = navigator.userAgent;

    // Regras simples baseadas no User-Agent para detectar dispositivos móveis
    if (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(ua.toLowerCase())) {
      // Detecção adicional para diferenciar entre celular e tablet pode ser necessária
      if (window.innerWidth < 800) { // Supondo uma largura de tela como heurística
        return 'mobile';
      } else {
        return 'tablet';
      }
    } else {
      return 'desktop';
    }
  }
  isMobileIOS(): boolean {
    const userAgent = navigator.userAgent || navigator.vendor;
    return /iPad|iPhone|iPod/.test(userAgent);
  }

  isIpad(userAgent: string): boolean {
    const ipadRegex = /iPad/i;
    return ipadRegex.test(userAgent);
  }
  @ViewChild('videoContainer') videoContainerRef?: ElementRef;
  marginTopVideo() {
    // const videoJsDivs = document.getElementsByClassName('video-js');
    // const videoContainer = document.getElementsByClassName('videoUploadContainer');
    // //const btnsPlaySeek = document.getElementsByClassName('ss-l-rpf-bar');
    // const videoTechElement = this.el.nativeElement.querySelector('.vjs-tech');
    // if (this.videoInnerRef) {   // 10px 10px 0px 0px
    //   if (this.videoInnerRef.nativeElement.classList.contains('ss-l-video-container-inner-landscape')) {
    //     let elementHeight = this.videoInnerRef.nativeElement.getBoundingClientRect().height;
    //     console.log("Altura do player no modo paisagem:", elementHeight);



    //     //this.renderer.setStyle(videoTechElement, 'border-radius', '0');
    //   } else {
    //     this.videoInnerRef.nativeElement.style.top = '';
    //     //this.renderer.setStyle(videoTechElement, 'border-radius', '10px 10px 10px 10px');
    //   }
    // }


    // let marginTop = 0;

    // if (videoJsDivs.length > 0 && this.videoContainerRef) {
    //   if (this.fullScreen && this.valSelect1Video.value == 2) {
    //     //const windowHeight = window.innerHeight;
    //     let videoHeight = (videoJsDivs[0] as HTMLElement).offsetHeight;
    //     let videoWidth = (videoJsDivs[0] as HTMLElement).offsetWidth;
    //     let videoContainerHeight = this.videoContainerRef.nativeElement.offsetHeight;
    //     const userAgent = navigator.userAgent;

    //     //////////////////////
    //     const windowHeight = window.innerHeight;
    //     const windowWidth = window.innerWidth;
    //     let videoAspectRatio = videoWidth / videoHeight;

    //     const windowAspectRatio = windowWidth / windowHeight;

    //     //let videoHeight, videoWidth, marginTop;

    //     // Se a proporção da janela for maior que a proporção do vídeo, ajustar pela altura
    //     if (windowAspectRatio > videoAspectRatio) {
    //       videoHeight = windowHeight; // Faz o vídeo preencher a altura
    //       videoWidth = videoHeight * videoAspectRatio; // Ajusta a largura para manter a proporção do vídeo
    //       marginTop = 0; // Sem necessidade de ajuste vertical, pois o vídeo preenche a altura
    //     } else {
    //       // Ajusta pela largura
    //       videoWidth = windowWidth; // Faz o vídeo preencher a largura
    //       videoHeight = videoWidth / videoAspectRatio; // Ajusta a altura para manter a proporção
    //       marginTop = (windowHeight - videoHeight) / 2; // Calcula o marginTop para centralizar verticalmente
    //     }
    //     /////////////////////
    //     (videoJsDivs[0] as HTMLElement).style.top = `${marginTop}px`;
    //     if (this.isMobileIOS()) {
    //       console.log('ios')

    //       if (this.fullScreen) {
    //         marginTop = (windowHeight - videoHeight) / 2;
    //       } else {
    //         console.log(this.isIpad(userAgent));
    //         if (!this.isIpad) {
    //           marginTop = (windowHeight - videoHeight) / 2;
    //         }


    //       }
    //       console.log(marginTop);
    //       if (marginTop >= 0) {
    //         if (this.isIpad(userAgent)) {
    //           (videoJsDivs[0] as HTMLElement).style.top = '60%';
    //         } else {
    //           (videoJsDivs[0] as HTMLElement).style.top = `${marginTop}px`;
    //         }

    //       } else {
    //         //(videoJsDivs[0] as HTMLElement).style.top = '100%';
    //       }



    //     } else if (this.detectDevice() == 'mobile') {
    //       console.log('mobile')
    //       if (this.fullScreen) {
    //         marginTop = (windowHeight - videoHeight) / 2;
    //       } else {
    //         marginTop = (videoContainerHeight - videoHeight) / 2;
    //       }

    //       if (marginTop >= 0) {
    //         (videoJsDivs[0] as HTMLElement).style.top = `${marginTop}px`;
    //       } else {
    //         //(videoJsDivs[0] as HTMLElement).style.top = '100%';
    //       }
    //     } else if (this.detectDevice() == 'tablet') {
    //       console.log('tablet')
    //       if (this.fullScreen) {
    //         marginTop = (windowHeight - videoHeight) / 2;
    //       } else {
    //         marginTop = (videoContainerHeight - videoHeight) / 2;
    //       }
    //       if (marginTop >= 0) {
    //         (videoJsDivs[0] as HTMLElement).style.top = `${marginTop}px`;
    //       } else {
    //         //(videoJsDivs[0] as HTMLElement).style.top = '100%';
    //       }
    //     } else if (this.detectDevice() == 'desktop') {
    //       console.log('desktop')
    //       marginTop = 0;
    //       //console.log(window.innerWidth);
    //       if (this.fullScreen) {
    //         if (window.innerWidth >= 821) {
    //           console.log('desktop');
    //           (videoJsDivs[0] as HTMLElement).style.top = `${marginTop}px`;
    //         } else {
    //           console.log('tablet');
    //           marginTop = (windowHeight - videoHeight) / 2;
    //           (videoJsDivs[0] as HTMLElement).style.top = `${marginTop}px`;
    //         }
    //       } else {
    //         //(videoJsDivs[0] as HTMLElement).style.top = '100%';
    //       }

    //     }
    //   } else if (this.valSelect1Video.value == 2) {
    //     marginTop = 100;
    //     //(videoJsDivs[0] as HTMLElement).style.marginTop = `${marginTop}%`;

    //     (videoJsDivs[0] as HTMLElement).style.top = `${marginTop}%`;
    //     // if (!this.typeLive) {
    //     //   (btnsPlaySeek[0] as HTMLElement).style.top = `${marginTop + 50}%`;
    //     // }


    //   } else if (this.valSelect1Video.value == 1) {
    //     marginTop = 0;
    //     //(videoJsDivs[0] as HTMLElement).style.marginTop = `${marginTop}%`;
    //     if (marginTop < 0) {
    //       marginTop = 0;
    //     }
    //     (videoJsDivs[0] as HTMLElement).style.top = `${marginTop}%`;
    //     // if (!this.typeLive) {
    //     //   (btnsPlaySeek[0] as HTMLElement).style.top = `${marginTop + 50}%`;
    //     // }
    //   } else if (this.valSelect1Video.value == 2 && this.fullScreen && this.isMobile) {
    //     marginTop = 100;
    //     (videoJsDivs[0] as HTMLElement).style.top = `${marginTop}%`;

    //     if (this.videoUploadContainerInside) {
    //       let elementHeight = this.videoUploadContainerInside.nativeElement.getBoundingClientRect().height;
    //       // let offsetTop = `calc(50% - ${elementHeight / 2}px)`;
    //       // this.videoUploadContainerInside.nativeElement.style.top = offsetTop;

    //     }
    //   }


    // }
  }


  marginTopVideo2() {
    // const videoJsDivs = document.getElementsByClassName('video-js');
    // if (videoJsDivs.length > 0) {
    //   console.log('ajustando video');
    //   if (this.fullScreen && this.valSelect1Video.value == 2) {
    //     // Calcula a altura da janela e do vídeo
    //     const windowHeight = window.innerHeight;
    //     const videoHeight = (videoJsDivs[0] as HTMLElement).offsetHeight;

    //     // Verifica se o vídeo está em formato retrato (9/16)
    //     const videoWidth = (videoJsDivs[0] as HTMLElement).offsetWidth;
    //     const isPortrait = (videoHeight / videoWidth) >= (1.76);
    //     console.log(videoHeight);
    //     console.log(videoWidth);
    //     const aspectRatio = 1.76;
    //     const windowWidth = window.innerWidth;
    //     const expectedVideoHeight = windowWidth * aspectRatio;
    //     console.log('ajustando top')
    //     let marginTop = 0;

    //     if (this.isMobileDevice()) {
    //       marginTop = (windowHeight - videoHeight) / 2;
    //     }

    //     //if(this.isLandscape()){
    //     console.log(videoHeight);
    //     console.log(videoWidth);




    //     if (videoHeight / videoWidth == 108 / 192) {
    //       if (videoHeight == 171) {
    //         (videoJsDivs[0] as HTMLElement).style.marginTop = `${marginTop}px`;
    //       } else {
    //         (videoJsDivs[0] as HTMLElement).style.marginTop = '10%';
    //       }
    //       console.log('108/192');

    //     } else if (videoHeight / videoWidth == 194 / 346) {
    //       console.log('194/346');
    //       (videoJsDivs[0] as HTMLElement).style.justifyContent = 'center';
    //     } else if (this.isLandscape()) {
    //       console.log('land');
    //       (videoJsDivs[0] as HTMLElement).style.marginTop = '0%';
    //     } else if (this.isMobile) {
    //       console.log('mob');
    //       if (navigator.maxTouchPoints > 0) {
    //         (videoJsDivs[0] as HTMLElement).style.marginTop = '40%';
    //       } else {
    //         (videoJsDivs[0] as HTMLElement).style.marginTop = `${marginTop}px`;
    //       }

    //     } else if (navigator.maxTouchPoints > 0) {
    //       console.log('touch');
    //       (videoJsDivs[0] as HTMLElement).style.marginTop = '40%';
    //     } else {
    //       console.log('desk');
    //       (videoJsDivs[0] as HTMLElement).style.marginTop = `${marginTop}px`;
    //     }
    //     if (this.isLandscape()) {
    //       console.log('land');
    //       (videoJsDivs[0] as HTMLElement).style.marginTop = '0%';
    //     } else if (this.detectDevice() == 'mobile') {
    //       (videoJsDivs[0] as HTMLElement).style.marginTop = `${marginTop}px`;
    //     } else if (this.detectDevice() == 'tablet') {
    //       (videoJsDivs[0] as HTMLElement).style.marginTop = '40%';
    //     } else {

    //     }
    //     // if (isPortrait) { ismo
    //     //   console.log("portrait")
    //     //   // Para vídeos retrato, ajusta a margem apenas se a altura do vídeo for menor que a da janela
    //     //   if (expectedVideoHeight < windowHeight) {
    //     //     console.log("portrait2")
    //     //     marginTop = (windowHeight - expectedVideoHeight) / 2;
    //     //   }
    //     // } else {
    //     //   console.log("portrait3")
    //     //   // Para vídeos não retrato, usa o cálculo normal 412
    //     //   // marginTop = (windowHeight - videoHeight) / 2;
    //     //   // marginTop = marginTop-50;
    //     // }
    //     // console.log("portrait4");        // Aplica a margem superior calculada
    //     // //(videoJsDivs[0] as HTMLElement).style.marginTop = `${marginTop}px`;
    //     // (videoJsDivs[0] as HTMLElement).style.marginTop = '';
    //   } else if (this.valSelect1Video.value == 2) {
    //     const marginTop = '60';
    //     (videoJsDivs[0] as HTMLElement).style.marginTop = `${marginTop}%`;

    //   } else {
    //     (videoJsDivs[0] as HTMLElement).style.marginTop = '';
    //   }

    // } else {
    //   console.log('não ajustando video');
    //   (videoJsDivs[0] as HTMLElement).style.marginTop = '';
    // }
  }
  isLandscape() {
    // Verifica a orientação usando a propriedade screen.orientation.type, se disponível
    if (screen.orientation && screen.orientation.type) {
      return screen.orientation.type.startsWith('landscape');
    } else {
      // Fallback usando a relação entre a largura e altura da janela
      return window.innerWidth > window.innerHeight;
    }
  }
  private applySwiperStyles2(containerWidth: number): void {
    const swiperSlides = this.gridContainer?.nativeElement.querySelectorAll('.mySwiperThird .swiper-slide') as NodeListOf<HTMLElement>;
    if (!swiperSlides) return;

    swiperSlides.forEach(swiperSlide => {
      if (containerWidth < 600) {
        swiperSlide.style.width = '80%';
      } else if (containerWidth < 960) {
        swiperSlide.style.width = '50%';
      } else if (containerWidth < 1280) {
        swiperSlide.style.width = '30%';
      } else {
        swiperSlide.style.width = '25%';
      }
    });
  }
  selectedSlideIndex: number = 0;
  // Abre a Sidebar com os produtos do slide específico

  private applySwiperStyles3(containerWidth: number): void {
    const swiperSlides = this.gridContainer?.nativeElement.querySelectorAll('.mySwiperSecond .swiper-slide') as NodeListOf<HTMLElement>;
    if (!swiperSlides) return;

    swiperSlides.forEach(swiperSlide => {
      // Para `configSwiperSecond.slidesPerView` numérico, o Swiper controla o width em px.
      // Então não setamos width manualmente aqui (isso estava brigando com o Swiper).
      swiperSlide.style.width = '';
    });
  }
  private applySwiperStyles(containerWidth: number): void {
    const swiperSlides = this.gridContainer?.nativeElement.querySelectorAll('.mySwiper .swiper-slide') as NodeListOf<HTMLElement>;
    if (!swiperSlides) return;

    swiperSlides.forEach(swiperSlide => {
      if (containerWidth < 600) {
        swiperSlide.style.width = '75%';
      } else if (containerWidth < 960) {
        swiperSlide.style.width = '50%';
      } else if (containerWidth < 1280) {
        swiperSlide.style.width = '30%';
      } else {
        swiperSlide.style.width = '25%';
      }
    });
  }
  private cleanupResizeObserver() {
    if (this.resizeObserver) {
      console.log("disconnect");
      this.resizeObserver.disconnect();
      this.resizeObserver = undefined;
    }
  }
  setupResizeObserver() {

    this.cleanupResizeObserver();

    this.resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        this.adjustGridColumn(entry.contentRect.width);
      }
    });

    if (this.gridContainer) {
      this.resizeObserver.observe(this.gridContainer.nativeElement);
    }
  }
  top1: number = 9;
  top2: number = 8; // alertas
  center: number = 9.5;
  bottom0: number = 5; // description
  bottom1: number = 6; // custom
  bottom2: number = 15; // produtos
  bottom3: number = 35; //swiper links
  ml: number = 20;
  mc: number = 65;
  mr: number = 15;
  adjustBottom3: number = 0;
  adjustGridColumn(width: number) {
    let columns: string;
    this.ml = 20;
    this.mc = 65;
    this.mr = 15;
    if (width < 350) {
      this.center = 9.5; // original
      this.bottom3 = 47.5; // original
      columns = `${this.ml}% ${this.mc}% ${this.mr}%`; // Example for XSmall screens
    } else if (width >= 350 && width < 400) {
      /////////////////////
      this.center = 12.5;
      this.bottom3 = 44.5;
      this.ml = this.ml - 5;
      this.mc = this.mc + 5;
      //this.mr = this.mr - 5;
      columns = `${this.ml}% ${this.mc}% ${this.mr}%`;
    } else if (width >= 400 && width < 600) {
      this.center = 12.5;
      this.bottom3 = 44.5;
      /////////////////////
      this.mc = this.mc - 5;
      this.mr = this.mr + 5;
      columns = `${this.ml}% ${this.mc}% ${this.mr}%`; // Example for Small screens
    } else if (width >= 600 && width < 960) {
      this.center = 12.5; // original
      this.bottom3 = 44.5;
      columns = `${this.ml}% ${this.mc}% ${this.mr}%`;
    } else if (width >= 960 && width < 1280) {
      this.center = 13.5; // original
      this.bottom3 = 43.5; // original
      this.ml = this.ml - 13;
      this.mc = this.mc + 21;
      this.mr = this.mr - 8;
      columns = `${this.ml}% ${this.mc}% ${this.mr}%`;
    } else if (width >= 1280 && width < 1920) {
      this.center = 13.5; // original
      this.bottom3 = 43.5;
      this.ml = this.ml - 15;
      this.mc = this.mc + 25;
      this.mr = this.mr - 10;
      columns = `${this.ml}% ${this.mc}% ${this.mr}%`;
    } else {
      this.center = 13.5; // original
      this.bottom3 = 43.5;
      this.ml = this.ml - 15;
      this.mc = this.mc + 25;
      this.mr = this.mr - 10;
      columns = `${this.ml}% ${this.mc}% ${this.mr}%`;
    }
    this.adjustBottom3 = (this.ml + this.mc);
    if (this.gridContainer) {
      this.gridContainer.nativeElement.style.gridTemplateColumns = columns;
    }
    this.applySwiperStyles2(width);
    this.applySwiperStyles(width);
    this.applySwiperStyles3(width);

    this.sum100();
  }
  handleDivClick(event: Event): void {
    event.stopPropagation(); // Isso sempre será chamado.
    if (this.fullViewActive) {
      this.goVerMaisFechar();
    }
    // Aqui, você não faz nada se fullViewActive for false.
  }

  ngAfterViewInit() {
    // Desconecta o observer anterior antes de criar outro — sem isso, cada
    // chamada (aqui, em updateLinksDisplay e em toggleShowCTAs) deixava um
    // ResizeObserver órfão ainda ativo, disparando pra sempre a cada resize.
    this.resizeObserverBreakPoints?.disconnect();
    this.resizeObserverBreakPoints = new ResizeObserver(entries => {
      for (const entry of entries) {
        const width = entry.contentRect.width;
        this.applySwiperStyles(width);
        this.applySwiperStyles2(width);
        this.applySwiperStyles3(width);
      }
    });

    if (this.gridContainer) {
      this.resizeObserverBreakPoints.observe(this.gridContainer.nativeElement);
    }
    //this.cdr.detectChanges();
    this.setupResizeObserver();
    this.updateProgressBarPosition();

    setTimeout(() => this.updateManagerPanelFixedState(), 0);
    const managerPreviewEl = this.fullscreenWrapperRef?.nativeElement;
    if (managerPreviewEl && typeof ResizeObserver !== 'undefined') {
      this.managerPanelResizeObserver = new ResizeObserver(() => this.updateManagerPanelFixedState());
      this.managerPanelResizeObserver.observe(managerPreviewEl);
    }


  }
  progressBarTop: string = '0px';
  updateProgressBarPosition(): void {
    if (this.gridContainer) {
      const gridHeight = this.gridContainer.nativeElement.offsetHeight;
      this.progressBarTop = `${gridHeight - 6}px`; // Posição dinâmica para a barra

      document.documentElement.style.setProperty('--progress-bar-top-time', `${gridHeight - 150}px`);
      //this.cdr.detectChanges();
    }
  }
  updateDynamicStyle() {
    const heightInPixels = window.innerHeight;
    this.dynamicStyle = this.isFullScreen ? { 'width': '100vw', 'border-radius': '0px' } : {};
    this.updateProgressBarPosition();
  }
  private observer?: MutationObserver;

  isDragDrop: boolean = false;
  dragDrop(x: number, event?: Event) {
    if (event) {
      event.stopPropagation(); // Previne que o clique se propague e desative o drag and drop
    }

    if (x === 0) {
      this.isDragDrop = true;
    } else {
      this.isDragDrop = false;
    }
    console.log('DragDrop status:', this.isDragDrop);
  }
  onReorder(event: any) {
    this.isDragDrop = false;
    console.log('Reordered, DragDrop status:', this.isDragDrop);
    this.debounceFunction();
    // this.setupFilteredLinks();
    // this.setupFilteredLinksShortucut();
    this.setupFilteredLinksUnificado();
  }
  onTouchStart(event: Event) {
    this.isDragDrop = true;
    console.log('Touch start, DragDrop status:', this.isDragDrop);
  }

  onTouchMove(event: Event) {
    this.isDragDrop = true;
    if (this.isDragDrop) {
      event.preventDefault(); // Previne o comportamento padrão de scroll
    }
  }

  onTouchEnd(event: Event) {
    this.isDragDrop = false;
    console.log('Touch ended, DragDrop status:', this.isDragDrop);
  }

  ////////////////////////////////////////////////

  sidebarChat?: boolean = true; // Inicialmente, mostrar o sidebar hhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhh
  // this.openSreenChat();
  screenChat: boolean = false;
  @ViewChild('chatBoxComponent') chatBoxComponent?: ChatAppComponent;
  openSreenChat() {  // onSplitterResizeEnd
    this.screenChat = this.screenChat == true ? false : true;
    if (this.chatBoxComponent) {
      this.chatBoxComponent.loadMessages();
    }
    //this.adjustVideoMargin();
  }

  // Botão de chat interno do slick-detail: em vez da sidebar local (screenChat),
  // abre direto a sidebar de Chat global (app.profilesidebar), já listando a
  // conversa deste slick. Usa o mesmo currentSlickChatContext que o botão de
  // chat do header usa, pra nunca dessincronizar entre os dois.
  openGlobalChat(): void {
    const ctx = this.layoutService.currentSlickChatContext;
    if (!ctx) return;
    this.layoutService.openDirectChat(ctx.uuid, ctx.description, ctx.thumbnail);
  }
  pinnedMessages: any[] = [];
  fecharChat() { // TabViewModul 
    this.screenChat = false;
  }
  setupFilteredAlerts(): void {
    const filteredAlerts = (this.alertsTabs || []).filter(alert => alert.show_item);
    // ðŸ”¹ Atualizar os arrays
    this.pinnedMessages = [...filteredAlerts];
  }
  selectedTab: any = null;
  onTabChange(event: any): void {
    this.selectedTab = this.tabs[event.index];
  }

  toggleSidebar() {
    this.displaySidebarBottom = !this.displaySidebarBottom;
    // if (this.displaySidebarBottom) {
    //   document.body.classList.add('no-scroll');
    // } else {
    //   document.body.classList.remove('no-scroll');
    // }
  }
  carouselResponsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 3,
      numScroll: 3
    },
    {
      breakpoint: '768px',
      numVisible: 2,
      numScroll: 2
    },
    {
      breakpoint: '560px',
      numVisible: 1,
      numScroll: 1
    }
  ];
  products!: Produto[];


  screenPromos?: boolean = false;
  openScreenPromos() {
    this.screenPromos = this.screenPromos == true ? false : true;
  }
  screenSaibaMais?: boolean = true;
  openSreenSaibaMais() {
    this.screenSaibaMais = this.screenSaibaMais == true ? false : true;
  }
  screenWhatsBtn?: boolean = false;
  screenWhats() {
    this.screenWhatsBtn = this.screenWhatsBtn == true ? false : true;
  }
  screenAlertsBtn?: boolean = true;
  screenAlerts() {
    this.screenAlertsBtn = this.screenAlertsBtn == true ? false : true;
  }

  pageStudioNow: string = '';
  openCTA() { // openSidebar
    this.mananger = 1;
    this.pageStudio = 'Studio ';
    this.pageStudioNow = '> Elementos Interativos';
    //this.loadPromotions()
    setTimeout(() => this.attachSourceScrollListener(), 0);
  }
  openConfigs() {
    this.mananger = 2;
    this.pageStudio = 'Studio ';
    this.pageStudioNow = '> Configurações e Estilos';
  }
  openAB() {
    this.mananger = 3;
    this.pageStudio = 'Studio ';
    this.pageStudioNow = '> Teste A/B';
  }
  openAnalytics() {
    this.mananger = 4;
    this.pageStudio = 'Studio ';
    this.pageStudioNow = '> Analytics';
  }

  openChapters() {
    this.mananger = 5;
    this.pageStudio = 'Studio ';
    this.pageStudioNow = '> Capítulos';
  }

  addChapter() {
    const lastSeconds = this.chapters.length > 0
      ? this.chapterTimeToSeconds(this.chapters[this.chapters.length - 1].time) + 1
      : 0;
    const newTime = this.secondsToVttTime(Math.min(lastSeconds, Math.max(0, Math.floor(this.videoDurationSeconds) - 1)));
    this.chapters = [...this.chapters, { title: '', time: newTime }];
    this.refreshChapterDropdownOptions();
    this.generateAndInjectVtt();
    this.debounceFunction();
    this.pushLiveUpdate();
  }

  removeChapter(index: number) {
    this.chapters = this.chapters.filter((_, i) => i !== index);
    this.refreshChapterDropdownOptions();
    this.generateAndInjectVtt();
    this.debounceFunction();
    this.pushLiveUpdate();
  }

  onChaptersEnabledChange(enabled: boolean) {
    if (enabled && this.chapters.length === 0) {
      this.chapters = [{ title: '', time: '00:00:00' }];
    }
    if (enabled && this.chapters[0]?.time !== '00:00:00') {
      this.chapters[0].time = '00:00:00';
    }
    this.refreshChapterDropdownOptions();
    this.generateAndInjectVtt();
    this.debounceFunction();
    this.pushLiveUpdate();
  }

  onChapterChange() {
    this.generateAndInjectVtt();
    this.debounceFunction();
    this.pushLiveUpdate();
  }

  onChapterTimeChange(index: number): void {
    if (index === 0) return;
    const chapter = this.chapters[index];
    if (!chapter) return;

    const seconds = this.chapterTimeToSeconds(chapter.time);
    const maxSeconds = Math.floor(this.videoDurationSeconds) - 1;

    // Regra 0: o mask "99:99:99" aceita qualquer dígito em cada posição, então
    // dá pra digitar minuto/segundo "99" (o PrimeNG InputMask não tem uma
    // sintaxe nativa pra limitar a dezena a 0-5). Em vez de bloquear a
    // digitação, normalizamos igual um cronômetro faria: 00:01:99 (99s) vira
    // 00:02:39 (o "seconds" já soma tudo certo, chapterTimeToSeconds não se
    // importa com overflow — só precisamos reescrever a string formatada).
    const normalized = this.secondsToVttTime(seconds);
    if (normalized !== chapter.time) {
      this.chapters = this.chapters.map((c, i) => i === index ? { ...c, time: normalized } : c);
    }

    // Regra 4: não pode ultrapassar a duração do vídeo
    if (seconds >= this.videoDurationSeconds) {
      const corrected = this.secondsToVttTime(Math.max(0, maxSeconds));
      this.chapters = this.chapters.map((c, i) => i === index ? { ...c, time: corrected } : c);
      this.refreshChapterDropdownOptions();
      this.generateAndInjectVtt();
      this.messageService.add({ severity: 'warn', summary: 'Aviso', detail: 'O tempo não pode ultrapassar a duração do vídeo.' });
      this.pushLiveUpdate();
      return;
    }

    // Regra 3: deve ser maior que o capítulo anterior
    const prevSeconds = this.chapterTimeToSeconds(this.chapters[index - 1].time);
    if (seconds <= prevSeconds) {
      const corrected = this.secondsToVttTime(Math.min(prevSeconds + 1, maxSeconds));
      this.chapters = this.chapters.map((c, i) => i === index ? { ...c, time: corrected } : c);
      this.refreshChapterDropdownOptions();
      this.generateAndInjectVtt();
      this.messageService.add({ severity: 'warn', summary: 'Aviso', detail: 'O tempo deve ser maior que o capítulo anterior.' });
      this.pushLiveUpdate();
      return;
    }

    this.generateAndInjectVtt();
    this.debounceFunction();
    this.pushLiveUpdate();
  }

  openDetails() {
    this.mananger = 6;
    this.pageStudio = 'Studio ';
    this.pageStudioNow = '> Detalhes';
  }
  openIntegrations() {
    this.mananger = 7;
    this.pageStudio = 'Studio ';
    this.pageStudioNow = '> Integrações';
  }





  menuInferior: MenuItem[] = [];

  private buildMenuInferior(): void {
    this.menuInferior = [
      {
        label: 'Ver Slick',
        icon: 'pi pi-eye',
        command: () => this.redirectToSlick(),
        disabled: this.verSlickStatus
      },
      {
        label: 'Compartilhar',
        icon: 'pi pi-share-alt',
        command: () => this.compartilhar()
      }
    ];
  }

  async comp2() {
    Share.share({
      title: 'Teste',
      text: 'Esse é um texto de teste',
      url: 'https://example.com',
      dialogTitle: 'Compartilhar com'
    });
  }

  isSharing: boolean = false;
  async compartilhar() {

    const currentUrl = window.location.href;
    const uidMatch = currentUrl.match(/\/slick\/([^/]+)/);
    const uid = uidMatch ? uidMatch[1] : '';

    if (!uid) {
      console.error('UID não encontrado na URL atual.');
      return;
    }
    ///////////////////////
    const domainStore = localStorage.getItem('domain_store') || '';
    const subdomain = domainStore.split('.')[0] || '';
    let shareUrl = `${environment.frontendUrl}/${subdomain}?slick_id=${uid}`;
    // Garante que só adiciona https:// se estiver faltando
    if (!/^https?:\/\//i.test(shareUrl)) {
      shareUrl = 'https://' + shareUrl;
    }

    // Remove qualquer http:// ou https:// do começo
    shareUrl = shareUrl.replace(/^https?:\/\//i, '');

    // Adiciona https:// somente uma vez
    shareUrl = 'https://' + shareUrl;
    this.isSharing = true;
    if (Capacitor.isNativePlatform()) {
      // App nativo
      try {
        await Share.share({
          title: 'Compartilhar Link',
          text: 'Veja esse conteúdo!',
          url: shareUrl,
          dialogTitle: 'Compartilhar via'
        });
      } catch (err) {
        console.error('Erro ao compartilhar:', err);
      }
    } else if (navigator.share) {
      // Navegador moderno
      try {
        await navigator.share({
          title: 'Compartilhar Link',
          url: shareUrl
        });
      } catch (err) {
        console.error('Erro ao compartilhar no navegador:', err);
      }
    } else {
      alert('Compartilhamento não suportado neste dispositivo.');
    }
    ///////////////////////
  }

  displayRTMPInofos: boolean = false;
  rtmpInfos = () => {
    console.log('rtmpInfos');
    this.displayRTMPInofos = true;
  }

  recarregarSaldo() {
    this.openSidebarSaldo();
    // Ação para 'Recarregar Saldo'
  }
  mananger: number = 0;
  pageStudio: string = 'Studio';



  //////////////////////// player recorders //////////////////////////
  stream?: MediaStream | null = null;
  currentCameraId: string | null = null;
  autoplay: boolean = false;
  dialogVisible: boolean = false;
  errorMessage: string = '';
  showError(message: string): void {
    this.errorMessage = message;
    this.dialogVisible = true;
  }
  dialogVisibleError: boolean = false;
  showErrorDisconnect(message: string): void {
    this.errorMessage = message;
    this.dialogVisibleError = true;
  }

  closeDialog() {
    this.dialogVisible = false;
  }
  closeDialogError() {
    this.dialogVisibleError = false;
  }
  showCountdown: boolean = true;
  countdownMessage: string = '';
  countdownStyle = {
    'font-size': '0vw',
    opacity: '0%'
  };
  timer: any;  // Adicione isso na classe para manter referência ao timer
  counter: number = 3;
  startCountdown = (x: number) => {
    let counter = 3;
    if (x >= 1) {
      counter = 0;
    }
    if (x < 0) {
      x = 3;
    }


    console.log('counter: ' + counter);
    return new Promise((resolve, reject) => {  // Inclua reject para poder rejeitar a promessa em caso de erro
      this.showCountdown = true;
      this.timer = setInterval(() => {
        this.countdownMessage = counter === 0 ? '' : counter.toString();
        this.countdownStyle = {
          'font-size': '40vw',
          opacity: '100%',
        };

        setTimeout(() => {
          this.countdownStyle.opacity = '0%';
        }, 900);

        counter--;

        if (counter < 0) {
          this.showCountdown = false;
          this.firstSuccessfulSend = true;
          clearInterval(this.timer);
          resolve(true);
          //if (x == 0) {
          this.startRecordingTimeCounter();
          //}
        }
      }, 1000);
    });
  };
  cancelCountdown = () => {
    clearInterval(this.timer); // Limpa o intervalo do timer
    this.showCountdown = false;
    this.countdownMessage = '';
  };
  lastData: Blob | null = null;
  heartbeatInterval: any = null;


  fallbackVideo: boolean = false;
  pauseSlick: boolean = false;
  videoChunks: Blob[] = [];
  isPaused: boolean = true;
  firstSuccessfulSend = false;
  private recorder?: typeof RecordRTC;
  private fallbackRecorder?: typeof RecordRTC;
  sendMonitorTimeout: any = null;



  // Função para iniciar ou resetar o temporizador de monitoramento
  async stopAndResetRecording() {
    this.resetRecordingTimer(); // Reseta o timer e zera a contagem
  }

  resetRecordingTimer() {
    clearInterval(this.recordingTimerInterval);
    this.recordingTimerInterval = undefined;
    this.recordingTimeSeconds = 0; // Zera o contador de tempo de gravação
    this.elapsedTimeBeforePause = 0; // Zera o tempo guardado antes de uma pausa
  }
  recordingTimeSeconds: number = 0;
  recordingInterval: any;
  recordingTimerInterval?: any;

  countdownSeconds: number = 300;
  countdownInterval?: any;
  startCountdownPause() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
    this.countdownInterval = setInterval(() => {
      if (this.countdownSeconds > 0) {
        this.countdownSeconds--;
      } else {
        clearInterval(this.countdownInterval);
      }
    }, 1000);
  }
  resetCountdownPause() {
    clearInterval(this.countdownInterval);
    this.countdownSeconds = 300;
  }


  elapsedTimeBeforePause = 0;
  startRecordingTimeCounter() {
    if (this.recordingTimerInterval !== undefined) return;

    // Recuperar o tempo decorrido do localStorage
    const savedTime = localStorage.getItem('elapsedTimeBeforePause');
    this.elapsedTimeBeforePause = savedTime ? parseInt(savedTime, 10) : 0;

    console.log('Reiniciando o contador de tempo com elapsedTimeBeforePause:', this.elapsedTimeBeforePause);
    const startTime = Date.now() - (this.elapsedTimeBeforePause * 1000);
    this.recordingTimerInterval = setInterval(() => {
      if (this.cliclkStop) {
        this.stopRecordingTimer();
      } else {
        const currentTime = Date.now();
        this.recordingTimeSeconds = Math.floor((currentTime - startTime) / 1000);

        console.log('Tempo atualizado:', this.recordingTimeSeconds);
      }

    }, 1000);
  }
  formatTime(seconds: number): string {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const sec = seconds % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`;
  }
  stopRecordingTimer() {
    if (this.recordingTimerInterval !== undefined) {
      clearInterval(this.recordingTimerInterval);
      this.recordingTimerInterval = undefined;
    }
    this.recordingTimeSeconds = 0; // Garante que o contador é zerado para nova gravação
    this.elapsedTimeBeforePause = 0; // Reseta o tempo decorrido antes da pausa

    // Limpar o valor salvo no localStorage
    localStorage.removeItem('elapsedTimeBeforePause');

  }
  stopRecordingTimerPause() {
    if (this.recordingTimerInterval !== undefined) {
      this.elapsedTimeBeforePause = this.recordingTimeSeconds;
      clearInterval(this.recordingTimerInterval);
      this.recordingTimerInterval = undefined;
      console.log('Timer pausado em:', this.elapsedTimeBeforePause);
      localStorage.setItem('elapsedTimeBeforePause', this.elapsedTimeBeforePause.toString());
    }
  }

  closeDialogConfirmation() {
    this.showConfirmDialog = false;
  }

  stopTransmission() {
    this.showConfirmDialog = true;
  }

  hasErrorLive: boolean = false;

  async pause() {
    if (this.pauseSlick) {
      // Retomar a transmissão ao vivo
      this.liveStatusService.setState('online');
      this.websocketService.sendMessage({ action: 'resume' });
      console.log('chamando start');
      await this.startRecording(2); // Reinicia a gravação sem perder o estado anterior
      this.startRecordingTimeCounter(); // Reinicia a contagem do timer de onde parou
      this.pauseSlick = false;
      this.resetCountdownPause();
    } else {
      // Pausar a transmissão ao vivo
      this.liveStatusService.setState('idle');
      if (this.recorder) {
        await this.recorder.stopRecording();
        this.websocketService.sendMessage({ action: 'pause' });
        // Para o timer de gravação e salva o tempo decorrido
        this.stopRecordingTimerPause();
        this.pauseSlick = true;
        this.startCountdownPause();
      }


    }
  }
  cliclkStop: boolean = false;
  async startRecording(x: number): Promise<boolean> {
    if (x == 0) {
      this.reconnectAttempts = 0;
    }

    if (!this.encontrouCam) {
      this.handleSocketError('list cam', '');
      return false;
    }

    this.showCountdown = true;
    this.firstSuccessfulSend = false;
    this.cliclkStop = false;
    this.hasErrorLive = false;
    this.initNewStream = false;
    //getUserMedia recording
    try {
      await this.connection();
    } catch (error) {
      let msg = 'Não foi possível estabelecer a conexão.';
      this.showError(msg);
      return false;
    }

    try {
      let constNumber = 9 / 16;
      if (this.valSelect1Video.value == 2) {
        constNumber = 16 / 9;
      }
      if (!this.isMobile) {
        console.log('desktop');
        this.stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
          video: {
            deviceId: { exact: this.currentCameraId ? this.currentCameraId : undefined },
            aspectRatio: { ideal: constNumber }
          },
        });
      } else {
        console.log('mobile');
        let constNumberWidth = 1920;
        let constNumberHeight = 1080;
        if (this.valSelect1Video.value == 2) {
          constNumberWidth = 1080;
          constNumberHeight = 1920;
        }
        this.stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
          video: {
            deviceId: { ideal: this.currentCameraId ? this.currentCameraId : undefined },
            width: { ideal: constNumberWidth },
            height: { ideal: constNumberHeight }
          },
        });
      }
      console.log('gravando')
      this.startCountdown(x);
      if (this.videoElementRef) {
        this.videoElementRef.nativeElement.srcObject = this.stream;
        if (!this.player) {
          if (typeof videojs !== 'undefined') {
            this.player = videojs(this.videoElementRef.nativeElement, {
              controls: false
            });
          }
        }

        this.player.ready(() => {
          const fullscreenButton = this.player.controlBar.getChild('FullscreenToggle');
          const index = this.player.controlBar.children().indexOf(fullscreenButton);
          this.player.controlBar.removeChild(fullscreenButton);

          const myButton = this.player.controlBar.addChild('button', {}, index);
          this.myButtonDom = myButton.el();
          this.myButtonDom.innerHTML = "<i class='pi pi-window-maximize active' style='cursor:pointer;'></i>";
          this.myButtonDom.onclick = () => {
            if (this.fullScreen) {
              this.goMinscreen();
            } else {
              this.goFullscreen();
            }
          };

          // Remove o botão PiP (se estiver disponível)
          if (this.player.controlBar.pictureInPictureToggle) {
            this.player.controlBar.removeChild('pictureInPictureToggle');
          }
          // Remove o controle de volume padrão
          this.player.controlBar.removeChild('volumePanel');



        });
      } else {
        let msg = 'Não foi possível encontrar player de gravação.';
        this.showError(msg);
        return false;
      }

      if (!this.micShow) {
        if (this.stream) {
          // Acessa todas as faixas de áudio da stream
          this.stream.getAudioTracks().forEach(track => {
            // Alterna o estado de 'enabled' da faixa
            track.enabled = !track.enabled;
          });
        }
      }
      this.websocketService.startStream();
      this.recorder = new RecordRTC(this.stream, {
        type: 'video',
        mimeType: 'video/webm',
        bitsPerSecond: 3000000,
        timeSlice: 1000, // Invoca o callback a cada 1000ms (1 segundo) Tempo de gravação
        ondataavailable: (blob: Blob) => {

          console.log('pauseSlick: ' + this.pauseSlick)
          console.log('cliclkStop: ' + this.cliclkStop)
          console.log('recording: ' + this.recording)
          console.log('hasErrorLive: ' + this.hasErrorLive)
          if (this.hasErrorLive) {
            this.recorder.stopRecording();
          }
          if (this.cliclkStop) {
            this.stopRecordingTimer();
          }
          if (!this.pauseSlick && !this.cliclkStop && !this.hasErrorLive && !this.initNewStream) {
            this.websocketService.sendStreamData(blob).then((enviadoComSucesso: boolean) => {
              if (enviadoComSucesso) {

                this.recording = true;
                if (!this.firstSuccessfulSend) {
                  this.firstSuccessfulSend = true; // Marca o primeiro envio bem-sucedido

                }
                if (!this.cliclkStop) {
                  this.liveStatusService.setState('online');
                }
                this.displayChangeCameraDialog = false;
                // if(this.initNewStream){

                // }

              }
            }).catch((error: Error) => {
              //console.error('Erro ao enviar dados:', error);
              this.liveStatusService.setState('offline');
            });
          }
        }
      });

      this.recorder.startRecording();


      this.autoplay = true;

      // Inicialize a gravação
      return true;

    } catch (error) {
      console.error("Erro ao acessar a mídia:", error);
      let msg = 'Não foi possível iniciar a gravação devido a um erro na conexão com a mídia.';
      this.errorCam = true;

      return false;
    }
  }

  async switchCamera(camera: MediaDeviceInfo) {
    if (this.recording) {
      //if (this.recorder) {
      this.recorder.stopRecording();
      this.recorder.destroy();
      this.recorder = null;
      //}
      this.stopRecordingTimerPause();
      if (this.stream) {
        await this.stream.getTracks().forEach(track => track.stop());
      }
      // Se já estiver gravando, prepare-se para trocar de câmera e iniciar nova transmissão
      this.initNewStream = true;
      this.changeCameraMessage = 'Trocando a câmera...';
      this.displayChangeCameraDialog = true;
      await this.stopMediaTracks(this.stream); // Encerra o stream atual
      this.currentCameraId = camera.deviceId;
      await this.updateCameraPreview(camera);
      //this.displayCameraSidebar = false;

      // Aguarde um momento antes de iniciar a nova gravação
      setTimeout(async () => {
        await this.startRecording(1);
        this.displayCameraSidebar = false;
      }, 2000);
    } else {
      // Se não estiver gravando, simplesmente atualize o preview da câmera
      await this.updateCameraPreview(camera);
      this.displayCameraSidebar = false;
    }
  }

  async updateCameraPreview(camera: MediaDeviceInfo) {
    this.initNewStream = true;
    if (this.stream) {
      await this.stream.getTracks().forEach(track => track.stop());
    }
    try {
      this.currentCameraId = camera.deviceId;
      let newStream;
      ///////////////////
      let constNumber = 9 / 16;
      if (this.valSelect1Video.value == 2) {
        constNumber = 16 / 9;
      }
      if (!this.isMobile) {
        console.log('desktop');
        newStream = await navigator.mediaDevices.getUserMedia({
          audio: true,
          video: {
            deviceId: { exact: this.currentCameraId },
            aspectRatio: { ideal: constNumber }
          },
        });
      } else {
        console.log('mobile');
        let constNumberWidth = 1920;
        let constNumberHeight = 1080;
        if (this.valSelect1Video.value == 2) {
          constNumberWidth = 1080;
          constNumberHeight = 1920;
        }
        newStream = await navigator.mediaDevices.getUserMedia({
          audio: true,
          video: {
            deviceId: { exact: this.currentCameraId },
            width: { ideal: constNumberWidth },
            height: { ideal: constNumberHeight }
          },
        });
      }
      ///////////////////
      this.stream = newStream;
      if (this.videoElementRef) {
        this.videoElementRef.nativeElement.srcObject = newStream;
      }
      this.currentCameraId = camera.deviceId;
      // Salva o novo stream
    } catch (error) {
      console.error("Erro ao atualizar preview da câmera:", error);
    }
  }


  displayChangeCameraDialog: boolean = false;
  changeCameraMessage: string = '';
  initNewStream: boolean = false;
  async listCameras() {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      this.cameras = devices.filter(device => device.kind === 'videoinput');
    } catch (error) {
      console.error("Erro ao listar câmeras:", error);
    }
  }
  async openCameraSelector() {
    try {
      if (this.recording) {
        this.listCameras();
      } else {

        if (this.cameras.length > 0) {
          this.listCameras();
        } else {
          // Solicitar acesso à câmera para garantir que as permissões sejam concedidas
          const stream = navigator.mediaDevices.getUserMedia({ video: true, audio: true });
          //stream.getTracks().forEach(track => track.stop()); // Encerra o stream, pois o objetivo é apenas solicitar permissão

          // Após a permissão ser concedida, listar as câmeras
          await this.listCameras();
        }

      }

      this.displayCameraSidebar = true; // Exibe a barra lateral para seleção de câmera
    } catch (error) {
      console.error("Erro ao acessar a câmera:", error);
      // Tratar o erro, como informar ao usuário que a permissão é necessária
    }
  }

  async listCamerasAndSetFirstAsCurrent(): Promise<void> {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const videoInputs = devices.filter(device => device.kind === 'videoinput');

      if (videoInputs.length > 0) {
        this.currentCameraId = videoInputs[0].deviceId; // Define a primeira câmera como a atual.
      } else {
        console.log('Nenhuma câmera encontrada.');
        this.currentCameraId = null;
      }

      // Se você quiser manter uma lista de todas as câmeras, você pode atribuí-las a uma variável de classe
      this.cameras = videoInputs;
    } catch (error) {
      console.error('Erro ao listar câmeras:', error);
    }
  }





  newCameraId: string | null = null;

  tert: number = 0;

  getLiveTert() {
    if (!this.uuid) {
      console.error('UUID é null ou undefined.');
      // Você pode optar por lançar um erro ou simplesmente retornar para evitar chamar o serviço.
      return;
    }
    this.liveShopService.getLiveTert(this.uuid).pipe(takeUntil(this.destroy$)).subscribe(
      response => {
        this.tert = response.tert;
      },
      error => {

      }
    );
  }

  isChangeCamButtonDisabled: boolean = false;
  encontrouCam: boolean = true;
  displayCameraSidebar: boolean = false;
  findCam(n: boolean): boolean {
    if (n) {
      return true;
    }
    this.encontrouCam = false;
    return false;
  }



  cameras: MediaDeviceInfo[] = [];
  showCounter: boolean = true;

  async getStream() {
    console.log("sw1 getStream");
    try {
      let constNumber = 9 / 16;
      if (this.valSelect1Video.value == 2) {
        constNumber = 16 / 9;
      }
      let videoConstraints = {};

      if (window.innerWidth > 768) {
        videoConstraints = {
          deviceId: { exact: this.currentCameraId }, // Use exact aqui
          aspectRatio: { ideal: constNumber }
        };
      } else {
        let constNumberWidth = 1920;
        let constNumberHeight = 1080;
        if (this.valSelect1Video.value == 2) {
          constNumberWidth = 1080;
          constNumberHeight = 1920;
        }
        videoConstraints = {
          ...(this.currentCameraId ? { deviceId: { ideal: this.currentCameraId } } : {}),
          width: { ideal: constNumberWidth },
          height: { ideal: constNumberHeight }
        };
      }

      this.stream = await navigator.mediaDevices.getUserMedia({
        audio: true,
        video: videoConstraints,
      });

      if (this.videoElementRef) {
        this.videoElementRef.nativeElement.srcObject = this.stream;
      }
    } catch (error) {
      console.error("Erro ao acessar a câmera:", error);
    }
  }

  recording: boolean = false;
  stopClicked: boolean = false;
  async stopMediaTracks(stream?: MediaStream | null) {
    this.disableRecorder = false;
    this.pauseSlick = false;
    this.recording = false;
    this.stopClicked = true;
    this.cliclkStop = true;



    if (!this.initNewStream) {
      this.stopRecordingTimer();
      this.stopAndResetRecording();
      // this.startRecordingTimeCounter();
    }

    if (stream) { // Checa se stream não é null ou undefined
      stream.getTracks().forEach((track: MediaStreamTrack) => {
        track.stop();
      });
      // enviar hook
      if (!this.pauseSlick) {
        this.liveShopService.sendHook(this.id).pipe(takeUntil(this.destroy$)).subscribe({
          next: (resp) => {
            console.log(resp)
            //
          },
          error: (err) => {

          }
        });
      }

    }
    if (this.stream) {
      this.stream.getTracks().forEach((track: MediaStreamTrack) => {
        track.stop();
      });
    }
    this.initNewStream = false;
    this.websocketService.sendMessage({ action: 'stop' });
    this.liveStatusService.setState('offline');
    this.resetRecordingTimer()
    this.stopRecordingTimer();
  }
  showConfirmDialog: boolean = false;

  async stopMediaTracksMessage(stream?: MediaStream | null) {
    if (stream) {
      stream.getTracks().forEach((track: MediaStreamTrack) => {
        track.stop();
      });
    }
  }
  baseWalletData: any;
  saldoDisponivel: string = '0.00';
  stream_status?: string;
  uniq_id?: string;

  dados: any;
  id: any;
  swalShown: boolean = false;
  // Antes de tudo, certifique-se de declarar errorSubscription no seu componente

  async connection() {
    const myStreamKey = this.dados.stream_key;
    this.websocketService.connect(myStreamKey, this.id);

    console.log('myStreamKey');
    console.log(myStreamKey);
    //return;

    this.websocketService.setRTMPDestination(myStreamKey);
    this.websocketService.setVideoCodec('libx264'); // Exemplo de codec
    this.websocketService.setTypeSlick(this.valSelect1Video.value); // Exemplo de codec

    const errorObservable = new Observable<SocketErrorEvent>((subscriber) => {
      const errorEvents = ['fatal', 'connect_error', 'disconnect', 'ffmpeg_stderr', 'exit', 'message'];
      errorEvents.forEach((event) => {
        this.websocketService.socket.on(event, (error: any) => {
          subscriber.next({ event, error });
          this.liveStatusService.handleSocketError(event, error);
        });
      });

      return () => {
        errorEvents.forEach((event) => {
          this.websocketService.socket.off(event);
        });
      };
    });

    // Subscrição correta ao Observable
    this.errorSubscription = errorObservable.pipe(takeUntil(this.destroy$)).subscribe(
      data => this.handleSocketError(data.event, data.error),
      err => console.error(err),
      () => console.log('Observable completado')
    );
    // this.websocketService.socket.on('connect', () => {
    //   this.liveStatusService.handleSocketConnect();
    // });


  }

  disconectSocket() {
    this.websocketService.disconnect();
    this.recording = false;
    clearInterval(this.timer);
    this.dialogVisibleError = false;
    if (this.stream) {
      this.stream.getTracks().forEach(track => track.stop());
      this.stream = null;
    }
  }

  errorCam: boolean = false;
  private errorSubscription?: Subscription;
  handleSocketError(event: string, error: any) {
    this.hasErrorLive = true;
    this.liveStatusService.setState('offline');

    console.log('erro do tipo: ' + event);

    this.recording = false;
    if (event === 'message') {
      if (error === 'Transmissão interrompida com sucesso.') {
        console.log(error); // Loga a mensagem
        this.liveStatusService.setState('offline'); // Atualiza o estado para 'offline'
      }
      return;
    }

    if (event === 'fatal' || event === 'exit' || event === 'ffmpeg_stderr' || event === 'disconnect' || event === 'error' || event === 'connect_error') {
      console.log('entrou no monitor de erros')

      //this.websocketService.handleError({ event: event, error });
      //this.monitorSocketErrors();
      clearInterval(this.timer);
      if (error.event !== 'disconnect') {
        if (this.reconnectAttempts === 0) {
          this.promptReconnect();
        } else if (this.reconnectAttempts === 3) {
          this.disconnectSocket();
        }
      } else {
        if (this.stream) {
          this.stopMediaTracks(this.stream);
        }
      }
      this.stopRecordingTimer();
      // //this.stopTransmission();
      // this.stopMediaTracks(this.stream);
      // if (this.stream) {
      //   this.stream.getTracks().forEach(track => track.stop());
      //   this.stream = null;
      // }
      // this.swalShown = true;
      // let msg = '';
      // this.recording = false;
      // if (event === 'fatal' && error === 'ffmpeg exit!') {
      //   msg = 'Erro no Socket. Tente novamente';
      // } else if (event === 'exit') {
      //   msg = 'Erro de pipe.';
      // } else if (event === 'connect_error') {
      //   msg = 'Um erro desconhecido ocorreu. Entre em contato ou tente novamente mais tarde.';
      //   this.showErrorDisconnect(msg);
      //   return;
      // } else if (event === 'ffmpeg_stderr') {
      //   return;
      // } else {
      //   msg = 'Um erro desconhecido ocorreu. Entre em contato ou tente novamente mais tarde.';
      // }
      // this.showError(msg);
    } else {

      console.log('evento: ' + event);

      let msg = 'Câmera não encontrada..';
      this.showError(msg);
    }
  }

  allProducts?: Item[];
  paid?: string;
  liveStreamId?: string = '0';
  like_reaction?: number = 0;
  tituloPaginaInicio?: string;
  currentTime: string = '0';

  timeM: number = 0;
  streamKey?: string;
  domainStoreValue?: string | null;
  link?: string;
  currentList?: Item[] = undefined;
  currentListCupons: Coupon[] = [];
  currentListAlerts: AnimatedText[] = [];
  tertResponse?: number;
  numViewers: number = 0;
  sessions: number = 0;
  shopping_carts?: number = 0;
  tmp?: string = '0';
  async getLiveAndUpdagte(): Promise<void> {
    try {
      //this.numViewers = await this.liveShopService.getLiveViewers(this.id).toPromise();
      const response: LiveShop = await this.liveShopService.getLive(this.id).toPromise();
      const responseData: LiveShop = await this.liveShopService.getLiveData(this.id).toPromise();
      if (this.typeLive) {
        const response2: LiveShop = await this.liveShopService.getLiveDetails(this.id).toPromise();
        if (this.liveStreamId !== undefined) {
          this.currentTime = (response2 as any)[this.liveStreamId];
        }
      }

      this.allProducts = response.items;
      this.paid = response.pay_off_amount;
      this.liveStreamId = response.liveStreamId;
      this.like_reaction = response.like_reaction;
      this.stream_status = response.stream_status;
      this.tituloPaginaInicio = response.name;


      this.tmp = response.watchedDuration;


      // analytics
      if (response.shopping_carts) {
        this.shopping_carts = response.total_users;
      }
      if (response.sessions) {
        this.sessions = response.sessions;
      }
      // analytics

      if (this.tmp !== undefined) {
        this.timeM = Math.floor((+this.tmp * 100) / (+this.currentTime / 60));
      } else {
        this.timeM = 0; // Ou algum outro valor padrão apropriado
      }

      this.timeM = isNaN(this.timeM) ? 0 : this.timeM;


      if (response.stream_key == null) {
        this.streamKey = environment.apiBaseUrl + '/live-redirect?streamkey=123';
      } else {
        this.streamKey = environment.apiBaseUrl + '/live-redirect?streamkey=' + response.stream_key;
      }

      this.dados = new ClockData();
      this.dados.id = this.id;
      this.dados.stream_key = responseData.stream_key;
      this.disableRecorder = false;

      this.listCamerasAndSetFirstAsCurrent();
      ////////////
    } catch (error) {
      console.log('Erro ao buscar dados:', error);
    }
  }
  isNumeric(value: any): boolean {
    return !isNaN(value);
  }
  formatTime2(minutes: number): string {
    if (minutes == null || isNaN(minutes)) {
      return '00:00:00';
    }
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = Math.floor(minutes % 60);
    const seconds = Math.floor((minutes * 60) % 60);

    const formattedHours = hours.toString().padStart(2, '0');
    const formattedMinutes = remainingMinutes.toString().padStart(2, '0');
    const formattedSeconds = seconds.toString().padStart(2, '0');

    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  }









  ///////////////////////////////
  recordedBlobs: BlobPart[] = [];

  private intervalId: number | null = null;
  pararEnvioImagem() {
    if (this.intervalId !== null) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  obterVideoComoBlob(): Blob {
    return new Blob(this.recordedBlobs, { type: 'video/webm' });
  }

  // Função para salvar ou manipular o Blob após a gravação
  manipularBlob() {
    const blob = this.obterVideoComoBlob();
    const url = URL.createObjectURL(blob);
    // Aqui você pode, por exemplo, salvar o Blob em um servidor ou reproduzi-lo em um elemento <video>
  }
  sourcePromotions: Promotion[] = [];
  targetPromotions: Promotion[] = [];
  targetAlerts: AlertsTab[] = [];
  sourceProducts: Produto[] = [];
  targetProducts: Produto[] = [];
  private allStoreProducts: Produto[] = [];
  //normalizeProductData
  store_id?: number;
  async loadProducts(): Promise<void> {
    this.productsService.getAppsStore('shopify').subscribe({
      next: async (response: any) => {
        const selectedStoreId = localStorage.getItem('ss_SelectedStoreId');
        let store_id;
        if (selectedStoreId) {
          this.store_id = Number(selectedStoreId);
        }

        const storeApp = response.store_apps?.find((app: any) => {
          return app.key.includes('shopify') && app.store_id === this.store_id;
        });

        if (storeApp && String(storeApp.active) === 'active') {
          const obs = await this.productsService.listProducts();
          obs.pipe(takeUntil(this.destroy$)).subscribe({
            next: (resp: any) => {
              this.sourceProducts = resp.products.map((product: ProdutoShopify) =>
                this.transformProdutoShopify(product)
              );
              if (this.uuid) {
                this.loadSlickDetails(this.uuid);
              }
            },
            error: (err: any) => {
              console.error('Erro ao carregar produtos:', err);
            },
          });
        } else {
          if (this.uuid) {
            this.loadSlickDetails(this.uuid);
          }
        }
      },
      error: (error) => {
        console.error(`Erro ao buscar detalhes do app :`, error);
      },
    });
  }

  private transformProdutoShopify(product: ProdutoShopify): Produto {
    console.log('produto montando')
    console.log(product)

    let prod = {
      id: product.id, // Extrai o ID e converte para número
      sku: product.id,
      name: product.title,
      status: 1, // Default status
      inputQty: product.inventory_quantity, // Quantidade inicial
      position: 0, // Posição inicial
      price: product.price,
      compare_at_price: product.compare_at_price,
      onsale_price: product.compare_at_price || '',
      price_exchange: '', // Não especificado
      thumbnail: product.thumbnail,
      categories: Array.isArray(product.categories)
      ? product.categories.map(c => ({ id: Number(c.id), title: String(c.title) }))
      : [],
      isSelected: false,
      show_item: true, // Default para exibir
      highlight: false, // Default para não destacar
      define_interval: false,
      show_slider: false,
      interval_time: { start: '', end: '' },
    };

    console.log('prod dps')
    console.log(prod)

    return prod;
  }
  showSplitter: boolean = false;
  show: boolean = false;
  canEditUpload = false;
  isVideo = false;
  isImage = false;

  chapters: { title: string; time: string; product_sku?: string }[] = [];
  chaptersEnabled: boolean = false;
  savingChapters: boolean = false;
  videoDurationSeconds: number = 0;
  currentVideoTime = signal(0);
  selectedChapterForProduct: string | null = null;
  displayedChapterTitle: string = '';
  private lastActiveChapterTime: string | null = null;
  private vttBlobUrl: string | null = null;
  private chapterTrackEl: HTMLTrackElement | null = null;

  progressTooltip: { time: string; chapterTitle: string; duration: string; show: boolean } = { time: '', chapterTitle: '', duration: '', show: false };

  onSeekTo(seconds: number): void {
    if (this.videoElementRef?.nativeElement) {
      this.videoElementRef.nativeElement.currentTime = seconds;
    }
  }

  onProgressDragStarted(): void {
    if (this.gridContainer?.nativeElement) {
      this.gridContainer.nativeElement.style.opacity = '0';
    }
  }

  onProgressDragEnded(event: { wasPlaying: boolean }): void {
    if (this.gridContainer?.nativeElement) {
      this.gridContainer.nativeElement.style.opacity = '1';
    }
    // Se o mouseup do seek cai fora da faixa da barra de progresso, o navegador
    // sintetiza um click cujo alvo é um ancestral comum (ex: #splitterTop), que
    // chama togglePlayPause() por cima da decisão que já tomamos aqui via
    // wasPlaying. suppressNextTogglePlayPause consome esse click fantasma uma
    // única vez (mesmo mecanismo já usado no gesto de hold-speed).
    this.suppressNextTogglePlayPause = true;
    if (event.wasPlaying) {
      this.videoElementRef?.nativeElement?.play();
    }
    this.showPlayPauseButton = true;
  }

  get chaptersAllowed(): boolean {
    return this.videoDurationSeconds >= 150;
  }

  chapterDropdownOptions: { label: string; value: string | null }[] = [];

  private refreshChapterDropdownOptions(): void {
    this.chapterDropdownOptions = [
      { label: 'Nenhum capítulo', value: null },
      ...this.chapters.map(c => ({ label: c.title || c.time, value: c.time }))
    ];
  }

  private chapterTimeToSeconds(time: string): number {
    const parts = (time || '00:00:00').split(':').map(Number);
    return (parts[0] || 0) * 3600 + (parts[1] || 0) * 60 + (parts[2] || 0);
  }

  private getActiveChapter() {
    const videoEl = this.videoElementRef?.nativeElement as HTMLVideoElement;
    if (!videoEl || !this.chapters.length) return undefined;
    const current = videoEl.currentTime;
    return [...this.chapters]
      .filter(c => this.chapterTimeToSeconds(c.time) <= current)
      .pop();
  }

  private scrollSwiperToProduct(sku: string): void {
    if (!this.filteredProducts) return;
    const index = this.filteredProducts.findIndex(p => String(p.sku) === sku);
    if (index >= 0) this.swiperInstanceProdutos?.slideTo(index);
  }

  getChapterForProduct(sku: string) {
    return this.chapters.find(c => String(c.product_sku) === String(sku));
  }

  seekToChapter(time: string): void {
    const videoEl = this.videoElementRef?.nativeElement as HTMLVideoElement;
    if (!videoEl) return;
    const seconds = this.chapterTimeToSeconds(time);
    videoEl.currentTime = seconds;
  }

  getChapterMarkerLeft(chapterTime: string): number {
    if (!this.videoDurationSeconds) return 0;
    const pct = this.chapterTimeToSeconds(chapterTime) / this.videoDurationSeconds;
    return pct * 100;
  }

  secondsToVttTime(seconds: number): string {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = Math.floor(seconds % 60);
    return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  }

  private generateVttString(): string {
    const sorted = [...this.chapters].sort(
      (a, b) => this.chapterTimeToSeconds(a.time) - this.chapterTimeToSeconds(b.time)
    );
    let vtt = 'WEBVTT\n\n';
    sorted.forEach((chapter, i) => {
      const start = chapter.time.length === 8 ? chapter.time : `00:${chapter.time}`;
      const endSeconds = sorted[i + 1]
        ? this.chapterTimeToSeconds(sorted[i + 1].time)
        : this.videoDurationSeconds;
      const end = this.secondsToVttTime(endSeconds);
      vtt += `${start}.000 --> ${end}.000\n`;
      vtt += `${JSON.stringify({ time: chapter.time, product_sku: chapter.product_sku ?? null })}\n\n`;
    });
    return vtt;
  }

  generateAndInjectVtt(): void {
    if (!this.videoElementRef) return;
    const videoEl = this.videoElementRef.nativeElement as HTMLVideoElement;

    if (this.chapterTrackEl) {
      try { videoEl.removeChild(this.chapterTrackEl); } catch {}
      this.chapterTrackEl = null;
    }
    if (this.vttBlobUrl) {
      URL.revokeObjectURL(this.vttBlobUrl);
      this.vttBlobUrl = null;
    }

    if (!this.chaptersEnabled || !this.chapters.length || !this.videoDurationSeconds) return;

    const blob = new Blob([this.generateVttString()], { type: 'text/vtt' });
    this.vttBlobUrl = URL.createObjectURL(blob);

    const track = document.createElement('track');
    track.kind = 'chapters';
    track.src = this.vttBlobUrl;
    track.default = true;

    track.addEventListener('load', () => {
      const textTrack = track.track;
      textTrack.mode = 'hidden';
      textTrack.addEventListener('cuechange', () => {
        const cue = textTrack.activeCues?.[0] as VTTCue | undefined;
        if (!cue) { this.lastActiveChapterTime = null; return; }
        try {
          const data = JSON.parse(cue.text);
          if (data.time !== this.lastActiveChapterTime) {
            this.lastActiveChapterTime = data.time;
            if (data.product_sku) this.scrollSwiperToProduct(data.product_sku);
          }
        } catch {}
      });
    });

    videoEl.appendChild(track);
    this.chapterTrackEl = track;
  }

  private revokeVttBlob(): void {
    if (this.chapterTrackEl) {
      try {
        (this.videoElementRef?.nativeElement as HTMLVideoElement)?.removeChild(this.chapterTrackEl);
      } catch {}
      this.chapterTrackEl = null;
    }
    if (this.vttBlobUrl) {
      URL.revokeObjectURL(this.vttBlobUrl);
      this.vttBlobUrl = null;
    }
  }

  onChapterProductChange(chapterTime: string | null): void {
    console.log('onChapterProductChange')
    const skuStr = String(this.selectedProductForEdit.sku);
    this.chapters = this.chapters.map(c => ({
      ...c,
      product_sku: c.product_sku === skuStr ? undefined : c.product_sku
    }));
    if (chapterTime) {
      this.chapters = this.chapters.map(c =>
        c.time === chapterTime ? { ...c, product_sku: skuStr } : c
      );
    }
    this.refreshChapterDropdownOptions();
    this.generateAndInjectVtt(); // Regenera o VTT com o novo product_sku
    this.debounceFunction();
    this.pushLiveUpdate();
  }

  hasCustom: boolean = false;
  hasProducts: boolean = false;
  hasLinks: boolean = false;
  hasShortcutLinks: boolean = false;
  hasSwiperLinks: boolean = false;
  canSelectLinkType(type: string): boolean {
    if (this.hasShortcutLinks && type === 'swiper') return false;
    if (this.hasSwiperLinks && type === 'shortcut') return false;
    return true;
  }
  private lastDetailRequestedUid: string | null = null;

  loadSlickDetails(uuid: string): void {
    // this.uuid nunca era atualizado ao trocar de item pelos botões de navegação
    // (goToNextItem/goToPreviousItem/goToNextInGroup/goToPreviousInGroup) — eles
    // chamavam changeUuid() ANTES do router.navigate(), que só relia o uuid ATUAL
    // (o antigo) do route.snapshot. Isso deixava this.uuid preso no primeiro item
    // carregado, quebrando tudo que dependia dele após a troca (ex.: chat).
    this.uuid = uuid;
    this.lastDetailRequestedUid = uuid;
    this.canSave = false;
    this.displaySidebarBottom = false;

    this.destroyPlayer();
    this.currentIndex = this.allItems.findIndex(item => item.content?.uid === uuid);

    this.detailCancel$.next();
    clearTimeout(this.debounceTimer);
    this.debounceTimer = null;
    // Cancela um hide-do-skeleton pendente de um load ANTERIOR (navegação
    // rápida pelas setas antes dos 150ms passarem) — sem isso, o timer
    // antigo dispararia atrasado e escondia o skeleton do load ATUAL,
    // reabrindo a mesma janela de flash que essa espera existe pra evitar.
    clearTimeout(this.showLoadingHideTimer);
    this.showLoadingHideTimer = null;
    this.loadingDetail = true;
    this.showLoading = true;
    this.showSplitter = true;

    // reset explícito para evitar flash de dados do item anterior
    this.contentTitle = '';
    this.slickDesc = '';
    this.videoUrl = '';
    this.videoPreviewUrl = '';
    this.currentThumbnail = '';
    this.imagePreviewUrl = '';
    this.mediaThumbnail = '';
    this.imageSelected = false;
    this.chapters = [];
    this.chaptersEnabled = false;
    this.targetProducts = [];
    this.whatsappTabs = [];
    this.accordionTabs = [];
    this.alertsTabs = [];
    this.linksSelecteds = [];
    this.hotspotsData = [];
    this.hasProducts = false;
    this.hasCustom = false;
    this.hasLinks = false;
    this.activeOption = null;
    this.activeItem = undefined;
    this.sideBarLinks = false;
    this.LinkSelectedName = '';
    this.LinkSelectedURL = '';
    this.selectedLinkColor = '#FFFFFF';
    this.iconGifSelected = '';
    this.hasIconGif = false;
    this.buttonText = '';
    this.buttonBgColor = '';
    this.buttonTextColor = '';
    this.cardTextColor = '';
    this.typeLive = false;
    this.isVideo = false;
    this.isImage = false;

    this.showMenuInf = false;
    this.liveShopService.detailAsset(uuid).pipe(takeUntil(this.detailCancel$), takeUntil(this.destroy$)).subscribe({
      next: (resp) => { // targetProducts
        // Catálogo de produtos (sourceProducts/allStoreProducts) agora é
        // carregado pelo próprio <app-product-picklist> quando a aba
        // "Elementos Interativos" abre — não precisa mais pré-carregar aqui.
        this.currentItem = resp.items[0];
        this.storeColors = resp.store_colors;
        this.canEditUpload = resp.items[0].content.source_id === 'up';
        this.isVideo = resp.items[0].media.type === 'shorts';
        this.isImage = resp.items[0].media.type === 'photo';
        this.chapters = resp.items[0].chapters ?? resp.items[0].media?.chapters ?? [];
        this.chaptersEnabled = resp.items[0].chapters_enabled === true || resp.items[0].media?.chapters_enabled === true;
        this.refreshChapterDropdownOptions();
        this.verSlickStatus = resp.items[0].media.status == 1 ? false : true;
        this.buildMenuInferior();

        //////////////
        const comps = resp?.items?.[0]?.content?.cta?.components ?? {};
        // helpers reutilizáveis
        const asArray = (v: any) => Array.isArray(v) ? v : [];
        const isTrue = (v: any) => v === true || v === 1 || v === '1';
        const isVisible = (item: any) => {
          // Se não vier show_item, considere visível por padrão (ajuste para false se quiser o contrário)
          if (item?.show_item === undefined) return true;
          return isTrue(item.show_item);
        };

        // coleções
        const customArr = asArray(comps.custom);
        const linksArr = asArray(comps.links);
        const productsArr = asArray(comps?.products?.items);

        // flags considerando show_item
        this.hasCustom = customArr.some(isVisible);
        this.hasLinks = linksArr.some(isVisible);
        this.hasProducts = productsArr.some(isVisible);

        // Regra: só um dos três tipos pode ficar visível por vez. Produtos
        // pode ter sido adicionado via listagem de slicks-data-view (que não
        // bloqueia a adição), então Produtos nunca tem prioridade — fica
        // desabilitado sempre que custom OU links estiver ativo, mesmo que
        // hasProducts também seja true (produto adicionado por fora enquanto
        // já havia custom/link ativo). Custom e Links mantêm a regra
        // original (só desabilita a aba que NÃO é a atualmente ativa),
        // porque entre eles a exclusividade já é garantida no backend
        // (updateAssets) — só Produtos precisa da checagem explícita.
        const disableAll = this.hasCustom || this.hasProducts || this.hasLinks;
        this.ctaOptions = [
          {
            label: 'Produtos', icon: 'algum-icon', command: () => this.selecionarOpcao(1),
            disabled: this.hasCustom || this.hasLinks,
          },
          {
            label: 'Custom', icon: 'algum-icon', command: () => this.selecionarOpcao(2),
            disabled: disableAll && !this.hasCustom,
          },

          { label: 'Whatsapp', icon: 'algum-icon', command: () => this.selecionarOpcao(3) },
          { label: 'Alertas', icon: 'algum-icon', command: () => this.selecionarOpcao(5) },
          {
            label: 'Links', icon: 'algum-icon', command: () => this.selecionarOpcao(6),
            disabled: disableAll && !this.hasLinks,
          },
        ];
        const firstEnabled = this.ctaOptions.find(option => !option.disabled);


        if (firstEnabled?.command) {
          firstEnabled.command();
        }
        this.activeItem = firstEnabled || null;

        this.videoReadyToLoad = true;

        const mediaType = resp.items[0].media.type; //(resp.items[0].media.type == null && resp.items[0].media.src == null) ? "live" : ((resp.items[0].media.src != null) ? "shorts" : resp.items[0].media.type);
        if (mediaType === "live") {
          this.typeLive = true;
        } else {
          this.typeLive = false;
        }
        this.videoUrl = resp.items[0].media.src;
        //this.posterURL = resp.items[0].media.thumbnail ?? '';

        let tagsFromDb: string;
        this.tagsString = '';
        if (resp.items[0].extra.tags) {
          tagsFromDb = resp.items[0].extra.tags;
          this.selectedTags = tagsFromDb.split(','); // Converte a string em um array
          this.tagsString = tagsFromDb;
        } else {
          this.selectedTags = []; // Assegura que selectedTags está limpo se não houver tags
          this.tagsString = '';
        }


        /// montando targetProducts
        this.targetProducts = [];
        this.targetProducts = resp.items[0].content.cta.components.products.items
          .map((productFromService: any) => this.normalizeProductData(productFromService as ProdutoShopify));

        this.prevTargetProducts = [...this.targetProducts];
        this.rebuildProductTags();

        if (this.allStoreProducts.length > 0) {
          this.sourceProducts = this.allStoreProducts.filter((p: any) =>
            !this.targetProducts.some((t: any) => String(t.sku) === String(p.sku))
          );
        }

        const productColorsUpdate: Record<number, { comprarFontColor: string; comprarBgColor: string; adicionarFontColor: string; adicionarBgColor: string; }> = {};
        this.targetProducts.forEach(product => {
          productColorsUpdate[product.id] = {
            comprarFontColor: product.comprar_font_color ?? '#FFFFFF',
            comprarBgColor: product.comprar_bg_color ?? '#000000',
            adicionarFontColor: product.adicionar_font_color ?? '#000000',
            adicionarBgColor: product.adicionar_bg_color ?? '#FFFFFF'
          };
        });
        this.stateManagementService.productColors.next(productColorsUpdate);
        this.products = this.targetProducts;


        this.setupFilteredProducts();
        if (this.filteredProducts$) {
          this.highlightedProductsLimited$ = this.filteredProducts$.pipe(
            map(products =>
              products.filter(product => product.highlight).slice(0, 3)
            )
          );
        }
        this.targetProducts = [...this.targetProducts];
        this.setupFilteredProducts();
        /// montando targetProducts

        /// hotspots HandleUser 
        this.handleUser = resp.items?.[0]?.media_creator?.handle ?? '';
        this.source_id = resp.items?.[0]?.media_creator?.source_id ?? '';
        this.permalink = resp.items?.[0]?.media_creator?.permalink ?? '';
        this.media_id = resp.items?.[0]?.media?.media_id ?? '';

        if (this.source_id == 'up') {
          const savedAvatar = localStorage.getItem('avatarUrl');
          this.avatar = savedAvatar ?? 'assets/layout/images/avatar.png';
        } else {
          this.avatar = resp.items?.[0]?.media_creator?.avatar ?? '/assets/rosto.jpg';
        }



        const rawHs = comps?.hotspot;
        const hs: HotspotDto = (rawHs ?? { enabled: false, items: [], settings: {} }) as HotspotDto;


        this.showHotspots = !!hs.enabled;
        if (!this.isImage) {
          this.showHotspots = false;
        } // hotspotShopEnabled
        const s = (hs.settings ?? {}) as HotspotSettingsDto;
        this.hotspotMarkerType = (s.markerType === 'dot' || s.markerType === 'number') ? s.markerType : 'number';
        console.log('s: ', s)
        const stl = (s.shopTheLook ?? {}) as HotspotShopTheLookDto;
        this.hotspotShopEnabled = !!stl.enabled;
        this.hotspotShopLabel = stl.label ?? 'Shop the Look';
        this.hotspotShopBtnBg = stl.btnBgColor ?? '#ff3b30';
        this.hotspotShopBtnText = stl.btnTextColor ?? '#ffffff';
        this.hotspotShopIcon = (stl.icon === 'cart' ? 'cart' : 'bag');

        // índices para casar por ID OU por SKU
        const idIndex = new Map(this.targetProducts.map(p => [String(p.id), p]));
        const skuIndex = new Map(this.targetProducts.map(p => [String(p.sku), p]));

        const rawItems = Array.isArray(hs.items) ? hs.items : [];
        const resolved: Hotspot[] = [];

        for (const i of rawItems) {
          const key = String(i?.productId ?? '');
          if (!key) continue;

          const p = idIndex.get(key) || skuIndex.get(key);
          if (!p) continue;

          resolved.push({
            productId: String(p.sku),               // ðŸ‘ˆ normaliza para SKU no front
            xPct: Number(i.xPct ?? 50),
            yPct: Number(i.yPct ?? 50),
            wPct: Number(i.wPct ?? 2),
            hPct: Number(i.hPct ?? 2),
            position: Number.isInteger(i.position) ? i.position : undefined,
          });
        }

        this.hotspotsData = resolved;
        // Bug real corrigido: o filtro abaixo consulta `this.productMap`, que só é
        // reconstruído por `rebuildProductMap()` — chamar essa reconstrução DEPOIS do
        // filtro deixava `productMap` com o estado antigo (vazio no primeiro load),
        // removendo TODOS os hotspots (nenhum SKU batia), mesmo com dados válidos vindos
        // do backend. Isso derrubava `hotspot.enabled` no player (via
        // `extractHotspot()`/`normalize.ts`, calculado como `items.length > 0`), fazendo
        // os produtos caírem de volta no carousel normal mesmo com o switch "Hotspots" ligado.
        this.rebuildProductMap();          // agora keyed por SKU
        this.hotspotsData = this.hotspotsData.filter(h => {
          const card = this.productMap[String(h.productId)];
          return card && card.show !== false;
        });
        this.syncHotspotOrderFromTarget(); // ordena por posição/target
        /// hotspots


        this.setupFilteredLinksUnificado(); // Verificando

        /////////////////////////////

        // promos
        // Filtrar targetProducts baseado nos IDs dos produtos selecionados
        this.targetPromotions = resp.items[0].content.cta.components.promotions.items
          .map(productFromService => this.normalizePromosData(productFromService));
        console.log(this.targetPromotions);
        // Primeiro, cria um conjunto dos IDs dos produtos que estão em targetPromotions para facilitar a comparação
        const idsInTargetPromotions = new Set(this.targetPromotions.map(p => p.id));

        // Depois, filtra sourcePromotions para remover os itens que estão em targetPromotions
        this.sourcePromotions = this.sourcePromotions.filter(product => !idsInTargetPromotions.has(product.id));
        this.setupFilteredPromotions();
        /////////////////////////////


        // configurações e estilos
        this._showProgressBar.next(resp.items[0].extra.player.show_progress_bar ?? true);
        this.smartAutoPlay = true; //resp.items[0].extra.player.auto_play;
        this.profileBtn = resp.items[0].extra.profileBtn;

        this.timeToPitch = resp.items[0].extra.player.time_to_pitch;
        this.timePitch = resp.items[0].extra.player.time_to_pitch_value;
        this.sliderValuePitch = this.convertTimeToSeconds(this.timePitch);
        this.updateTimeValue();

        this.aspect_ratio = resp.items[0].media.aspect_ratio;

        //
        this.currentThumbnail = resp.items[0].media.thumbnail ?? '';
        const loadedThumbnailSource = resp.items[0].media.thumbnail_source;
        this.thumbnailMode = (loadedThumbnailSource === 'video' || loadedThumbnailSource === 'upload') ? loadedThumbnailSource : 'default';
        if (resp.items[0].media.thumbnail) {

          const thumbnail = resp.items[0].media.thumbnail;
          this.imageSelected = true;

          if (thumbnail.includes('cloudfront')) {
            this.imagePreviewUrl = thumbnail.split('?')[0];
          } else {
            this.imagePreviewUrl = thumbnail;
          }
        } else {
          this.imageSelected = false;
        }
        // media.type
        this.asset_id = resp.items[0].content.id;
        // `aspect_ratio` não é usado de verdade pra decidir orientação
        // (confirmado pelo usuário) — sempre Vertical. Bug real que isso
        // substitui: `if (aspect_ratio == "1") Vertical else Horizontal`
        // tratava QUALQUER valor diferente de "1" (inclusive
        // `null`/`undefined`, o caso de assets importados de rede social,
        // que nunca passaram pelo fluxo que grava esse campo) como
        // Horizontal, encolhendo o player (`.ss-landscape`, 16:9) em vez do
        // 9:16 vertical esperado.
        this.valSelect1Video = this.landscapeOptions2[0];
        this.currentOrientation = 'portrait';

        if ((this.valSelectviewMode.value == 1 && this.valSelect1Video.value == 2) || (this.valSelectviewMode.value == 2 && this.valSelect1Video.value == 1)) {
          this.hasTheaterMode = false;
        } else {
          this.hasTheaterMode = true;
        }

        this.videoPreviewUrl = this.videoUrl;

        if (resp.items[0].media.src) {
          this.isLive = false;
        } else if (resp.items[0].media.thumbnail) {
          this.isLive = false;
        } else {
          this.isLive = true;
        }
        this.shouMuteImg = true;
        this.mediaType = resp.items[0].media.type;
        this.mediaSrc = resp.items[0].media.src;
        this.mediaDuration = resp.items[0].media.duration;
        // Bug real corrigido: `videoDurationSeconds` (usado pra clampar o
        // tempo digitado em cada capítulo — `addChapter()`/`onChapterTimeChange()`
        // — e pro gate de `chaptersAllowed`) só era populado pelo
        // `onloadedmetadata` do `<video>` real, que não existe mais desde a
        // migração pro player Lit embutido. O backend já manda a duração
        // pronta (`media.duration`) — usa ela direto, sem depender de nenhum
        // elemento de vídeo no DOM.
        this.videoDurationSeconds = Number(this.mediaDuration) || 0;
        this.mediaThumbnail = resp.items[0].media.thumbnail;
        const extUrl = this.mediaType === 'shorts' ? this.mediaSrc : this.mediaThumbnail;
        this.mediaExtension = this.extractExtension(extUrl);
        this.publicarAgora = resp.items[0].media.status == 1 ? true : false;
        if (!this.publicarAgora) {
          this.dataSelecionada = new Date(resp.items[0].schedule.date_from);
        }

        this.mediaAspectRatio = resp.items[0].media.aspect_ratio;
        this.mediaStatus = resp.items[0].media.status;

        if (resp.items[0].content.source_id != "up") {
          this.slickDesc = resp.items[0].content.caption;
        } else {
          this.slickDesc = resp.items[0].content.description;
        }

        this.handleTruncatedDesc();

        this.stateManagementService.updateTypeLive(this.typeLive);
        const foundType = this.slickTypes.find(type => type.value === mediaType);

        // Se nenhum tipo correspondente for encontrado, atribui um valor padrão que corresponda ao tipo SlickType
        this.selectedSlickType = foundType ?? { label: 'Default Label', value: '' };

        this.contentTitle = resp.items[0].content.title;

        // Publica o contexto do slick atual pro LayoutService — usado tanto pelo
        // botão de chat interno quanto pelo botão de chat do header, garantindo
        // que os dois sempre abram o chat do slick que está realmente na tela.
        this.layoutService.currentSlickChatContext = {
          uuid,
          description: this.slickDesc ?? undefined,
          thumbnail: this.currentThumbnail,
        };

        this.scheduleDateFrom = resp.items[0].schedule.date_from;
        this.scheduleDateTo = resp.items[0].schedule.date_to;
        this.time_to_pitch = resp.items[0].media.time_to_pitch;

        // fazer o mesmo para accordionTabs
        const customComponents = resp.items[0].content.cta.components.custom;
        this.customComponentsTmp = customComponents;
        this.setCustom(this.customComponentsTmp);

        const anyDefineIntervalTrue = this.accordionTabs.some(tab => tab.define_interval);
        if (anyDefineIntervalTrue) {
          this.accordionTabs.forEach(tab => tab.define_interval = true);
        } else {
          this.accordionTabs.forEach(tab => tab.define_interval = false);
          if (this.accordionTabs.length > 0) {
            this.isAddButtonDisabled = true;
          }
        }
        if (this.accordionTabs.length == 1 && this.accordionTabs[0].define_interval == false) {
          this.isAddButtonDisabled = false;
        }
        if (this.accordionTabs.length > 0) {
          const initialTab = this.accordionTabs[0]; // Ou alguma lógica para selecionar a aba correta
          this.stateManagementService.updateAccordionColors(
            initialTab.font_color_custom ?? '#FFFFFF', // Valor padrão se font_color_custom for undefined
            initialTab.bg_color_custom ?? '#000000' // Valor padrão se bg_color_custom for undefined
          );
        }
        this.isAddButtonDisabled = this.accordionTabs.length > 0 ? true : false;

        if (resp.items[0].extra.player.player_color == null) {
          this.playPauseColor = resp.items[0].extra.player.player_color != "" ? resp.items[0].extra.player.player_color : '#ff0000';
          //this.pickListObserverService.notifyChange();
        }
        if (resp.items[0].extra.player.progress_bar_color == null) {
          this.progressBarColor = resp.items[0].extra.player.progress_bar_color != "" ? resp.items[0].extra.player.progress_bar_color : '#ff0000';
          //this.pickListObserverService.notifyChange();
        }

        this.playPauseColor = resp.items[0].extra.player.player_color != "" ? resp.items[0].extra.player.player_color : '#ff0000';
        this.progressBarColor = resp.items[0].extra.player.progress_bar_color != "" ? resp.items[0].extra.player.progress_bar_color : '#ff0000';
        this.updatePlayPauseColor(resp.items[0].extra.player.player_color);
        this.updateProgressBarColor(resp.items[0].extra.player.progress_bar_color);

        this.progressBarColor = resp.items[0].extra.player.progress_bar_color;
        //updatePlayerControlsColors
        this.stateManagementService.updatePlayerControlsColors(
          this.playPauseColor,
          this.progressBarColor
        );

        this.setupVisibleButton();
        // fazer o mesmo para whats
        const whatsComponents = resp.items[0].content.cta.components.whatsapp;
        this.whatsAppComponentsTmp = whatsComponents;
        this.setWhatsAppTabs(this.whatsAppComponentsTmp);
        this.setupVisibleButtonWhatsApp()
        const anyDefineIntervalTrueWhats = this.whatsappTabs.some(tab => tab.define_interval);
        if (anyDefineIntervalTrueWhats) {
          this.whatsappTabs.forEach(tab => tab.define_interval = true);
        } else {
          this.whatsappTabs.forEach(tab => tab.define_interval = false);
        }
        // Bug real corrigido: só setava `true` condicionalmente, nunca
        // `false` — trocar pra um asset SEM whatsapp (setas laterais,
        // goToNextItem/goToPreviousItem) deixava o botão "+" preso
        // desabilitado com o valor do asset anterior. Mesmo padrão de
        // `isAddButtonDisabled` (linha ~5032, botão custom) logo acima.
        this.isAddButtonDisabledWhats = this.whatsappTabs.length > 0;

        // Mapeie os componentes custom para o formato AccordionTab fffffffffffffffffffffffffffffffffffffffffffff
        const alertsComponents = resp.items[0].content.cta.components.alerts;
        this.alertsAppComponentsTmp = alertsComponents;
        console.log('antes de setar alertas ', this.alertsAppComponentsTmp)
        this.setAlerts(this.alertsAppComponentsTmp);
        this.setupFilteredAlerts();

        this.displayButtons = true;
        this.setLinks(resp.items[0].content.cta.components.links);


        // fazer o mesmo para AlertsTab targetAlerts
        this.showMenuInf = false;
        this.showControls = true;
        this.showBtns = true;
        this.marginTopVideo();

        this.hasData = true;
        this.loadingDetail = false;
        // Bug real corrigido (restauração do skeleton): `showLoading` só
        // virava `false` dentro de `initVideoPlayer()`, num bloco inteiro
        // gated por `this.videoElementRef` — referência morta desde a
        // migração pro player Lit embutido (o `<video>` que ela apontava
        // foi deletado). Pra vídeo normal (não live, não imagem), isso
        // deixava `showLoading` preso em `true` PRA SEMPRE. O reset de
        // verdade agora acontece mais abaixo, DEPOIS de `bridge?.init()` —
        // ver comentário lá.

        if (!this.typeLive) {
          this.showSplitter = true;
          this.initVideoPlayer();
        } else {
          this.iniciarTimeout();
        }

        this.updateTabs();
        this.columnSize = 'col-12 md:col-12 lg:col-12 xl:col-8 2xl:col-4';
        this.splitterColumnSize = 'col-12 md:col-12 lg:col-12 xl:col-12 2xl:col-4'; //ssssssssssssssssssssssss
        this.applyColumnSizeToSplitter();

        this.setupVisibleButtonWhatsApp()
        this.createForm();
        this.connectToRoom();

        // Manda o item pro player Lit embutido (iframe já vivo desde
        // ngOnInit()) — Studio mostra sempre UM item só, sem paginação.
        void this.bridge?.init({
          items: [this.buildLivePlayerItem()],
          totalAssets: 1,
          storeId: Number(this.storeId) || 0,
          widgetId: 0,
          initialAssetPosition: 0,
          sessionId: this.ensureSessionId(),
          playerSessionId: this.ensurePlayerSessionId(),
          orientation: this.currentOrientation,
          editableHotspots: true,
          hideCloseButton: true,
          storeColors: this.storeColors
        });

        // Bug real corrigido: esconder o skeleton NA HORA (mesmo tick do
        // `bridge?.init()`) deixava um flash visível do asset ANTERIOR —
        // `bridge.init()` só manda a mensagem (postMessage é assíncrono);
        // dentro do iframe, `embed-entry.ts::onInit` ainda precisa remover
        // o `<slicksell-player>` antigo, criar um novo e montá-lo antes do
        // conteúdo novo aparecer de verdade. Nesse intervalo (poucos ms,
        // mas visível), o player antigo — ainda de pé — mostra o item
        // anterior por baixo do skeleton já escondido. Sem nenhum sinal de
        // "player pronto" vindo do bridge pra esperar de verdade, um atraso
        // curto e fixo cobre esse intervalo na prática (mesmo valor do
        // debounce de `pushLiveUpdate()`, já validado como imperceptível).
        this.showLoadingHideTimer = setTimeout(() => {
          this.showLoading = false;
          this.cdr.detectChanges();
        }, 150);
      },
      error: (err) => {

      }
    });
  }
  private storageBridge?: BroadcastChannel;
  private setupStorageBridgeForPopup(): void {
    if (this.storageBridge) return;
    this.storageBridge = new BroadcastChannel('oauth-storage');

    this.storageBridge.onmessage = (e) => {
      if (e.data?.type === 'request-storage') {
        // Envie as chaves que a popup precisa
        this.storageBridge?.postMessage({
          type: 'storage-dump',
          payload: {
            SelectedStoreId: localStorage.getItem('ss_SelectedStoreId'),
            user_id: localStorage.getItem('user_id'),
            // adicione outras chaves se quiser
          }
        });
      }
    };
  }
  private oauthChannel: BroadcastChannel | null = null;
  private startOAuthPopupListener(): void {

    if (this.oauthChannel) return;
    this.oauthChannel = new BroadcastChannel('oauth-channel');

    this.oauthChannel.onmessage = (event) => {

      switch (event.data?.type) {
        case 'instagram-connected':

          // pequeno atraso pra backend consolidar e UI mostrar o toast
          setTimeout(() => {
            try { this.oauthChannel?.close(); } catch { }
            this.oauthChannel = null;
            window.focus();
            window.location.reload(); // â¬…ï¸ atualiza a aba chamadora somente quando chegou a msg
          }, 0);

          break;

        case 'shopify-connected':

          // pequeno atraso pra backend consolidar e UI mostrar o toast
          setTimeout(() => {
            try { this.oauthChannel?.close(); } catch { }
            this.oauthChannel = null;
            window.focus();
            window.location.reload(); // â¬…ï¸ atualiza a aba chamadora somente quando chegou a msg
          }, 0);

          break;

        case 'nuvemshop-connected':

          // pequeno atraso pra backend consolidar e UI mostrar o toast
          setTimeout(() => {
            try { this.oauthChannel?.close(); } catch { }
            this.oauthChannel = null;
            window.focus();
            window.location.reload(); // â¬…ï¸ atualiza a aba chamadora somente quando chegou a msg
          }, 0);

          break;

        case 'tiktok-connected':

          // pequeno atraso pra backend consolidar e UI mostrar o toast
          setTimeout(() => {
            try { this.oauthChannel?.close(); } catch { }
            this.oauthChannel = null;
            window.focus();
            window.location.reload(); // â¬…ï¸ atualiza a aba chamadora somente quando chegou a msg
          }, 0);

          break;

        case 'google-connected':

          // pequeno atraso pra backend consolidar e UI mostrar o toast
          setTimeout(() => {
            try { this.oauthChannel?.close(); } catch { }
            this.oauthChannel = null;
            window.focus();
            window.location.reload(); // â¬…ï¸ atualiza a aba chamadora somente quando chegou a msg
          }, 0);

          break;

        default:
          console.warn('âš ï¸ Tipo de mensagem desconhecido:', event.data?.type);
          break;
      }
    };

    console.log('startOAuthPopupListener 3');
  }
  shopifyConnection(): void {
    this.setupStorageBridgeForPopup();
    this.startOAuthPopupListener(); // âœ… inicia o listener

    const isNative = Capacitor.isNativePlatform();
    const selectedStoreId = localStorage.getItem('ss_SelectedStoreId') || '';
    let stateObj: any = { selectedStoreId };
    if (isNative) {
      const accessToken = localStorage.getItem('access_token') || '';
      stateObj.accessToken = accessToken;
    }
    stateObj.nonce = Math.random().toString(36).substring(2);
    const state = btoa(JSON.stringify(stateObj));
    localStorage.setItem('shopify_oauth_state', state);
    const redirectUri = encodeURIComponent('https://app.slicksell.com.br/auth/shopify');

    const authUrl = `https://slicksell-test.myshopify.com/admin/oauth/authorize?` +
      `client_id=0d45482ed6adf4a59e4e8fc7f367b9ab` +
      `&scope=read_content,read_discounts,read_gift_cards,read_inventory,read_orders,read_products,read_themes,write_pixels,write_products,write_script_tags,write_themes` +
      `&redirect_uri=${redirectUri}` +
      `&state=${encodeURIComponent(state)}`;

    if (isNative) {
      void Browser.open({ url: authUrl });
      return;
    }

    window.location.assign(authUrl);
  }

  nuvemshopConnection(): void {
    this.setupStorageBridgeForPopup();
    this.startOAuthPopupListener();
    const selectedStoreId = localStorage.getItem('ss_SelectedStoreId') || '';

    const stateObj = {
      selectedStoreId,
      nonce: Math.random().toString(36).substring(2),
    };

    const state = btoa(JSON.stringify(stateObj));
    const appId = '21877';
    const authUrl =
      `https://www.nuvemshop.com.br/apps/${appId}/authorize?state=${encodeURIComponent(state)}`;

    window.open(authUrl, 'Nuvemshop Login', 'width=600,height=700');
  }
  showIntegration: boolean = false;
  hasShopifyIntegration = false;
  hasNuvemshopIntegration = false;
  nextCursor: string | null = null;
  hasNextPage = false;
  isLoadingMore = false;
  currentSearchTerm = '';
  remoteFilter = '';

  private hasActiveStoreApp(response: any): boolean {
    const apps = response?.store_apps;
    if (!Array.isArray(apps) || !apps.length) {
      return false;
    }
    return apps.some((app: any) => {
      const status = (app?.active ?? app?.status ?? '').toString().toLowerCase();
      return status === 'active' || status === '1' || status === 'true';
    });
  }

  onSourceFilterChange(term: string) {
    const value = (term || '').trim();
    this.remoteFilter = value;

    clearTimeout(this.searchDebounce);
    this.searchDebounce = setTimeout(() => {
      // Quando digitar, reseta paginação e busca de novo na Shopify
      this.carregaProdutos(value);
    }, 400);
  }

  @ViewChild('productsPickList', { read: ElementRef })
  productsPickListRef!: ElementRef<HTMLElement>;

  private sourceScrollHandler?: (ev: Event) => void;
  private attachSourceScrollListener(): void {
    if (!this.productsPickListRef) return;


    const host = this.productsPickListRef.nativeElement;

    // tenta pegar a UL que rola a lista de "source"
    const sourceList = this.getSourceListElement();
    if (!sourceList) {
      console.warn('Source list da PickList não encontrada');
      return;
    }

    this.sourceScrollHandler = (event: Event) => this.onSourceScroll(event);
    sourceList.addEventListener('scroll', this.sourceScrollHandler);
  }
  private scrollSourceListToBottom(): void {
    const sourceList = this.getSourceListElement();
    if (!sourceList) return;

    // espera o Angular renderizar o item fake
    setTimeout(() => {
      sourceList.scrollTop = sourceList.scrollHeight;
    }, 0);
  }

  private detachSourceScrollListener(): void {
    if (!this.productsPickListRef || !this.sourceScrollHandler) return;

    const host = this.productsPickListRef.nativeElement;
    const sourceList =
      host.querySelector('.p-picklist-source .p-picklist-list') as HTMLElement
      || host.querySelector('.p-picklist-list') as HTMLElement;

    if (sourceList) {
      sourceList.removeEventListener('scroll', this.sourceScrollHandler);
    }
    this.sourceScrollHandler = undefined;
  }

  private onSourceScroll(event: Event): void {
    const el = event.target as HTMLElement;
    const padding = 30; // px de tolerância

    const isNearBottom =
      el.scrollTop + el.clientHeight >= el.scrollHeight - padding;

    if (isNearBottom) {
      this.loadMoreProducts(); // já tem os guardas hasNextPage/isLoadingMore
    }
  }

  async carregaProdutos(searchTerm: string = '') {
    console.log('carregaProdutos 1');
    this.isLoadingMore = false;       // garante que o botão não fique travado
    this.currentSearchTerm = searchTerm;

    try {
      const [shopifyResponse, nuvemshopResponse] = await Promise.all([
        this.productsService.getAppsStore('shopify').toPromise(),
        this.productsService.getAppsStore('nuvemshop').toPromise()
      ]);

      this.hasShopifyIntegration = this.hasActiveStoreApp(shopifyResponse);
      this.hasNuvemshopIntegration = this.hasActiveStoreApp(nuvemshopResponse);

      if (!this.hasShopifyIntegration && !this.hasNuvemshopIntegration) {
        this.showIntegration = true;
        return;
      }

      this.showIntegration = false;

      const activeKey = this.hasShopifyIntegration ? 'shopify' : 'nuvemshop';
      const response: any = this.hasShopifyIntegration ? shopifyResponse : nuvemshopResponse;

      const selectedStoreId = localStorage.getItem('ss_SelectedStoreId');
      if (selectedStoreId) {
        this.store_id = Number(selectedStoreId);
      }

      const storeApp = response.store_apps?.find((app: any) =>
        app.key.includes(activeKey) && app.store_id === this.store_id
      );

      if (storeApp && String(storeApp.active) === 'active') {
        const observable = await this.productsService.listProducts(null, searchTerm);

        observable.pipe(takeUntil(this.destroy$)).subscribe({
          next: (resp: any) => {

            console.log('resp')
            console.log(resp)

            const allProducts = resp.products.map((product: ProdutoShopify) =>
              this.transformProdutoShopify(product)
            );

            console.log('allProducts')
            console.log(allProducts)

            this.allStoreProducts = allProducts;
            this.sourceProducts = allProducts.filter((sourceProduct: any) =>
              !this.targetProducts.some((targetProduct: any) =>
                String(targetProduct.sku) === String(sourceProduct.sku)
              )
            );

            this.nextCursor = resp.page_info?.end_cursor ?? null;
            this.hasNextPage = !!resp.page_info?.has_next_page;
            this.isLoadingMore = false;

            console.log('sourceProducts ', this.sourceProducts);
            console.log('targetProducts1', this.targetProducts);
            this.cdr.detectChanges();
          },
          error: (err: any) => {
            console.error('Erro ao carregar produtos:', err);
            this.isLoadingMore = false;
          },
        });
      }
    } catch (error) {
      console.error('Erro ao buscar detalhes do app:', error);
      this.isLoadingMore = false;
    }
  }
  ///////////////
  private loadingSentinel: Produto = {
    id: -1,
    sku: -1,
    name: '',
    status: 0,
    inputQty: 0,
    position: 0,
    price: '0',
    compare_at_price: null,
    onsale_price: '0',
    price_exchange: '0',
    thumbnail: '',
    __loading: true
  };
  private addLoadingPlaceholder() {
    console.log('addLoadingPlaceholder 1')
    // evita duplicar
    if (!this.sourceProducts.some(p => p.__loading)) {
      console.log('addLoadingPlaceholder 2')
      this.sourceProducts = [...this.sourceProducts, this.loadingSentinel];

      this.scrollSourceListToBottom();
      this.cdr.detectChanges();
    }
  }
  private getSourceListElement(): HTMLElement | null {
    if (!this.productsPickListRef) return null;

    const host = this.productsPickListRef.nativeElement;

    const sourceList =
      host.querySelector('.p-picklist-source .p-picklist-list') as HTMLElement
      || host.querySelector('.p-picklist-list') as HTMLElement;

    return sourceList ?? null;
  }

  private removeLoadingPlaceholder() {
    this.sourceProducts = this.sourceProducts.filter(p => !p.__loading);
  }

  ///////////////
  async loadMoreProducts() {
    if (!this.hasNextPage || this.isLoadingMore) return;

    this.isLoadingMore = true;
    console.log('loadMoreProducts')
    this.addLoadingPlaceholder();
    try {
      const observable = await this.productsService.listProducts(this.nextCursor, this.currentSearchTerm);

      observable.pipe(takeUntil(this.destroy$)).subscribe({
        next: (resp: any) => {
          // ðŸ”¹ Remove o placeholder antes de mergear
          this.removeLoadingPlaceholder();

          const newProducts = resp.products.map((product: ProdutoShopify) =>
            this.transformProdutoShopify(product)
          );

          console.log('loadMoreProducts - newProducts:', newProducts);

          const merged = [
            ...this.sourceProducts,
            ...newProducts.filter((np: any) => {
              const key = this.getProductKey(np);
              return !this.sourceProducts.some(sp => this.getProductKey(sp) === key) &&
                !this.targetProducts.some(tp => this.getProductKey(tp) === key);
            })
          ];

          console.log('loadMoreProducts - merged length:', merged.length);

          this.sourceProducts = merged;

          this.nextCursor = resp.page_info?.end_cursor ?? null;
          this.hasNextPage = !!resp.page_info?.has_next_page;
          this.isLoadingMore = false;
          this.cdr.detectChanges();
        },
        error: (err: any) => {
          console.error('Erro ao carregar mais produtos:', err);
          this.removeLoadingPlaceholder();
          this.isLoadingMore = false;
        },
      });
    } catch (e) {
      console.error('Erro loadMoreProducts:', e);
      this.removeLoadingPlaceholder();
      this.isLoadingMore = false;
    }
  }
  get sourceProductsCount(): number {
    return this.sourceProducts.filter(p => !p.__loading).length;
  }
  private getProductKey(p: any): string {
    return String(p.sku ?? p.id);
  }
  private searchDebounce: any;
  //import { PickListSourceFilterEvent } from 'primeng/picklist';


  createForm() {
    this.issueForm = this.fb.group({
      widget: this.fb.array([ // Início do FormArray para 'widget'
        this.fb.group({ // Início do FormGroup dentro do array 'widget'
          assets: this.fb.group({ // Início do FormGroup para 'assets'
            items: this.fb.array([ // Início do FormArray para 'items'
              this.fb.group({ // Início do FormGroup para cada item em 'items'
                schedule: this.fb.group({
                  date_from: [this.scheduleDateFrom],
                  date_to: [this.scheduleDateTo]
                }),
                media: this.fb.group({
                  type: [this.mediaType],
                  src: [this.replaceDomain(this.mediaSrc)],
                  time_to_pitch: this.time_to_pitch,
                  img_slate: [""],
                  duration: [this.mediaDuration],
                  thumbnail: this.imageSelected ? [this.replaceDomain(this.mediaThumbnail)] : [this.currentThumbnail],
                  thumbnail_source: [this.thumbnailMode],
                  aspect_ratio: [this.mediaAspectRatio],
                  status: [this.mediaStatus]
                }),
                content: this.fb.group({
                  description: [this.slickDesc],
                  cta: this.fb.group({
                    type: [0],
                    components: this.fb.group({
                      custom: this.fb.array(this.accordionTabs), // Se 'this.accordionTabs' já é um array, use diretamente sem colchetes adicionais
                      whatsapp: this.fb.array(this.whatsappTabs), // Se 'this.whatsappTabs' já é um array, use diretamente sem colchetes adicionais
                      products: this.fb.group({
                        items: this.fb.array(this.targetProducts) // Se 'this.targetProducts' já é um array, use diretamente sem colchetes adicionais
                      }),
                      promotions: this.fb.group({
                        items: this.fb.array(this.targetPromotions) // Se 'this.targetPromotions' já é um array, use diretamente sem colchetes adicionais
                      }),
                      alerts: this.fb.array(this.alertsTabs), // Se 'this.alertsTabs' já é um array, use diretamente sem colchetes adicionais
                      links: this.fb.array(this.linksSelecteds)
                    })
                  })
                }),
                extra: this.fb.group({ // Início do FormGroup 'extra'
                  player: this.fb.group({ // FormGroup 'player' dentro de 'extra'
                    time_to_pitch: [this.timeToPitch ? 1 : 0],
                    time_to_pitch_value: [this.timePitch],
                    player_color: [this.playPauseColor],
                    progress_bar_color: [this.progressBarColor],
                    auto_play: true,
                    show_progress_bar: [this.showProgressBar ? 1 : 0],

                  }),
                  "tags": this.tagsString,
                  "profileBtn": this.profileBtn,
                }) // Fim do FormGroup 'extra'
              }) // Fim do FormGroup para cada item em 'items'
            ]) // Fim do FormArray para 'items'
          }) // Fim do FormGroup para 'assets'
        }) // Fim do FormGroup dentro do array 'widget'
      ]) // Fim do FormArray para 'widget'
    });
  }
  currentThumbnail: string = '';
  private normalizeProductData(productFromService: ProdutoShopify): Produto {
    let showInterval = false;

    // Verifica se há intervalo de tempo válido
    if (productFromService.created_at !== "00:00:00" || productFromService.updated_at !== "00:00:00") {
      showInterval = true;
    }
    //isSelected
    return {
      id: productFromService.id,                      // ID convertido corretamente
      sku: productFromService.sku,
      name: productFromService.name,     // Título do produto
      status: 1,                          // Status padrão
      inputQty: productFromService.inventory_quantity ?? 0,                         // Quantidade padrão
      position: 0,                        // Posição padrão
      price: productFromService.price,
      compare_at_price: productFromService.compare_at_price,
      onsale_price: productFromService.compare_at_price || '', // Preço promocional
      price_exchange: '',                 // Não especificado
      thumbnail: productFromService.image || productFromService.thumbnail || '', // Imagem
      isSelected: true,  // Se não existir, define como falso
      show_item: productFromService.show_item ?? true,     // Visível por padrão
      highlight: productFromService.highlight ?? false,    // Não destacado por padrão
      define_interval: productFromService.define_interval ?? false,  // Sem intervalo por padrão
      show_slider: showInterval,                    // Slider ativado se houver intervalo
      comprar_font_color: productFromService.comprar_font_color ?? '#FFFFFF',  // Cor padrão
      comprar_bg_color: productFromService.comprar_bg_color ?? '#000000',
      adicionar_font_color: productFromService.adicionar_font_color ?? '#000000',
      adicionar_bg_color: productFromService.adicionar_bg_color ?? '#FFFFFF',
      interval_time: productFromService.interval_time ?? { start: '', end: '' }, // Intervalo vazio
    };
  }


  // private normalizeProductData(productFromService: ProdutoShopify): Produto {
  //   let showInterval = false;

  //   // Verifica se há intervalo de tempo válido
  //   if (productFromService.created_at !== "00:00:00" || productFromService.updated_at !== "00:00:00") {
  //     showInterval = true;
  //   }

  //   return {
  //     id: parseInt(productFromService.id.split('/').pop() || '0', 10), // Extrai o ID e converte para número
  //     name: productFromService.title, // Título do produto
  //     status: 1,                      // Status padrão
  //     inputQty: 0,                    // Quantidade padrão
  //     position: 0,                    // Posição padrão
  //     price: productFromService.price,
  //     onsale_price: productFromService.compare_at_price || '', // Preço promocional se existir
  //     price_exchange: '',             // Não especificado
  //     thumbnail: productFromService.thumbnail || '', // Imagem do produto
  //     isSelected: true,               // Produtos de target já começam selecionados
  //     show_item: true,                // Produto visível por padrão
  //     highlight: false,               // Não destacado por padrão
  //     define_interval: false,         // Sem intervalo definido por padrão
  //     show_slider: showInterval,      // Slider ativado se houver intervalo
  //     comprar_font_color: '#FFFFFF',  // Cor padrão para o botão Comprar
  //     comprar_bg_color: '#000000',
  //     adicionar_font_color: '#000000',// Cor padrão para o botão Adicionar
  //     adicionar_bg_color: '#FFFFFF',
  //     interval_time: { start: '', end: '' } // Intervalo vazio por padrão
  //   };
  // }

  loadPromotions(): void {
    console.log('Loading promotion');
    this.productsService.GetPromotions().pipe(takeUntil(this.destroy$)).subscribe({
      next: (resp) => {
        this.sourcePromotions = resp;
      },
      error: (err) => console.error('Erro ao carregar produtos:', err)
    });
  }

  removeFromSelected(productToRemove: Produto): void {
    this.targetProducts = this.targetProducts.filter(product => product !== productToRemove);
    this.pickListObserverService.notifyChange();
  }
  onDefineIntervalChange(product: Produto): void {
    product.show_slider = !product.show_slider; // Alterna a visibilidade do slider
    this.pickListObserverService.notifyChange();
  }

  onMoveToSourcePromos(event: any): void {
    event.items.forEach((item: Produto) => item.isSelected = false);
    this.pickListObserverService.notifyChange();
    console.log("Move to source");
    this.setupFilteredPromotions();
  }

  updateProductPositions(): void {
    this.targetProducts.forEach((product, index) => {
      product.position = index;
    });
    this.prevTargetProducts = [...this.targetProducts];
    this.debounceFunction();
  }
  onMoveToTargetPromos(event: any): void {
    console.log("Move to target");
    event.items.forEach((item: Produto) => {
      item.isSelected = true;
      // Outras propriedades para os switches e sliders
      item.highlight = false;
      item.define_interval = false;
      item.show_slider = false;
      item.show_item = false;
      item.interval_time = { start: "00:00:00", end: "00:00:00" },
        // Definindo cores padrão para botões e fundos
        item.comprar_font_color = "#FFFFFF"; // Cor branca para o texto do botão de compra
      item.comprar_bg_color = "#007BFF"; // Cor azul para o fundo do botão de compra
      item.adicionar_font_color = "#FFFFFF"; // Cor branca para o texto do botão de adicionar
      item.adicionar_bg_color = "#28A745";
    });

    this.pickListObserverService.notifyChange();
    this.setupFilteredPromotions();
  }
  smartAutoPlay: boolean = true;
  profileBtn: boolean = true;
  showProgressBar: boolean = true;
  private _showProgressBar = new BehaviorSubject<boolean>(true);
  showProgressBar$ = this._showProgressBar.asObservable();
  setShowProgressBar(value: boolean): void {
    this._showProgressBar.next(value);
  }


  timeToPitch: boolean = false;
  timePitch?: string;
  barColor: string = '#FF1122';
  playPauseColor: string = '#FF0000';
  time_to_pitch?: string;
  saveAsset(n: number): void {
    this.mediaAspectRatio = this.valSelect1Video.value;

    const hotspotEnabled = this.showHotspots === true; // ou sua flag

    const hotspotItems = this.hotspotsData.map((h, idx) => ({
      productId: h.productId,
      xPct: h.xPct,
      yPct: h.yPct,
      wPct: h.wPct,
      hPct: h.hPct,
      position: h.position ?? idx, // garante valor
    }));

    const chaptersPayload = this.chaptersEnabled ? this.chapters : [];

    const hotspotSettings = {
      markerType: this.hotspotMarkerType,           // 'number' | 'dot'
      shopTheLook: {
        enabled: this.hotspotShopEnabled,
        label: this.hotspotShopLabel,
        btnBgColor: this.hotspotShopBtnBg,
        btnTextColor: this.hotspotShopBtnText,
        icon: this.hotspotShopIcon,                // 'bag' | 'cart'
      }
    };

    this.issueForm = this.fb.group({
      widget: this.fb.array([ // Início do FormArray para 'widget'
        this.fb.group({ // Início do FormGroup dentro do array 'widget'
          assets: this.fb.group({ // Início do FormGroup para 'assets'
            items: this.fb.array([ // Início do FormArray para 'items'
              this.fb.group({ // Início do FormGroup para cada item em 'items'
                schedule: this.fb.group({
                  date_from: [this.scheduleDateFrom],
                  date_to: [this.scheduleDateTo]
                }),
                media: this.fb.group({
                  type: [this.mediaType],
                  src: [this.replaceDomain(this.mediaSrc)],
                  time_to_pitch: this.time_to_pitch,
                  img_slate: [""],
                  duration: [this.mediaDuration],
                  thumbnail: this.imageSelected ? [this.replaceDomain(this.mediaThumbnail)] : [this.currentThumbnail],
                  thumbnail_source: [this.thumbnailMode],
                  aspect_ratio: [this.mediaAspectRatio],
                  status: [this.mediaStatus],
                  chapters_enabled: [this.chaptersEnabled],
                  chapters: this.fb.array(
                    chaptersPayload.map(c => this.fb.group({ title: [c.title], time: [c.time], product_sku: [c.product_sku ?? null] }))
                  ),
                }),
                content: this.fb.group({
                  description: [this.slickDesc],
                  cta: this.fb.group({
                    type: [0],
                    components: this.fb.group({
                      custom: this.fb.array(this.accordionTabs), // Se 'this.accordionTabs' já é um array, use diretamente sem colchetes adicionais
                      whatsapp: this.fb.array(this.whatsappTabs), // Se 'this.whatsappTabs' já é um array, use diretamente sem colchetes adicionais
                      products: this.fb.group({
                        items: this.fb.array(this.targetProducts) // Se 'this.targetProducts' já é um array, use diretamente sem colchetes adicionais
                      }),
                      promotions: this.fb.group({
                        items: this.fb.array(this.targetPromotions) // Se 'this.targetPromotions' já é um array, use diretamente sem colchetes adicionais
                      }),
                      alerts: this.fb.array(this.alertsTabs), // Se 'this.alertsTabs' já é um array, use diretamente sem colchetes adicionais
                      links: this.fb.array(this.linksSelecteds),

                      hotspot: this.fb.group({
                        enabled: [hotspotEnabled],
                        items: this.fb.array(
                          hotspotItems.map(i => this.fb.group({
                            productId: [i.productId],
                            xPct: [i.xPct], yPct: [i.yPct],
                            wPct: [i.wPct], hPct: [i.hPct],
                            position: [i.position],
                          }))
                        ),
                        settings: this.fb.group({
                          markerType: [hotspotSettings.markerType],
                          shopTheLook: this.fb.group({
                            enabled: [hotspotSettings.shopTheLook.enabled],
                            label: [hotspotSettings.shopTheLook.label],
                            btnBgColor: [hotspotSettings.shopTheLook.btnBgColor],
                            btnTextColor: [hotspotSettings.shopTheLook.btnTextColor],
                            icon: [hotspotSettings.shopTheLook.icon],
                          })
                        })
                      })
                    })
                  })
                }),
                extra: this.fb.group({ // Início do FormGroup 'extra'
                  player: this.fb.group({ // FormGroup 'player' dentro de 'extra'
                    time_to_pitch: [this.timeToPitch ? 1 : 0],
                    time_to_pitch_value: [this.timePitch],
                    player_color: [this.playPauseColor],
                    progress_bar_color: [this.progressBarColor],
                    auto_play: true,
                    show_progress_bar: [this.showProgressBar ? 1 : 0],

                  }),
                  "tags": this.tagsString,
                  "profileBtn": this.profileBtn,
                }) // Fim do FormGroup 'extra'
              }) // Fim do FormGroup para cada item em 'items'
            ]) // Fim do FormArray para 'items'
          }) // Fim do FormGroup para 'assets'
        }) // Fim do FormGroup dentro do array 'widget'
      ]) // Fim do FormArray para 'widget'
    });
    if (!this.canSave) {
      return;
    }

    this.liveShopService.updateAsset(this.issueForm.value, this.asset_id).pipe(takeUntil(this.destroy$)).subscribe({
      next: (resp) => { //this.loadingBtn
        this.loadingBtn = false;
        this.loadingBtnNovo = false;
        if (this.isUpdatingLinks) {
          this.isUpdatingLinks = false;
          this.loadingLinksCtas = false;

          this.messageService.add({
            severity: 'success',
            summary: 'Slick Salvo',
            detail: 'O slick foi salvo com sucesso!'
          });
        }
        this.loadingBtnNovo = false;
        this.cdr.detectChanges();

        // Mantém a descrição usada pela sidebar global de Chat em sincronia
        // com o que acabou de ser salvo em Details (ver [[feature-slick-detail-editor-display]]).
        if (this.uuid && this.layoutService.currentSlickChatContext?.uuid === this.uuid) {
          this.layoutService.currentSlickChatContext.description = this.slickDesc ?? undefined;
        }
        if (this.uuid) {
          this.layoutService.updateDirectChatDescription(this.uuid, this.slickDesc ?? undefined);
        }

        if (n == 1) {
          this.loadingBtn = false;
          this.uploadOn = false;
          //this.loadProducts();

          if (this.player) {
            this.player.src({ src: this.replaceDomain(this.mediaSrc) || '' });
          }
          //this.unregisterSwService.registerServiceWorker();
          // Exiba uma mensagem de sucesso
          this.messageService.add({
            severity: 'success',
            summary: 'Slick Salvo',
            detail: 'O slick foi salvo com sucesso!'
          });
        }

        /////////////////////////////
        const comps = resp?.widget?.[0]?.assets?.items?.[0]?.content?.cta?.components ?? {};

        const asArray = (v: any) => Array.isArray(v) ? v : [];
        const isTrue = (v: any) => v === true || v === 1 || v === '1';
        const isVisible = (item: any) => {
          // Se não vier show_item, considere visível por padrão
          if (item?.show_item === undefined) return true;
          return isTrue(item.show_item);
        };

        const customArr = asArray(comps.custom);
        const linksArr = asArray(comps.links);
        const productsArr = asArray(comps?.products?.items);

        this.hasCustom = customArr.some(isVisible);
        this.hasLinks = linksArr.some(isVisible);
        this.hasProducts = productsArr.some(isVisible);

        // Ver comentário equivalente em detailAsset(): Produtos nunca tem
        // prioridade (desabilitado se custom OU links ativo, mesmo com
        // hasProducts=true — caso de produto adicionado via slicks-data-view
        // enquanto custom/link já existia). Custom/Links mantêm a regra
        // original entre si.
        const disableAll = this.hasCustom || this.hasProducts || this.hasLinks;
        this.ctaOptions = [
          {
            label: 'Produtos',
            command: () => this.selecionarOpcao(1),
            disabled: this.hasCustom || this.hasLinks,
          },
          {
            label: 'Custom',
            command: () => this.selecionarOpcao(2),
            disabled: disableAll && !this.hasCustom,
          },
          { label: 'Whatsapp', command: () => this.selecionarOpcao(3) },
          { label: 'Alertas', command: () => this.selecionarOpcao(5) },
          {
            label: 'Links',
            command: () => this.selecionarOpcao(6),
            disabled: disableAll && !this.hasLinks,
          },
        ];

        // Mantém a tab atual se ainda estiver habilitada, senão seleciona a primeira habilitada
        const currentTab = this.activeItem?.label
          ? this.ctaOptions.find(opt => opt.label === this.activeItem?.label && !opt.disabled)
          : null;
        const tabToSelect = currentTab ?? this.ctaOptions.find(opt => !opt.disabled) ?? this.ctaOptions[0];
        if (tabToSelect?.command && tabToSelect !== currentTab) {
          tabToSelect.command();
        }
        this.activeItem = tabToSelect;
        this.cdr.detectChanges();
        /////////////////////////////

      },
      error: (error) => {
        this.loadingBtnNovo = false;
        let message = '';
        this.loadingBtn = false;
        this.savePixelLoading = false;
        if (error.status === 400 || error.status === 403 || error.status === 401) {
          message = error.error.message;
        } else if (error.status === 500) {
          message = "Ops... Algo de errado aconteceu. Tente novamente mais tarde.";
        } else if (error.status !== 404) {
          message = error.error.message;
        }

        if (message) {
          this.errorHandler.handle(error, message);
        }


      }
    });

  }
  showErrorDialog(message: string) {
    this.confirmationService.confirm({
      message: message,
      header: 'Erro',
      icon: 'pi pi-times',
      accept: () => {
        // Lógica de aceitação, se necessário
      }
    });
  }
  currentItem: any = null;
  // Cores da loja (primária/secundária) pros botões do player Lit embutido
  // aqui - vêm junto com detailAsset() (detailAssetsUid, backend). Ver
  // pushLiveUpdate()/bridge?.init() abaixo, onde são repassadas pro embed.
  storeColors?: { primary_color?: string | null; secondary_color?: string | null };
  mediaType?: string | null;
  mediaSrc?: string | null;
  mediaDuration?: number | null;
  mediaThumbnail?: string | null;
  mediaAspectRatio?: string | null;
  mediaExtension?: string | null;
  mediaStatus?: number | null;

  onUsageRightsSaved(event: { items: any[], keyword: string }): void {
    if (this.currentItem) this.currentItem.usage_rights = 'waiting';
  }

  onUsageRightsCommentSent(event: { items: any[] }): void {
    if (this.currentItem) this.currentItem.usage_rights = 'waiting';
  }

  private extractExtension(url?: string | null): string | null {
    if (!url) return null;
    try {
      const pathname = new URL(url).pathname;
      const ext = pathname.split('.').pop()?.toLowerCase();
      return ext && ext.length <= 5 ? ext : null;
    } catch {
      return null;
    }
  }
  loadingPublish = false;
  contentTitle?: string | null;
  scheduleDateFrom?: string | null;
  scheduleDateTo?: string | null;
  asset_id!: number;

  customComponentsTmp?: any;
  whatsAppComponentsTmp?: any;
  alertsAppComponentsTmp?: any;
  playerTimeout?: any;
  linksSelecteds: Links[] = [];
  showBtns: boolean = false;
  // Botão de Comprar duration adjustVideoMargin 
  shouMuteImg: boolean = false;
  displayButtons: boolean = false;
  videoReadyToLoad: boolean = false;



  setVideoSRC(videoSRC: string | null | undefined): string | null {
    const replacedDomainURL = this.replaceDomain(videoSRC);
    if (replacedDomainURL) {
      return replacedDomainURL.split('?')[0] + '?ngsw-bypass=true';
    }
    return null; // ou qualquer valor padrão que faça sentido no seu caso
  }
  username: string = '';
  currentNumUsers: number = 0;
  private subscriptionsChat = new Subscription();
  user_chat?: string;
  adminChatName: string = '';
  is_chat_conected: boolean = false;
  private connectToRoom(): void {
    // Chat listing migrated to REST API â€” messages load via chatBoxComponent.loadMessages()
  }

  changeIntervalAlert() {
    this.setupFilteredAlerts();
    this.debounceFunction();
  }


  setLinks(linksComponents: any) {
    this.linksSelecteds = linksComponents.map((component: any) => {
      const start = component.time_from || "00:00:00";
      const end = component.time_to || "00:00:00";

      // Utiliza a função convertAccordionTimeToSliderValue para calcular os valores do slider
      const sliderTimeRange = this.convertAccordionTimeToSliderValue(start, end, this.sliderMaxValue);
      return {
        id: component.id,
        name: component.name,
        bg_color: component.bg_color || '#000000', // Certifique-se de ter um valor padrão para background
        define_interval: component.define_interval, // Convertendo para booleano
        show_item: component.show_item, // Convertendo para booleano
        position: component.position, //
        redirect_url: component.redirect_url,
        click_url: component.click_url, //
        interval_time: {
          start: component.time_from || "00:00:00",
          end: component.time_to || "00:00:00"
        },
        slider_time_range: sliderTimeRange,
        // Novos campos do botão
        button_bg_color: component.button_bg_color || '#222',     // cor de fundo do botão
        button_text_color: component.button_text_color || '#fff',  // cor do texto do botão
        button_text: component.button_text || 'Aprender já',
        card_text_color: component.card_text_color || 'Aprender já',
        description: component.description || '',
      };
    });
    this.changeShowLinks();
  }
  changeShowLinks() {
    this.cdr.detectChanges();
    // this.setupFilteredLinks();
    // this.setupFilteredLinksShortucut();
    this.setupFilteredLinksUnificado();
    this.debounceFunction();
  }
  setAlerts(alertsComponents: any) {
    this.alertsTabs = alertsComponents.map((component: any) => {
      const start = component.time_from || "00:00:00";
      const end = component.time_to || "00:00:00";

      // Utiliza a função convertAccordionTimeToSliderValue para calcular os valores do slider
      const sliderTimeRange = this.convertAccordionTimeToSliderValue(start, end, this.sliderMaxValue);

      const toBool = (v: any) =>
        v === true || v === 1 || v === '1' || v === 'true' || v === 'TRUE';
      return {
        header: component.header,
        text: component.text,
        showAlerts: toBool(component.show_alerts),
        font_color: component.font_color || '#FFFFFF',
        background: component.background || '#000000', // Certifique-se de ter um valor padrão para background
        define_interval: component.define_interval, // Convertendo para booleano
        show_item: toBool(component.show_item),
        interval_time: {
          start: component.time_from || "00:00:00",
          end: component.time_to || "00:00:00"
        },
        slider_time_range: sliderTimeRange // Usando os valores calculados
      };
    });

    this.changeShowAlert();
  }
  changeShowAlert() {
    this.cdr.detectChanges();
    this.setupFilteredAlerts();
    this.debounceFunction();
  }


  setWhatsAppTabs(whatsComponents: any) {
    this.whatsappTabs = whatsComponents.map((component: any) => {
      const start = component.time_from || "00:00:00";
      const end = component.time_to || "00:00:00";
      // Utiliza a função convertAccordionTimeToSliderValue para calcular os valores do slider
      const sliderTimeRange = this.convertAccordionTimeToSliderValue(start, end, this.sliderMaxValue);

      // Verifica se há um DDI salvo, senão usa um valor padrão (Brasil)
      const ddi = component.ddi || '+55';

      // Encontra o país correspondente ao DDI para exibir a bandeira correta
      const selectedCountry = this.countries.find(country => country.ddi === ddi) || this.countries[0];

      return {
        header: component.title,
        ddd: component.ddd,
        whatsappMsg: component.whatsappMsg,
        ddi: selectedCountry,
        show_item: component.show_item,
        fone: component.phone || '',
        define_interval: component.define_interval, // Isto converte para booleano
        interval_time: {
          start: component.time_from || "00:00:00",
          end: component.time_to || "00:00:00"
        },
        slider_time_range: sliderTimeRange,
        selectedCountry: selectedCountry
      };
    });
  }
  setCustom(customComponents: any) {
    this.accordionTabs = customComponents.map((component: any) => {
      const start = component.time_from || "00:00:00";
      const end = component.time_to || "00:00:00";
      // Supondo que convertTimeToSliderValue já foi corrigido conforme discutido
      const sliderTimeRange = this.convertAccordionTimeToSliderValue(start, end, this.sliderMaxValue);
      return {
        header: component.title, // ou outro campo relevante para o cabeçalho
        button_text: component.name,
        show_item: component.show_item,
        redirect_url: component.redirect_url || '',
        font_color_custom: component.font || '#FFFFFF',
        bg_color_custom: component.background || '#000000',
        define_interval: component.define_interval,
        interval_time: {
          start: component.time_from || "00:00:00",
          end: component.time_to || "00:00:00"
        },
        // Use os valores convertidos para inicializar slider_time_range
        slider_time_range: sliderTimeRange
      };
    });
  }


  public filteredProducts: any[] = [];

  setupFilteredProducts(): void {
    this.filteredProducts = (this.targetProducts || [])
      .filter(product => product.show_item)
      .slice(0, 5); // mostra apenas os 5 primeiros

    this.updateTabs();
  }

  public filteredLinks: any[] = [];

  setupFilteredLinksUnificado(): void {
    const links = this.linksSelecteds || [];
    this.filteredLinks = links
      .filter(link => link.show_item)
      .map(link => ({
        id: link.id,
        name: link.name,
        bg_color: link.bg_color || '#000000',
        define_interval: link.define_interval,
        show_item: link.show_item,
        position: link.position,
        redirect_url: link.redirect_url,
        click_url: link.click_url,
        interval_time: link.interval_time || { start: '00:00:00', end: '00:00:00' },
        slider_time_range: this.convertAccordionTimeToSliderValue(
          link.interval_time?.start || '00:00:00',
          link.interval_time?.end || '00:00:00',
          this.sliderMaxValue
        ),
        button_bg_color: link.button_bg_color || '#222',
        button_text_color: link.button_text_color || '#fff',
        card_text_color: link.card_text_color || '#fff',
        button_text: link.button_text || 'Aprender járrr',
        description: link.description || '',
      }));

    this.hasVisibleLinksSwiper = this.filteredLinks.length > 0;
  }

  hexToRgba(hex: string, alpha: number = 1): string {
    let c = hex.replace('#', '');
    if (c.length === 3) {
      c = c.split('').map(x => x + x).join('');
    }
    const num = parseInt(c, 16);
    const r = (num >> 16) & 255;
    const g = (num >> 8) & 255;
    const b = num & 255;
    return `rgba(${r},${g},${b},${alpha})`;
  }

  // setupFilteredLinks(): void {
  //   const links = this.linksSelecteds || [];

  //   this.filteredLinks = links
  //     .filter(link => !link.link_type || (link.link_type === 'swiper' && link.show_item))
  //     .map(link => ({
  //       id: link.id,
  //       name: link.name,
  //       bg_color: link.bg_color || '#000000',
  //       define_interval: link.define_interval,
  //       show_item: link.show_item,
  //       position: link.position,
  //       redirect_url: link.redirect_url,
  //       click_url: link.click_url,
  //       interval_time: link.interval_time || { start: '00:00:00', end: '00:00:00' },
  //       slider_time_range: this.convertAccordionTimeToSliderValue(
  //         link.interval_time?.start || '00:00:00',
  //         link.interval_time?.end || '00:00:00',
  //         this.sliderMaxValue
  //       )
  //     }));

  //   this.hasVisibleLinksSwiper = this.filteredLinks.length > 0;
  //   this.updateTabs();
  // }

  public filteredLinksShortucut: any[] = [];

  // setupFilteredLinksShortucut(): void {
  //   const links = this.linksSelecteds || [];



  //   this.filteredLinksShortucut = links
  //     .filter(link => link.link_type === 'shortcut' && link.show_item)
  //     .map(link => ({
  //       id: link.id,
  //       name: link.name,
  //       bg_color: link.bg_color || '#000000',
  //       define_interval: link.define_interval,
  //       show_item: link.show_item,
  //       link_type: link.link_type,
  //       position: link.position,
  //       redirect_url: link.redirect_url,
  //       click_url: link.click_url,
  //       interval_time: link.interval_time || { start: '00:00:00', end: '00:00:00' },
  //       slider_time_range: this.convertAccordionTimeToSliderValue(
  //         link.interval_time?.start || '00:00:00',
  //         link.interval_time?.end || '00:00:00',
  //         this.sliderMaxValue
  //       )
  //     }));
  //   this.updateTabs();
  // }
  public visibleButtons: any[] = [];

  setupVisibleButton(): void {
    this.visibleButtons = (this.accordionTabs || [])
      .filter(tab => tab.show_item)
      .slice(0, 1) // só exibe o primeiro visível
      .map(tab => ({

        button_text: tab.button_text || '',
        redirect_url: tab.redirect_url || '',
        font_color_custom: tab.font_color_custom || '#FFFFFF',
        bg_color_custom: tab.bg_color_custom || '#000000',
        show_item: tab.show_item,
        define_interval: tab.define_interval,
        interval_time: tab.interval_time || { start: '00:00:00', end: '00:00:00' },
        slider_time_range: this.convertAccordionTimeToSliderValue(
          tab.interval_time?.start || '00:00:00',
          tab.interval_time?.end || '00:00:00',
          this.sliderMaxValue
        )
      }));
    this.updateTabs();
  }

  productsToShow: number = 5;
  linksToShow: number = 5;
  shortsToShow: number = 5;
  tabs: { header: string, items: any[], type: string, totalItems: number, isLoading: boolean }[] = [];
  get hasTabsWithItems(): boolean {
    return this.tabs?.some(tab => tab.items?.length > 0) ?? false;
  }
  updateTabs(): void {
    this.tabs = [
      {
        header: 'Produtos',
        items: this.filteredProducts?.slice(0, this.productsToShow) ?? [],
        totalItems: this.filteredProducts?.length ?? 0,
        type: 'products',
        isLoading: true
      },
      {
        header: 'Links',
        items: this.filteredLinks?.slice(0, this.linksToShow) ?? [],
        totalItems: this.filteredLinks?.length ?? 0,
        type: 'links',
        isLoading: true
      },
      {
        header: 'CTA',
        items: this.visibleButtons?.slice(0, 1) ?? [],
        totalItems: this.visibleButtons?.length ?? 0,
        type: 'buttons',
        isLoading: true
      }
    ];

    this.tabs = this.tabs
      .filter(tab => tab.items.length > 0)
      .sort((a, b) => b.items.length - a.items.length);

    if (this.tabs.length > 0) {
      this.selectedTab = this.tabs[0];
    } else {
      this.selectedTab = null;
    }

    this.cdr.detectChanges();
  }

  loadMoreLinks() {
    const activeTab = this.tabs.find(tab => tab.type === 'links');
    if (!activeTab) return;

    const totalLinks = activeTab.totalItems;
    const currentCount = activeTab.items.length;

    // if (currentCount < totalLinks) {
    //   activeTab.items.push(
    //     ...this.linksPerSlide[this.realActiveIndex].slice(currentCount, currentCount + this.linksToShow)
    //   );
    // }
  }
  loadMoreShorts() {
    const activeTab = this.tabs.find(tab => tab.type === 'shorts');
    if (!activeTab) return;

    const totalShorts = activeTab.totalItems;
    const currentCount = activeTab.items.length;

    // if (currentCount < totalShorts) {
    //   activeTab.items.push(
    //     ...this.shortcutsPerSlide[this.realActiveIndex].slice(currentCount, currentCount + this.shortsToShow)
    //   );
    // }
  }
  addToCart(product: any, event: any) {

  }
  async handleLinkClickShortcut(link: any): Promise<void> { }



  filteredProducts$?: Observable<Produto[]>;

  //////////////////////////
  visibleButton$?: Observable<AccordionTab | null>;



  shouldShowButton(tab: AccordionTab, videoTime: number): boolean {

    if (tab.define_interval === false) {
      return true;
    }

    const startSeconds = this.timeToSeconds(tab.interval_time?.start || '00:00:00');
    const endSeconds = this.timeToSeconds(tab.interval_time?.end || '00:00:00');
    return (videoTime >= startSeconds && videoTime <= endSeconds) || (startSeconds === 0 && endSeconds === 0);
  }
  //////////////////////////
  visibleButtonWhatsApp$?: Observable<WhatsAppTab | null>;

  setupVisibleButtonWhatsApp(): void {
    this.visibleButtonWhatsApp$ = combineLatest([
      this.stateManagementService.getVideoTime(),
    ]).pipe(
      map(([videoTime]) => {
        const button = this.whatsappTabs.find(tab => tab.show_item);
        return button ? button : null; // ðŸ‘ˆ aqui garante que não fique undefined
      })
    );
  }

  shouldShowButtonWhatsApp(tab: WhatsAppTab, videoTime: number): boolean {

    if (tab.define_interval === false) {
      return true;
    }

    const startSeconds = this.timeToSeconds(tab.interval_time?.start || '00:00:00');
    const endSeconds = this.timeToSeconds(tab.interval_time?.end || '00:00:00');
    return (videoTime >= startSeconds && videoTime <= endSeconds) || (startSeconds === 0 && endSeconds === 0);
  }

  // Extrai a lógica de abertura do WhatsApp para sua própria função para reutilização.
  displayDialogWhats: boolean = false;
  whatsappCtaDismissed: boolean = false;

  closeWhatsappCta(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.whatsappCtaDismissed = true;
  }

  cancelRedirectWhats() {
    this.displayDialogWhats = false;
    if (document.pictureInPictureElement) {
      document.exitPictureInPicture();
    }
  }
  openWhatsApp(tab: WhatsAppTab): void {
    const ddiStr = (tab.ddi as any)?.ddi ?? tab.ddi ?? '+55';
    this.tmpWhasPhone = `${String(ddiStr).replace('+', '')}${tab.ddd}${tab.fone}`;
    this.tmpWhatsMessage = tab.whatsappMsg || '';
    this.displayDialogWhats = true;
    if (!document.pictureInPictureElement && this.player.requestPictureInPicture) {
      this.player.requestPictureInPicture();
    }
  }


  convertToRgba(hexColor: string | undefined, opacity: number): string {
    if (!hexColor) {
      return ''; // Retorne um valor padrão ou mantenha vazio
    }

    return hexColor + '30'; // Retorna a cor original caso algo dê errado ou o formato não seja esperado
  }


  confirmRedirectWhats() {
    this.displayDialogWhats = false;
    this.openWhatsAppUrl(this.tmpWhasPhone);
  }
  tmpWhasPhone: string = '';
  tmpWhatsMessage: string = '';
  openWhatsAppUrl(phoneNumber: string) {
    const text = this.tmpWhatsMessage ? `&text=${encodeURIComponent(this.tmpWhatsMessage)}` : '';
    const whatsappUrl = `https://api.whatsapp.com/send/?phone=${phoneNumber}${text}&type=phone_number&app_absent=0`;
    window.open(whatsappUrl, '_blank');
  }

  //////////////////////////
  filteredPromotions$: Observable<Promotion[]> = of([]);
  setupFilteredPromotions(): void {
    this.filteredPromotions$ = combineLatest([
      this.stateManagementService.getVideoTime(),
      of(this.targetPromotions),
      this.stateManagementService.typeLive$
    ]).pipe(
      map(([videoTime, promotions, typeLive]) => {
        if (typeLive) {
          // Se typeLive for true, retorne todas as promoções
          return promotions;
        } else {

          // Se typeLive for false, aplique o filtro baseado em videoTime
          return promotions.filter(promotion => {
            if (promotion.define_interval === false) {
              return true;
            }
            const startSeconds = this.timeToSeconds(promotion.interval_time?.start || '00:00:00');
            const endSeconds = this.timeToSeconds(promotion.interval_time?.end || '00:00:00');
            return (videoTime >= startSeconds && videoTime <= endSeconds) ||
              (startSeconds === 0 && endSeconds === 0);
          });
        }
      })
    );
  }
  //////////////////////////



  filteredLinks$?: Observable<Links[]>;

  showAllShortucutLinks: boolean = false;
  filteredLinksShortucut$?: Observable<Links[]>;
  hasLinks$?: Observable<boolean>;
  additionalLinks$?: Observable<Links[]>;
  private resizeSubscription: Subscription | null = null;

  @ViewChild('btnsRightSup') btnsRightSup?: ElementRef;
  trackByLinkId(index: number, link: Links): number {
    return link.id; // ou outra propriedade única
  }

  updateLinksDisplay(itemsToShow: number, linksSource$: Observable<Links[]>): void {
    this.filteredLinksShortucut$ = linksSource$.pipe(
      map(links => links.slice(0, itemsToShow))
    );
    this.hasLinks$ = this.filteredLinksShortucut$.pipe(
      map(links => links.length > 0)
    );
    this.resizeObserverBreakPoints?.disconnect();
    this.resizeObserverBreakPoints = new ResizeObserver(entries => {
      for (const entry of entries) {
        const width = entry.contentRect.width;
        this.applySwiperStyles2(width);
        this.applySwiperStyles3(width);
      }
    });

    if (this.gridContainer) {
      this.resizeObserverBreakPoints.observe(this.gridContainer.nativeElement);
    }
  }


  updateLinkType() {


    // Encontre o índice com base no identificador único
    const index = this.linksSelecteds.findIndex(link => link.name === this.linkSelecionado.name);
    //const index = this.linksSelecteds['id'];
    if (index !== -1) {
      this.linksSelecteds[index] = { ...this.linkSelecionado };
    }

    this.linksSelecteds = [...this.linksSelecteds];

    // this.setupFilteredLinks();
    // this.setupFilteredLinksShortucut();
    this.setupFilteredLinksUnificado();
  }

  // getLinksSource(): Observable<Links[]> {
  //   // Simula a obtenção dos links (deverá ser substituído pelo seu serviço real)
  //   return this.stateManagementService.getLinksObservable();
  // }

  openSidebarCTALinks() {
    this.showAllShortucutLinks = !this.showAllShortucutLinks;
  }

  //////////////////////////
  sidebarPromotions: boolean = true;
  sidebarVisible = false;
  @ViewChild('promoDiv') promoDiv?: ElementRef;
  //private clickOutsideHandler: (event: MouseEvent) => void;
  toggleSidebarPromos(event: MouseEvent): void {
    //document.body.classList.add('body-fixed');
    event.stopPropagation();
    this.sidebarVisible = !this.sidebarVisible;
    //this.adjustVideoMargin();
  }

  //////////////////////////


  normalizePromosData(productFromService: any) {
    let showInterval = false;
    if (productFromService.interval_time.start != "00:00:00" || productFromService.interval_time.end != "00:00:00") {
      showInterval = true;
    }
    return {
      id: productFromService.id, // Use id em vez de product_id
      name: productFromService.header,
      value: productFromService.value,
      status: productFromService.status,
      isSelected: true,
      show_item: productFromService.show_item,
      highlight: productFromService.highlight,
      define_interval: productFromService.define_interval, // Supondo que você queria essa propriedade baseado na imagem
      show_slider: showInterval,
      interval_time: productFromService.interval_time,
      // Outras propriedades que você deseja incluir...
    };
  }
  convertPriceProduct(price: any): number {
    // Verifica se price é uma string e se contém uma vírgula
    if (typeof price === 'string' && price.includes(',')) {
      // Substitui a vírgula por ponto para fazer a conversão correta para float
      return parseFloat(price.replace(',', '.'));
    } else if (typeof price === 'string') {
      // Se for uma string, mas não tiver vírgula, tenta converter diretamente
      return parseFloat(price);
    } else {
      // Se não for uma string ou se não puder ser convertido, retorna 0 ou algum outro valor padrão
      // Você pode ajustar este retorno conforme a necessidade da sua aplicação
      return price;
    }
  }


  toggleDefineInterval(value: boolean): void {

    if (this.selectedProductForEdit) { // onDefineIntervalChange
      // Criar uma cópia atualizada do produto
      const updatedProduct = {
        ...this.selectedProductForEdit,
        define_interval: value,
        show_slider: value
      };

      // Atualizar o produto na lista de produtos alvo (targetProducts)
      const index = this.targetProducts.findIndex(p => p.id === this.selectedProductForEdit.id);
      if (index !== -1) {
        this.targetProducts[index] = updatedProduct;
        // Atualizar a referência para selectedProductForEdit
        this.selectedProductForEdit = updatedProduct;
      }

      this.targetProducts = [...this.targetProducts];
      this.setupFilteredProducts();

      if (this.filteredProducts$) {
        this.highlightedProductsLimited$ = this.filteredProducts$.pipe(
          map(products =>
            products.filter(product => product.highlight).slice(0, 3)
          )
        );
      }

      this.cdr.detectChanges();
      this.debounceFunction();
    }
  }
  toggleDefineIntervalPromotions(value: boolean): void {

    if (this.selectedProductForEdit) { // onDefineIntervalChange
      // Criar uma cópia atualizada do produto
      const updatedProduct = {
        ...this.selectedProductForEdit,
        define_interval: value,
        show_slider: value
      };

      // Atualizar o produto na lista de produtos alvo (targetPromotions)
      const index = this.targetPromotions.findIndex(p => p.id === this.selectedProductForEdit.id);
      if (index !== -1) {
        //this.targetPromotions[index] = updatedProduct;
        // Atualizar a referência para selectedProductForEdit
        this.selectedProductForEdit = updatedProduct;
      }

      this.targetPromotions = [...this.targetPromotions];
      this.setupFilteredPromotions();

      ////////////this.cdr.detectChanges();
      this.debounceFunction();
    }
  }



  onSliderChangeCustom(index: number, event: any): void {
    // Assumindo que o evento traz um objeto com 'start' e 'end'
    const { start, end } = event.values;

    // Verifique se ambos os valores são strings de tempo válidas
    if (typeof start === 'string' && typeof end === 'string') {
      const tab = this.accordionTabs[index];

      // Atualize o objeto 'tab' diretamente com os novos valores
      if (!tab.interval_time) {
        tab.interval_time = { start: "00:00:00", end: "00:00:00" };
      }

      //tab.interval_time = { start: start, end: end };
      tab.interval_time.start = this.convertNumericToTime(event.values[0]);
      tab.interval_time.end = this.convertNumericToTime(event.values[1]);
      // this.debounceFunction();
    } else {
      console.error('Valores do slider não são strings de tempo:', start, end);
    }
  }

  convertNumericToTime(numericValue: number): string {
    const hours = Math.floor(numericValue / 60);
    const minutes = numericValue % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`;
  }


  onSliderChangeWhats(index: number, event: any): void {
    const tab = this.whatsappTabs[index];
    // Aqui você chama o método de conversão passando os valores do slider (event.values) para obter os novos tempos de início e fim formatados.
    const { start, end } = this.convertSliderValueToTime(event.values);
    tab.interval_time!.start = start;
    tab.interval_time!.end = end;
  }

  convertSliderValueToTime(values: number[]): { start: string, end: string } {
    const convertValueToTimeString = (val: number): string => {
      const hours = Math.floor(val / 3600);
      const minutes = Math.floor((val % 3600) / 60);
      const seconds = val % 60;
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };

    return {
      start: convertValueToTimeString(values[0]),
      end: convertValueToTimeString(values[1])
    };
  }
  convertAccordionTimeToSliderValue(start: string, end: string, sliderMaxValue: number): [number, number] {
    const convertTimeStringToSliderValue = (timeString: string): number => {
      const [hours, minutes, seconds] = timeString.split(':').map(Number);
      // Converte o tempo para segundos totais
      const totalTimeInSeconds = (hours * 3600) + (minutes * 60) + seconds;
      // Ajusta o valor para o intervalo do slider
      return totalTimeInSeconds / sliderMaxValue; // Proporção do sliderMaxValue
    };

    const startValue = convertTimeStringToSliderValue(start) * sliderMaxValue;
    const endValue = convertTimeStringToSliderValue(end) * sliderMaxValue;

    // Garante que os valores estejam dentro dos limites do slider
    return [startValue, endValue];
  }




  convertTimeToSliderValue(time: { start: string, end: string } | undefined): number[] {
    if (time) {
      const convertTimeStringToValue = (timeString: string): number => {
        const [hours, minutes, seconds] = timeString.split(':').map(Number);
        // Aqui estamos convertendo tudo para segundos, se necessário.
        return (hours * 3600) + (minutes * 60) + seconds;
      };

      return [convertTimeStringToValue(time.start), convertTimeStringToValue(time.end)];
    }
    // Retorne um valor padrão se 'time' for 'undefined'.
    return [0, 86400]; // Pode ajustar para um valor padrão específico, se necessário.
  }

  issueForm?: FormGroup;

  openDialogDrag: boolean = false;
  openDialogDragPromotion: boolean = false;
  selectedProductIndex: number | null = null;
  // sliderValue
  openSidebarEditConfigs(product: Produto, index: number): void {
    // Inicialize o intervalTime caso não esteja definido
    const intervalTime = product.interval_time || { start: '00:00:00', end: '00:00:00' };

    // Atualize a referência de selectedProductForEdit para o objeto dentro de targetProducts
    this.selectedProductIndex = this.targetProducts.findIndex(p => p.id === product.id);
    if (this.selectedProductIndex !== -1) {
      this.selectedProductForEdit = this.targetProducts[this.selectedProductIndex];
    } else {
      this.selectedProductForEdit = product;
    }

    this.sliderValue = this.convertTimeToSliderValue(intervalTime);
    const associated = this.chapters.find(c => c.product_sku === String(product.sku));
    this.selectedChapterForProduct = associated?.time ?? null;
    this.openDialogDrag = true;
    this.pickListObserverService.notifyChange();
  }

  updateProductSwiper(product: Produto, changes: any) {
    const index = this.targetProducts.findIndex(p => p.id === product.id);
    if (index !== -1) {
      const updatedProduct = { ...this.targetProducts[index], ...changes };
      this.targetProducts[index] = updatedProduct;
      this.setupFilteredProducts();
      ////////////this.cdr.detectChanges();
    }
  }
  openSidebarEditConfigsPromotion(product: Produto, index: number): void {
    // Inicialize o intervalTime caso não esteja definido
    const intervalTime = product.interval_time || { start: '00:00:00', end: '00:00:00' };

    // Atualize a referência de selectedProductForEdit para o objeto dentro de targetProducts
    this.selectedProductIndex = this.targetProducts.findIndex(p => p.id === product.id);
    if (this.selectedProductIndex !== -1) {
      this.selectedProductForEdit = this.targetProducts[this.selectedProductIndex];
    } else {
      this.selectedProductForEdit = product;
    }

    this.sliderValuePromotion = this.convertTimeToSliderValue(intervalTime);
    this.openDialogDragPromotion = true;
    this.pickListObserverService.notifyChange();
  }

  sliderValue: number[] = [0, 1440];
  sliderValuePromotion: number[] = [0, 1440];

  fontColorOptions = [
    { label: 'Preto', value: 'black' },
    { label: 'Branco', value: 'white' },
  ];

  bgColorOptions = [
    { label: 'Vermelho', value: 'red' },
    { label: 'Verde', value: 'green' },
  ];

  closeSidebarDetail() {
    this.openDialogDrag = false;
  }
  closeSidebarDetailPromos() {
    this.openDialogDragPromotion = false;
  }
  closeSidebarDetailCtasLinks() {
    this.sideBarLinks = false;
  }

  defineIntervalCustom: boolean = false;
  intervalCustom: Custom = {
    id: 0,
    interval_time: { start: "00:00:00", end: "00:00:00" },
  }
  fontColorCustom: string = "#000000";
  bgColorCustom: string = "#ffffff";


  accordionTabs: AccordionTab[] = [];
  whatsappTabs: WhatsAppTab[] = [];
  linksTabs: Links[] = [];
  alertsTabs: AlertsTab[] = [];

  addComponentWhatsApp() {
    const newTabNumber = this.whatsappTabs.length + 1;
    if (this.whatsappTabs.length > 0) {
      this.whatsappTabs.push({
        header: `Whatsaap ${newTabNumber}`,
        ddi: '+55',
        ddd: '',
        fone: '',
        define_interval: true,
        show_item: true,
        interval_time: { start: "00:00:00", end: "00:00:00" },
        slider_time_range: [0, 0],
        whatsappMsg: ''
      });
    } else {
      this.whatsappTabs.push({
        header: `Whatsaap ${newTabNumber}`,
        ddi: '+55',
        ddd: '',
        fone: '',
        define_interval: false,
        show_item: true,
        interval_time: { start: "00:00:00", end: "00:00:00" },
        slider_time_range: [0, 0],
        whatsappMsg: ''
      });
      this.isAddButtonDisabledWhats = true;
    }
    this.pickListObserverService.notifyChange();
    this.debounceFunction();
    this.setupVisibleButtonWhatsApp();
    this.pushLiveUpdate();
  }
  addComponentCustom() {
    const newTabNumber = this.accordionTabs.length + 1;
    if (this.accordionTabs.length > 0) {
      this.accordionTabs.push({
        header: `Botão ${newTabNumber}`,
        button_text: 'Botão 1',
        redirect_url: '',
        font_color_custom: '#FFFFFF',
        bg_color_custom: '#000000',
        define_interval: false,
        show_item: true,
        interval_time: { start: "00:00:00", end: "00:00:00" }, // Garantido que sempre existe
        slider_time_range: [0, 0]
      });
    } else {
      this.accordionTabs.push({
        header: `Botão ${newTabNumber}`,
        button_text: 'Botão 1',
        redirect_url: '',
        font_color_custom: '#FFFFFF',
        bg_color_custom: '#000000',
        define_interval: false,
        show_item: true,
        interval_time: { start: "00:00:00", end: "00:00:00" }, // Garantido que sempre existe
        slider_time_range: [0, 0]
      });
      this.isAddButtonDisabled = true;
    }

    // Desativa o botão após adicionar o primeiro item
    this.isAddButtonDisabled = this.accordionTabs.length > 0;

    this.setupVisibleButton();
    this.pickListObserverService.notifyChange();
    this.pushLiveUpdate();
  }
  handleDefineIntervalChange(tab: any) {
    const newValue = tab.define_interval;
    // Atualiza todos os itens para ter o mesmo valor de define_interval_custom
    this.accordionTabs.forEach(item => {
      item.define_interval = newValue;
    });
    // Atualiza o estado do botão de adicionar "+" baseado no novo valor
    this.isAddButtonDisabled = !newValue;
    this.pushLiveUpdate();
  }
  handleDefineIntervalChangeWhats(tab: any) {
    const newValue = tab.define_interval;
    // Atualiza todos os itens para ter o mesmo valor de define_interval_custom
    this.whatsappTabs.forEach(item => {
      item.define_interval = newValue;
    });
    // Atualiza o estado do botão de adicionar "+" baseado no novo valor
    this.isAddButtonDisabledWhats = !newValue;
    this.pushLiveUpdate();
  }

  isAddButtonDisabled: boolean = false;
  isAddButtonDisabledWhats: boolean = false;

  removeComponentCustom(index: number): void {
    if (index > -1 && index < this.accordionTabs.length) {
      this.accordionTabs.splice(index, 1);
      ////////////this.cdr.detectChanges();
    }

    if (this.accordionTabs.length == 0) {
      this.isAddButtonDisabled = false;
    }

    // Reativa o botão se não houver mais itens na lista
    this.isAddButtonDisabled = this.accordionTabs.length > 0 ? true : false;
    this.canSave = true;
    this.pickListObserverService.notifyChange();
    this.setupVisibleButton();
    this.pushLiveUpdate();
  }
  removeComponentWhatsapp(index: number): void {
    if (index > -1 && index < this.whatsappTabs.length) {
      this.whatsappTabs.splice(index, 1);
      ////////////this.cdr.detectChanges();
    }
    this.pickListObserverService.notifyChange();
    this.setupVisibleButtonWhatsApp();
    this.pushLiveUpdate();
    if (this.whatsappTabs.length == 0) {
      this.isAddButtonDisabledWhats = false;
    }
  }
  removeComponentAlerts(index: number): void {
    if (index > -1 && index < this.alertsTabs.length) {
      this.alertsTabs.splice(index, 1);
      //////////this.cdr.detectChanges();
    }
    this.pickListObserverService.notifyChange();
    this.setupFilteredAlerts();
    this.pushLiveUpdate();
  }
  removeProduct(product: any) {
    // Defina isSelected como false antes de mover o produto de volta para a source.
    product.isSelected = false;

    // Remove o produto da lista de target.
    this.targetProducts = this.targetProducts.filter(p => p !== product);

    // Adiciona o produto de volta à lista de source.
    this.sourceProducts.push(product);
    this.pickListObserverService.notifyChange();
    this.targetProducts = [...this.targetProducts];
    this.setupFilteredProducts();
    if (this.filteredProducts$) {
      this.highlightedProductsLimited$ = this.filteredProducts$.pipe(
        map(products =>
          products.filter(product => product.highlight).slice(0, 3)
        )
      );
    }
    this.canSave = true;
    this.targetProducts = [...this.targetProducts];
    this.setupFilteredProducts();
    this.rebuildProductTags();
    this.cdr.detectChanges();
    this.pushLiveUpdate();
  }
  removeLink(index: number): void {
    // Remove o item no índice fornecido
    this.linksSelecteds.splice(index, 1);
    // Atualiza a lista para uma nova referência, garantindo que o Angular detecte a mudança
    this.linksSelecteds = [...this.linksSelecteds];
    // this.setupFilteredLinks();
    // this.setupFilteredLinksShortucut();
    this.setupFilteredLinksUnificado();
    this.pickListObserverService.notifyChange();
    this.pushLiveUpdate();
  }
  removePromotion(promotion: any) {
    // Defina isSelected como false antes de mover o produto de volta para a source.
    promotion.isSelected = false;

    // Remove o produto da lista de target.
    this.targetPromotions = this.targetPromotions.filter(p => p !== promotion);

    // Adiciona o produto de volta à lista de source.
    this.sourcePromotions.push(promotion);
    this.pickListObserverService.notifyChange();
    this.targetPromotions = [...this.targetPromotions];
    this.setupFilteredPromotions();
  }

  onSliderChange(product: Produto, event: any): void {
    if (product.interval_time) {
      // Asegura que os valores de `event.values` estejam dentro do range
      const startValue = Math.min(event.values[0], this.sliderMaxValue);
      const endValue = Math.min(event.values[1], this.sliderMaxValue);

      product.interval_time.start = this.formatSliderValue(startValue);
      product.interval_time.end = this.formatSliderValue(endValue);

      this.pickListObserverService.notifyChange();
    }
  }

  updateIntervalTime(values: number[]): void { // ddddddddddd
    if (this.selectedProductForEdit && this.selectedProductForEdit.interval_time && this.selectedProductIndex !== null) {
      // Agora trata os valores como segundos para converter para o formato de tempo HH:MM:SS
      const startTime = this.secondsToTimeString(values[0]);
      const endTime = this.secondsToTimeString(values[1]);

      this.selectedProductForEdit.interval_time.start = startTime;
      this.selectedProductForEdit.interval_time.end = endTime;

      this.debounceFunction();
      this.setupFilteredProducts();
      if (this.filteredProducts$) {
        this.highlightedProductsLimited$ = this.filteredProducts$.pipe(
          map(products =>
            products.filter(product => product.highlight).slice(0, 3)
          )
        );
      }
      this.setupFilteredProducts();
    }
  }
  // updateInputsFromSlider slider_time_range
  updateIntervalTime2(values: number[]): void {
    if (this.selectedProductForEdit && this.selectedProductForEdit.interval_time && this.selectedProductIndex !== null) {
      // Agora trata os valores como segundos para converter para o formato de tempo HH:MM:SS
      const startTime = this.secondsToTimeString(values[0]);
      const endTime = this.secondsToTimeString(values[1]);

      this.selectedProductForEdit.interval_time.start = startTime;
      this.selectedProductForEdit.interval_time.end = endTime;

      // Atualiza o produto na lista targetProducts
      this.targetProducts[this.selectedProductIndex] = { ...this.selectedProductForEdit };
      this.setupFilteredProducts();
      if (this.filteredProducts$) {
        this.highlightedProductsLimited$ = this.filteredProducts$.pipe(
          map(products =>
            products.filter(product => product.highlight).slice(0, 3)
          )
        );
      }
      this.pickListObserverService.notifyChange();
      this.targetProducts = [...this.targetProducts];
      this.setupFilteredProducts();
    }
  }
  secondsToTimeString(seconds: number): string {
    // Certifique-se de que está convertendo segundos para horas, minutos e segundos
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hrs.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  }
  minutesToTimeString(minutes: number): string {
    const hours = Math.floor(minutes / 60);
    const mins = Math.floor(minutes % 60);
    return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:00`;
  }

  formatSliderValue(value: number): string {
    const hours = Math.floor(value / 60);
    const minutes = value % 60;
    // Formato HH:MM:SS
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`;
  }
  showAlerts: boolean = false;
  addComponentAlerts() {
    const newTabNumber = this.alertsTabs.length + 1;
    this.alertsTabs.push({
      header: `Alerta ${newTabNumber}`,
      text: 'Alerta 1',
      font_color: '#FFFFFF',
      background: '#000000',
      define_interval: false,
      show_item: true,
      interval_time: { start: "00:00:00", end: "00:00:00" },
      slider_time_range: [0, 0]
    });

    //setup alertas
    this.setupFilteredAlerts();
    this.pickListObserverService.notifyChange();
    this.cdr.detectChanges();
  }
  toCssHex(v?: string): string {
    if (!v) return '';
    return v.startsWith('#') ? v : `#${v}`;
  }

  closeSidebarSaldo() {
    this.displaySidebarSaldo = false;
  }
  loadingBtnNovo:boolean= false;
  // Publicar/despublicar precisa passar pela MESMA rota usada em
  // slicks-data-view (feedService.publicarSelecionados/despublicarSelecionados
  // -> LiveShopController::publicar/despublicar) — é lá que mora a checagem de
  // limite de slicks ativos do plano (retorna 403 {code:1} quando estourado).
  // Antes esse botão chamava saveAsset() (o salvamento genérico do slick, que
  // também grava o campo status), então a checagem de limite nunca era
  // executada — dava pra publicar direto de dentro do slick-detail sem
  // respeitar o plano.
  toggleSlickStatus(newStatus: number): void {
    if (!this.uuid) return;
    const uids = [this.uuid];
    const statusOriginal = this.mediaStatus;
    this.loadingBtnNovo = true;

    const obs = newStatus === 1
      ? this.feedService.publicarSelecionados(uids)
      : this.feedService.despublicarSelecionados(uids);

    obs.subscribe({
      next: (res: any) => {
        this.loadingBtnNovo = false;
        // publicarSelecionados pode "aceitar" a chamada (200) mas não publicar
        // o item se o limite foi atingido exatamente nesse meio-tempo — mesma
        // checagem defensiva que slicks-data-view já faz.
        const publicados: string[] = res?.uids_publicados ?? [];
        const aplicado = newStatus === 1 ? publicados.includes(this.uuid!) : true;

        if (!aplicado) {
          this.mediaStatus = statusOriginal;
          this.messageService.add({
            severity: 'warn',
            summary: 'Limite Atingido',
            detail: 'Este item não foi publicado devido ao limite do plano.'
          });
          this.cdr.detectChanges();
          return;
        }

        this.mediaStatus = newStatus;
        this.verSlickStatus = newStatus !== 1;
        this.buildMenuInferior();
        this.messageService.add({
          severity: 'success',
          summary: newStatus === 1 ? 'Publicado' : 'Despublicado',
          detail: newStatus === 1 ? 'Slick publicado com sucesso.' : 'Slick despublicado com sucesso.'
        });
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.loadingBtnNovo = false;
        this.mediaStatus = statusOriginal;
        if (err.status === 403 && err.error?.code === 1 || err.status === 429) {
          this.handleUpgrade();
        } else {
          this.errorHandler.handle(err, newStatus === 1 ? 'Falha ao publicar o slick.' : 'Falha ao despublicar o slick.');
        }
        this.cdr.detectChanges();
      }
    });
  }

  upgradeDialogTitle: string = '';
  upgradeDialogMessage: string = '';
  showUpgradeDialog: boolean = false;
  handleUpgrade(): void {
    this.upgradeDialogTitle = 'Você atingiu seu limite de slicks ativos.';
    this.upgradeDialogMessage = 'Gostaria de alterar seu plano e aumentar seus limites de uso?';
    // Se já estava aberto, força fechar e reabrir no próximo ciclo (mesmo
    // padrão de slicks-data-view.handleUpgrade).
    this.showUpgradeDialog = false;
    setTimeout(() => {
      this.showUpgradeDialog = true;
      this.cdr.detectChanges();
    });
  }
  irParaAssinatura(): void {
    this.router.navigate(['/profile'], { fragment: 'feed_subs' });
  }

  closeSidebarGeral() {
    this.displaySidebar = false;
    if (this.observer) {
      this.observer.disconnect();
    }


    this.uploadProgress = 0;
    this.uploadProgressVideo = 0;

  }
  @Input() facebookPixel: boolean = false;
  ngOnChanges(changes: SimpleChanges) {
    // if (changes['facebookPixel'] && changes['facebookPixel'].currentValue === true) {
    //   this.loadPixelsLazy(); // Chame seu método aqui
    // }
  }
  openFacebookPixel() {
    this.facebookPixel = true;
    if (this.isMobile) {
      this.displaySidebar = false;
    }
    this.loadPixelsLazy();
  }
  filterValue: string = '';
  searchTerm: string = '';
  onFilterSlicks(event: Event) {
    this.filterValue = (event.target as HTMLInputElement).value.toLowerCase();
  }
  filteredPixels: any[] = [];
  onFilterSlicksPixel(event: any) {
    if (!this.searchTerm.trim()) {
      this.loadPixelsLazy();
    } else {
      // Converta o termo de busca para minúsculas para busca case-insensitive
      const searchTermLower = this.searchTerm.toLowerCase();
      // Filtre os pixels baseado no termo de pesquisa
      this.filteredPixels = this.pixels.filter((pixel) => {
        return pixel.key.toLowerCase().includes(searchTermLower) ||
          pixel.pixel_id.toString().toLowerCase().includes(searchTermLower);
      });
    }

    // Atualize a contagem total de registros com o número de itens filtrados
    this.totalRecords = this.filteredPixels.length;
    // Peça para o Angular atualizar a interface
    this.cdr.detectChanges();
  }


  addPixelDialog: boolean = false;
  savePixelLoading: boolean = false;
  isEditing: boolean = false;
  openAddPixel() {
    this.formData = {
      key: '',
      pixel_id: '',
      view_events: {
        fb_pixel_view: {
          view_events: {
            view_percentage: false,
            pitch_hit: false
          }
        }
      },
      conversion_events: {
        fb_pixel_conversion: {
          conversion_events: {
            skus: [], // Array vazio para iniciar
            product_view: false,
            credit_card_purchase: false,
            pixel_purchase: {
              trigger: false,
              conversion_value: null
            },
            slip_purchase: {
              trigger: false,
              conversion_value: null
            },
            cart_abandonment: false,
            credit_card_purchase_denied: false
          }
        }
      }
    }; // Limpe o formulário ou redefina para os valores padrões
    this.isEditing = false;
    this.addPixelDialog = true;
    this.updateFormattedProducts();
  }
  selectedItems: any[] = [];
  closeFacebookPixel() {
    this.facebookPixel = false;
  }
  closeAddFacebookPixel() {
    this.loadPixelsLazy();
    this.addPixelDialog = false;

  }
  formData: any = {
    key: '',
    pixel_id: '',
    view_events: {
      fb_pixel_view: {
        view_events: {
          view_percentage: false,
          pitch_hit: false
        }
      }
    },
    conversion_events: {
      fb_pixel_conversion: {
        conversion_events: {
          skus: [], // Array vazio para iniciar
          product_view: false,
          credit_card_purchase: false,
          pixel_purchase: {
            trigger: false,
            conversion_value: null
          },
          slip_purchase: {
            trigger: false,
            conversion_value: null
          },
          cart_abandonment: false,
          credit_card_purchase_denied: false
        }
      }
    }
  };
  pixels: any[] = [];
  actionMenuModel?: any[];
  totalRecords: number = 0;
  loadingPixels: boolean = true;
  loadingPixelsTable: boolean = true;
  loadPixelsLazy(event: any = {}) {
    if (!this.facebookPixel) return;
    this.loadingPixels = true;
    this.loadingPixelsTable = true;
    let page = ((event.first ?? 0) / (event.rows ?? 10)) || 0;
    let size = event.rows ?? 10;

    this.liveShopService.listPixelLazy(this.uuid!, page, size).pipe(takeUntil(this.destroy$)).subscribe({
      next: (data) => {
        if (data && data.data) {
          this.filteredPixels = data.data;
          this.totalRecords = data.total;
        } else {
          this.filteredPixels = [];
          this.totalRecords = 0;
        }
        this.loadingPixels = false;
        this.loadingPixelsTable = false;
        this.cdr.detectChanges();
      },
      error: (error) => {
        this.loadingPixels = false;
        this.loadingPixelsTable = false;
        this.cdr.detectChanges();
        let message = '';
        this.savePixelLoading = false;  // Supõe-se que você tenha um indicador de loading

        // Manuseio de erro conforme os códigos de status HTTP
        if (error.status === 400 || error.status === 403 || error.status === 401) {
          message = error.error.message;
        } else if (error.status === 500) {
          message = "Ops... Algo de errado aconteceu. Tente novamente mais tarde.";
        } else if (error.status !== 404) {
          message = error.error.message;
        }

        // Mostrar erro se houver uma mensagem
        if (message) {
          this.showErrorDialog(message);
        }
      }
    });
  }
  countries = [
    { name: 'Afghanistan', code: 'AF', ddi: '+93' },
    { name: 'Albania', code: 'AL', ddi: '+355' },
    { name: 'Algeria', code: 'DZ', ddi: '+213' },
    { name: 'Andorra', code: 'AD', ddi: '+376' },
    { name: 'Angola', code: 'AO', ddi: '+244' },
    { name: 'Argentina', code: 'AR', ddi: '+54' },
    { name: 'Australia', code: 'AU', ddi: '+61' },
    { name: 'Austria', code: 'AT', ddi: '+43' },
    { name: 'Bahamas', code: 'BS', ddi: '+1-242' },
    { name: 'Bahrain', code: 'BH', ddi: '+973' },
    { name: 'Bangladesh', code: 'BD', ddi: '+880' },
    { name: 'Barbados', code: 'BB', ddi: '+1-246' },
    { name: 'Belarus', code: 'BY', ddi: '+375' },
    { name: 'Belgium', code: 'BE', ddi: '+32' },
    { name: 'Belize', code: 'BZ', ddi: '+501' },
    { name: 'Benin', code: 'BJ', ddi: '+229' },
    { name: 'Bhutan', code: 'BT', ddi: '+975' },
    { name: 'Bolivia', code: 'BO', ddi: '+591' },
    { name: 'Bosnia and Herzegovina', code: 'BA', ddi: '+387' },
    { name: 'Botswana', code: 'BW', ddi: '+267' },
    { name: 'Brazil', code: 'BR', ddi: '+55' },
    { name: 'Bulgaria', code: 'BG', ddi: '+359' },
    { name: 'Burkina Faso', code: 'BF', ddi: '+226' },
    { name: 'Burundi', code: 'BI', ddi: '+257' },
    { name: 'Cambodia', code: 'KH', ddi: '+855' },
    { name: 'Cameroon', code: 'CM', ddi: '+237' },
    { name: 'Canada', code: 'CA', ddi: '+1' },
    { name: 'Cape Verde', code: 'CV', ddi: '+238' },
    { name: 'Central African Republic', code: 'CF', ddi: '+236' },
    { name: 'Chad', code: 'TD', ddi: '+235' },
    { name: 'Chile', code: 'CL', ddi: '+56' },
    { name: 'China', code: 'CN', ddi: '+86' },
    { name: 'Colombia', code: 'CO', ddi: '+57' },
    { name: 'Comoros', code: 'KM', ddi: '+269' },
    { name: 'Congo', code: 'CG', ddi: '+242' },
    { name: 'Congo (Democratic Republic)', code: 'CD', ddi: '+243' },
    { name: 'Costa Rica', code: 'CR', ddi: '+506' },
    { name: 'Croatia', code: 'HR', ddi: '+385' },
    { name: 'Cuba', code: 'CU', ddi: '+53' },
    { name: 'Cyprus', code: 'CY', ddi: '+357' },
    { name: 'Czech Republic', code: 'CZ', ddi: '+420' },
    { name: 'Denmark', code: 'DK', ddi: '+45' },
    { name: 'Djibouti', code: 'DJ', ddi: '+253' },
    { name: 'Dominican Republic', code: 'DO', ddi: '+1-809' },
    { name: 'Ecuador', code: 'EC', ddi: '+593' },
    { name: 'Egypt', code: 'EG', ddi: '+20' },
    { name: 'El Salvador', code: 'SV', ddi: '+503' },
    { name: 'Equatorial Guinea', code: 'GQ', ddi: '+240' },
    { name: 'Eritrea', code: 'ER', ddi: '+291' },
    { name: 'Estonia', code: 'EE', ddi: '+372' },
    { name: 'Eswatini', code: 'SZ', ddi: '+268' },
    { name: 'Ethiopia', code: 'ET', ddi: '+251' },
    { name: 'Fiji', code: 'FJ', ddi: '+679' },
    { name: 'Finland', code: 'FI', ddi: '+358' },
    { name: 'France', code: 'FR', ddi: '+33' },
    { name: 'Germany', code: 'DE', ddi: '+49' },
    { name: 'Ghana', code: 'GH', ddi: '+233' },
    { name: 'Greece', code: 'GR', ddi: '+30' },
    { name: 'Guatemala', code: 'GT', ddi: '+502' },
    { name: 'Honduras', code: 'HN', ddi: '+504' },
    { name: 'Hungary', code: 'HU', ddi: '+36' },
    { name: 'Iceland', code: 'IS', ddi: '+354' },
    { name: 'India', code: 'IN', ddi: '+91' },
    { name: 'Indonesia', code: 'ID', ddi: '+62' },
    { name: 'Iran', code: 'IR', ddi: '+98' },
    { name: 'Iraq', code: 'IQ', ddi: '+964' },
    { name: 'Ireland', code: 'IE', ddi: '+353' },
    { name: 'Israel', code: 'IL', ddi: '+972' },
    { name: 'Italy', code: 'IT', ddi: '+39' },
    { name: 'Japan', code: 'JP', ddi: '+81' },
    { name: 'Kenya', code: 'KE', ddi: '+254' },
    { name: 'Mexico', code: 'MX', ddi: '+52' },
    { name: 'Morocco', code: 'MA', ddi: '+212' },
    { name: 'Netherlands', code: 'NL', ddi: '+31' },
    { name: 'New Zealand', code: 'NZ', ddi: '+64' },
    { name: 'Nigeria', code: 'NG', ddi: '+234' },
    { name: 'Norway', code: 'NO', ddi: '+47' },
    { name: 'Pakistan', code: 'PK', ddi: '+92' },
    { name: 'Peru', code: 'PE', ddi: '+51' },
    { name: 'Philippines', code: 'PH', ddi: '+63' },
    { name: 'Poland', code: 'PL', ddi: '+48' },
    { name: 'Portugal', code: 'PT', ddi: '+351' },
    { name: 'Russia', code: 'RU', ddi: '+7' },
    { name: 'South Africa', code: 'ZA', ddi: '+27' },
    { name: 'South Korea', code: 'KR', ddi: '+82' },
    { name: 'Spain', code: 'ES', ddi: '+34' },
    { name: 'Sweden', code: 'SE', ddi: '+46' },
    { name: 'Switzerland', code: 'CH', ddi: '+41' },
    { name: 'Thailand', code: 'TH', ddi: '+66' },
    { name: 'Turkey', code: 'TR', ddi: '+90' },
    { name: 'Ukraine', code: 'UA', ddi: '+380' },
    { name: 'United Kingdom', code: 'GB', ddi: '+44' },
    { name: 'United States', code: 'US', ddi: '+1' },
    { name: 'Uruguay', code: 'UY', ddi: '+598' },
    { name: 'Venezuela', code: 'VE', ddi: '+58' },
    { name: 'Vietnam', code: 'VN', ddi: '+84' }
  ];


  selectedCountry: any;

  hasErrorNamePixel: boolean = false;
  hasErrorIdPixel: boolean = false;

  pixel_id?: number;
  getActionMenuPixel(pixel: any) {
    return [
      { label: 'Editar', icon: 'pi pi-file-edit', command: () => { console.log('Editar clicked'); this.editPixel(pixel.id); } },
      { label: 'Deletar', icon: 'pi pi-trash', command: () => { console.log('Deletar clicked'); this.confirmDeletionPixel(pixel.id); } },
    ];
  }


  editPixel(pixel_id: any) {

    this.updateFormattedProducts();
    //this.facebookPixel = false;
    this.pixel_id = pixel_id;
    // list_pixel
    this.liveShopService.detail_pixel(pixel_id).pipe(takeUntil(this.destroy$)).subscribe({
      next: (resp: any) => {
        this.addPixelDialog = true;

        this.isEditing = true; // Defina o estado para edição

        this.formData = this.convertPixelDataToFormData(resp); // Assumindo que essa função ajusta os dados para o seu formulário
        this.cdr.detectChanges();
        //;

      },
      error: (error) => {
        let message = '';
        this.savePixelLoading = false;
        if (error.status === 400 || error.status === 403 || error.status === 401) {
          message = error.error.message;
        } else if (error.status === 500) {
          message = "Ops... Algo de errado aconteceu. Tente novamente mais tarde.";
        } else {
          message = error.error.message;
        }

        if (message) {
          this.showErrorDialog(message);
        }
      }
    });
  }
  convertPixelDataToFormData(pixelData: any) {
    return {
      key: pixelData.key || '',
      pixel_id: pixelData.pixel_id || '',
      view_events: {
        fb_pixel_view: {
          view_events: {
            view_percentage: pixelData.value_2?.view_events?.view_percentage || false,
            pitch_hit: pixelData.value_2?.view_events?.pitch_hit || false,
          }
        }
      },
      conversion_events: {
        fb_pixel_conversion: {
          conversion_events: {
            skus: pixelData.value_3?.conversion_events?.skus,
            product_view: pixelData.value_3?.conversion_events?.product_view || false,
            credit_card_purchase: pixelData.value_3?.conversion_events?.credit_card_purchase || false,
            pixel_purchase: {
              trigger: pixelData.value_3?.conversion_events?.pixel_purchase?.trigger || false,
              conversion_value: pixelData.value_3?.conversion_events?.pixel_purchase?.conversion_value || null,
            },
            slip_purchase: {
              trigger: pixelData.value_3?.conversion_events?.slip_purchase?.trigger || false,
              conversion_value: pixelData.value_3?.conversion_events?.slip_purchase?.conversion_value || null,
            },
            cart_abandonment: pixelData.value_3?.conversion_events?.cart_abandonment || false,
            credit_card_purchase_denied: pixelData.value_3?.conversion_events?.credit_card_purchase_denied || false,
          }
        }
      }
    };
  }


  confirmDeletionPixel(pixel_id: any) {
    this.facebookPixel = false;
    this.confirmationService.confirm({
      message: 'Você realmente deseja remover este pixel?',
      header: 'Confirmação de Exclusão',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.deletarPixel(pixel_id);
      },
      reject: () => {
        this.facebookPixel = true;
      }
    });
  }
  deletarPixel(pixel_id: any): void {
    this.liveShopService.deletar_pixel(pixel_id).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        // Remova o pixel da lista de pixels filtrados
        this.filteredPixels = this.filteredPixels.filter(pixel => pixel.id !== pixel_id);
        this.totalRecords = this.totalRecords - 1; // Atualize o total de registros
        this.facebookPixel = true;
        // Exiba uma mensagem de sucesso
        this.messageService.add({
          severity: 'success',
          summary: 'Pixel Deletado',
          detail: 'O pixel foi deletado com sucesso!'
        });
      },
      error: (error) => {
        this.errorHandler.handle(error, 'Erro ao deletar pixel.');
      }
    });
  }




  url_share?: string = "www.google.com";




  copiarLink() {
    if (this.url_share) {
      navigator.clipboard.writeText(this.url_share).then(() => {
        this.messageService.add({
          severity: 'success',
          summary: 'Link copiado',
          detail: 'Link copiado com sucesso!'
        });
      }).catch(err => {
        console.error('Erro ao copiar o link:', err);
      });
    } else {
      console.error('Erro: O link está vazio ou indefinido.');
    }
  }
  simuladorDialog: boolean = false;
  simulateLive() {
    this.simuladorDialog = true;
  }
  closeLive() {
    this.simuladorDialog = false;
  }

  selectedIntegration: any = null;
  integrations: any[] = [
    { name: 'Inline', key: 'I' },
    { name: 'Popup', key: 'P' },
  ];

  script_share: string = '<script type="text/javascript" src="https://shopper.slicksell.com.br/gp-shopper.js" defer></script>';
  widget_share: string = '<script type="text/javascript" src="https://shopper.slicksell.com.br/gp-shopper.js" defer></script>';
  copiarScript() {
    if (this.script_share) {
      navigator.clipboard.writeText(this.script_share).then(() => {
        this.messageService.add({
          severity: 'success',
          summary: 'Script copiado',
          detail: 'Script copiado com sucesso!'
        });
      }).catch(err => {
        console.error('Erro ao copiar o Script:', err);
      });
    } else {
      console.error('Erro: O Script está vazio ou indefinido.');
    }
  }
  copiarWidget() {
    if (this.widget_share) {
      navigator.clipboard.writeText(this.widget_share).then(() => {
        this.messageService.add({
          severity: 'success',
          summary: 'Script copiado',
          detail: 'Script copiado com sucesso!'
        });
      }).catch(err => {
        console.error('Erro ao copiar o Script:', err);
      });
    } else {
      console.error('Erro: O Script está vazio ou indefinido.');
    }
  }


  slickDesc?: string = '';
  hasError2: boolean = false;
  hasError3: boolean = false;

  slickTypes = [
    { label: 'Shorts', value: 'shorts' },
    // { label: 'Live', value: 'live' }
  ];
  typeLive: boolean = false;
  //selectedSlickType?: SlickType;
  selectedSlickType: SlickType = { label: '', value: '' };

  onTypeChange(event: any) {
    this.typeLive = event.value.value === 'shorts';

    if (this.selectedSlickType) {
      this.hasError2 = false;
    } else {
      this.hasError2 = true;
    }
  }
  disabledDates: Date[] = [];
  dataSelecionada?: Date;
  onDateChange(event: Date | null) {
    if (event === null) {
      return null;
    } else {
      // Formate a data ao receber uma nova seleção
      //const formattedDate = formatDate(event, 'yyyy-MM-dd HH:mm:ss', this.locale);
      if (this.dataSelecionada) {
        const formattedDate = formatDate(this.dataSelecionada, 'yyyy-MM-dd HH:mm:ss', 'en-US');
        return formattedDate;
      } else {
        return null;
      }



    }
  }
  tags = [
    { label: 'Novo', value: 'novo' },
    { label: 'Atual', value: 'atual' },
    { label: 'Antigo', value: 'antigo' }
  ];
  selectedTags: string[] = [];
  tagsString: string = '';
  // Tags fixas geradas automaticamente a partir dos produtos associados (product_{id}).
  // Não editáveis via p-chips — só somem quando o produto é removido da picklist (ver [[feature_product_locked_tags]]).
  productTags: string[] = [];

  private productTagFor(product: { id: number; sku?: number }): string {
    // sku é o identificador estável entre o produto "recém-escolhido no picklist" (vem do
    // catálogo da loja) e o produto "recarregado do backend" após salvar — o próprio filtro
    // de sourceProducts (linha ~4600) já usa sku por esse mesmo motivo, nunca id, porque o id
    // retornado pelo backend após persistir difere do id original do catálogo.
    return `product_${product.sku ? product.sku : product.id}`;
  }

  // Recalcula productTags a partir do targetProducts atual e remove de selectedTags
  // qualquer tag que hoje corresponda a um produto associado (evita duplicar a chip).
  rebuildProductTags(): void {
    this.productTags = this.targetProducts.map(p => this.productTagFor(p));
    this.selectedTags = this.selectedTags.filter(t => !this.productTags.includes(t));
    this.updateTagsString();
  }

  updateTagsString() {
    this.tagsString = [...this.selectedTags, ...this.productTags].join(',');
  }
  publicarAgora: boolean = true;
  armazenarEvento: boolean = false;
  resultSimulatePrice?: string;
  targetTime?: any[];

  viewers!: string;
  averageViewTimeValue!: number;
  hour: string = '00';
  minute: string = '40';
  second: string = '00';
  durationLive?: string;
  //selectedTime!: number;
  selectedTime!: { label: string; value: number };
  liveTime!: string;
  hasErrorTime: boolean = false;
  hasErrorViewers: boolean = false;
  hasErrorSelectedTime: boolean = false;
  loadingSimulate: boolean = false;
  convertTimeToMinutes(time: string): number {
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes;
  }
  convertTimeToMinutesPitch(time: string): number {
    // Verifica se o tempo está no novo formato sem ":" (por exemplo, "1430")
    if (time.length === 4) {
      // Extrai as horas e os minutos da string
      const hours = Number(time.substring(0, 2));
      const minutes = Number(time.substring(2, 4));
      return hours * 60 + minutes;
    } else {
      // Se o tempo ainda estiver no formato antigo (por exemplo, "14:30"), mantém a lógica antiga
      const [hours, minutes] = time.split(':').map(Number);
      return hours * 60 + minutes;
    }
  }

  simular() {

    // Inicia sem erros
    this.hasErrorTime = false;
    this.hasErrorViewers = false;
    this.hasErrorSelectedTime = false;

    // Verifica se o tempo de duração é nulo ou vazio
    if (!this.liveTime || this.liveTime.trim() === '') {
      this.hasErrorTime = true;
      console.error('Erro: O tempo de duração é inválido.');
    }

    // Verifica se o número de espectadores é nulo ou vazio
    if (!this.viewers || this.viewers.trim() === '') {
      this.hasErrorViewers = true;
      console.error('Erro: O número de espectadores é inválido.');
    }

    // Verifica se o tempo médio de permanência é nulo ou não selecionado
    if (!this.selectedTime || Object.keys(this.selectedTime).length === 0) {
      this.hasErrorSelectedTime = true;
      console.error('Erro: O tempo médio de permanência não foi selecionado.');
    }

    // Se houver algum erro, interrompe a execução do método aqui
    if (this.hasErrorTime || this.hasErrorViewers || this.hasErrorSelectedTime) {
      return;
    }
    this.loadingSimulate = true;
    const liveTimeInMinutes = this.convertTimeToMinutesPitch(this.liveTime);

    console.log('em minutos: ' + liveTimeInMinutes);
    console.log('antes: ' + this.liveTime);



    this.liveShopService.liveSimulator(liveTimeInMinutes, 720, this.viewers, this.selectedTime.value).pipe(takeUntil(this.destroy$)).subscribe({
      next: (resp: any) => {
        this.resultSimulatePrice = resp.price;
        this.loadingSimulate = false;
      },
      error: (error) => {
        this.loadingSimulate = false;
        let message = '';
        this.savePixelLoading = false;
        if (error.status === 400 || error.status === 403 || error.status === 401) {
          message = error.error.message;
        } else if (error.status === 500) {
          message = "Ops... Algo de errado aconteceu. Tente novamente mais tarde.";
        } else if (error.status !== 404) {
          message = error.error.message;
        }

        if (message) {
          this.showErrorDialog(message);
        }
      }
    });
  }


  convertToMinutes(time: string): number {
    if (!time.includes(':')) {
      if (time.length === 4) {
        return (parseInt(time.substring(0, 2)) * 60) + parseInt(time.substring(2, 4));
      } else {
        // Handle unexpected formats or throw an error
        return NaN;
      }
    }
    const [hours, minutes] = time.split(':').map(Number);
    return (hours * 60) + minutes;
  }
  uploadProgress: number = 0;
  uploadProgressVideo: number = 0;
  videoFile: File | null = null;
  imageFile: File | null = null;
  uploadProgressBar: boolean = false;
  loadingBtn: boolean = false;
  uploadOn: boolean = false;
  imageSelected: boolean = false;
  imagePreviewUrl: string | null = null;
  showImageDeleteButton: boolean = false;
  downloadingMedia: boolean = false;

  // Baixa a mídia atualmente carregada no editor (painel "File info").
  // Mesma estratégia usada em slicks-data-view (fetch+blob com fallback pra
  // link direto quando CORS bloqueia o fetch) — aqui sem a variante nativa
  // (Capacitor/Filesystem) porque slick-detail só roda no admin web.
  // fetch+blob é o caminho principal (baixa direto, sem abrir aba nova) — só
  // funciona quando o bucket/CloudFront manda Access-Control-Allow-Origin.
  // Link cru como fallback SÓ quando o fetch falha de verdade: um <a download>
  // cross-origin sem CORS não é honrado pelo Chrome (ele ignora o atributo
  // download e navega pra URL) — por isso não dá pra usar esse caminho como
  // padrão pra tudo, senão vira navegação/nova aba até pros arquivos que não
  // tinham problema nenhum de CORS.
  async downloadMedia(): Promise<void> {
    const url = this.isVideo ? this.videoPreviewUrl : this.imagePreviewUrl;
    if (!url) {
      console.warn('❌ Nenhuma URL de mídia encontrada para download.');
      return;
    }

    const extension = this.mediaExtension || (this.isVideo ? 'mp4' : 'jpg');
    const filename = `slick-${Date.now()}.${extension}`;

    this.downloadingMedia = true;
    try {
      const response = await fetch(url, { mode: 'cors' });
      if (!response.ok) throw new Error('Resposta inválida.');

      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.warn('⚠️ Falha ao baixar via fetch (CORS?). Fazendo fallback para link direto...', err);

      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      a.target = '_blank';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      this.messageService.add({
        severity: 'warn',
        summary: 'Download com fallback',
        detail: 'O download foi iniciado sem confirmação por causa de restrição CORS.',
        life: 4000,
      });
    } finally {
      this.downloadingMedia = false;
    }
  }

  // Thumbnail de vídeo (painel "Thumbnail", só pra isVideo) — "Padrão" reverte
  // pro primeiro frame do vídeo; "Selecionar imagem do vídeo" captura o frame
  // atual (this.videoElementRef) via canvas; "Upload" deixa subir um arquivo
  // manualmente. A captura em si (canvas/blob) mora em
  // VideoThumbnailCaptureService — aqui só a orquestração (upload + save).
  thumbnailMode: 'default' | 'video' | 'upload' = 'default';
  thumbnailModeOptions = [
    { label: 'Padrão', value: 'default' },
    { label: 'Selecionar imagem do vídeo', value: 'video' },
    { label: 'Upload de imagem', value: 'upload' }
  ];
  capturingThumbnail: boolean = false;
  // Em mobile a sidebar cobre o slick e some com a barra de progresso — sem ela
  // não dá pra escolher o frame. "Selecionar imagem do vídeo" então fecha a
  // sidebar e esconde os CTAs (mesmo botão "olho" do dock) pra liberar a tela,
  // e mostra esse card flutuante com o botão de salvar. Ver exitMobileThumbnailCapture().
  showMobileThumbnailCapture: boolean = false;

  onThumbnailModeChange(): void {
    if (this.thumbnailMode === 'video') {
      // Pausa pra facilitar escolher um frame preciso ao arrastar a barra.
      // Bug real corrigido: `videoElementRef` não existe mais desde a
      // migração pro player Lit embutido (ver `buildLivePlayerItem()`) —
      // era sempre `undefined`, então essa chamada nunca fazia nada.
      void this.bridge?.pause();
      if (this.isMobile) {
        this.displaySidebar = false;
        if (this.showCTAs) {
          this.toggleShowCTAs();
        }
        this.showMobileThumbnailCapture = true;
      }
      return;
    }

    this.showMobileThumbnailCapture = false;

    if (this.thumbnailMode === 'upload') {
      // Só mostra a área de upload — o upload em si dispara onThumbnailFileSelected.
      return;
    }

    // "Padrão" é sempre o primeiro frame do vídeo (tempo 0) — captura de novo
    // na hora em vez de reaproveitar this.currentThumbnail, que pode já ser
    // um frame escolhido manualmente numa edição anterior.
    void this.applyFirstFrameThumbnail();
  }

  // Sai do modo de captura mobile (botão X do card ou após salvar a imagem):
  // reexibe os CTAs (mesmo estado do botão "olho" do dock) e reabre a sidebar
  // de gerenciamento.
  exitMobileThumbnailCapture(): void {
    this.showMobileThumbnailCapture = false;
    if (!this.showCTAs) {
      this.toggleShowCTAs();
    }
    this.displaySidebar = true;
  }

  async captureVideoThumbnail(): Promise<void> {
    if (this.capturingThumbnail) {
      console.log('[slick-detail] captureVideoThumbnail: abortado', { capturingThumbnail: this.capturingThumbnail });
      return;
    }

    if (!this.mediaSrc) {
      console.log('[slick-detail] captureVideoThumbnail: abortado, mediaSrc vazio');
      return;
    }

    // Bug real corrigido: com `OnPush`, setar `capturingThumbnail=true`
    // DEPOIS do primeiro `await` não reflete no botão (spinner/disabled)
    // — o `click` do template só dispara a checagem automática de CD
    // ANTES desse await resolver (síncrona), e a continuação assíncrona
    // não marca o componente pra re-render sozinha. Setar a flag ANTES do
    // await (ainda dentro do trecho síncrono do handler de clique)
    // resolve, igual já era feito em `applyFirstFrameThumbnail()`.
    this.capturingThumbnail = true;
    try {
      // O instante de reprodução ("onde a barra de progresso está parada
      // agora") só existe DENTRO do player Lit embutido via iframe — não
      // tem mais `<video>` no lado Angular pra ler `currentTime` direto
      // (era daqui que vinha antes da migração pro player Lit).
      const time = await this.bridge?.getCurrentTime() ?? 0;
      console.log('[slick-detail] captureVideoThumbnail: start', { mediaSrc: this.mediaSrc, time });
      const blob = await this.liveShopService.captureVideoThumbnailFrame(this.mediaSrc, time).toPromise();
      if (!blob) {
        throw new Error('Backend não retornou imagem.');
      }
      console.log('[slick-detail] captureVideoThumbnail: blob capturado, aplicando', { size: blob.size });
      await this.applyThumbnailBlob(blob);
      this.thumbnailMode = 'video';
      console.log('[slick-detail] captureVideoThumbnail: sucesso, salvando asset');
      this.saveAsset(1);
      if (this.showMobileThumbnailCapture) {
        this.exitMobileThumbnailCapture();
      }
    } catch (error: any) {
      console.error('[slick-detail] captureVideoThumbnail: erro', error);
      this.handleThumbnailCaptureError(error, 'Não foi possível capturar a imagem deste momento do vídeo.');
    } finally {
      this.capturingThumbnail = false;
      this.cdr.detectChanges();
    }
  }

  // Chamado pelo (fileSelected) do app-upload-file no modo "Upload".
  async onThumbnailFileSelected(file: File): Promise<void> {
    if (this.capturingThumbnail) {
      return;
    }

    this.capturingThumbnail = true;
    try {
      const mediaUrl = await this.uploadFile(file, 'slick_media', 2);
      this.mediaThumbnail = this.resolveThumbnailUrl(mediaUrl);
      this.imageSelected = true;
      this.thumbnailMode = 'upload';
      this.pushLiveUpdate();
      this.saveAsset(1);
    } catch (error: any) {
      this.handleThumbnailCaptureError(error, 'Não foi possível fazer upload da imagem.');
    } finally {
      this.capturingThumbnail = false;
      this.cdr.detectChanges();
    }
  }

  // Chamado pelo (removeFile) do app-upload-file — só limpa a preview local,
  // sem salvar nada sozinho. O usuário decide o próximo passo (trocar de
  // modo, escolher "Upload" e subir uma nova imagem, etc.) e o save
  // acontece só quando uma dessas ações realmente define uma nova thumbnail
  // (ou quando ele salva o slick inteiro pelo botão "Salvar" da sidebar).
  onThumbnailFileRemoved(): void {
    this.mediaThumbnail = null;
  }

  private async applyFirstFrameThumbnail(): Promise<void> {
    if (this.capturingThumbnail) {
      console.log('[slick-detail] applyFirstFrameThumbnail: abortado', { capturingThumbnail: this.capturingThumbnail });
      return;
    }

    if (!this.mediaSrc) {
      console.log('[slick-detail] applyFirstFrameThumbnail: abortado, mediaSrc vazio');
      return;
    }

    console.log('[slick-detail] applyFirstFrameThumbnail: start', { mediaSrc: this.mediaSrc });

    this.capturingThumbnail = true;
    try {
      const blob = await this.liveShopService.captureVideoThumbnailFrame(this.mediaSrc, 0).toPromise();
      if (!blob) {
        throw new Error('Backend não retornou imagem.');
      }
      console.log('[slick-detail] applyFirstFrameThumbnail: blob capturado, aplicando', { size: blob.size });
      await this.applyThumbnailBlob(blob);
      console.log('[slick-detail] applyFirstFrameThumbnail: sucesso, salvando asset');
      this.saveAsset(1);
    } catch (error: any) {
      console.error('[slick-detail] applyFirstFrameThumbnail: erro', error);
      this.handleThumbnailCaptureError(error, 'Não foi possível capturar o primeiro frame do vídeo.');
    } finally {
      this.capturingThumbnail = false;
      this.cdr.detectChanges();
    }
  }

  private async applyThumbnailBlob(blob: Blob): Promise<void> {
    const file = this.videoThumbnailCaptureService.blobToJpegFile(blob, `${this.generateUID()}.jpeg`);
    console.log('[slick-detail] applyThumbnailBlob: subindo imagem capturada', { size: file.size });
    const mediaUrl = await this.uploadFile(file, 'slick_media', 2);
    this.mediaThumbnail = this.resolveThumbnailUrl(mediaUrl);
    this.imageSelected = true;
    console.log('[slick-detail] applyThumbnailBlob: upload concluído', { mediaThumbnail: this.mediaThumbnail });
    this.pushLiveUpdate();
  }

  private resolveThumbnailUrl(urlOrKey: string): string {
    // uploadFile() já retorna a URL pública completa (R2). O fallback pro
    // CloudFront antigo fica só por segurança, caso algum storageKey "cru"
    // ainda circule por aí.
    if (urlOrKey.startsWith('http://') || urlOrKey.startsWith('https://')) {
      return urlOrKey;
    }
    return `https://d2434dp583bttd.cloudfront.net/public/${urlOrKey}`;
  }

  // A captura roda no backend (ffmpeg), então o erro mais comum aqui é HTTP
  // (falha do ffmpeg ao acessar a URL do vídeo, timeout etc.) — como a
  // resposta é responseType: 'blob', o corpo de erro também vem como Blob
  // (não dá pra ler error.error.message direto), então usamos o fallback.
  private handleThumbnailCaptureError(error: any, fallbackDetail: string): void {
    console.error('[slick-detail] handleThumbnailCaptureError', error);
    this.messageService.add({
      severity: 'error',
      summary: 'Erro ao capturar thumbnail',
      detail: fallbackDetail
    });
  }

  removeImage(): void {
    this.imageSelected = false;
    this.showImageDeleteButton = false;
  }
  myImageUploadMethod(event: any): void {
    // Implemente a lógica para o upload da imagem
  }
  handleUniversalVideoUpload(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file: File | null = input.files?.[0] || null;
    if (!file) return;

    this.onFileSelect({ files: [file] }); // mantém compatibilidade
  }
  handleUniversalImageUpload(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file: File | null = input.files?.[0] || null;
    if (!file) return;

    this.onImageSelect({ files: [file] }); // mantém compatibilidade
  }
  erroTamanhoImagem: boolean = false;
  erroTipoImagem: boolean = false;
  onImageSelect(event: any): void {
    this.erroTamanhoImagem = false;
    this.erroTipoImagem = false;
    if (event.files && event.files.length > 0) {
      this.imageFile = event.files[0]; // Atribuir o arquivo selecionado à variável imageFile

      // Verificar o tamanho do arquivo (máximo 1MB)
      if (this.imageFile && this.imageFile.size > 1048576) {
        this.erroTamanhoImagem = true;
        this.imageFile = null;
        this.imageSelected = false;
        return;
      }


      // Verificar o tipo do arquivo (webp, png, jpg, jpeg)
      const fileType = this.imageFile?.type;
      if (fileType && !['image/webp', 'image/png', 'image/jpg', 'image/jpeg', 'image/avif'].includes(fileType)) {
        this.erroTipoImagem = true;
        this.imageFile = null;
        this.imageSelected = false;
        return;
      }


      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.imageSelected = true;
        this.imagePreviewUrl = e.target.result; // Atribui a URL da imagem para visualização
      };
      if (this.imageFile) {
        reader.readAsDataURL(this.imageFile);
      }

    } else {
      this.imageSelected = false;
      this.imageFile = null; // Resetar imageFile se nenhum arquivo for selecionado
    }
  }

  handleUploadError(errorType: string): void {
    if (errorType === 'size') this.hasSizeVideoError = true;
    if (errorType === 'type') this.hasTypeVideoError = true;
    this.hasError3 = true;
  }
  videoPreviewUrl: string | null = null;
  invoiceSelected: boolean = false;
  removeVideo(): void {
    this.videoPreviewUrl = '';
    this.invoiceSelected = false;
  }
  myUploadMethod(event: any) {
    const formData: FormData = new FormData();

    // Vou assumir que você quer enviar o primeiro arquivo selecionado
    const file = event.files[0];
    formData.append('mime', file, file.name);

    // O campo 'folder' é fixo e deve ser enviado junto, como você mostrou no Postman
    formData.append('folder', 'thumbnail');


  }
  duration: number = 0;
  closeDialogDuration() {
    this.openDialogDuration = false;
  }
  zeraDialogDuration() {
    this.openDialogDuration = false;

    this.accordionTabs.forEach(tab => {
      if (tab.interval_time) {
        const startInSeconds = this.convertTimeToSeconds(tab.interval_time.start);
        const endInSeconds = this.convertTimeToSeconds(tab.interval_time.end);

        if (this.duration > startInSeconds || this.duration > endInSeconds) {
          tab.interval_time.start = "00:00:00";
          tab.interval_time.end = "00:00:00";
          tab.slider_time_range = [0, 0]; // Se necessário, atualizar também o slider_time_range
        }
      }
    });
    this.whatsappTabs.forEach(tab => {
      if (tab.interval_time) {
        const startInSeconds = this.convertTimeToSeconds(tab.interval_time.start);
        const endInSeconds = this.convertTimeToSeconds(tab.interval_time.end);

        if (this.duration > startInSeconds || this.duration > endInSeconds) {
          tab.interval_time.start = "00:00:00";
          tab.interval_time.end = "00:00:00";
          tab.slider_time_range = [0, 0]; // Se necessário, atualizar também o slider_time_range
        }
      }
    });
    this.alertsTabs.forEach(tab => {
      if (tab.interval_time) {
        const startInSeconds = this.convertTimeToSeconds(tab.interval_time.start);
        const endInSeconds = this.convertTimeToSeconds(tab.interval_time.end);

        if (this.duration > startInSeconds || this.duration > endInSeconds) {
          tab.interval_time.start = "00:00:00";
          tab.interval_time.end = "00:00:00";
          tab.slider_time_range = [0, 0]; // Se necessário, atualizar também o slider_time_range
        }
      }
    });
    this.linksSelecteds.forEach(tab => {
      if (tab.interval_time) {
        const startInSeconds = this.convertTimeToSeconds(tab.interval_time.start);
        const endInSeconds = this.convertTimeToSeconds(tab.interval_time.end);

        if (this.duration > startInSeconds || this.duration > endInSeconds) {
          tab.interval_time.start = "00:00:00";
          tab.interval_time.end = "00:00:00";
          tab.slider_time_range = [0, 0]; // Se necessário, atualizar também o slider_time_range
        }
      }
    });
    this.debounceFunction();
  }

  convertTimeToSeconds2(time: string): number {
    const [hours, minutes, seconds] = time.split(':').map(Number);
    return (hours * 3600) + (minutes * 60) + seconds;
  }
  openDialogDuration: boolean = false;
  hasSizeVideoError: boolean = false;
  hasTypeVideoError: boolean = false;
  onFileSelect(event: any): void {
    this.invoiceSelected = true;
    this.hasError3 = false;
    this.hasTypeVideoError = false;
    this.hasSizeVideoError = false;

    const file = event.files?.[0];
    if (!file) {
      this.videoPreviewUrl = null;
      this.invoiceSelected = false;
      this.videoFile = null;
      return;
    }

    if (file.size > 400 * 1024 * 1024) {
      this.hasSizeVideoError = true;
      this.videoPreviewUrl = null;
      this.invoiceSelected = false;
      this.videoFile = null;
      return;
    }

    const allowedTypes = ['video/mp4', 'video/quicktime', 'audio/mpeg', 'audio/wav', 'video/webm', 'video/vnd.avi', 'video/x-ms-wmv', 'video/x-matroska', 'video/x-flv', 'video/mpeg', 'video/3gpp', 'video/x-m4v'];
    if (!allowedTypes.includes(file.type)) {
      this.hasTypeVideoError = true;
      this.videoPreviewUrl = null;
      this.invoiceSelected = false;
      this.videoFile = null;
      return;
    }

    this.videoFile = file;
    this.videoPreviewUrl = URL.createObjectURL(file);
    this.invoiceSelected = true;

    const videoElement = document.createElement('video');
    videoElement.preload = 'metadata';

    videoElement.onloadedmetadata = () => {
      window.URL.revokeObjectURL(videoElement.src);
      this.duration = videoElement.duration;
    };

    videoElement.onerror = () => {
      console.error('Erro ao carregar o vídeo.');
    };

    videoElement.src = this.videoPreviewUrl;
    videoElement.load();
  }

  // onFileSelect(event: any): void {
  //   this.invoiceSelected = true;
  //   this.hasError3 = false;
  //   this.hasTypeVideoError = false;
  //   this.hasSizeVideoError = false;
  //   if (event.files && event.files[0]) {
  //     this.videoFile = event.files[0]; // Atribuir o arquivo selecionado à variável videoFile fileExtension
  //     if (this.videoFile) {
  //       this.videoPreviewUrl = URL.createObjectURL(this.videoFile);

  //       // Verificar o tamanho do arquivo (máximo 400 MB)
  //       if (this.videoFile.size > 400 * 1024 * 1024) {
  //         this.hasSizeVideoError = true;
  //         this.videoPreviewUrl = null;
  //         this.invoiceSelected = false;
  //         this.videoFile = null; // Resetar videoFile se o tamanho exceder o limite
  //         return;
  //       }

  //       // Verificar o tipo do arquivo
  //       const allowedTypes = ['video/mp4', 'video/quicktime', 'audio/mpeg', 'audio/wav', 'video/webm', 'video/vnd.avi', 'video/x-ms-wmv', 'video/x-matroska', 'video/x-flv', 'video/mpeg', 'video/3gpp', 'video/x-m4v'];
  //       if (!allowedTypes.includes(this.videoFile.type)) {
  //         this.hasTypeVideoError = true;
  //         this.videoPreviewUrl = null;
  //         this.invoiceSelected = false;
  //         this.videoFile = null; // Resetar videoFile se o tipo não for permitido
  //         return;
  //       }
  //       this.videoPreviewUrl = URL.createObjectURL(this.videoFile);
  //       const videoElement = document.createElement('video');
  //       videoElement.preload = 'metadata';
  //       const contentType: string = this.videoFile.type;
  //       this.fileExtension = this.getFileExtension(contentType);

  //       videoElement.onloadedmetadata = () => {
  //         window.URL.revokeObjectURL(videoElement.src); // Limpe a URL após o uso
  //         this.duration = videoElement.duration;
  //         console.log(`A duração do vídeo é: ${this.duration} segundos.`);

  //         // if (this.mediaDuration) {
  //         //   if (this.mediaDuration > this.duration) {
  //         //     this.openDialogDuration = true;
  //         //   }
  //         // }


  //       };

  //       videoElement.onerror = () => {
  //         console.error('Erro ao carregar o vídeo.');
  //       };

  //       videoElement.src = this.videoPreviewUrl;
  //       videoElement.load();

  //       this.invoiceSelected = true;
  //     }

  //   } else {
  //     this.videoPreviewUrl = null;
  //     this.invoiceSelected = false;
  //     this.videoFile = null; // Resetar videoFile se nenhum arquivo for selecionado
  //   }
  // }
  url_slick_maps_1!: string;
  url_slick_maps_2!: string;
  loadingBtnSlicks: boolean = false;
  valuesMaps: string[] | undefined;
  loadDataChipsMaps() {
    // Desativado: a tabela "maps" (backend) é uma funcionalidade legada, sem
    // uso hoje — os capítulos do Studio salvam via o fluxo principal
    // (saveAsset/updateAssets), não por aqui. Chamada de rede removida
    // para não bater mais nesses endpoints.
    this.selectedIntegration = this.integrations[1];
  }
  saveSlickMaps() {
    // Desativado: ver comentário em loadDataChipsMaps() — funcionalidade
    // legada da tabela "maps", sem chamada de rede.
    this.loadingBtnSlicks = false;
    this.messageService.add({
      severity: 'success',
      summary: 'Slick Maps Salvo',
      detail: 'O slick maps foi salvo com sucesso!'
    });
    this.displayDialogSidebar = false;
  }

  generateUID() {
    return uuidv4();
  }
  saveEditSlick() {
    this.uploadSave();
  }
  async removeServiceWorkerAndCaches(): Promise<void> {
    if ('serviceWorker' in navigator) {
      try {
        // Força a atualização do SW (se houver um novo)
        const registrations = await navigator.serviceWorker.getRegistrations();
        // for (const registration of registrations) {
        //   registration.update();
        // }

        // Desregistra o service worker
        for (const registration of registrations) {
          const success = await registration.unregister();
          if (success) {
            console.log('Service worker unregistered successfully');
          }
        }

        // Limpa os caches
        const cacheNames = await caches.keys();
        for (const name of cacheNames) {
          await caches.delete(name);
        }
        console.log('All caches deleted successfully');

        // Força o Bypass for network, removendo o controller do SW
        if (navigator.serviceWorker.controller) {
          console.log('Service worker still controlling, applying bypass...');
          navigator.serviceWorker.controller.postMessage({ action: 'skipWaiting' });
        }

      } catch (error) {
        console.error('Error while unregistering service worker or clearing caches:', error);
      }
    }
  }

  //async uploadSave() {}
  async uploadSave() {
    this.uploadProgressVideo = 0;
    this.uploadProgress = 0;
    console.log('entrou em salvar/editar');

    if (!this.selectedSlickType) {
      this.hasError2 = true;
    }

    if (!this.hasError2) {
      console.log('entrou 3');
      if (this.selectedSlickType?.value === 'shorts' && !this.invoiceSelected && (this.videoPreviewUrl == null || this.videoPreviewUrl == "")) {
        this.hasError3 = true;
        return;
      }

      // Inicia os uploads e salva
      this.loadingBtn = true;
      const uploadStatus = {
        video: false,
        image: false,
      };

      // Upload do vídeo
      if (this.selectedSlickType?.value === 'shorts' && this.videoFile) {
        console.log('tem vídeo');

        try {
          const videoUrl = await this.uploadFile(this.videoFile, 'slick_media', 1);
          this.mediaSrc = this.resolveThumbnailUrl(videoUrl);
          uploadStatus.video = true;
          this.pushLiveUpdate();
        } catch (error: any) {
          this.errorHandler.handle(error, 'Erro no upload do vídeo: ' + error.message);
          return;
        }
      } else {
        uploadStatus.video = true;
      }


      // Upload da imagem
      if (this.imageFile) {
        try {
          const imageUrl = await this.uploadFile(this.imageFile, 'slick_media', 2);
          this.mediaThumbnail = this.resolveThumbnailUrl(imageUrl);
          console.log('entrou 5.5');
          uploadStatus.image = true;
        } catch (error: any) {
          this.errorHandler.handle(error, 'Erro no upload da imagem: ' + error.message);
          return;
        }
      } else {
        console.log('entrou 5.6');
        uploadStatus.image = true;
      }

      // Verifica se ambos os uploads foram concluídos
      if (uploadStatus.video && uploadStatus.image) {
        this.saveSlicks();
      }
    } else {
      console.log('entrou erro');
      if (this.selectedSlickType?.value === 'shorts' && !this.invoiceSelected) {
        this.hasError3 = true;
      }
      return;
    }
  }

  async uploadFile(file: File, purpose: 'slick_media' | 'slick_link_icon', bar: number): Promise<string> {
    try {
      const { url } = await this.mediaUploadService.uploadForStore(file, this.storeId, purpose, (progress) => {
        console.log(`Progresso atual: ${progress}%`);
        if (bar === 2) {
          this.uploadProgress = progress;
        } else if (bar === 1) {
          this.uploadProgressVideo = progress;
        }
      });

      console.log('Upload concluído com sucesso.');
      return url;  // Retorna a URL pública já resolvida (R2)

    } catch (error) {
      console.error('Erro no upload:', error);
      throw error;  // Lança o erro para ser tratado onde a função for chamada
    }
  }



  checkUploadsAndSave(uploadStatus: any) {
    // Verifica se ambos os uploads (vídeo e imagem) foram concluídos
    if (uploadStatus.video && uploadStatus.image) {
      console.log('Todos os uploads foram concluídos');
      // Aguarda até que this.uploadProgressVideo atinja 100%
      if (uploadStatus.video) {
        console.log('Todos os uploads foram concluídos');
        const interval = setInterval(() => {

          if (this.selectedSlickType?.value == 'shorts') {
            if (this.uploadProgressVideo === 100) {
              console.log('Todos os uploads foram concluídos');
              clearInterval(interval); // Para o intervalo
              console.log('Upload de vídeo concluído');
              this.saveSlicks(); // Chama o método para salvar após a conclusão dos uploads
              this.loadingBtn = false; // Atualiza o estado do botão, se necessário
            }
          } else {
            if (this.uploadProgress === 100) {
              console.log('Todos os uploads foram concluídos');
              clearInterval(interval); // Para o intervalo
              console.log('Upload de vídeo concluído');
              this.saveSlicks(); // Chama o método para salvar após a conclusão dos uploads
              this.loadingBtn = false; // Atualiza o estado do botão, se necessário
            }
          }
          console.log(this.uploadProgressVideo)

        }, 100); // Verifica a cada segundo
      } else {
        this.saveSlicks();
        this.loadingBtn = false;
      }

    } else {
      this.saveSlicks();
    }
  }

  getForm() {
    return
  }

  saveSlicks() {

    this.saveAsset(1);
  }
  displayDialog: boolean = false;
  displayDialogSidebar: boolean = false;
  resetFormCreator() {
    this.slickDesc = undefined;
    //this.selectedSlickType = undefined;
    this.selectedTags = [];
    this.productTags = [];
    this.publicarAgora = true;
    this.armazenarEvento = false;
    this.dataSelecionada = undefined;
    this.imageSelected = false;
    this.imageFile = null;
    this.videoPreviewUrl = null;
    this.invoiceSelected = false;
    this.typeLive = false;
    this.videoFile = null;
  }
  validateTime(event: KeyboardEvent) {
    const controlKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight'];
    if (controlKeys.includes(event.key)) {
      return;
    }

    // Assegura que event.target é um HTMLInputElement
    const input = event.target as HTMLInputElement | null;

    if (input) {
      // Usa o operador de coalescência nula para garantir que temos um número
      const selectionStart = input.selectionStart ?? 0;
      const selectionEnd = input.selectionEnd ?? 0;

      const regex = new RegExp("^[0-9]{0,2}[:]?[0-9]{0,2}$");
      const currentValue = input.value;
      const nextValue = currentValue.substring(0, selectionStart) +
        event.key +
        currentValue.substring(selectionEnd);

      if (!regex.test(nextValue)) {
        //event.preventDefault();
      }
    }
  }

  showSlickClearFunction() {
    if (this.valuesMaps && this.valuesMaps?.length > 0) {
      this.showClearSlickMaps = true;
    } else {
      this.showClearSlickMaps = false;
    }
  }

  showClearSlickMaps: boolean = false;
  clearSlickMaps() {
    // Desativado: ver comentário em loadDataChipsMaps() — funcionalidade
    // legada da tabela "maps", sem chamada de rede.
    this.valuesMaps = [];
    this.showClearSlickMaps = false;
    this.loadingBtnSlicks = false;
    this.messageService.add({
      severity: 'success',
      summary: 'Slick Maps Limpo',
      detail: 'O slick maps foi limpo com sucesso!'
    });
    this.displayDialogSidebar = false;
  }


  selectedProductForEdit: Produto = {
    id: 0,
    sku: 0,
    name: '',
    status: 0,
    inputQty: 0,
    position: 0,
    price: '0',
    onsale_price: '',
    price_exchange: '',
    thumbnail: '',
    isSelected: false,
    highlight: false,
    define_interval: false,
    show_slider: false,
    interval_time: { start: "00:00:00", end: "00:00:00" },
    comprar_font_color: '#ffffff',
    comprar_bg_color: '#000000',
    adicionar_font_color: '#000000',
    adicionar_bg_color: '#ffffff',
  };
  private debounceTimer: any = null;

  public currentlyEditingTab: AccordionTab | null = null;

  setCurrentTabAndDebounce(tab: AccordionTab) {//sss
    this.currentlyEditingTab = tab;

    //this.stateManagementService.updateAccordionColors(this.currentlyEditingTab?.font_color_custom ?? '#000000', this.currentlyEditingTab?.bg_color_custom ?? '#FFFFFF');

    this.setupVisibleButton();
    this.updateTabs();
    this.debounceFunction();
    this.pushLiveUpdate();
  }
  saveProfileBtn() {
    this.canSave = true;
    this.debounceFunction();
    this.pushLiveUpdate();
  }

  // Quando a importação (hashtag/tags) não conseguiu resolver o handle do
  // autor original, "Botão de Perfil" fica indisponível — essa ação tenta
  // recuperar via RapidAPI (mesmo endpoint usado em "Atualizar Insights" no
  // slicks-data-view). Backend agora também grava a coluna handle, não só o
  // JSON de insights.
  loadingInsightsHandle: boolean = false;
  atualizarInsightsHandle(): void {
    if (!this.uuid || this.loadingInsightsHandle) return;
    this.loadingInsightsHandle = true;
    this.feedService.atualizarInsights(this.uuid, 'instagram').subscribe({
      next: (res) => {
        this.loadingInsightsHandle = false;
        if (res?.handle) {
          this.handleUser = res.handle;
          if (res.insights?.profile_picture) {
            this.avatar = res.insights.profile_picture;
          }
          // Player Lit já aberto (Studio) precisa saber do handle/avatar
          // novo NA HORA, sem esperar reload — mesmo mecanismo debounced
          // que as outras ilhas editáveis já usam (buildLivePlayerItem()
          // já lê this.handleUser/this.avatar direto, não precisa de mais
          // nada além de disparar o push).
          this.pushLiveUpdate();
          this.messageService.add({ severity: 'success', summary: 'Autor identificado', detail: 'Botão de Perfil liberado.' });
        } else {
          this.messageService.add({ severity: 'warn', summary: 'Autor não encontrado', detail: 'Não foi possível identificar o autor original desse post.' });
        }
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.loadingInsightsHandle = false;
        this.errorHandler.handle(err, 'Falha ao atualizar insights.');
        this.cdr.detectChanges();
      }
    });
  }
  debounceFunction() {
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this.canSave = true;
      this.pickListObserverService.notifyChange();
    }, 750);
  }

  updateColors() {
    // Atualiza as cores imediatamente para a reatividade da UI
    if (this.selectedProductForEdit && this.selectedProductForEdit.id) {
      this.stateManagementService.updateProductColors(this.selectedProductForEdit.id, {
        comprarFontColor: this.selectedProductForEdit.comprar_font_color ?? '#FFFFFF',
        comprarBgColor: this.selectedProductForEdit.comprar_bg_color ?? '#000000',
        adicionarFontColor: this.selectedProductForEdit.adicionar_font_color ?? '#000000',
        adicionarBgColor: this.selectedProductForEdit.adicionar_bg_color ?? '#FFFFFF',
      });
    }

    // Debounce a chamada de notificação de mudança
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this.pickListObserverService.notifyChange();
    }, 750); // Debounce de 500ms; ajuste conforme necessário
  }



  /// reorganiza postion em produtos
  private prevTargetProducts: Produto[] = [];
  ngDoCheck() {
    if (!this.arraysEqual(this.prevTargetProducts, this.targetProducts)) {
      // A ordem dos produtos no targetProducts mudou
      this.updateProductPositions(); // Atualiza as posições
      this.syncHotspotOrderFromTarget();
      this.prevTargetProducts = [...this.targetProducts]; // Atualiza a cópia
      this.targetProducts = [...this.targetProducts]; // Atualiza a cópia
      this.setupFilteredProducts();
      if (this.filteredProducts$) {
        this.highlightedProductsLimited$ = this.filteredProducts$.pipe(
          map(products =>
            products.filter(product => product.highlight).slice(0, 3)
          )
        );
      }
      this.targetProducts = [...this.targetProducts];
      this.setupFilteredProducts();
    }
  }
  private arraysEqual(a: any[], b: any[]) {
    return (
      a.length === b.length &&
      a.every((val, index) => val === b[index])
    );
  }
  isDragging: boolean = false;
  /// reorganiza postion em produtos
  @ViewChild('progressContainer') progressContainer?: ElementRef;
  @ViewChild('originalProgress') originalProgress?: ElementRef;
  @ViewChild('marker') marker?: ElementRef<HTMLDivElement>;


  listenersAdded: boolean = false;
  private dragEvents = new Subject<MouseEvent | TouchEvent>();
  initPlayPause: boolean = false;
  ////////////////////////////
  onDragStart(event: MouseEvent | TouchEvent): void {
    //event.preventDefault(); // Impede comportamentos padrão, como seleção de texto ou eventos de clique.
    this.isDragging = true; // Marca que o arraste começou
    this.initPlayPause = !this.videoElementRef?.nativeElement?.paused;
    //this.player.pause();
    this.moveMarker(event); // Move a marker para a posição inicial

    // Adiciona event listeners para movimentos e término do arraste
    if (this.progressContainer && !this.listenersAdded) {
      this.progressContainer.nativeElement.addEventListener('mousemove', this.boundOnDragging);
      this.progressContainer.nativeElement.addEventListener('mouseup', this.boundOnDragEnd);
      this.progressContainer.nativeElement.addEventListener('touchmove', this.boundOnDragging);
      this.progressContainer.nativeElement.addEventListener('touchend', this.boundOnDragEnd);
      this.listenersAdded = true;
      document.addEventListener('mousemove', this.boundOnDragging);
      document.addEventListener('mouseup', this.boundOnDragEnd);
      document.addEventListener('touchmove', this.boundOnDragging);
      document.addEventListener('touchend', this.boundOnDragEnd);
    }

    const wrapper = this.progressContainerWrapper?.nativeElement;
    // Definir os listeners do sprite diretamente no onDragging e onDragEnd
    const mouseMoveListener = (event: MouseEvent) => {
      this.onDragging(event); // Executar o arrasto
      this.updateThumbnail(event.clientX); // Atualizar a posição da miniatura
    };

    const touchMoveListener = (event: TouchEvent) => {
      this.onDragging(event); // Executar o arrasto
      this.updateThumbnail(event.touches[0].clientX); // Atualizar a posição da miniatura
    };

    const touchEndListener = () => {
      if (this.thumbnailPreview && this.thumbnailPreview.nativeElement) {
        this.thumbnailPreview.nativeElement.style.display = 'none';
      }
    };

    const mouseLeaveListener = () => {
      if (this.thumbnailPreview && this.thumbnailPreview.nativeElement) {
        this.thumbnailPreview.nativeElement.style.display = 'none';
      }
    };


    // Adicionar listeners ao progress bar e à janela para finalizar
    wrapper?.addEventListener('mousemove', mouseMoveListener);
    wrapper?.addEventListener('touchmove', touchMoveListener, { passive: true });
    wrapper?.addEventListener('mouseup', this.onDragEnd.bind(this));
    wrapper?.addEventListener('touchend', this.onDragEnd.bind(this));
    wrapper?.addEventListener('touchcancel', this.onDragEnd.bind(this));
    wrapper?.addEventListener('mouseleave', mouseLeaveListener);

    // Armazenar os listeners para remoção futura
    this.spriteListeners = { touchMoveListener, mouseMoveListener, mouseLeaveListener, touchEndListener };
  }
  private spriteListeners: {
    touchMoveListener?: (event: TouchEvent) => void,
    touchEndListener?: () => void,
    mouseMoveListener?: (event: MouseEvent) => void,
    mouseLeaveListener?: () => void
  } = {};
  moveMarker(event: MouseEvent | TouchEvent): void {
    //console.log('chamou moveMarker: ' + this.isDragging);
  }

  //////////////////////////
  isSeeking: boolean = false;
  displayedTime: string = '';
  // Atualize isto com o valor real ou estimado


  getClientXFromEvent(event: MouseEvent | TouchEvent): number | null {
    if (event instanceof MouseEvent) {
      return event.clientX;
    } else if (this.isTouchEvent(event)) {
      let clientX: number | null = null; // Inicializado como null
      if (event.type === 'touchend' || event.type === 'touchcancel') {
        if (event.changedTouches && event.changedTouches.length > 0) {
          clientX = event.changedTouches[0].clientX; // Usar changedTouches em touchend/touchcancel
        } else {
          console.warn('TouchEvent (touchend/touchcancel) sem clientX válido');
        }
      } else if (event.touches && event.touches.length > 0) {
        clientX = event.touches[0].clientX; // Usar touches para eventos normais de touch
      }
      return clientX; // Agora garantimos que `clientX` será null ou um número
    }
    return null;
  }
  //////////////////////////
  // Eventos de arraste - arrastando


  @ViewChild('thumbnailContainer') thumbnailContainer?: ElementRef<HTMLDivElement>;
  @ViewChild('timeDisplay') timeDisplay!: ElementRef;
  private animationFrameId?: number;
  onDragging(event: MouseEvent | TouchEvent): void {
    if (!this.isDragging) return;

    const progressContainer = this.progressContainerWrapper?.nativeElement;
    if (!progressContainer) return;
    /////////////////////////////////
    const rect = progressContainer.getBoundingClientRect();
    let clientX: number | null = this.getClientXFromEvent(event);
    if (clientX === null) return;

    const clickX = clientX - rect.left;
    const video = this.videoElementRef?.nativeElement;
    const seekTime = (clickX / rect.width) * (video?.duration ?? 0);

    /////////////////////////////////

    // update da barra de progress
    if (this.progressContainer) {
      if (this.progressContainer) {
        if (this.isMobile) {
          this.progressContainer.nativeElement.classList.add('touch-active');
        }

      }
      this.setOpacity(1, 0);
      const rect = this.progressContainer.nativeElement.getBoundingClientRect();
      let clientX: number | null = null;
      if (this.isTouchEvent(event) && event.touches && event.touches.length > 0) {
        clientX = event.touches[0].clientX;
      } else if (event instanceof MouseEvent) {
        clientX = event.clientX;
      }

      if (clientX === null) {
        return;
      }
      const clickX = clientX - rect.left;
      const containerWidth = rect.width;
      const visualClickPercentage = clickX / containerWidth; // Posição visual na barra (0-1)

      const seekPercentage = visualClickPercentage;
      const progressPercentage = seekPercentage * 100;
      if (this.originalProgress) {
        this.originalProgress.nativeElement.style.width = `${progressPercentage}%`;
      }
      const seekTime = (seekPercentage) * (video?.duration ?? 0);

      if (video) {
        video.currentTime = seekTime; // âœ… Atualiza tempo real enquanto arrasta
      }
      // MOVE A BOLINHA: posicionar no ponto visual onde foi clicado
      const markerX = visualClickPercentage * containerWidth;
      if (this.marker?.nativeElement) {
        this.marker.nativeElement.style.left = `${markerX - 7}px`;
      }
      //this.updateProgress(event);
      // Atualiza a posição da barra de progresso e outras alterações no próximo frame de animação
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
      }
      // Atualiza o tempo mostrado
      this.animationFrameId = requestAnimationFrame(() => {
        this.updateDisplayedTime(seekTime);
        if (this.progressContainer) {
          if (this.isMobile) {
            this.progressContainer.nativeElement.classList.add('ss-g-progress-container-expanded');
          }
        }
        if (this.timeDisplay) {
          this.timeDisplay.nativeElement.style.display = 'block';
        }
        this.setOpacity(1, 0);
      });
    }
  }
  updateDisplayedTime(time: number) {
    this.displayedTime = this.formatDuration2(time);
    if (this.chaptersEnabled && this.chapters.length) {
      const active = [...this.chapters]
        .filter(c => this.chapterTimeToSeconds(c.time) <= time)
        .pop();
      this.displayedChapterTitle = active?.title || '';
    } else {
      this.displayedChapterTitle = '';
    }
    this.cdr.detectChanges();
  }
  formatDuration2(seconds: number): string {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = Math.floor(seconds % 60);
    const mm = m.toString().padStart(2, '0');
    const ss = s.toString().padStart(2, '0');
    if (h > 0) return `${h.toString().padStart(2, '0')}:${mm}:${ss}`;
    return `${mm}:${ss}`;
  }
  updateThumbnail(clientX: number): void {
    const progressBar = this.progressContainerWrapper?.nativeElement;
    const thumbnailContainer = this.thumbnailContainer?.nativeElement;
    if (!progressBar || !thumbnailContainer) return;

    const rect = progressBar.getBoundingClientRect();
    const boundedClientX = Math.max(rect.left, Math.min(clientX, rect.right));
    const relativeX = boundedClientX - rect.left;
    const video = this.videoElementRef?.nativeElement;
    const spriteTime = (relativeX / rect.width) * (video?.duration ?? 0);

    this.updateDisplayedTime(spriteTime);
    thumbnailContainer.style.display = 'flex';
  }
  hoverListeners: { mouseEnterListener?: (event: MouseEvent) => void, mouseMoveListener?: (event: MouseEvent) => void, mouseLeaveListener?: (event: MouseEvent) => void } = {};
  // Eventos de arraste - terminar o arraste
  onDragEnd(event: MouseEvent | TouchEvent): void {
    if (this.isDragging) {
      this.isDragging = false;
      const progressContainer = this.progressContainerWrapper?.nativeElement;

      if (this.progressContainer) {
        if (this.isMobile) {
          this.progressContainer.nativeElement.classList.remove('touch-active');
          this.progressContainer.nativeElement.classList.remove('ss-g-progress-container-expanded');
        }

      }

      // Limpar a animação do `requestAnimationFrame`
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
        this.animationFrameId = undefined;
      }
      this.setOpacity(0, 1);
      this.updateProgress(event);
      if (this.progressContainer) {
        this.progressContainer.nativeElement.removeEventListener('mousemove', this.boundOnDragging);
        this.progressContainer.nativeElement.removeEventListener('mouseup', this.boundOnDragEnd);
        this.progressContainer.nativeElement.removeEventListener('touchmove', this.boundOnDragging);
        this.progressContainer.nativeElement.removeEventListener('touchend', this.boundOnDragEnd);
        this.listenersAdded = false;
        document.removeEventListener('mousemove', this.boundOnDragging);
        document.removeEventListener('mouseup', this.boundOnDragEnd);
        document.removeEventListener('touchmove', this.boundOnDragging);
        document.removeEventListener('touchend', this.boundOnDragEnd);


        if (this.videoElementRef && this.videoElementRef.nativeElement) {
          this.showPlayPauseButton = true; // Sempre mostra o botão enquanto interage.
        }
        if (this.initPlayPause) {
          this.videoElementRef?.nativeElement?.play();
        }

      }

      this.removeSpriteListeners();
      this.removeHoverListeners();
      const thumbnailContainer = this.thumbnailContainer?.nativeElement;
      if (thumbnailContainer) {
        thumbnailContainer.style.display = 'none'; // Ocultar manualmente a miniatura
      }
      if (this.timeDisplay) {
        this.timeDisplay.nativeElement.style.display = 'none';
      }
    }
  }
  removeHoverListeners(): void {
    const progressBar = this.progressContainerWrapper?.nativeElement;

    if (!progressBar || !this.hoverListeners) return;

    const { mouseEnterListener, mouseMoveListener, mouseLeaveListener } = this.hoverListeners;

    // Remover eventos de hover do progress bar apenas se eles existirem
    if (mouseEnterListener) progressBar.removeEventListener('mouseenter', mouseEnterListener);
    if (mouseMoveListener) progressBar.removeEventListener('mousemove', mouseMoveListener);
    if (mouseLeaveListener) progressBar.removeEventListener('mouseleave', mouseLeaveListener);
    const thumbnailContainer = this.thumbnailContainer?.nativeElement;
    if (thumbnailContainer) {
      thumbnailContainer.style.display = 'none'; // Ocultar manualmente a miniatura
    }
    // Limpar os listeners armazenados
    this.hoverListeners = {};

  }
  removeSpriteListeners(): void {
    const wrapper = this.progressContainerWrapper?.nativeElement;
    if (!wrapper) return;

    const { touchMoveListener, mouseMoveListener, mouseLeaveListener, touchEndListener } = this.spriteListeners;

    if (touchMoveListener) wrapper.removeEventListener('touchmove', touchMoveListener);
    if (mouseMoveListener) wrapper.removeEventListener('mousemove', mouseMoveListener);
    if (mouseLeaveListener) wrapper.removeEventListener('mouseleave', mouseLeaveListener);
    if (touchEndListener) {
      wrapper.removeEventListener('touchend', touchEndListener);
      wrapper.removeEventListener('touchcancel', touchEndListener);
    }

    // Garantir que a miniatura seja removida
    const thumbnailPreview = this.thumbnailPreview?.nativeElement;
    if (thumbnailPreview) {
      thumbnailPreview.style.display = 'none'; // Ocultar manualmente a miniatura
    }
    const thumbnailContainer = this.thumbnailContainer?.nativeElement;
    if (thumbnailContainer) {
      thumbnailContainer.style.display = 'none'; // Ocultar manualmente a miniatura
    }

    this.spriteListeners = {};
  }
  private isTouchEvent(event: MouseEvent | TouchEvent): event is TouchEvent {
    return event.type.startsWith('touch');
  }
  // Atualiza a reprodução do vídeo quando a marker é solta
  updateProgress(event: MouseEvent | TouchEvent): void {
    this.ngZone.runOutsideAngular(() => {
      if (this.progressContainer) {
        const rect = this.progressContainer.nativeElement.getBoundingClientRect();
        let clientX: number | null = null;

        if (this.isTouchEvent(event)) {
          if (event.type === 'touchend' || event.type === 'touchcancel') {
            clientX = event.changedTouches?.[0]?.clientX ?? null;
          } else if (event.touches?.length) {
            clientX = event.touches[0].clientX;
          }
        } else if (event instanceof MouseEvent) {
          clientX = event.clientX;
        }

        if (clientX === null) return;

        const clickX = clientX - rect.left;
        const containerWidth = rect.width;
        const visualClickPercentage = clickX / containerWidth; // Posição visual (0-1)

        const seekPercentage = visualClickPercentage;

        const video = this.videoElementRef?.nativeElement;
        const seekTime = seekPercentage * (video?.duration ?? 0);

        if (video) {
          video.currentTime = seekTime; // âœ… remove o `.pause()` aqui
        }

        // atualiza UI da barra de progresso
        const progressPercentage = seekPercentage * 100;
        this.originalProgress?.nativeElement?.style.setProperty('width', `${progressPercentage}%`);

        // Posicionar marker na posição visual onde foi solto
        if (this.marker && this.progressContainer?.nativeElement) {
          const markerX = visualClickPercentage * containerWidth;
          this.marker.nativeElement.style.left = `${markerX - 7}px`;
        }
      }
    });
  }

  ////////////////////////////

  @ViewChild('progressContainerWrapper') progressContainerWrapper?: ElementRef<HTMLDivElement>;

  @ViewChild('rewindButton') rewindButton?: ElementRef;
  @ViewChild('playPauseButton') playPauseButton?: ElementRef;
  @ViewChild('forwardButton') forwardButton?: ElementRef;
  @ViewChild('videoElement') videoElement?: ElementRef<HTMLVideoElement>;

  // Método para retroceder
  rewind(): void {
    if (this.player) {
      let newTime = this.player.currentTime() - 10;
      newTime = Math.max(0, newTime); // Não vai abaixo de 0
      this.player.currentTime(newTime);
    }
  }
  forward(): void {
    if (this.player) {
      let newTime = this.player.currentTime() + 10;
      newTime = Math.min(newTime, this.player.duration()); // Não excede a duração total
      this.player.currentTime(newTime);
    }
  }
  // Método para alternar play/pause
  //isPaused:boolean = false;


  // Método para avançar

  progressBarColor: string = '#FF6347'; // Cor padrão da barra de progresso
  updatePlayPauseColor(value: string | object): void {
    const color = typeof value === 'string' ? value : '#FF0000';
    this.playPauseColor = color;
    this.stateManagementService.updatePlayerControlsColors(this.playPauseColor, this.progressBarColor);
    this.pushLiveUpdate();
  }

  updateProgressBarColor(value: string | object): void {
    const color = typeof value === 'string' ? value : ''; // Use um valor padrão ou faça uma conversão conforme necessário
    this.stateManagementService.updatePlayerControlsColors(this.playPauseColor, this.progressBarColor);
    this.pushLiveUpdate();
  }


  checkIntervalsForOverlap(customTabs: AccordionTab[], whatsappTabs: WhatsAppTab[]) {
    const allIntervals: Interval[] = [];

    customTabs.forEach(tab => {
      if (tab.define_interval && tab.interval_time && !(tab.interval_time.start === "00:00:00" && tab.interval_time.end === "00:00:00")) {
        allIntervals.push({
          start: this.convertTimeToMilliseconds(tab.interval_time.start),
          end: this.convertTimeToMilliseconds(tab.interval_time.end),
          source: 'Custom'
        });
      }
    });

    whatsappTabs.forEach(tab => {
      if (tab.define_interval && tab.interval_time && !(tab.interval_time.start === "00:00:00" && tab.interval_time.end === "00:00:00")) {
        allIntervals.push({
          start: this.convertTimeToMilliseconds(tab.interval_time.start),
          end: this.convertTimeToMilliseconds(tab.interval_time.end),
          source: 'WhatsApp'
        });
      }
    });

    for (let i = 0; i < allIntervals.length; i++) {
      for (let j = i + 1; j < allIntervals.length; j++) {
        // Verifica se ambos os intervalos não são ambos "00:00:00"
        if (!(allIntervals[i].start === 0 && allIntervals[i].end === 0 && allIntervals[j].start === 0 && allIntervals[j].end === 0) && this.intervalsOverlap(allIntervals[i], allIntervals[j])) {
          console.warn(`Overlap detected between ${allIntervals[i].source} and ${allIntervals[j].source} intervals.`);
          // Emita seu aviso aqui
        }
      }
    }
  }


  convertTimeToMilliseconds(timeStr: string): number {
    const [hours, minutes, seconds] = timeStr.split(':').map(Number);
    return ((hours * 60 + minutes) * 60 + seconds) * 1000;
  }
  intervalsOverlap(intervalA: Interval, intervalB: Interval): boolean {
    // Retorna true se houver sobreposição
    return intervalA.start < intervalB.end && intervalB.start < intervalA.end;
  }



  convertMinutesToTime(minutes: number): string {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:00`;
  }
  getSliderValues(index: number): number[] {
    const tab = this.accordionTabs[index];
    if (tab && tab.interval_time) {
      return [
        this.convertTimeToMinutes(tab.interval_time.start),
        this.convertTimeToMinutes(tab.interval_time.end)
      ];
    }
    return [0, 1440]; // Um valor padrão que representa o início e o fim do dia, ajuste conforme necessário
  }


  /// conditins to custom
  numberToTimeString(value: number): string {
    const hours = Math.floor(value / 3600);
    const minutes = Math.floor((value % 3600) / 60);
    const seconds = value % 60;

    return [hours, minutes, seconds]
      .map(val => val < 10 ? '0' + val : val)
      .join(':');
  }
  timeStringToNumber(time: string): number {
    const [hours, minutes, seconds] = time.split(':').map(Number);
    return hours * 3600 + minutes * 60 + seconds;
  }
  // Atualiza os valores do slider com base nos inputs de tempo
  updateSliderFromInput(tab: any, which: 'start' | 'end', value: string) {
    const timeValue = this.timeStringToNumber(value);

    if (!tab.interval_time_range) {
      tab.interval_time_range = [0, 0];
    }

    if (which === 'start') {
      tab.interval_time_range[0] = timeValue;
    } else {
      tab.interval_time_range[1] = timeValue;
    }
  }

  // Atualiza os inputs de tempo com base nos valores do slider
  updateInputsFromSlider(tab: any, event: any) {


    console.log('tab antes de tudo');
    console.log(tab);

    //return;

    if (!tab.interval_time) {
      tab.interval_time = { start: "00:00:00", end: "00:00:00" };
    }


    console.log('antes de converter');
    console.log(event.values[0]);
    console.log('converter');
    console.log(this.numberToTimeString(event.values[0]));


    tab.interval_time.start = this.numberToTimeString(event.values[0]);
    tab.interval_time.end = this.numberToTimeString(event.values[1]);


    console.log('nova tab (stringified):', JSON.stringify(tab, null, 2));


    this.debounceFunction();
  }
  /// conditins to custom
  handleChanges(index: number, type: 'text' | 'fontColor' | 'backgroundColor', value: string) {
    // Aqui você chama o debounceFunction conforme necessário
    // Mas também prepara e envia as mudanças para o serviço
    let change: Partial<AlertChange> = { index };
    switch (type) {
      case 'text':
        change.text = value;
        break;
      case 'fontColor':
        change.fontColor = value;
        break;
      case 'backgroundColor':
        change.backgroundColor = value;
        break;
    }
    this.stateManagementService.emitAlertChange(change as AlertChange);
    this.setupFilteredAlerts();
    // Assumindo que debounceFunction não precisa de argumentos específicos
    // ou você pode ajustá-lo conforme necessário
    this.debounceFunction();
  }

  configSwiper: SwiperOptions = {
    // Exemplo de configuração
    loop: false,
    slidesPerView: 'auto',
    spaceBetween: 10,
    keyboard: {
      enabled: true,
    },
    pagination: false,
    navigation: false,
  };
  @ViewChild('swiperSecond', { static: false }) swiperRef?: any;
  @ViewChild('swiperLinks', { static: false }) swiperLinksRef?: any;
  @ViewChild('swiperShorts', { static: false }) swiperShortsRef?: any;

  get swiperInstanceProdutos() {
    return this.swiperRef?.swiperRef;
  }
  get swiperInstanceLinks() {
    return this.swiperLinksRef?.swiperRef;
  }

  get swiperInstanceShorts() {
    return this.swiperShortsRef?.swiperRef;
  }
  configSwiperSecond: SwiperOptions = {
    loop: false,
    slidesPerView: 1.2,
    spaceBetween: 10,
    pagination: false,
    navigation: false,
    watchOverflow: true,
  };
  configSwiperThird: SwiperOptions = {
    slidesPerView: 'auto',
    loop: false,
    spaceBetween: 10,
    pagination: false,
    navigation: false,
  };
  configSwiperShortcuts: SwiperOptions = { // swiper de links swiperConfig
    slidesPerView: 'auto',
    loop: false,
    spaceBetween: 10,
    lazy: {
      loadPrevNext: true, // Carrega o slide anterior e o próximo
      loadPrevNextAmount: 1, // Pode ajustar para carregar mais slides além dos visíveis
    },
    //cssMode: true,
    pagination: false,
    navigation: false,
    watchOverflow: true,
  };

  // Controla a visibilidade das setas de navegação dos swipers de produtos e
  // links: o próprio Swiper (watchOverflow, ligado no config acima) sabe se os
  // slides cabem todos na área visível ou não — "lock"/"unlock" disparam
  // quando esse estado muda (inclusive em resize). Mesmo padrão do carousel.component.
  isSwiperSecondLocked = false;
  onSwiperSecondLock(): void {
    this.isSwiperSecondLocked = true;
    this.cdr.markForCheck();
  }
  onSwiperSecondUnlock(): void {
    this.isSwiperSecondLocked = false;
    this.cdr.markForCheck();
  }

  isSwiperLinksLocked = false;
  onSwiperLinksLock(): void {
    this.isSwiperLinksLocked = true;
    this.cdr.markForCheck();
  }
  onSwiperLinksUnlock(): void {
    this.isSwiperLinksLocked = false;
    this.cdr.markForCheck();
  }

  configSwiperPin: SwiperOptions = { // swiper de links swiperConfig
    slidesPerView: 'auto',
    loop: false,
    spaceBetween: 10,
    lazy: {
      loadPrevNext: true, // Carrega o slide anterior e o próximo
      loadPrevNextAmount: 1, // Pode ajustar para carregar mais slides além dos visíveis
    },
    cssMode: false,
    pagination: false,
    navigation: false,
  };

  onHighlightChange(productToHighlight: Produto) {
    if (productToHighlight.highlight) {
      // Conta quantos produtos estão destacados
      const highlightedProducts = this.targetProducts.filter(p => p.highlight);
      console.log('produtos com hilight true');
      console.log(highlightedProducts.length);
      // Se mais de três produtos estão destacados
      if (highlightedProducts.length > 3) {
        // Encontra o primeiro produto destacado que não é o produto atualmente alterado
        // Assumindo que `this.targetProducts` está ordenada de modo que o "mais antigo" seja o primeiro
        const firstHighlightedNotCurrent = highlightedProducts.find(p => p !== productToHighlight);

        // Garante que um produto foi encontrado
        if (firstHighlightedNotCurrent) {
          // Desmarca o `highlight`
          firstHighlightedNotCurrent.highlight = false;
        }
      }
      this.targetProducts = [...this.targetProducts];
    }

    // Atualiza a UI ou estado do componente se necessário
    this.targetProducts = [...this.targetProducts];
    this.setupFilteredProducts();
    if (this.filteredProducts$) {
      this.highlightedProductsLimited$ = this.filteredProducts$.pipe(
        map(products =>
          products.filter(product => product.highlight).slice(0, 3)
        )
      );
    }
    this.targetProducts = [...this.targetProducts];
    this.setupFilteredProducts();
  }

  // onHighlightChange(product: Produto): void {
  //   this.pickListObserverService.notifyChange();
  //   // Lógica para tratar mudança no switch "Destacar"
  // }
  onShowProductChange(p: Produto) {

  }
  updateShowItem(p: Produto) {
    p.show_item = p.show_item == true ? true : false;
    this.targetProducts = [...this.targetProducts];
    this.canSave = true;
    this.debounceFunction();
    this.pushLiveUpdate();

    // Recria o mapa com a flag "show"
    this.rebuildProductMap();                    // <<< importante

    // Se a sidebar â€œShop the Lookâ€ estiver aberta, atualize a lista lá também (opcional)
  }
  showControls: boolean = false;
  formattedProducts: any[] = [];
  updateFormattedProducts(): void {

    console.log('target')
    console.log(this.targetProducts)


    this.formattedProducts = this.targetProducts.map(product => ({
      label: product.name,
      value: product.id  // Ou simplesmente passe o objeto inteiro se preferir: value: product
    }));

    console.log(this.formattedProducts)
  }



  showCTAs: boolean = true;
  showAllCTAs() {

  }

  convertToHHMMSS(minutesValue: number): string {
    // Converte minutos para horas, minutos e segundos
    let hours = Math.floor(minutesValue / 60);
    let minutes = Math.floor(minutesValue % 60);
    let seconds = Math.floor((minutesValue - hours * 60 - minutes) * 60);

    // Formata para 2 dígitos
    const padTo2Digits = (num: number) => num.toString().padStart(2, '0');

    // Retorna no formato HH:MM:SS
    return `${padTo2Digits(hours)}:${padTo2Digits(minutes)}:${padTo2Digits(seconds)}`;
  }

  toggleShowCTAs(): void {
    this.showCTAs = !this.showCTAs;
    this.showAllCTAs(); // Chama a função que manipula a mudança
    //this.adjustVideoMargin();
    this.updateItemsDock();

    this.resizeObserverBreakPoints?.disconnect();
    this.resizeObserverBreakPoints = new ResizeObserver(entries => {
      for (const entry of entries) {
        const width = entry.contentRect.width;
        this.applySwiperStyles(width);
        this.applySwiperStyles2(width);
        this.applySwiperStyles3(width);
      }
    });

    if (this.gridContainer) {
      this.resizeObserverBreakPoints.observe(this.gridContainer.nativeElement);
    }
  }

  handleButtonClick(event: MouseEvent) {
    event.stopPropagation();
  }



  isControlKey(event: KeyboardEvent): boolean {
    // Lista de teclas de controle que não produzem caracteres e podem ser permitidas
    const controlKeys = [
      'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
      'Backspace', 'Delete', 'Tab', 'End', 'Home', 'Enter'
    ];
    return controlKeys.includes(event.key);
  }

  validateTimeSimulator(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/[^0-9]/g, ''); // Remove caracteres não numéricos.

    // Limita a string a 4 caracteres numéricos para HHmm.
    value = value.substring(0, 4);

    // Formata a string como 'HH:mm' se for longa o suficiente.
    if (value.length >= 4) {
      // Separa horas e minutos.
      const hours = parseInt(value.substring(0, 2), 10);
      const minutes = parseInt(value.substring(2, 4), 10);

      // Valida horas e minutos. Ajustado para o intervalo correto das horas até 23.
      if (hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59) {
        value = `${value.substring(0, 2)}:${value.substring(2)}`;
      } else {
        // Se horas ou minutos não são válidos, mantém o valor como está, mas marca como inválido se necessário.
        value = input.value; // Mantém o valor atual para permitir correção manual pelo usuário.
      }
    } else if (value.length > 2) {
      // Se apenas parte do horário foi inserido, insere ':' após os dois primeiros dígitos.
      value = `${value.substring(0, 2)}:${value.substring(2)}`;
    }

    // Atualiza o valor do campo e o modelo Angular (ngModel) com o valor corrigido.
    input.value = value;
    this.liveTime = value;
  }


  onModelChange(value: string) {
    // Verifica se o valor é numérico e se não termina com um sinal de porcentagem
    if (value && !isNaN(+value) && !value.endsWith('%')) {
      // Atualiza o valor do modelo para incluir o sinal de porcentagem
      this.formData.conversion_events.fb_pixel_conversion.conversion_events.slip_purchase.conversion_value = `${value}%`;
    }
  }
  validateNumber(event: KeyboardEvent, maxLength: number) {
    const pattern = /[0-9]/;
    const input = event.target as HTMLInputElement;

    // Checa se a tecla pressionada é um número e se atende ao limite de caracteres
    if (!pattern.test(event.key) || (input.value.length >= maxLength && !this.isControlKey(event))) {
      // Se a tecla pressionada não é um número ou excede o limite de comprimento, previne a ação padrão.
      //event.preventDefault();
    }
  }
  validateNumberX(event: KeyboardEvent) {
    const pattern = /[0-9]/;
    const input = event.target as HTMLInputElement;

    // Checa se a tecla pressionada é um número e se atende ao limite de caracteres
    if (!pattern.test(event.key)) {
      // Se a tecla pressionada não é um número ou excede o limite de comprimento, previne a ação padrão.
      //event.preventDefault();
    }
  }

  @ViewChild('menu') menu?: MenuItem;
  @ViewChild('actionDiv') actionDiv?: Menu;
  toggleMenu(event: MouseEvent, rowIndex: number) {
    // Captura o elemento do botão clicado
    const actionButton = event.target as HTMLElement;

    // Identifica o elemento do menu relacionado usando o rowIndex ou outro identificador
    const menuId = `actionMenu${rowIndex}`;
    const menuElement = document.getElementById(menuId);

    if (actionButton && menuElement) {
      const buttonRect = actionButton.getBoundingClientRect();

      // Calcula a nova posição para o menu. Aqui, estamos posicionando o menu logo abaixo do botão.
      // Você pode ajustar isso conforme necessário para sua UI.
      const topPosition = buttonRect.bottom + window.scrollY;
      const leftPosition = buttonRect.left + window.scrollX;

      // Aplica a posição calculada ao menu. Você pode precisar ajustar isto para trabalhar com seu layout e estilos.
      menuElement.style.position = 'absolute';
      menuElement.style.top = `${topPosition}px`;
      menuElement.style.left = `${leftPosition}px`;

      // Garante que o menu é visível e posicionado corretamente
    }
  }
  // PiP removido (feature descontinuada — player Lit embutido não tem
  // integração com Picture-in-Picture do navegador). Excluídos: checkPiP(),
  // openLink() (usada só por checkPiP), isPiPActive, togglePiP() e o item
  // "PiP" do menu de 3 pontos (getActionMenu2()) e o efeito colateral de PiP
  // em handleLinkClick().



  @ViewChild('volumeSlider', { static: false }) volumeSlider!: ElementRef;
  volumeValue: number = 0;
  updateVolumeSlider(volume: number) {
    const volumeSlider = this.volumeSlider.nativeElement;
    volumeSlider.value = volume * 100; // Converte o volume para a escala de 0 a 100
  }
  showMute: boolean = true;
  toggleMute(): void {

    this.showMute = false;

    if (!this.videoElementRef || !this.videoElementRef.nativeElement) return;

    const videoEl = this.videoElementRef.nativeElement as HTMLVideoElement;
    const isMuted = videoEl.muted;

    videoEl.muted = !isMuted;

    if (isMuted) {
      // Se estava mudo e vai desmutar, restaura o volume anterior.
      videoEl.volume = this.lastVolume;
      this.volumeValue = this.lastVolume * 100;
    } else {
      // Se não estava mudo e vai mutar, guarda o último volume e zera.
      this.lastVolume = videoEl.volume;
      videoEl.volume = 0;
      this.volumeValue = 0;
    }
  }

  setVolume(event: any) {
    const volume = event.target.value / 100;
    this.volumeValue = event.target.value;
    this.player.volume(volume);
    this.lastVolume = volume;
    this.saveVolume(volume);

    // Apenas desmuta o vídeo se o volume estiver acima de 0.
    this.player.muted(false);
    if (volume == 0) {
      this.player.muted(true);
    }
  }

  showVolumeControl() {
    this.volumeControlVisible = true;
    clearTimeout(this.volumeControlTimeout); // Limpa qualquer timeout existente antes de definir um novo
  }

  hideVolumeControl() {
    this.volumeControlTimeout = setTimeout(() => {
      this.volumeControlVisible = false;
    }, 2000); // Aguarda 3 segundos para esconder a barra de volume
  }
  volumeControlVisible: boolean = false;
  volumeControlTimeout: any;


  // setVolume(event: any) {
  //   const volume = event.target.value / 100;
  //   this.volumeValue = event.target.value; // Atualiza o ngModel diretamente com o valor do evento.
  //   this.player.volume(volume);
  //   this.lastVolume = volume;
  //   this.saveVolume(volume);

  //   // Desmuta o vídeo se o volume for ajustado para mais que 0.
  //   if (volume > 0 && this.player.muted()) {
  //     this.player.muted(false);
  //   }
  // }

  loadVolume() {
    // Garante que o volume seja carregado e aplicado ao iniciar o componente.
    const volume = parseFloat(localStorage.getItem('volume') || '0.5');
    this.lastVolume = volume;
    this.player.volume(volume);
    this.volumeValue = volume * 100; // Atualiza o ngModel da slider.
  }

  saveVolume(volume: number) {
    if (volume > 0) {
      localStorage.setItem('volume', volume.toString());
    }

  }
  isVideoMuted(): boolean {
    return !!this.videoElementRef?.nativeElement?.muted;
  }



  private subscriptions: Subscription[] = [];
  formatTimeBar(seconds: number): string {
    const date = new Date(0);
    date.setSeconds(seconds);
    return date.toISOString().substr(11, 8);
  }


  sliderValuePitch: number = 0;
  updateTimeValue() {
    // Converte o valor do slider (em segundos) para o formato desejado (00h00m00s)
    let hours = Math.floor(this.sliderValuePitch / 3600);
    let minutes = Math.floor((this.sliderValuePitch - (hours * 3600)) / 60);
    let seconds = this.sliderValuePitch - (hours * 3600) - (minutes * 60);


    console.log('upd ' + this.sliderValuePitch);

    this.timePitch = `${this.pad(hours)}h${this.pad(minutes)}m${this.pad(seconds)}s`;

    this.debounceFunction();
    this.pushLiveUpdate();
  }

  // Função auxiliar para garantir que os valores de tempo sejam sempre dois dígitos
  pad(value: number): string {
    return value < 10 ? `0${value}` : `${value}`;
  }

  convertTimeToSeconds(timeString: string): number {
    if (timeString !== undefined && timeString !== null) {
      const timeParts = timeString.match(/(\d+)[hms]/g) || [];
      let seconds = 0;

      timeParts.forEach(part => {
        const unit = part.charAt(part.length - 1);
        const value = parseInt(part.slice(0, -1), 10);

        if (unit === 'h') {
          seconds += value * 3600;
        } else if (unit === 'm') {
          seconds += value * 60;
        } else if (unit === 's') {
          seconds += value;
        }
      });

      return seconds;
    }
    return 0;
  }

  onlyNumber(event: any) {
    // Expressão regular que corresponde a qualquer coisa que não seja um número
    const nonNumericRegex = /[^0-9]/g;

    // Verifica se o valor contém algo que não seja um número e o remove
    if (nonNumericRegex.test(event.target.value)) {
      event.target.value = event.target.value.replace(nonNumericRegex, '');
      // Atualiza o valor da variável ligada ao ngModel manualmente, se necessário
      this.viewers = event.target.value;
    }
  }

  limitInput(event: any) {
    const value = event.target.value;
    if (value.length > 2) {
      event.target.value = value.slice(0, 2);
      // Atualize o valor no seu modelo, se necessário
      // Isso pode ser necessário porque a atualização direta do valor do input
      // pode não refletir automaticamente no modelo Angular.
    }
  }
  preventE(event: KeyboardEvent) {
    if (event.key === 'e' || event.key === 'E') {
      event.preventDefault();
    }
  }

  correctMinutes(value: string): void {
    if (value.length === 4) { // Garante que o valor tem o comprimento esperado
      const hours = value.substring(0, 2);
      let minutes = parseInt(value.substring(2, 4), 10);

      // Corrige os minutos para 59 se estiverem acima desse valor
      if (minutes > 59) {
        minutes = 59;
        // Atualiza o modelo com as horas originais e os minutos corrigidos
        this.liveTime = hours + (minutes < 10 ? '0' : '') + minutes.toString();
      }
    }
  }

  moveItemOnTop(event: any) {
    event.item.moveOnTop();
  }

  onDialogPixelClose() {
    this.hasErrorNamePixel = false;
    this.hasErrorIdPixel = false;

  }
  sideBarLinks: boolean = false;
  displayDialogIconsGifs: boolean = false;
  // selectedLink()
  updateShowLink(link: Links, isChecked: boolean) {
    // Atualiza apenas a propriedade necessária sem redefinir todo o objeto
    const linkToUpdate = this.linksSelecteds.find(l => l === link);
    if (linkToUpdate) {
      linkToUpdate.show_item = isChecked;
      this.pushLiveUpdate();
    }
    const index = this.linksSelecteds.findIndex(link => link === this.linkSelecionado);
    if (index !== -1) {
      this.linksSelecteds[index] = { ...this.linkSelecionado };  // Cria uma nova referência para o objeto atualizado
    }
    this.linksSelecteds = [...this.linksSelecteds];
    // this.setupFilteredLinks();
    // this.setupFilteredLinksShortucut();
    this.setupFilteredLinksUnificado();
    this.debounceFunction();
  }
  loadingLinksCtas: boolean = false;
  isUpdatingLinks: boolean = false;
  async updateLinks() {
    this.loadingLinksCtas = true;
    this.isUpdatingLinks = true;

    if (this.pendingIconFile) {
      const uploadedUrl = await this.uploadPendingIcon();
      if (uploadedUrl) {
        this.iconGifSelected = uploadedUrl;
      } else {
        this.loadingLinksCtas = false;
        this.isUpdatingLinks = false;
        return;
      }
    }

    this.updateLinkIcon(this.iconGifSelected || '');

    if (this.linkDraft) {
      this.linkDraft.name = this.LinkSelectedName || '';
      this.linkDraft.redirect_url = this.LinkSelectedURL || '';
      this.linkDraft.click_url = this.iconGifSelected || '';
      this.linkDraft.bg_color = this.selectedLinkColor || '#FFFFFF';
      this.linkDraft.define_interval = !!this.defineIntervalLinkSelected;
      this.linkDraft.interval_time = {
        start: this.intervalTimeStartLinkSelected || '00:00:00',
        end: this.intervalTimeEndLinkSelected || '00:00:00',
      };
      this.linkDraft.slider_time_range = (this.sliderValue?.length === 2 ? this.sliderValue : [0, 0]) as [number, number];
      this.linkDraft.button_text = this.buttonText || 'Aprender já';
      this.linkDraft.button_bg_color = this.buttonBgColor || '#222222';
      this.linkDraft.button_text_color = this.buttonTextColor || '#FFFFFF';
      this.linkDraft.card_text_color = this.cardTextColor || '#222222';
      this.linkDraft.description = this.linkDescription || '';

      this.linksSelecteds = [...this.linksSelecteds, this.linkDraft];
      this.linkDraft = null;
    }

    this.setupFilteredLinksUnificado();
    this.debounceFunction();
  }


  linkDraft: Links | null = null;
  addLinks() {
    this.linkDraft = null;

    this.linkDraft = {
      id: 0,
      name: '',
      show_link: false,
      redirect_url: '',
      click_url: '',
      position: this.linksSelecteds.length + 1,
      bg_color: '#FFFFFF',
      define_interval: false,
      show_item: true,
      time_from: '00:00:00',
      time_to: '00:00:00',
      interval_time: { start: "00:00:00", end: "00:00:00" },
      slider_time_range: [0, 0],
      button_text_color: '#FFFFFF',     // branco como padrão
      button_bg_color: '#222222',       // cinza escuro como padrão
      card_text_color: '#222222',       // cinza escuro como padrão
      button_text: 'Aprender já',       // texto padrão do botão
      description: '',
    };

    this.defineIntervalLinkSelected = false;
    this.selectedLinkIndex = -1; // Não está na lista ainda
    this.linkSelecionado = this.linkDraft;
    this.sideBarLinks = true;

    this.LinkSelectedName = '';
    this.selectedLinkColor = '#FFFFFF';
    this.buttonBgColor = '#222222';
    this.buttonTextColor = '#FFFFFF';
    this.cardTextColor = '#222222';
    this.buttonText = 'Aprender já';
    this.LinkSelectedURL = '';
    this.iconGifSelected = '';
    this.hasIconGif = false;
    this.linkDescription = '';
    this.intervalTimeEndLinkSelected = "00:00:00";
    this.intervalTimeStartLinkSelected = "00:00:00";
    this.sliderValue = [0, 0];
    this.setupFilteredLinksUnificado();
  }




  updateLinkURL(url: string) {
    if (this.selectedLinkIndex !== undefined) {
      this.linksSelecteds[this.selectedLinkIndex].redirect_url = url;
      this.pushLiveUpdate();
    }
  }
  updateLinksColors(color: string) {
    if (this.selectedLinkIndex !== undefined) {
      this.linksSelecteds[this.selectedLinkIndex].bg_color = color;
      this.refreshLinks();
      this.setupFilteredLinksUnificado();
      this.pushLiveUpdate();
    }
  }
  refreshLinks() {
    const index = this.linksSelecteds.findIndex(link => link === this.linkSelecionado);
    if (index !== -1) {
      this.linksSelecteds[index] = { ...this.linkSelecionado };  // Cria uma nova referência para o objeto atualizado
    }
    this.linksSelecteds = [...this.linksSelecteds]; // Atualiza o array para refletir mudanças na view
  }
  updateLinksPositions(): void {
    this.linksSelecteds.forEach((link, index) => {
      link.position = index;  // Atualiza a propriedade position baseada no índice atual do item no array
    });
    this.debounceFunction();
    // this.setupFilteredLinks();
    // this.setupFilteredLinksShortucut();
    this.setupFilteredLinksUnificado();
    this.pushLiveUpdate();
  }
  icons: any[] = [];

  nameIconSearch: string = "";
  nameGifSearch: string = "";
  loadingLinks: boolean = false;

  iconGifColor?: string;
  iconGifShape?: string;
  selectedColors = {
    black: false,
    white: false,
    multicolor: false,
    gradient: false
  };

  setIconGifShape(option: { label: string, value: string }) {
    this.iconGifShape = option.value;
    this.loadData({ first: 0, rows: 25 });
  }
  setIconGifColor(option: { label: string, value: string }) {
    console.log('Valor recebido:', option); // Agora espera um objeto
    this.iconGifColor = option.value;
    console.log('iconGifColor definido como:', this.iconGifColor); // Deve mostrar o valor correto agora

    this.loadData({ first: 0, rows: this.rowsIcons });
  }



  closeIconsModal() {
    this.displayDialogIconsGifs = false;
  }
  //current_page
  loadMoreData() {

  }
  totalRecordsIcons: number = 0;
  totalRecordsGifs: number = 0;
  limitIcons: number = 25;

  rowsIcons: number = 0;


  loadAllDataIcons: boolean = false;
  clearSearchIcons() {
    this.nameIconSearch = ''; // Limpa a busca
    this.icons = []; // Limpa os resultados atuais
    this.totalRecordsIcons = 0; // Reset o contador de registros
    this.valSelect1 = ''; // Reset a seleção de Cor
    this.valSelect2 = ''; // Reset a seleção de Shapes

    // Chame as funções que lidam com mudanças nesses SelectButtons, se necessário
    // Isto irá garantir que qualquer lógica adicional ligada à mudança desses valores seja executada
    // this.setIconGifColor(null);
    // this.setIconGifShape(null);

    this.cdr.detectChanges();// Se necessário para atualizar a view
  }
  clearSearchGifs() {
    this.nameGifSearch = ''; // Limpa a busca
    this.gifs = []; // Limpa os resultados atuais
    this.totalRecordsGifs = 0; // Reset o contador de registros
    this.cdr.detectChanges(); // Se necessário para atualizar a view
  }

  async loadData(event: LazyLoadEvent) {
    if (!this.loadAllDataIcons) {
      this.loadAllDataIcons = true;
      return;
    }
    this.loadingLinks = true;

    const first = event.first ?? 0;
    this.rowsIcons = event.rows ?? 96;
    const page = Math.floor(first / this.rowsIcons) + 1;

    try {
      const iconObservable = await this.productsService.searchIcons(
        this.nameIconSearch,
        first,
        this.rowsIcons,
        this.iconGifColor,
        this.iconGifShape
      );

      iconObservable.pipe(takeUntil(this.destroy$)).subscribe({
        next: (data) => {
          this.icons = data.data;
          this.totalRecordsIcons = data.meta.pagination.total > 10080
            ? 10080
            : data.meta.pagination.total;

          console.log('total de itens: ' + this.totalRecordsIcons);
          this.loadingLinks = false;
          this.cdr.detectChanges();
        },
        error: (err) => {
          console.error('Erro ao carregar ícones:', err);
          this.loadingLinks = false;
        }
      });
    } catch (err) {
      console.error('Erro ao buscar ícones:', err);
      this.loadingLinks = false;
    }
  }


  gifs: Gif[] = [];


  async loadDataGifs(event: LazyLoadEvent) {
    console.log("Paginação alterada em gifs:", event);
    this.loadingLinks = true;

    const first = event.first ?? 0;
    const rows = event.rows ?? 25;
    const page = Math.floor(first / rows) + 1;

    try {
      const observable$ = await this.productsService.searchGifs(this.nameGifSearch, first, rows);

      observable$.pipe(takeUntil(this.destroy$)).subscribe({
        next: (data: any) => {
          this.gifs = [...data.data];
          this.totalRecordsGifs = data.pagination.total_count;
          console.log(`Dados carregados: ${data.data.length} itens, página ${page}`);
          this.loadingLinks = false;
        },
        error: (err: any) => {
          console.error('Erro ao carregar GIFs:', err);
          this.loadingLinks = false;
        }
      });
    } catch (err) {
      console.error('Erro ao preparar requisição de GIFs:', err);
      this.loadingLinks = false;
    }
  }

  private debounceTimerCTALinks: any;
  searchIcons() {
    if (this.debounceTimerCTALinks) {
      clearTimeout(this.debounceTimerCTALinks);
    }

    this.debounceTimerCTALinks = setTimeout(() => {
      this.loadData({ first: 0, rows: this.rowsIcons });
    }, 750);
  }
  valSelect1: string = 'black';
  valSelect2: string = '-';
  linkOptions = [
    { label: '-', value: '' },
    { label: 'Preto', value: 'black' },
    { label: 'Branco', value: 'white' },
    { label: 'Colorful', value: 'multicolor' },
    { label: 'Gradiente', value: 'gradient' }
  ];
  linkOptionsGif = [
    { label: '-', value: '' },
    { label: 'Outline', value: 'outline' },
    { label: 'Filed', value: 'fill' },
    { label: 'Sketch', value: 'hand-drawn' }
  ];





  searchGifs() {
    if (this.debounceTimerCTALinks) {
      clearTimeout(this.debounceTimerCTALinks);
    }

    this.debounceTimerCTALinks = setTimeout(() => {
      this.loadDataGifs({ first: 0, rows: 25 });
    }, 750);
  }
  hasIconGif: boolean = false;
  iconGifSelected?: string = '';
  uploadingIcon = false;
  uploadIconProgress = 0;
  iconDragOver = false;
  pendingIconFile: File | null = null;

  onIconFileSelected(event: any): void {
    const file: File = event.target?.files?.[0] || event.files?.[0];
    if (!file) return;
    const validTypes = ['image/png', 'image/jpeg', 'image/gif', 'image/webp', 'image/svg+xml'];
    if (!validTypes.includes(file.type)) {
      this.messageService.add({ severity: 'warn', summary: 'Formato inválido', detail: 'Use PNG, JPG, GIF, WebP ou SVG.' });
      return;
    }
    if (file.size > 2 * 1024 * 1024) {
      this.messageService.add({ severity: 'warn', summary: 'Arquivo grande', detail: 'Máximo 2MB.' });
      return;
    }
    this.pendingIconFile = file;
    this.iconGifSelected = URL.createObjectURL(file);
    this.hasIconGif = true;
  }

  private async uploadPendingIcon(): Promise<string | null> {
    if (!this.pendingIconFile) return null;
    const file = this.pendingIconFile;
    this.uploadingIcon = true;
    this.uploadIconProgress = 0;
    try {
      const { url } = await this.mediaUploadService.uploadForStore(file, this.storeId, 'slick_link_icon', (progress) => {
        this.uploadIconProgress = progress;
        this.cdr.detectChanges();
      });
      this.pendingIconFile = null;
      this.uploadingIcon = false;
      this.uploadIconProgress = 0;
      return url;
    } catch (err: any) {
      this.uploadingIcon = false;
      this.uploadIconProgress = 0;
      this.errorHandler.handle(err, 'Falha ao fazer upload da imagem.');
      return null;
    }
  }

  onIconDrop(event: DragEvent): void {
    const file = event.dataTransfer?.files?.[0];
    if (file) this.onIconFileSelected({ target: { files: [file] } });
  }

  removeIconGif(): void {
    this.hasIconGif = false;
    this.iconGifSelected = '';
    this.pendingIconFile = null;
  }

  getIcon(url: string) {
    this.displayDialogIconsGifs = false;
    this.hasIconGif = true;
    this.iconGifSelected = url;
    this.updateLinkIcon(url);
    this.setupFilteredLinksUnificado();
  }
  LinkSelectedName?: string = "";
  LinkSelectedURL?: string = "";
  selectedLinkColor?: string = "";

  selectedClickURL?: string = "";

  defineIntervalLinkSelected?: boolean = false;
  intervalTimeStartLinkSelected?: string = '00:00:00';
  intervalTimeEndLinkSelected?: string = '00:00:00';
  updateIntervalTimeLinks(values: number[]): void {
    console.log(this.sliderMaxValue); // Para depuração
    if (this.linkSelecionado && this.selectedLinkIndex !== null) {

      const startTime = this.secondsToTimeString(values[0]);
      const endTime = this.secondsToTimeString(values[1]);

      // Atualiza o interval_time do link selecionado
      this.linkSelecionado.interval_time!.start = startTime;
      this.linkSelecionado.interval_time!.end = endTime;

      // Atualizar os campos da interface de usuário
      this.intervalTimeStartLinkSelected = startTime;
      this.intervalTimeEndLinkSelected = endTime;

      console.log('Intervalo atualizado para:', startTime, 'a', endTime);
      this.linkSelecionado.time_from = startTime;
      this.linkSelecionado.time_to = endTime;
      this.linkSelecionado.define_interval = this.defineIntervalLinkSelected;
      this.debounceFunction();
      if (this.selectedLinkIndex) {
        // Essa linha é crucial para garantir que as mudanças sejam refletidas na interface do usuário
        this.linksSelecteds[this.selectedLinkIndex] = { ...this.linkSelecionado };

        // this.setupFilteredLinks();
        // this.setupFilteredLinksShortucut();
        this.setupFilteredLinksUnificado();
        // Opcional: Se você precisa de algum tratamento adicional ou recálculo com base na mudança de intervalos
        this.debounceFunction();
      }
    }
  }

  toggleDefineIntervalLinks(newValue: boolean): void {

    if (this.selectedLinkIndex != null && this.linksSelecteds[this.selectedLinkIndex]) {
      this.linksSelecteds[this.selectedLinkIndex].define_interval = newValue;
      // if(newValue){
      //   this.linksSelecteds[this.selectedLinkIndex].show_item = false;
      // }
      // /updateIntervalTimeLinks
      this.linksSelecteds[this.selectedLinkIndex] = { ...this.linkSelecionado };

      console.log('Intervalo definido alterado para:', newValue, 'no item:', this.linksSelecteds[this.selectedLinkIndex]);
      this.cdr.detectChanges();
      // this.setupFilteredLinks();
      // this.setupFilteredLinksShortucut();
      this.setupFilteredLinksUnificado();
      this.debounceFunction();
    }
  }
  linkSelecionado: Links = {
    id: 0,
    name: '',
    show_link: false,
    bg_color: '',
    position: 0,
    redirect_url: '',
    click_url: '',
    define_interval: false,
    show_item: false,
    time_from: '',
    time_to: '',
    interval_time: { start: '00:00:00', end: '00:00:00' },
    slider_time_range: [0, 0]
  };
  selectedLinkIndex?: number = 0;
  buttonText: string = '';
  buttonBgColor: string = '#222';
  buttonTextColor: string = '#fff';
  cardTextColor: string = '#fff';
  linkDescription: string = '';
  expandedLinkDescIds = new Set<number>();
  selectedLink(linkSelected: Links, index: number) {
    this.selectedLinkIndex = index; // Atualiza sempre o índice selecionado
    this.linkSelecionado = linkSelected;

    this.LinkSelectedName = linkSelected.name;
    this.LinkSelectedURL = linkSelected.redirect_url;
    this.selectedLinkColor = linkSelected.bg_color;
    this.defineIntervalLinkSelected = linkSelected.define_interval;

    this.intervalTimeStartLinkSelected = linkSelected.interval_time?.start || "00:00:00";
    this.intervalTimeEndLinkSelected = linkSelected.interval_time?.end || "00:00:00";

    // Converte os tempos em segundos para usar no slider
    const startSeconds = this.timeToSeconds(this.intervalTimeStartLinkSelected);
    const endSeconds = this.timeToSeconds(this.intervalTimeEndLinkSelected);

    // Atualiza o valor do slider
    this.sliderValue = [startSeconds, endSeconds];

    if (linkSelected.click_url != '' && linkSelected.click_url != 'theny') {
      this.hasIconGif = true;
      this.iconGifSelected = linkSelected.click_url;
    } else {
      this.hasIconGif = false;
    }

    // NOVOS CAMPOS:
    this.buttonText = linkSelected.button_text || 'Aprender já';
    this.buttonBgColor = linkSelected.button_bg_color || '#222';
    this.buttonTextColor = linkSelected.button_text_color || '#fff';

    this.cardTextColor = linkSelected.card_text_color || '#fff';
    this.linkDescription = linkSelected.description || '';

    //this.linkSelecionado = linkSelected;
    this.selectedLinkIndex = index;
    this.sideBarLinks = true;
  }
  updateLinkDescription(value: string) {
    if (this.selectedLinkIndex !== undefined && this.selectedLinkIndex >= 0) {
      this.linksSelecteds[this.selectedLinkIndex].description = value;
      this.setupFilteredLinksUnificado();
      this.pushLiveUpdate();
    }
  }
  isLinkDescExpanded(link: Links): boolean {
    return this.expandedLinkDescIds.has(link.id);
  }
  toggleLinkDesc(link: Links, event: Event): void {
    event.stopPropagation();
    if (this.expandedLinkDescIds.has(link.id)) {
      this.expandedLinkDescIds.delete(link.id);
    } else {
      this.expandedLinkDescIds.add(link.id);
    }
  }
  updateButtonText(value: string) {
    if (this.selectedLinkIndex !== undefined && this.selectedLinkIndex >= 0) {
      this.linksSelecteds[this.selectedLinkIndex].button_text = value;
      this.setupFilteredLinksUnificado();
      this.pushLiveUpdate();
    }
  }
  updateCardTextColor(value: string) {
    this.cardTextColor = value;
    if (this.selectedLinkIndex !== undefined && this.selectedLinkIndex >= 0) {
      this.linksSelecteds[this.selectedLinkIndex].card_text_color = value;
      this.setupFilteredLinksUnificado();
      this.pushLiveUpdate();
    }
  }
  updateButtonBgColor(value: string) {
    if (this.selectedLinkIndex !== undefined && this.selectedLinkIndex >= 0) {
      this.linksSelecteds[this.selectedLinkIndex].button_bg_color = value;
      this.setupFilteredLinksUnificado();
      this.pushLiveUpdate();
    }
  }

  updateLinkName(name: string) {
    if (this.selectedLinkIndex !== undefined) {
      this.linksSelecteds[this.selectedLinkIndex].name = name;
      this.setupFilteredLinksUnificado();
      this.pushLiveUpdate();
    }
  }

  updateButtonTextColor(value: string) {
    if (this.selectedLinkIndex !== undefined && this.selectedLinkIndex >= 0) {
      this.linksSelecteds[this.selectedLinkIndex].button_text_color = value;
      this.setupFilteredLinksUnificado();
      this.pushLiveUpdate();
    }
  }

  updateLinkIcon(url: string) {
    if (this.selectedLinkIndex !== undefined && this.linksSelecteds?.[this.selectedLinkIndex]) {
      this.linksSelecteds[this.selectedLinkIndex].click_url = url;
      this.pushLiveUpdate();
    }
  }
  saveNewLink(): void {
    const newLink: Links = {
      id: 0,
      name: this.LinkSelectedName,
      bg_color: this.selectedLinkColor,
      redirect_url: this.LinkSelectedURL,
      click_url: this.iconGifSelected,
      show_link: true, // Suponho que isso pode ser true ou depende de outra lógica
      position: this.linksSelecteds.length + 1, // Um exemplo simples para determinar a posição
      define_interval: false, // Valor default ou dependente de outra entrada do usuário
      show_item: true, // Suponho que seja visível por default
      interval_time: { start: '', end: '' }, // Valores default ou lógica específica
      time_from: '',
      time_to: '',
      slider_time_range: [0, 100] // Valores default ou entrada do usuário
    };
    //this.linksSelecteds.push(newLink);
    this.linksSelecteds = [...this.linksSelecteds, newLink];
    this.debounceFunction();
    this.pushLiveUpdate();
  }

  selectedType?: string;

  //activeLinkOption: any;  // Supõe-se que você tenha essa variável definida em algum lugar do seu componente
  tempIconGifUrl: string = '';  // Guarda temporariamente a URL do ícone/GIF
  errorGif: boolean = false;
  // Método para detectar mudanças no input
  onInputChange2(): void {
    this.errorGif = false;
  }
  selectIconGif(url: string): void {
    this.errorGif = false;
    // Verifica se a URL termina com uma das extensões de imagem permitidas
    const validImageExtensions = /\.(png|jpg|jpeg|gif|webp|svg|ico|bmp|heif|avif|tiff)$/i;

    if (!validImageExtensions.test(url)) {
      this.errorGif = true;
      return;
    }

    if (url && validImageExtensions.test(url)) {
      this.iconGifSelected = url;  // Atribui a URL temporária à variável final
      this.tempIconGifUrl = '';
      this.linkSelecionado.click_url = url;

      const index = this.linksSelecteds.findIndex(link => link === this.linkSelecionado);
      if (index !== -1) {
        this.linksSelecteds[index] = { ...this.linkSelecionado };  // Cria uma nova referência para o objeto atualizado
      }
      this.linksSelecteds = [...this.linksSelecteds];

      this.hasIconGif = true;
      this.displayDialogIconsGifs = false;
      // this.setupFilteredLinks();
      // this.setupFilteredLinksShortucut();
      this.setupFilteredLinksUnificado();
    } else {
      console.error('URL inválida ou não aponta para uma imagem.');
      this.hasIconGif = false;
    }
  }
  // confirmRedirect
  confirmRedirect(): void {
    localStorage.setItem(this.tempUrl, 'confirmed'); // Salva a confirmação no localStorage
    this.navigateTo(this.tempUrl);
    this.displayDialog = false;
  }
  async cancelRedirect(): Promise<void> {
    this.displayDialog = false;
    //this.player?.play(); // Opcional: Reiniciar o vídeo após cancelar
  }
  navigateTo(url: string | undefined): void {
    if (!url) return;  // Verifica se URL é nula ou vazia

    if (url.startsWith('http')) {
      window.open(url, '_blank');
    } else {
      window.open('https://' + url, '_blank');
    }
    // Verifica se a URL é externa

  }
  tempUrl: string = '';
  async handleLinkClick(link: any): Promise<void> {
    this.tempUrl = link.redirect_url;
    this.displayDialog = true;
    //this.player?.pause(); // Pausar o vídeo
  }
  getLinkIcon(linkType: string): string {
    if (linkType === 'shortcut') {
      return 'https://cdn-icons-png.freepik.com/128/9970/9970692.png';
    } else if (linkType === 'swiper') {
      return 'https://cdn-icons-png.freepik.com/128/9417/9417114.png';
    }
    return ''; // Pode retornar uma imagem padrão ou uma string vazia caso não tenha correspondência
  }

  handleCanPlayThrough() {
    console.log('Video can play through without interruption.');
  }


  replaceDomain(url: string | null | undefined): string | null | undefined {
    const s3Domain = 'https://krabo163508-dev.s3.sa-east-1.amazonaws.com';
    const cloudFrontDomain = 'https://d2434dp583bttd.cloudfront.net';
    if (url && url.includes(s3Domain)) {
      return url.replace(s3Domain, cloudFrontDomain);
    }
    return url; // Retorna a URL original, que pode ser undefined
  }
  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.linksSelecteds, event.previousIndex, event.currentIndex);
    this.updateLinksPositions();
  }





  columnSize?: string = 'col-12 md:col-8 lg:col-8';
  itemsDock: MenuItem[] | undefined;
  openFinder() {

  }
  @ViewChild('splitterWrapper2', { static: true }) splitterWrapper2Ref!: ElementRef;
  onSidebarShow() { // itemsDock
    if (!Capacitor.isNativePlatform()) return;
    setTimeout(() => {
      const mask = document.querySelector('.p-sidebar-mask');
      if (mask && this.splitterWrapper2Ref?.nativeElement) {
        this.splitterWrapper2Ref.nativeElement.appendChild(mask);
        // Opcional: ajustar estilo para garantir posicionamento correto
        (mask as HTMLElement).style.position = 'absolute';
        (mask as HTMLElement).style.top = '0';
        (mask as HTMLElement).style.left = '0';
        (mask as HTMLElement).style.right = '0';
        (mask as HTMLElement).style.bottom = '0';
        (mask as HTMLElement).style.zIndex = '999';
      }
    }, 0);
  }

  onSidebarHide() {
    const mask = document.querySelector('.p-sidebar-mask');
  }

  loadingPage: boolean = false;
  platform?: string;
  verSlickStatus: boolean = true;
  ngOnInit(): void {
    this.bridge = this.embedBridgeService.createIframe(this.iframeHost.nativeElement);
    this.bridge.onCloseRequested = () => {
      // Studio é uma rota cheia (`/slick/{uid}`), não um modal — não existe
      // conceito de "fechar" próprio aqui. O X/Escape de dentro do player Lit
      // (ss-player-close) não tem uma ação equivalente pra disparar; deixado
      // sem handler proposital (ver relatório final).
    };
    this.bridge.onTrackEvent = (detail) => {
      if (detail.type === 'pitch') {
        // Grep por "pitch" neste componente não encontrou nenhum watch de
        // currentTime/timestamp disparando evento (a lógica que existe hoje —
        // sliderValuePitch/timePitch — é só a UI de configuração do tempo de
        // pitch, não um listener de reprodução). Não há método existente
        // equivalente pra chamar aqui — ver relatório final.
      } else if (detail.type === 'openChat') {
        // Botão de chat do player embutido (ícone na faixa lateral) — no
        // Studio ele não abre mais o chat interno do player (ver
        // `handleOpenChatSidebar` em `slicksell-player.ts`, guardado por
        // `editableHotspots`), só dispara esse evento. Bug real corrigido:
        // existia um SEGUNDO botão de chat fora do iframe (removido do
        // template) só pra cobrir essa função — agora o único botão visível
        // (o do player) já chama o chat de suporte certo no Studio.
        this.openGlobalChat();
      }
    };
    // Vem do arrasto de um hotspot dentro do player embutido (modo
    // `editableHotspots`, só o Studio liga isso) — reaproveita EXATAMENTE a
    // lógica que `onHotspotDrop()` já tinha pro `app-hotspot-editor`
    // deletado (mesma assinatura de dado, `productId` = sku), só troca a
    // origem do evento.
    this.bridge.onHotspotPositionChange = (detail) => {
      const h = this.hotspotsData.find((x) => String(x.productId) === String(detail.sku));
      if (!h) return;
      h.xPct = detail.xPct;
      h.yPct = detail.yPct;
      this.syncHotspotOrderFromTarget();
      this.canSave = true;
      this.debounceFunction();
      this.pushLiveUpdate();
    };

    if (this.observer) {
      this.observer.disconnect();
    }
    // Em desktop o painel "Gerenciar Slick" é docado (não é mais um overlay que
    // precisa ser aberto), então já começa visível — com o MESMO estado que
    // openSidebar() monta (sidebarGerenciar/mananger/pageStudio), senão o
    // header e o menu "Studio" (guardados por *ngIf="sidebarGerenciar && mananger == 0")
    // ficam em branco até o usuário abrir/fechar manualmente. Em mobile
    // continua overlay fechado, como sempre foi.
    if (!this.isCompactView) {
      this.openSidebar();
    }
    this.platform = this.platformService.identifyPlatform();

    //if (Capacitor.isNativePlatform()) {
    document.body.classList.add('is-capacitor');
    //}

    this.pauseSlick = false;
    this.typeLive = false;
    // items
    this.fullScreen = false;
    this.uuid = this.route.snapshot.paramMap.get('uuid');

    this.id = this.uuid;
    if (this.uuid) {
      this.loadSlickDetails(this.uuid);
    }
    this.menuitems = [
      { label: 'View', icon: 'pi pi-search' },
      { label: 'Refresh', icon: 'pi pi-refresh' }
    ]

    this.landscapeOptions = [
      {
        label: 'Player', command: () => {
          this.addItem();
        }
      },
      {
        label: 'CTA', command: () => {
          this.addItem();
        }
      },
      {
        label: 'Chat', command: () => {
          this.addItem();
        }
      },
      {
        label: 'Configurações', command: () => {
          this.addItem();
        }
      },
      {
        label: 'Analytics', command: () => {
          this.addItem();
        }
      },
      { label: 'Integrações', routerLink: 'lives' },
    ];
    this.landscapeOptions2 = [
      { icon: 'pi pi-mobile', name: 'Vertical', value: 1 },
      { icon: 'pi pi-mobile rotate-90', name: 'Horizontal', value: 2 },
    ];
    this.landscapeOptions3 = [
      { icon: 'pi pi-mobile rotate-minus-90', name: '', value: 1 },
      { icon: 'pi pi-desktop rotate-minus-90', name: '', value: 2 },
    ];
    this.valSelectviewMode = this.landscapeOptions3[0];

    this.linksOptions = [
      { label: 'Ícones', icon: 'pi pi-fw pi-images', command: () => { this.activeLinkOption = this.linksOptions[0]; } },
      { label: 'Custom', icon: 'pi pi-fw pi-pencil', command: () => { this.activeLinkOption = this.linksOptions[1]; } },
      { label: 'GIFS', icon: 'pi pi-fw pi-file', command: () => { this.activeLinkOption = this.linksOptions[2]; } },
    ];
    this.activeLinkOption = this.linksOptions[0];

    this.valSelect1Video = this.landscapeOptions2[0];
    document.addEventListener('fullscreenchange', this.handleFullscreenChange);

    this.buildMenuInferior();
    this.selectedIntegration = this.integrations[1];

    //updateColors
    this.subscription = this.pickListObserverService.pickListChange$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.saveAsset(0);
    });


    this.targetTime = Array.from({ length: 10 }, (_, i) => ({
      label: `${(i + 1) * 10}%`,
      value: (i + 1) * 10,
    }));

    this.loadDataChipsMaps();

    this.subscription2 = this.stateManagementService.getIconColor().pipe(takeUntil(this.destroy$)).subscribe(color => {
      this.iconColor = color;
    });

    this.subscriptionAlerts = this.stateManagementService.alertChange$.pipe(takeUntil(this.destroy$)).subscribe({
      next: (change) => {
        if (change.index >= 0 && change.index < this.alertsTabs.length) {
          if (change.text !== undefined) {
            this.alertsTabs[change.index].text = change.text;
          }
          if (change.fontColor !== undefined) {
            this.alertsTabs[change.index].font_color = change.fontColor;
          }
          if (change.backgroundColor !== undefined) {
            this.alertsTabs[change.index].background = change.backgroundColor;
          }
        }
      },
    });
    // this.checkCameras();


    if (this.observer) {
      this.observer.disconnect();
    }



    this.showProgressBarSubscription = this.showProgressBar$.pipe(takeUntil(this.destroy$)).subscribe(value => {
      this.showProgressBar = value; // Atualiza sua variável local showProgressBar — a resync do marker/barra
      // agora é responsabilidade do próprio app-progress-bar (signal reativo ao [showProgressBar]).
    });


    this.stopRecordingTimer();
    this.cliclkStop = false;

    // Desabilitado: não dispara dialog de "alterações não salvas"
    // window.addEventListener('beforeunload', this.boundBeforeUnloadHandler);



    combineLatest([
      this.route.paramMap,
      this.route.queryParams,
      this.liveShopService.getAssets()
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([paramMap, queryParams, res]) => {


        const currentUid = this.uuid;// paramMap.get('uid');
        const idxFromParam = parseInt(queryParams['i'] ?? '-1', 10);
        //// nova orderm
        const flatItems = res.assets.flatMap(asset => asset.items);
        this.groupedAssets = this.groupAssetsByParentId(flatItems);
        this.allItems = flatItems;
        //// nova orderm

        this.groupedByParent.clear();

        for (const item of this.allItems) {
          const groupKey = item.parent_id ?? item.media_id;
          if (!groupKey) continue;

          const key = String(groupKey);
          if (!this.groupedByParent.has(key)) {
            this.groupedByParent.set(key, []);
          }
          this.groupedByParent.get(key)!.push(item);
        }

        // ðŸ”§ CORREÃ‡ÃƒO AQUI: reordenar os grupos garantindo que o "pai real" (parent_id === media_id) fique no topo
        for (const [key, group] of this.groupedByParent.entries()) {
          const trueParent = group.find(i => String(i.parent_id) === String(i.media_id));
          if (trueParent) {
            const orderedGroup = [trueParent, ...group.filter(i => i !== trueParent)];
            this.groupedByParent.set(key, orderedGroup);
          }
        }

        if (currentUid) {
          const idxFromUid = this.allItems.findIndex(item => item.content?.uid === currentUid);

          if (idxFromUid !== -1) {
            this.currentIndex = (!isNaN(idxFromParam) && this.allItems[idxFromParam])
              ? idxFromParam
              : idxFromUid;

            const uid = this.allItems[this.currentIndex]?.content?.uid;
            if (uid && uid !== this.lastDetailRequestedUid) {
              this.loadSlickDetails(uid);
            }
          }
        }

        // OnPush: groupedByParent/currentIndex acabaram de ser atualizados
        // acima, mas essa mutação sozinha não marca o componente pra
        // re-renderizar (não veio de um @Input, de um evento do próprio
        // template ou de async pipe). Sem isso, os botões de navegação de
        // grupo (isFirstInGroupHidden/isLastInGroupHidden, que leem
        // groupedByParent) só atualizavam na tela quando outro evento do
        // template (ex.: mousemove no vídeo) forçava uma checagem por conta própria.
        this.cdr.detectChanges();
      });
  }
  groupedAssets: any[] = [];
  groupAssetsByParentId(items: Item[]): any[] {
    const groupedResults: any[] = [];

    const groupsByParentId = new Map<string, Item[]>();
    const orphanItems: Item[] = [];

    for (const item of items) {
      if (item.parent_id !== null && item.parent_id !== undefined) {
        const key = String(item.parent_id);
        if (!groupsByParentId.has(key)) {
          groupsByParentId.set(key, []);
        }
        groupsByParentId.get(key)!.push(item);
      } else if (!item.media_id && !item.parent_id) {
        orphanItems.push(item);
      }
    }

    for (const [parentId, groupItems] of groupsByParentId.entries()) {
      const parent = groupItems.find(i => String(i.media_id) === parentId) || groupItems[0];
      const children = groupItems.filter(i => i !== parent);

      groupedResults.push({
        ...parent,
        children: { data: children }
      });
    }

    for (const orphan of orphanItems) {
      groupedResults.push({ ...orphan, children: { data: [] } });
    }

    // Comparador IDÊNTICO ao de slicks-data-view.component.ts (mesmo método,
    // truthy em vez de === 1 — ver comentário no início da função). Testado
    // com dados reais via Node (mesmo V8 do navegador): mesmo parecendo "não
    // transitivo" à primeira vista, dá o resultado certo de forma consistente
    // — não trocar por uma versão "corrigida", já tentamos e dava ordem
    // diferente da de slicks-data-view.
    groupedResults.sort((a, b) => {
      if (!!a.media?.pin) return -1;
      if (!!b.media?.pin) return 1;

      const aDate = new Date(a.created_at ?? a.post_timestamp ?? 0).getTime();
      const bDate = new Date(b.created_at ?? b.post_timestamp ?? 0).getTime();
      return bDate - aDate;
    });

    return groupedResults;
  }



  destroyPlayer(isImage: boolean = false): void {
    if (this.player) {
      try {
        this.player.dispose(); // remove eventos, classes, overlays etc
      } catch (err) {
        console.warn('Erro ao destruir player:', err);
      }
      this.player = null;
    }

    const videoEl = this.videoElementRef?.nativeElement as HTMLVideoElement;

    if (videoEl) {
      // ðŸ§½ Remove o wrapper do Video.js se existir
      const wrapper = videoEl.parentElement;
      if (wrapper?.classList.contains('video-js')) {
        const realParent = wrapper.parentElement;

        if (realParent) {
          // remove o wrapper inteiro criado pelo Video.js
          this.renderer.removeChild(realParent, wrapper);

          // recria apenas a <video> limpa no lugar
          const cleanVideo = this.renderer.createElement('video');
          cleanVideo.setAttribute('id', 'my-video');
          cleanVideo.setAttribute('class', 'video-js video-preview');
          cleanVideo.setAttribute('muted', '');
          cleanVideo.setAttribute('autoplay', '');
          cleanVideo.setAttribute('playsinline', '');
          cleanVideo.setAttribute('loop', '');
          cleanVideo.setAttribute('preload', 'auto');
          this.renderer.setStyle(cleanVideo, 'display', isImage ? 'none' : 'block');

          this.renderer.appendChild(realParent, cleanVideo);
          this.videoElementRef = new ElementRef(cleanVideo); // atualiza ref
        }
      } else {
        // se não foi tocado pelo video.js, só limpa o conteúdo
        videoEl.pause();
        videoEl.removeAttribute('src');
        videoEl.load();
        this.renderer.setStyle(videoEl, 'display', isImage ? 'none' : 'block');
      }
    }

    this.videoUrl = '';
    this.mediaThumbnail = '';
    this.mediaType = '';
    this.videoPreviewUrl = '';
    this.showPlayPauseButton = false;
    this.sliderMaxValue = 0;
    this.originalProgress?.nativeElement?.style?.setProperty('width', '0%');
    this.revokeVttBlob();
    this.lastActiveChapterTime = null;
  }

  changeUuid() {
    this.uuid = this.route.snapshot.paramMap.get('uuid');
    this.cdr.detectChanges();
    this.is_chat_conected = false;
    this.connectToRoom();
  }

  goToPreviousItem(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
    this.changeUuid();
    const currentItem = this.allItems[this.currentIndex];
    const currentGroupKey = currentItem.parent_id ?? currentItem.media_id ?? currentItem.content?.uid;

    const currentGroupIndex = this.groupedAssets.findIndex(g => {
      const key = g.parent_id ?? g.media_id ?? g.content?.uid;
      return key === currentGroupKey;
    });

    const prevIndex = currentGroupIndex - 1;

    if (prevIndex >= 0) {
      const prevGroup = this.groupedAssets[prevIndex];
      const uid = prevGroup.content?.uid;

      const idxInAll = this.allItems.findIndex(i => i.content?.uid === uid);

      if (idxInAll !== -1) {
        this.currentIndex = idxInAll;
        this.router.navigate(['/slick', uid], {
          queryParams: { i: this.currentIndex },
          replaceUrl: true,
        });
        this.loadSlickDetails(uid);
      }
    }
  }



  goToNextItem(): void {
    const currentItem = this.allItems[this.currentIndex];
    const currentGroupKey = currentItem.parent_id ?? currentItem.media_id ?? currentItem.content?.uid;
    this.changeUuid();
    const currentGroupIndex = this.groupedAssets.findIndex(g => {
      const key = g.parent_id ?? g.media_id ?? g.content?.uid;
      return key === currentGroupKey;
    });

    const nextIndex = currentGroupIndex + 1;

    if (nextIndex < this.groupedAssets.length) {
      const nextGroup = this.groupedAssets[nextIndex];
      const uid = nextGroup.content?.uid;

      const idxInAll = this.allItems.findIndex(i => i.content?.uid === uid);

      if (idxInAll !== -1) {
        this.currentIndex = idxInAll;
        this.router.navigate(['/slick', uid], {
          queryParams: { i: this.currentIndex },
          replaceUrl: true,
        });
        this.loadSlickDetails(uid);
      }
    }
  }




  // Precisa usar o índice do grupo dentro de groupedAssets (mesma base que
  // goToPreviousItem/goToNextItem usam pra navegar) — não dá pra escanear
  // allItems (ordem crua da API), porque essa ordem não reflete o
  // reordenamento por pin feito em groupAssetsByParentId.
  private currentGroupIndexInGroupedAssets(): number {
    const currentItem = this.allItems[this.currentIndex];
    if (!currentItem) return -1;

    const currentGroupKey = currentItem.parent_id ?? currentItem.media_id ?? currentItem.content?.uid;

    return this.groupedAssets.findIndex(g => {
      const key = g.parent_id ?? g.media_id ?? g.content?.uid;
      return key === currentGroupKey;
    });
  }

  isFirstItem(): boolean {
    if (!this.allItems[this.currentIndex]) return false;

    const currentGroupIndex = this.currentGroupIndexInGroupedAssets();
    return currentGroupIndex <= 0;
  }

  isLastItem(): boolean {
    if (this.observer) {
      this.observer.disconnect();
    }
    if (!this.allItems[this.currentIndex]) return false;

    const currentGroupIndex = this.currentGroupIndexInGroupedAssets();
    return currentGroupIndex === -1 || currentGroupIndex >= this.groupedAssets.length - 1;
  }
  groupedByParent = new Map<string, any[]>();
  goToNextInGroup(): void {
    const currentItem = this.allItems[this.currentIndex];
    this.changeUuid();
    const groupKey = currentItem.parent_id && currentItem.parent_id !== currentItem.media_id
      ? currentItem.parent_id
      : currentItem.media_id;

    const group = this.groupedByParent.get(String(groupKey)) ?? [];

    const currentInGroupIdx = group.findIndex(i => i.content?.uid === currentItem.content?.uid);
    const nextItem = group[currentInGroupIdx + 1];

    if (nextItem) {
      const nextIndexInAllItems = this.allItems.findIndex(i => i.content?.uid === nextItem.content?.uid);
      if (nextIndexInAllItems !== -1) {
        this.currentIndex = nextIndexInAllItems;
        this.router.navigate(['/slick', nextItem.content.uid], {
          queryParams: { i: this.currentIndex },
          replaceUrl: true,
        });
        this.loadSlickDetails(nextItem.content.uid);
      }
    }
  }

  goToPreviousInGroup(): void {
    const currentItem = this.allItems[this.currentIndex];

    this.changeUuid();
    const groupKey = currentItem.parent_id && currentItem.parent_id !== currentItem.media_id
      ? currentItem.parent_id
      : currentItem.media_id;


    const group = this.groupedByParent.get(String(groupKey)) ?? [];

    const currentInGroupIdx = group.findIndex(i => i.content?.uid === currentItem.content?.uid);
    const prevItem = group[currentInGroupIdx - 1];

    if (prevItem) {
      const prevIndexInAllItems = this.allItems.findIndex(i => i.content?.uid === prevItem.content?.uid);
      if (prevIndexInAllItems !== -1) {
        this.currentIndex = prevIndexInAllItems;
        this.router.navigate(['/slick', prevItem.content.uid], {
          queryParams: { i: this.currentIndex },
          replaceUrl: true,
        });
        this.loadSlickDetails(prevItem.content.uid);
      }
    }
  }

  shouldHideNavButtons(): boolean {
    const currentItem = this.allItems[this.currentIndex];
    if (!currentItem) return true;

    const groupKey = String(this.getGroupKey(currentItem));
    const group = this.groupedByParent.get(groupKey) ?? [];

    // Se não há outros no grupo além dele mesmo, oculta
    return group.length <= 1 && (!currentItem.parent_id || !this.groupedByParent.has(groupKey));
  }
  isFirstInGroupHidden(): boolean {
    return this.shouldHideNavButtons() || this.isFirstInGroup();
  }

  isLastInGroupHidden(): boolean {
    return this.shouldHideNavButtons() || this.isLastInGroup();
  }
  isFirstInGroup(): boolean {
    if (this.observer) {
      this.observer.disconnect();
    }
    const currentItem = this.allItems[this.currentIndex];
    if (!currentItem) return true;

    const groupKey = String(this.getGroupKey(currentItem));

    const group = this.groupedByParent.get(groupKey) ?? [];

    const fullGroup = [...group];
    if (!group.some(i => i.content?.uid !== currentItem.content?.uid)) return true;

    const currentIndex = fullGroup.findIndex(i => i?.content?.uid === currentItem.content?.uid);
    return currentIndex <= 0;
  }
  getGroupKey(item: Item): string {
    return String(
      item.parent_id && item.parent_id !== item.media_id
        ? item.parent_id
        : item.media_id
    );
  }

  isLastInGroup(): boolean {
    if (this.observer) {
      this.observer.disconnect();
    }
    //console.log('entrou isLastInGroup')
    const currentItem = this.allItems[this.currentIndex];
    if (!currentItem) return true;

    const groupKey = String(this.getGroupKey(currentItem));
    const group = this.groupedByParent.get(groupKey) ?? [];

    const fullGroup = [...group];
    if (!group.some(i => i.content?.uid !== currentItem.content?.uid)) return true;

    const currentIndex = fullGroup.findIndex(i => i?.content?.uid === currentItem.content?.uid);
    return currentIndex >= fullGroup.length - 1;
  }





  isLoadingTabs: boolean = false;


  // XSmall: Telas menores que 600px de largura.
  // Small: Telas de 600px até 959px de largura.
  // Medium: Telas de 960px até 1279px de largura.
  // Large: Telas de 1280px até 1919px de largura.
  // XLarge: Telas maiores que 1920px de largura.



  principal: boolean = false;
  hasAlerts: boolean = true;
  gridTemplateRows: string = '8% 10% 34.5% 10% 15% 12% 10.5%';
  gridTemplateRowsMobileFullScreen: string = '8% 10% 35.5% 10% 18% 8% 10.5%';

  updateGridRows() {
    // Ajuste as proporções do grid quando não há alertas
    //this.gridTemplateRows = this.hasAlerts ? '8% 10% 34.5% 10% 15% 12% 10.5%' : '8% 0% 44.5% 10% 15% 12% 10.5%';
  }

  hasLinksSwiper: boolean = false;


  hasVisibleButton: boolean = false;
  hasVisibleAlerts: boolean = false;
  hasVisibleProducts: boolean = false;
  hasVisibleLinksSwiper: boolean = false;
  checkLinks(): void {
    if (this.filteredLinks$)
      this.filteredLinks$.subscribe(links => {
        this.hasLinksSwiper = links.length > 0;
      });
  }

  removeBtnCustom: boolean = true;
  hasVisibleDesc: boolean = false;
  removeAlerts: boolean = true;
  centerTmp: number = 40.5;
  sumTotal: number = 0;

  sum100() {
    this.sumTotal = this.top1 + this.top2 + this.center + this.bottom0 + this.bottom1 + this.bottom2 + this.bottom3;
    let diff = 100 - this.sumTotal;
    if (diff > 0) {
      this.center = this.center + diff;
    } else if (diff < 0) {
      this.center = this.center - diff;
    }
    //this.gridTemplateRows = `${this.top1}% ${this.top2}% ${this.center}% ${this.bottom0}% ${this.bottom1}% ${this.bottom2}% ${this.bottom3}%`;
  }

  @ViewChild('bottomDiv') bottomDiv!: ElementRef<HTMLDivElement>;
  dynamicHeight: string = 'auto';
  handleTruncatedDesc(): void {
    this.truncatedDesc = '';
    this.showBtnVerMais = false;
    if (this.slickDesc) {

      if (this.valSelectviewMode.value === 1) {
        if (this.slickDesc.length > 25) {
          this.truncatedDesc = `${this.slickDesc.substring(0, 25)}...`;
          this.showBtnVerMais = true;
        } else {
          this.truncatedDesc = this.slickDesc;
          this.showBtnVerMais = false;

        }
      } else {
        if (this.slickDesc.length > 120) {
          this.truncatedDesc = `${this.slickDesc.substring(0, 120)}...`;
          this.showBtnVerMais = true;
        } else {
          this.truncatedDesc = this.slickDesc;
          this.showBtnVerMais = false;

        }
      }



    }
  }
  @ViewChild('progressBarTime') progressBarTime!: ElementRef;
  private setOpacity(progressOpacity: number, gridOpacity: number): void {
    if (this.progressBarTime && this.progressBarTime.nativeElement) {
      if (progressOpacity == 1) {
        this.progressBarTime.nativeElement.classList.add('visible2');
        this.progressBarTime.nativeElement.classList.remove('hiddenBar');
      } else {
        this.progressBarTime.nativeElement.classList.add('hiddenBar');
        this.progressBarTime.nativeElement.classList.remove('visible2');
      }
    }

    if (this.gridContainer && this.gridContainer.nativeElement) {
      this.gridContainer.nativeElement.style.opacity = gridOpacity.toString();
    }
  }
  @ViewChild('gridContainer') gridContainer?: ElementRef<HTMLDivElement>;
  private resizeObserverBreakPoints?: ResizeObserver;
  resizeObserver?: ResizeObserver; // quebras de tela para definir largura de colunas do grid
  showBtnVerMais: boolean = false;
  showBtnVerMaisFechar: boolean = false;
  truncatedDesc?: string = '';
  fullViewActive: boolean = false;
  goVerMaisFechar() {
    this.fullViewActive = false;
    this.showBtnVerMais = true;
    this.showBtnVerMaisFechar = false;
    this.center = this.center + 8;
    this.bottom3 = this.bottom3 - 8;
    this.gridTemplateRows = `${this.top1}% ${this.top2}% ${this.center}% ${this.bottom0}% ${this.bottom1}% ${this.bottom2}% ${this.bottom3}%`;
    this.handleTruncatedDesc();
    this.sum100();
  }
  goVerMais() {
    this.fullViewActive = true;
    this.showBtnVerMaisFechar = true;
    this.showBtnVerMais = false;
    this.center = this.center - 8;
    this.bottom3 = this.bottom3 + 8;
    this.truncatedDesc = this.slickDesc;
    this.gridTemplateRows = `${this.top1}% ${this.top2}% ${this.center}% ${this.bottom0}% ${this.bottom1}% ${this.bottom2}% ${this.bottom3}%`;
    this.sum100();
  }
  toggleAlerts() {
    this.hasAlerts = !this.hasAlerts;
    this.updateGridRows();
  }
  liked: boolean = false;
  sendLike() {
    this.liked = !this.liked;
  }




  tempoAtual = new BehaviorSubject<string>('');
  durationTotal: string = '00:00';
  maxTimeWidth: number = 200;
  get timeWidth(): number {
    let currentTime = parseInt(this.tempoAtual.value);
    let totalDuration = parseInt(this.durationTotal);
    return Math.min((currentTime / totalDuration) * this.maxTimeWidth, this.maxTimeWidth);
  }

  get progressContainerWidth(): string {
    return `100%`;
  }
  ////////////////////
  productMap: Record<string | number, ProductCard> = {};


  rebuildProductMap() {
    const map: Record<string, ProductCard> = {};
    for (const p of this.targetProducts) {
      const sku = String(p.sku);
      map[sku] = {
        id: sku,
        sku: sku,
        name: p.name,
        price: this.convertPriceProduct(p.price),
        compare_at_price: p.compare_at_price != null
          ? this.convertPriceProduct(p.compare_at_price)
          : undefined,
        thumbnail: p.thumbnail,
        show: p.show_item !== false, // default = true
      };
    }
    this.productMap = { ...map }; // nova referência
  }

  onMoveToSource(event: any): void {
    // remove hotspot dos que saíram do target
    const skusToRemove = new Set(event.items.map((p: any) => String(p.sku)));
    this.hotspotsData = this.hotspotsData.filter(h => !skusToRemove.has(String(h.productId)));

    event.items.forEach((item: Produto) => item.isSelected = false);
    this.updateProductPositions();
    console.log("Move to source");
    this.targetProducts = [...this.targetProducts];
    this.setupFilteredProducts();
    if (this.filteredProducts$) {
      this.highlightedProductsLimited$ = this.filteredProducts$.pipe(
        map(products =>
          products.filter(product => product.highlight).slice(0, 3)
        )
      );
    }
    this.canSave = true;
    this.targetProducts = [...this.targetProducts];
    this.setupFilteredProducts();

    this.syncHotspotOrderFromTarget();
    // ðŸŸ¢ Atualiza o mapa de produtos
    this.rebuildProductMap();
    this.rebuildProductTags();
    this.debounceFunction();
    this.pushLiveUpdate();
  }
  onMoveToTarget(event: any): void {

    for (const p of event.items) {
      const sku = String(p.sku);
      const exists = this.hotspotsData.some(h => String(h.productId) === sku);
      if (!exists) {
        const pos = this.spawnPos(this.hotspotsData.length);
        this.hotspotsData.push({
          productId: sku,           // ðŸ‘ˆ agora é o SKU
          xPct: pos.xPct,
          yPct: pos.yPct,
          wPct: 2, hPct: 2,
          position: this.targetProducts.findIndex(tp => String(tp.sku) === sku),
        });
      }
    }

    console.log("Move to target");
    event.items.forEach((item: Produto) => {
      item.isSelected = true;
      // Outras propriedades para os switches e sliders
      item.highlight = false;
      item.define_interval = false;
      item.show_slider = false;
      item.show_item = true;
      item.interval_time = { start: "00:00:00", end: "00:00:00" },
        // Definindo cores padrão para botões e fundos
        item.comprar_font_color = "#FFFFFF"; // Cor branca para o texto do botão de compra
      item.comprar_bg_color = "#007BFF"; // Cor azul para o fundo do botão de compra
      item.adicionar_font_color = "#FFFFFF"; // Cor branca para o texto do botão de adicionar
      item.adicionar_bg_color = "#28A745";
    });
    console.log(this.targetProducts);
    this.canSave = true;
    console.log('cansave: ' + this.canSave)
    this.updateProductPositions();
    this.targetProducts = [...this.targetProducts];
    this.filteredProducts$ = of([...this.targetProducts]);
    this.setupFilteredProducts();
    if (this.filteredProducts$) {
      this.highlightedProductsLimited$ = this.filteredProducts$.pipe(
        map(products =>
          products.filter(product => product.highlight).slice(0, 3)
        )
      );
    }
    this.targetProducts = [...this.targetProducts];
    this.setupFilteredProducts();

    this.syncHotspotOrderFromTarget();
    // ðŸŸ¢ Atualiza o mapa de produtos
    this.rebuildProductMap();
    this.rebuildProductTags();

    this.debounceFunction();
    this.pushLiveUpdate();
  }

  onHotspotDrop(e: { index: number; productId?: string | number; xPct: number; yPct: number }) {
    // já está tudo em this.hotspotsData; basta marcar que há alterações e debouncar
    this.syncHotspotOrderFromTarget();
    this.canSave = true;
    this.debounceFunction(); // vai cair no saveAsset pelo seu subscriber
    this.pushLiveUpdate();
  }

  private syncHotspotOrderFromTarget(): void {
    const bySku = new Map(this.hotspotsData.map(h => [String(h.productId), h])); // productId = SKU
    const ordered: typeof this.hotspotsData = [];

    for (let idx = 0; idx < this.targetProducts.length; idx++) {
      const p = this.targetProducts[idx];
      const h = bySku.get(String(p.sku));
      if (h) ordered.push({ ...h, position: idx });
    }
    this.hotspotsData = ordered;
  }

  ////////////////////
  spawnPos(count: number) {
    // círculo crescente em torno do centro
    const baseX = 50, baseY = 50;
    const radius = 6 + Math.floor(count / 6) * 6; // 6%, 12%, 18%...
    const angle = (count % 6) * (360 / 6) * (Math.PI / 180);
    return {
      xPct: Math.max(0, Math.min(100, baseX + radius * Math.cos(angle))),
      yPct: Math.max(0, Math.min(100, baseY + radius * Math.sin(angle))),
    };
  }

  onHotspotsChange(newList: Hotspot[]) {
    this.hotspotsData = newList;  // só atualiza
    this.canSave = true;          // marque que há alterações para salvar
  }


  // Array final que você passa ao <app-hotspot-editor>
  hotspotsData: Hotspot[] = [];
  showHotspots = false;


  toggleSwitchHotspots() {
    this.canSave = true;
    this.debounceFunction();
    this.pushLiveUpdate();
  }

  // ======= estado do design =======
  hotspotDesignOpen = false;

  // tipo do marcador: 'number' ou 'dot'
  hotspotMarkerType: 'number' | 'dot' = 'number';
  hotspotMarkerOptions = [
    { value: 'dot', name: 'Ponto' },
    { value: 'number', name: 'Numérico' }
  ];

  // shop the look
  hotspotShopEnabled = true;
  hotspotShopLabel = 'Shop the Look';
  hotspotShopBtnBg = '#ff3b30';  // vermelho iOS-ish como default
  hotspotShopBtnText = '#ffffff';


  hotspotShopIcon: 'bag' | 'cart' = 'bag';
  hotspotShopIconOptions = [
    { value: 'bag', icon: 'pi pi-shopping-bag', label: '' },
    { value: 'cart', icon: 'pi pi-shopping-cart', label: '' },
  ];

  openHotspotDesignSidebar() {
    this.hotspotDesignOpen = true;
    this.displaySidebar = false;
  }

  onHotspotDesignHide() {
    // nada especial, só fecha
    this.displaySidebar = true;
  }

  onHotspotDesignChange() {
    // salva tudo após debounce
    this.canSave = true;
    this.debounceFunction();
    this.pushLiveUpdate();
  }

  backToMainSidebar() {
    this.hotspotDesignOpen = false;
    this.displaySidebar = true;
  }

  ////////////////////////////////////////////////////////////////////////////////
  openUserGrid(): void {
    this.userGridOpen = true;

    // reset para primeira carga
    this.userGridItems = [];
    this.userGridNextPage = 1;

    // dispara a primeira página
    this.fetchUserGridPage(false);
  }

  onUserGridHide(): void {
    // se quiser limpar ao fechar
    this.userGridItems = [];
    this.userGridNextPage = null;
    this.isLoadingUserGrid = false;
  }

  private fetchUserGridPage(loadMore = false): void {
    if (this.isLoadingUserGrid || !this.userGridNextPage) return;
    this.isLoadingUserGrid = true;

    const page = this.userGridNextPage;      // número da página atual
    const limit = 20;                         // ðŸ”’ máximo 20 (combina com o backend)

    this.liveShopService
      .getUserMediaByHandle(this.handleUser!, this.source_id!, page, limit)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          // res.assets é um array; cada item tem "items: [ { ... } ]"
          const mapped = (res.assets || []).map((block: any) => {
            const it = block?.items?.[0] ?? {};
            const thumb =
              it?.media?.thumbnail ??
              it?.thumbnail ??
              null;

            const mt = String(it?.media_type ?? it?.media?.type ?? '').toUpperCase();
            const isVideo = ['VIDEO', 'REELS', 'MP4', 'MOV'].includes(mt);

            const id = it?.content?.id ?? it?.media_id ?? it?.id;
            return { id, thumbnail: thumb, isVideo };
          });

          this.userGridItems = [...this.userGridItems, ...mapped];

          // paginação
          this.userGridNextPage = res.nextPage ?? null;

          this.isLoadingUserGrid = false;
          this.cdr.detectChanges();
        },
        error: (error) => {
          this.isLoadingUserGrid = false;
          this.cdr.detectChanges();
          let message = 'Ops... Algo de errado aconteceu. Tente novamente mais tarde.';
          if ([400, 401, 403].includes(error?.status)) {
            message = error?.error?.message || message;
          }
          this.messageService.add({ severity: 'error', summary: 'Erro ao carregar mídias', detail: message });
        },
      });
  }

  loadMoreUserGrid(): void {
    if (!this.userGridNextPage || this.isLoadingUserGrid) return;
    this.fetchUserGridPage(true);
  }




  // ação ao clicar em um item do grid (abra modal, etc.)
  openUserGridItem(item: any): void {
    // exemplo simples: se tiver vídeo/thumbnail maior, chame seu modal
    // this.openModal(item);
  }

  ////////////////////////////////////////////////////////////////////////////////
  // estado
  userGridOpen = false;
  isLoadingUserGrid = false;
  userGridItems: Array<{ id?: any; thumbnail: string; isVideo?: boolean }> = [];
  userGridNextPage: number | null = 1;
  userGridSkeletons = Array.from({ length: 10 });

  // de onde vem este handle? defina antes de abrir
  handleUser?: string;
  avatar = '';
  source_id = '';
  permalink: string = '';
  media_id: string = '';

  goToPost() {
    this.verPostNo(this.source_id, this.permalink, this.media_id)
  }

  verPostNo(source: string, permalink: string, media_id: string): void {
    let link: string | null = null;
    let plataforma = source.toLowerCase();

    if (plataforma === 'yt') {
      const mediaId = media_id;
      if (mediaId) {
        link = `https://www.youtube.com/watch?v=${mediaId}`;
      }
    } else if (plataforma === 'ig') {
      link = permalink;
    } else if (plataforma === 'tt') {
      link = permalink; // Ou outro campo, se você salvar diferente para TikTok
    }

    if (!link) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Este item não possui um link para o post.'
      });
      return;
    }

    window.open(link, '_blank');
  }
  hasDiscount(p: any): boolean {
    if (!p) return false;

    const price = Number(
      typeof p.price === 'string' ? p.price.replace(',', '.').trim() : p.price
    );
    const compare = Number(
      typeof p.compare_at_price === 'string'
        ? p.compare_at_price.replace(',', '.').trim()
        : p.compare_at_price
    );

    return !!compare && compare > price;
  }

}


